(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as mS, getPartnerDevApiHeaders as pS, WidgetContextProvider as fS, makeExecuteQuery as hS, makeUseLazyQuery as yS, makeUseQuery as gS, makeUseMutation as kS, validateApiHostName as rb, useTracking as kn, useWidgetContext as mn, hasDownstreamApiForbiddenError as km, hasDownstreamApiAuthorizationError as vm, DisplayErrors as wn, useCopyWithDelay as Xt, defaultDateFormat as ct, displayAttributeValue as ib, OAuthSettings as Ga, useData as bm, isDownstreamApiNotFoundError as vS, isDownstreamApiAuthorizationError as ab, KlaviyoSubscribeSetting as bS, isDownstreamApiPermissionError as _S, capitalizeFirstCharacter as ws, hasDownstreamApiTooManyRequestsError as xS, hasDownstreamApiPermissionError as ob, hasDownstreamApiNotFoundError as Ya, getCountryNameFromCountryCode as SS } from "@dixa/partner-widget-integration-support";
export * from "@dixa/partner-widget-integration-support";
import Se, { useMemo as et, useState as se, useEffect as qe, useRef as Fi, useCallback as at, useReducer as NS, useLayoutEffect as jS, useContext as wS, isValidElement as CS, createElement as FS, Fragment as IS } from "react";
import { Modal as gt, ModalHead as kt, ModalBody as vt, ModalFoot as wt, Text as A, FlexBox as b, Spinner as un, Icon as me, Tooltip as Ke, List as He, Badge as Un, Button as Wn, IconButton as Kt, Tag as On, NavigationButton as jt, Select as br, CollapseCard as rr, Box as Jn, FormGrid as zt, FormField as nn, FieldWrapper as An, InputText as kr, Textarea as Lu, TagsInput as Cs, Image as Li, Banner as Ja, Divider as _m, InputSelectionList as Kr, SelectionList as pt, FieldText as ir, FieldTextarea as ES, CopyToClipboardButton as TS, getSelectionListContext as $S, Avatar as xm, Timestamp as DS, Attachment as RS, Switch as Vu, FieldLabel as OS, EmptyState as Sm, Table as Qn, Checkbox as Lp, TextWithHighlight as PS, ErrorBoundaryContext as sb, FieldSwitch as lb } from "@dixa/lib-shared-habla";
import { ApolloLink as Nm, Observable as cb, ApolloClient as AS, InMemoryCache as LS, createHttpLink as VS, ApolloProvider as zS, useApolloClient as US, ApolloConsumer as MS, gql as Qr, NetworkStatus as ar, isApolloError as db, ApolloError as BS, useQuery as qS, useMutation as Vp } from "@apollo/client";
import HS from "cross-fetch";
import { config as qa } from "lib-shared-backend-config";
import dt from "classnames";
import Pn from "moment";
import { __rest as WS, __assign as Gs } from "tslib";
import { useNavigate as KS, useLocation as GS } from "react-router-dom";
import "moment-timezone";
function jm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var co = { exports: {} }, Gi = {};
var zp;
function YS() {
  if (zp) return Gi;
  zp = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Gi.Fragment = r, Gi.jsx = s, Gi.jsxs = s, Gi;
}
var Yi = {};
var Up;
function JS() {
  return Up || (Up = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var E = !1, j = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || E || j || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function W(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return W(c) + ".Consumer";
          case s:
            var p = t;
            return W(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, ke, ue, ce, he, H, be, Ce;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, ue = console.info, ce = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: ke
            }),
            info: K({}, t, {
              value: ue
            }),
            warn: K({}, t, {
              value: ce
            }),
            error: K({}, t, {
              value: he
            }),
            group: K({}, t, {
              value: H
            }),
            groupCollapsed: K({}, t, {
              value: be
            }),
            groupEnd: K({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              y = te;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), T = y.stack.split(`
`), V = x.length - 1, z = T.length - 1; V >= 1 && z >= 0 && x[V] !== T[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== T[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== T[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var C in t)
          if (L(t, C)) {
            var x = void 0;
            try {
              if (typeof t[C] != "function") {
                var T = Error((y || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              x = t[C](c, C, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, C, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, C) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, C = {}, x = null, T = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (T = c.ref, tn(c, R));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (x || T) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(C, z), T && fn(C, z);
        }
        return pn(t, x, T, R, y, B.current, C);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), C; !(C = L.next()).done; )
              an(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var C = ee(t);
        if (!C) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Hn();
          T ? x += T : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    Yi.Fragment = i, Yi.jsx = Bn, Yi.jsxs = qn;
  })()), Yi;
}
var Mp;
function QS() {
  return Mp || (Mp = 1, process.env.NODE_ENV === "production" ? co.exports = YS() : co.exports = JS()), co.exports;
}
var Ue = QS();
function ub(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: XS } = Object.prototype, { getPrototypeOf: wm } = Object, { iterator: Fs, toStringTag: mb } = Symbol, Is = /* @__PURE__ */ ((e) => (n) => {
  const r = XS.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), _r = (e) => (e = e.toLowerCase(), (n) => Is(n) === e), Es = (e) => (n) => typeof n === e, { isArray: Vi } = Array, Ri = Es("undefined");
function Qa(e) {
  return e !== null && !Ri(e) && e.constructor !== null && !Ri(e.constructor) && qt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const pb = _r("ArrayBuffer");
function ZS(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && pb(e.buffer), n;
}
const e0 = Es("string"), qt = Es("function"), fb = Es("number"), Xa = (e) => e !== null && typeof e == "object", n0 = (e) => e === !0 || e === !1, Mo = (e) => {
  if (Is(e) !== "object")
    return !1;
  const n = wm(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(mb in e) && !(Fs in e);
}, t0 = (e) => {
  if (!Xa(e) || Qa(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, r0 = _r("Date"), i0 = _r("File"), a0 = _r("Blob"), o0 = _r("FileList"), s0 = (e) => Xa(e) && qt(e.pipe), l0 = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || qt(e.append) && ((n = Is(e)) === "formdata" || // detect form-data instance
  n === "object" && qt(e.toString) && e.toString() === "[object FormData]"));
}, c0 = _r("URLSearchParams"), [d0, u0, m0, p0] = ["ReadableStream", "Request", "Response", "Headers"].map(_r), f0 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Za(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Vi(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (Qa(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function hb(e, n) {
  if (Qa(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const oi = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, yb = (e) => !Ri(e) && e !== oi;
function zu() {
  const { caseless: e, skipUndefined: n } = yb(this) && this || {}, r = {}, i = (a, o) => {
    const s = e && hb(r, o) || o;
    Mo(r[s]) && Mo(a) ? r[s] = zu(r[s], a) : Mo(a) ? r[s] = zu({}, a) : Vi(a) ? r[s] = a.slice() : (!n || !Ri(a)) && (r[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && Za(arguments[a], i);
  return r;
}
const h0 = (e, n, r, { allOwnKeys: i } = {}) => (Za(n, (a, o) => {
  r && qt(a) ? e[o] = ub(a, r) : e[o] = a;
}, { allOwnKeys: i }), e), y0 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), g0 = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, k0 = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && wm(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, v0 = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, b0 = (e) => {
  if (!e) return null;
  if (Vi(e)) return e;
  let n = e.length;
  if (!fb(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, _0 = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && wm(Uint8Array)), x0 = (e, n) => {
  const i = (e && e[Fs]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, S0 = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, N0 = _r("HTMLFormElement"), j0 = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, i, a) {
    return i.toUpperCase() + a;
  }
), Bp = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), w0 = _r("RegExp"), gb = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  Za(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, C0 = (e) => {
  gb(e, (n, r) => {
    if (qt(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const i = e[r];
    if (qt(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, F0 = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Vi(e) ? i(e) : i(String(e).split(n)), r;
}, I0 = () => {
}, E0 = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function T0(e) {
  return !!(e && qt(e.append) && e[mb] === "FormData" && e[Fs]);
}
const $0 = (e) => {
  const n = new Array(10), r = (i, a) => {
    if (Xa(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (Qa(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = Vi(i) ? [] : {};
        return Za(i, (s, l) => {
          const d = r(s, a + 1);
          !Ri(d) && (o[l] = d);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return r(e, 0);
}, D0 = _r("AsyncFunction"), R0 = (e) => e && (Xa(e) || qt(e)) && qt(e.then) && qt(e.catch), kb = ((e, n) => e ? setImmediate : n ? ((r, i) => (oi.addEventListener("message", ({ source: a, data: o }) => {
  a === oi && o === r && i.length && i.shift()();
}, !1), (a) => {
  i.push(a), oi.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  qt(oi.postMessage)
), O0 = typeof queueMicrotask < "u" ? queueMicrotask.bind(oi) : typeof process < "u" && process.nextTick || kb, P0 = (e) => e != null && qt(e[Fs]), ge = {
  isArray: Vi,
  isArrayBuffer: pb,
  isBuffer: Qa,
  isFormData: l0,
  isArrayBufferView: ZS,
  isString: e0,
  isNumber: fb,
  isBoolean: n0,
  isObject: Xa,
  isPlainObject: Mo,
  isEmptyObject: t0,
  isReadableStream: d0,
  isRequest: u0,
  isResponse: m0,
  isHeaders: p0,
  isUndefined: Ri,
  isDate: r0,
  isFile: i0,
  isBlob: a0,
  isRegExp: w0,
  isFunction: qt,
  isStream: s0,
  isURLSearchParams: c0,
  isTypedArray: _0,
  isFileList: o0,
  forEach: Za,
  merge: zu,
  extend: h0,
  trim: f0,
  stripBOM: y0,
  inherits: g0,
  toFlatObject: k0,
  kindOf: Is,
  kindOfTest: _r,
  endsWith: v0,
  toArray: b0,
  forEachEntry: x0,
  matchAll: S0,
  isHTMLForm: N0,
  hasOwnProperty: Bp,
  hasOwnProp: Bp,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: gb,
  freezeMethods: C0,
  toObjectSet: F0,
  toCamelCase: j0,
  noop: I0,
  toFiniteNumber: E0,
  findKey: hb,
  global: oi,
  isContextDefined: yb,
  isSpecCompliantForm: T0,
  toJSONObject: $0,
  isAsyncFn: D0,
  isThenable: R0,
  setImmediate: kb,
  asap: O0,
  isIterable: P0
};
function Fn(e, n, r, i, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), r && (this.config = r), i && (this.request = i), a && (this.response = a, this.status = a.status ? a.status : null);
}
ge.inherits(Fn, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ge.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const vb = Fn.prototype, bb = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  bb[e] = { value: e };
});
Object.defineProperties(Fn, bb);
Object.defineProperty(vb, "isAxiosError", { value: !0 });
Fn.from = (e, n, r, i, a, o) => {
  const s = Object.create(vb);
  ge.toFlatObject(e, s, function(u) {
    return u !== Error.prototype;
  }, (m) => m !== "isAxiosError");
  const l = e && e.message ? e.message : "Error", d = n == null && e ? e.code : n;
  return Fn.call(s, l, d, r, i, a), e && s.cause == null && Object.defineProperty(s, "cause", { value: e, configurable: !0 }), s.name = e && e.name || "Error", o && Object.assign(s, o), s;
};
const A0 = null;
function Uu(e) {
  return ge.isPlainObject(e) || ge.isArray(e);
}
function _b(e) {
  return ge.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function qp(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = _b(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function L0(e) {
  return ge.isArray(e) && !e.some(Uu);
}
const V0 = ge.toFlatObject(ge, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Ts(e, n, r) {
  if (!ge.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ge.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(N, F) {
    return !ge.isUndefined(F[N]);
  });
  const i = r.metaTokens, a = r.visitor || u, o = r.dots, s = r.indexes, d = (r.Blob || typeof Blob < "u" && Blob) && ge.isSpecCompliantForm(n);
  if (!ge.isFunction(a))
    throw new TypeError("visitor must be a function");
  function m(S) {
    if (S === null) return "";
    if (ge.isDate(S))
      return S.toISOString();
    if (ge.isBoolean(S))
      return S.toString();
    if (!d && ge.isBlob(S))
      throw new Fn("Blob is not supported. Use a Buffer instead.");
    return ge.isArrayBuffer(S) || ge.isTypedArray(S) ? d && typeof Blob == "function" ? new Blob([S]) : Buffer.from(S) : S;
  }
  function u(S, N, F) {
    let I = S;
    if (S && !F && typeof S == "object") {
      if (ge.endsWith(N, "{}"))
        N = i ? N : N.slice(0, -2), S = JSON.stringify(S);
      else if (ge.isArray(S) && L0(S) || (ge.isFileList(S) || ge.endsWith(N, "[]")) && (I = ge.toArray(S)))
        return N = _b(N), I.forEach(function(q, E) {
          !(ge.isUndefined(q) || q === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? qp([N], E, o) : s === null ? N : N + "[]",
            m(q)
          );
        }), !1;
    }
    return Uu(S) ? !0 : (n.append(qp(F, N, o), m(S)), !1);
  }
  const f = [], h = Object.assign(V0, {
    defaultVisitor: u,
    convertValue: m,
    isVisitable: Uu
  });
  function v(S, N) {
    if (!ge.isUndefined(S)) {
      if (f.indexOf(S) !== -1)
        throw Error("Circular reference detected in " + N.join("."));
      f.push(S), ge.forEach(S, function(I, g) {
        (!(ge.isUndefined(I) || I === null) && a.call(
          n,
          I,
          ge.isString(g) ? g.trim() : g,
          N,
          h
        )) === !0 && v(I, N ? N.concat(g) : [g]);
      }), f.pop();
    }
  }
  if (!ge.isObject(e))
    throw new TypeError("data must be an object");
  return v(e), n;
}
function Hp(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(i) {
    return n[i];
  });
}
function Cm(e, n) {
  this._pairs = [], e && Ts(e, this, n);
}
const xb = Cm.prototype;
xb.append = function(n, r) {
  this._pairs.push([n, r]);
};
xb.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, Hp);
  } : Hp;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function z0(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Sb(e, n, r) {
  if (!n)
    return e;
  const i = r && r.encode || z0;
  ge.isFunction(r) && (r = {
    serialize: r
  });
  const a = r && r.serialize;
  let o;
  if (a ? o = a(n, r) : o = ge.isURLSearchParams(n) ? n.toString() : new Cm(n, r).toString(i), o) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class Wp {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ge.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Nb = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, U0 = typeof URLSearchParams < "u" ? URLSearchParams : Cm, M0 = typeof FormData < "u" ? FormData : null, B0 = typeof Blob < "u" ? Blob : null, q0 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: U0,
    FormData: M0,
    Blob: B0
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Fm = typeof window < "u" && typeof document < "u", Mu = typeof navigator == "object" && navigator || void 0, H0 = Fm && (!Mu || ["ReactNative", "NativeScript", "NS"].indexOf(Mu.product) < 0), W0 = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", K0 = Fm && window.location.href || "http://localhost", G0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Fm,
  hasStandardBrowserEnv: H0,
  hasStandardBrowserWebWorkerEnv: W0,
  navigator: Mu,
  origin: K0
}, Symbol.toStringTag, { value: "Module" })), Ct = {
  ...G0,
  ...q0
};
function Y0(e, n) {
  return Ts(e, new Ct.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Ct.isNode && ge.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function J0(e) {
  return ge.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function Q0(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function jb(e) {
  function n(r, i, a, o) {
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && ge.isArray(a) ? a.length : s, d ? (ge.hasOwnProp(a, s) ? a[s] = [a[s], i] : a[s] = i, !l) : ((!a[s] || !ge.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && ge.isArray(a[s]) && (a[s] = Q0(a[s])), !l);
  }
  if (ge.isFormData(e) && ge.isFunction(e.entries)) {
    const r = {};
    return ge.forEachEntry(e, (i, a) => {
      n(J0(i), a, r, 0);
    }), r;
  }
  return null;
}
function X0(e, n, r) {
  if (ge.isString(e))
    try {
      return (n || JSON.parse)(e), ge.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const eo = {
  transitional: Nb,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(n, r) {
    const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = ge.isObject(n);
    if (o && ge.isHTMLForm(n) && (n = new FormData(n)), ge.isFormData(n))
      return a ? JSON.stringify(jb(n)) : n;
    if (ge.isArrayBuffer(n) || ge.isBuffer(n) || ge.isStream(n) || ge.isFile(n) || ge.isBlob(n) || ge.isReadableStream(n))
      return n;
    if (ge.isArrayBufferView(n))
      return n.buffer;
    if (ge.isURLSearchParams(n))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let l;
    if (o) {
      if (i.indexOf("application/x-www-form-urlencoded") > -1)
        return Y0(n, this.formSerializer).toString();
      if ((l = ge.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return Ts(
          l ? { "files[]": n } : n,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return o || a ? (r.setContentType("application/json", !1), X0(n)) : n;
  }],
  transformResponse: [function(n) {
    const r = this.transitional || eo.transitional, i = r && r.forcedJSONParsing, a = this.responseType === "json";
    if (ge.isResponse(n) || ge.isReadableStream(n))
      return n;
    if (n && ge.isString(n) && (i && !this.responseType || a)) {
      const s = !(r && r.silentJSONParsing) && a;
      try {
        return JSON.parse(n, this.parseReviver);
      } catch (l) {
        if (s)
          throw l.name === "SyntaxError" ? Fn.from(l, Fn.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ct.classes.FormData,
    Blob: Ct.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ge.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  eo.headers[e] = {};
});
const Z0 = ge.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), eN = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && Z0[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
}, Kp = Symbol("internals");
function Ji(e) {
  return e && String(e).trim().toLowerCase();
}
function Bo(e) {
  return e === !1 || e == null ? e : ge.isArray(e) ? e.map(Bo) : String(e);
}
function nN(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const tN = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Ys(e, n, r, i, a) {
  if (ge.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!ge.isString(n)) {
    if (ge.isString(i))
      return n.indexOf(i) !== -1;
    if (ge.isRegExp(i))
      return i.test(n);
  }
}
function rN(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function iN(e, n) {
  const r = ge.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Ht = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = Ji(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = ge.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = Bo(l));
    }
    const s = (l, d) => ge.forEach(l, (m, u) => o(m, u, d));
    if (ge.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (ge.isString(n) && (n = n.trim()) && !tN(n))
      s(eN(n), r);
    else if (ge.isObject(n) && ge.isIterable(n)) {
      let l = {}, d, m;
      for (const u of n) {
        if (!ge.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        l[m = u[0]] = (d = l[m]) ? ge.isArray(d) ? [...d, u[1]] : [d, u[1]] : u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = Ji(n), n) {
      const i = ge.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return nN(a);
        if (ge.isFunction(r))
          return r.call(this, a, i);
        if (ge.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = Ji(n), n) {
      const i = ge.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || Ys(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = Ji(s), s) {
        const l = ge.findKey(i, s);
        l && (!r || Ys(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return ge.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || Ys(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return ge.forEach(this, (a, o) => {
      const s = ge.findKey(i, o);
      if (s) {
        r[s] = Bo(a), delete r[o];
        return;
      }
      const l = n ? rN(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Bo(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ge.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && ge.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[Kp] = this[Kp] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = Ji(s);
      i[l] || (iN(a, s), i[l] = !0);
    }
    return ge.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Ht.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ge.reduceDescriptors(Ht.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ge.freezeMethods(Ht);
function Js(e, n) {
  const r = this || eo, i = n || r, a = Ht.from(i.headers);
  let o = i.data;
  return ge.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function wb(e) {
  return !!(e && e.__CANCEL__);
}
function zi(e, n, r) {
  Fn.call(this, e ?? "canceled", Fn.ERR_CANCELED, n, r), this.name = "CanceledError";
}
ge.inherits(zi, Fn, {
  __CANCEL__: !0
});
function Cb(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new Fn(
    "Request failed with status code " + r.status,
    [Fn.ERR_BAD_REQUEST, Fn.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function aN(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function oN(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const v = u && m - u;
    return v ? Math.round(h * 1e3 / v) : void 0;
  };
}
function sN(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const is = (e, n, r = 3) => {
  let i = 0;
  const a = oN(50, 250);
  return sN((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = s - i, m = a(d), u = s <= l;
    i = s;
    const f = {
      loaded: s,
      total: l,
      progress: l ? s / l : void 0,
      bytes: d,
      rate: m || void 0,
      estimated: m && l && u ? (l - s) / m : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, Gp = (e, n) => {
  const r = e != null;
  return [(i) => n[0]({
    lengthComputable: r,
    total: e,
    loaded: i
  }), n[1]];
}, Yp = (e) => (...n) => ge.asap(() => e(...n)), lN = Ct.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Ct.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Ct.origin),
  Ct.navigator && /(msie|trident)/i.test(Ct.navigator.userAgent)
) : () => !0, cN = Ct.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o) {
      const s = [e + "=" + encodeURIComponent(n)];
      ge.isNumber(r) && s.push("expires=" + new Date(r).toGMTString()), ge.isString(i) && s.push("path=" + i), ge.isString(a) && s.push("domain=" + a), o === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function dN(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function uN(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function Fb(e, n, r) {
  let i = !dN(n);
  return e && (i || r == !1) ? uN(e, n) : n;
}
const Jp = (e) => e instanceof Ht ? { ...e } : e;
function fi(e, n) {
  n = n || {};
  const r = {};
  function i(m, u, f, h) {
    return ge.isPlainObject(m) && ge.isPlainObject(u) ? ge.merge.call({ caseless: h }, m, u) : ge.isPlainObject(u) ? ge.merge({}, u) : ge.isArray(u) ? u.slice() : u;
  }
  function a(m, u, f, h) {
    if (ge.isUndefined(u)) {
      if (!ge.isUndefined(m))
        return i(void 0, m, f, h);
    } else return i(m, u, f, h);
  }
  function o(m, u) {
    if (!ge.isUndefined(u))
      return i(void 0, u);
  }
  function s(m, u) {
    if (ge.isUndefined(u)) {
      if (!ge.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, u);
  }
  function l(m, u, f) {
    if (f in n)
      return i(m, u);
    if (f in e)
      return i(void 0, m);
  }
  const d = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, u, f) => a(Jp(m), Jp(u), f, !0)
  };
  return ge.forEach(Object.keys({ ...e, ...n }), function(u) {
    const f = d[u] || a, h = f(e[u], n[u], u);
    ge.isUndefined(h) && f !== l || (r[u] = h);
  }), r;
}
const Ib = (e) => {
  const n = fi({}, e);
  let { data: r, withXSRFToken: i, xsrfHeaderName: a, xsrfCookieName: o, headers: s, auth: l } = n;
  if (n.headers = s = Ht.from(s), n.url = Sb(Fb(n.baseURL, n.url, n.allowAbsoluteUrls), e.params, e.paramsSerializer), l && s.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  ), ge.isFormData(r)) {
    if (Ct.hasStandardBrowserEnv || Ct.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if (ge.isFunction(r.getHeaders)) {
      const d = r.getHeaders(), m = ["content-type", "content-length"];
      Object.entries(d).forEach(([u, f]) => {
        m.includes(u.toLowerCase()) && s.set(u, f);
      });
    }
  }
  if (Ct.hasStandardBrowserEnv && (i && ge.isFunction(i) && (i = i(n)), i || i !== !1 && lN(n.url))) {
    const d = a && o && cN.read(o);
    d && s.set(a, d);
  }
  return n;
}, mN = typeof XMLHttpRequest < "u", pN = mN && function(e) {
  return new Promise(function(r, i) {
    const a = Ib(e);
    let o = a.data;
    const s = Ht.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, v, S;
    function N() {
      v && v(), S && S(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let F = new XMLHttpRequest();
    F.open(a.method.toUpperCase(), a.url, !0), F.timeout = a.timeout;
    function I() {
      if (!F)
        return;
      const q = Ht.from(
        "getAllResponseHeaders" in F && F.getAllResponseHeaders()
      ), j = {
        data: !l || l === "text" || l === "json" ? F.responseText : F.response,
        status: F.status,
        statusText: F.statusText,
        headers: q,
        config: e,
        request: F
      };
      Cb(function(U) {
        r(U), N();
      }, function(U) {
        i(U), N();
      }, j), F = null;
    }
    "onloadend" in F ? F.onloadend = I : F.onreadystatechange = function() {
      !F || F.readyState !== 4 || F.status === 0 && !(F.responseURL && F.responseURL.indexOf("file:") === 0) || setTimeout(I);
    }, F.onabort = function() {
      F && (i(new Fn("Request aborted", Fn.ECONNABORTED, e, F)), F = null);
    }, F.onerror = function(E) {
      const j = E && E.message ? E.message : "Network Error", $ = new Fn(j, Fn.ERR_NETWORK, e, F);
      $.event = E || null, i($), F = null;
    }, F.ontimeout = function() {
      let E = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const j = a.transitional || Nb;
      a.timeoutErrorMessage && (E = a.timeoutErrorMessage), i(new Fn(
        E,
        j.clarifyTimeoutError ? Fn.ETIMEDOUT : Fn.ECONNABORTED,
        e,
        F
      )), F = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in F && ge.forEach(s.toJSON(), function(E, j) {
      F.setRequestHeader(j, E);
    }), ge.isUndefined(a.withCredentials) || (F.withCredentials = !!a.withCredentials), l && l !== "json" && (F.responseType = a.responseType), m && ([h, S] = is(m, !0), F.addEventListener("progress", h)), d && F.upload && ([f, v] = is(d), F.upload.addEventListener("progress", f), F.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (u = (q) => {
      F && (i(!q || q.type ? new zi(null, e, F) : q), F.abort(), F = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const g = aN(a.url);
    if (g && Ct.protocols.indexOf(g) === -1) {
      i(new Fn("Unsupported protocol " + g + ":", Fn.ERR_BAD_REQUEST, e));
      return;
    }
    F.send(o || null);
  });
}, fN = (e, n) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (n || r) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const u = m instanceof Error ? m : this.reason;
        i.abort(u instanceof Fn ? u : new zi(u instanceof Error ? u.message : u));
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new Fn(`timeout ${n} of ms exceeded`, Fn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: d } = i;
    return d.unsubscribe = () => ge.asap(l), d;
  }
}, hN = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, yN = async function* (e, n) {
  for await (const r of gN(e))
    yield* hN(r, n);
}, gN = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, Qp = (e, n, r, i) => {
  const a = yN(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream({
    async pull(d) {
      try {
        const { done: m, value: u } = await a.next();
        if (m) {
          l(), d.close();
          return;
        }
        let f = u.byteLength;
        if (r) {
          let h = o += f;
          r(h);
        }
        d.enqueue(new Uint8Array(u));
      } catch (m) {
        throw l(m), m;
      }
    },
    cancel(d) {
      return l(d), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, Xp = 64 * 1024, { isFunction: uo } = ge, kN = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(ge.global), {
  ReadableStream: Zp,
  TextEncoder: ef
} = ge.global, nf = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, vN = (e) => {
  e = ge.merge.call({
    skipUndefined: !0
  }, kN, e);
  const { fetch: n, Request: r, Response: i } = e, a = n ? uo(n) : typeof fetch == "function", o = uo(r), s = uo(i);
  if (!a)
    return !1;
  const l = a && uo(Zp), d = a && (typeof ef == "function" ? /* @__PURE__ */ ((S) => (N) => S.encode(N))(new ef()) : async (S) => new Uint8Array(await new r(S).arrayBuffer())), m = o && l && nf(() => {
    let S = !1;
    const N = new r(Ct.origin, {
      body: new Zp(),
      method: "POST",
      get duplex() {
        return S = !0, "half";
      }
    }).headers.has("Content-Type");
    return S && !N;
  }), u = s && l && nf(() => ge.isReadableStream(new i("").body)), f = {
    stream: u && ((S) => S.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((S) => {
    !f[S] && (f[S] = (N, F) => {
      let I = N && N[S];
      if (I)
        return I.call(N);
      throw new Fn(`Response type '${S}' is not supported`, Fn.ERR_NOT_SUPPORT, F);
    });
  });
  const h = async (S) => {
    if (S == null)
      return 0;
    if (ge.isBlob(S))
      return S.size;
    if (ge.isSpecCompliantForm(S))
      return (await new r(Ct.origin, {
        method: "POST",
        body: S
      }).arrayBuffer()).byteLength;
    if (ge.isArrayBufferView(S) || ge.isArrayBuffer(S))
      return S.byteLength;
    if (ge.isURLSearchParams(S) && (S = S + ""), ge.isString(S))
      return (await d(S)).byteLength;
  }, v = async (S, N) => {
    const F = ge.toFiniteNumber(S.getContentLength());
    return F ?? h(N);
  };
  return async (S) => {
    let {
      url: N,
      method: F,
      data: I,
      signal: g,
      cancelToken: q,
      timeout: E,
      onDownloadProgress: j,
      onUploadProgress: $,
      responseType: U,
      headers: Z,
      withCredentials: Q = "same-origin",
      fetchOptions: ee
    } = Ib(S), J = n || fetch;
    U = U ? (U + "").toLowerCase() : "text";
    let W = fN([g, q && q.toAbortSignal()], E), P = null;
    const K = W && W.unsubscribe && (() => {
      W.unsubscribe();
    });
    let ne;
    try {
      if ($ && m && F !== "get" && F !== "head" && (ne = await v(Z, I)) !== 0) {
        let be = new r(N, {
          method: "POST",
          body: I,
          duplex: "half"
        }), Ce;
        if (ge.isFormData(I) && (Ce = be.headers.get("content-type")) && Z.setContentType(Ce), be.body) {
          const [G, ze] = Gp(
            ne,
            is(Yp($))
          );
          I = Qp(be.body, Xp, G, ze);
        }
      }
      ge.isString(Q) || (Q = Q ? "include" : "omit");
      const ke = o && "credentials" in r.prototype, ue = {
        ...ee,
        signal: W,
        method: F.toUpperCase(),
        headers: Z.normalize().toJSON(),
        body: I,
        duplex: "half",
        credentials: ke ? Q : void 0
      };
      P = o && new r(N, ue);
      let ce = await (o ? J(P, ee) : J(N, ue));
      const he = u && (U === "stream" || U === "response");
      if (u && (j || he && K)) {
        const be = {};
        ["status", "statusText", "headers"].forEach((Be) => {
          be[Be] = ce[Be];
        });
        const Ce = ge.toFiniteNumber(ce.headers.get("content-length")), [G, ze] = j && Gp(
          Ce,
          is(Yp(j), !0)
        ) || [];
        ce = new i(
          Qp(ce.body, Xp, G, () => {
            ze && ze(), K && K();
          }),
          be
        );
      }
      U = U || "text";
      let H = await f[ge.findKey(f, U) || "text"](ce, S);
      return !he && K && K(), await new Promise((be, Ce) => {
        Cb(be, Ce, {
          data: H,
          headers: Ht.from(ce.headers),
          status: ce.status,
          statusText: ce.statusText,
          config: S,
          request: P
        });
      });
    } catch (ke) {
      throw K && K(), ke && ke.name === "TypeError" && /Load failed|fetch/i.test(ke.message) ? Object.assign(
        new Fn("Network Error", Fn.ERR_NETWORK, S, P),
        {
          cause: ke.cause || ke
        }
      ) : Fn.from(ke, ke && ke.code, S, P);
    }
  };
}, bN = /* @__PURE__ */ new Map(), Eb = (e) => {
  let n = e ? e.env : {};
  const { fetch: r, Request: i, Response: a } = n, o = [
    i,
    a,
    r
  ];
  let s = o.length, l = s, d, m, u = bN;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : vN(n)), u = m;
  return m;
};
Eb();
const Bu = {
  http: A0,
  xhr: pN,
  fetch: {
    get: Eb
  }
};
ge.forEach(Bu, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const tf = (e) => `- ${e}`, _N = (e) => ge.isFunction(e) || e === null || e === !1, Tb = {
  getAdapter: (e, n) => {
    e = ge.isArray(e) ? e : [e];
    const { length: r } = e;
    let i, a;
    const o = {};
    for (let s = 0; s < r; s++) {
      i = e[s];
      let l;
      if (a = i, !_N(i) && (a = Bu[(l = String(i)).toLowerCase()], a === void 0))
        throw new Fn(`Unknown adapter '${l}'`);
      if (a && (ge.isFunction(a) || (a = a.get(n))))
        break;
      o[l || "#" + s] = a;
    }
    if (!a) {
      const s = Object.entries(o).map(
        ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let l = r ? s.length > 1 ? `since :
` + s.map(tf).join(`
`) : " " + tf(s[0]) : "as no adapter specified";
      throw new Fn(
        "There is no suitable adapter to dispatch the request " + l,
        "ERR_NOT_SUPPORT"
      );
    }
    return a;
  },
  adapters: Bu
};
function Qs(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new zi(null, e);
}
function rf(e) {
  return Qs(e), e.headers = Ht.from(e.headers), e.data = Js.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Tb.getAdapter(e.adapter || eo.adapter, e)(e).then(function(i) {
    return Qs(e), i.data = Js.call(
      e,
      e.transformResponse,
      i
    ), i.headers = Ht.from(i.headers), i;
  }, function(i) {
    return wb(i) || (Qs(e), i && i.response && (i.response.data = Js.call(
      e,
      e.transformResponse,
      i.response
    ), i.response.headers = Ht.from(i.response.headers))), Promise.reject(i);
  });
}
const $b = "1.12.2", $s = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  $s[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const af = {};
$s.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + $b + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new Fn(
        a(s, " has been removed" + (r ? " in " + r : "")),
        Fn.ERR_DEPRECATED
      );
    return r && !af[s] && (af[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
$s.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function xN(e, n, r) {
  if (typeof e != "object")
    throw new Fn("options must be an object", Fn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = n[o];
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new Fn("option " + o + " must be " + d, Fn.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new Fn("Unknown option " + o, Fn.ERR_BAD_OPTION);
  }
}
const qo = {
  assertOptions: xN,
  validators: $s
}, xr = qo.validators;
let di = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new Wp(),
      response: new Wp()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          i.stack ? o && !String(i.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (i.stack += `
` + o) : i.stack = o;
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = fi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && qo.assertOptions(i, {
      silentJSONParsing: xr.transitional(xr.boolean),
      forcedJSONParsing: xr.transitional(xr.boolean),
      clarifyTimeoutError: xr.transitional(xr.boolean)
    }, !1), a != null && (ge.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : qo.assertOptions(a, {
      encode: xr.function,
      serialize: xr.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), qo.assertOptions(r, {
      baseUrl: xr.spelling("baseURL"),
      withXsrfToken: xr.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && ge.merge(
      o.common,
      o[r.method]
    );
    o && ge.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (S) => {
        delete o[S];
      }
    ), r.headers = Ht.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(N) {
      typeof N.runWhen == "function" && N.runWhen(r) === !1 || (d = d && N.synchronous, l.unshift(N.fulfilled, N.rejected));
    });
    const m = [];
    this.interceptors.response.forEach(function(N) {
      m.push(N.fulfilled, N.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const S = [rf.bind(this), void 0];
      for (S.unshift(...l), S.push(...m), h = S.length, u = Promise.resolve(r); f < h; )
        u = u.then(S[f++], S[f++]);
      return u;
    }
    h = l.length;
    let v = r;
    for (; f < h; ) {
      const S = l[f++], N = l[f++];
      try {
        v = S(v);
      } catch (F) {
        N.call(this, F);
        break;
      }
    }
    try {
      u = rf.call(this, v);
    } catch (S) {
      return Promise.reject(S);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = fi(this.defaults, n);
    const r = Fb(n.baseURL, n.url, n.allowAbsoluteUrls);
    return Sb(r, n.params, n.paramsSerializer);
  }
};
ge.forEach(["delete", "get", "head", "options"], function(n) {
  di.prototype[n] = function(r, i) {
    return this.request(fi(i || {}, {
      method: n,
      url: r,
      data: (i || {}).data
    }));
  };
});
ge.forEach(["post", "put", "patch"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(fi(l || {}, {
        method: n,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: s
      }));
    };
  }
  di.prototype[n] = r(), di.prototype[n + "Form"] = r(!0);
});
let SN = class Db {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new zi(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new Db(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function NN(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function jN(e) {
  return ge.isObject(e) && e.isAxiosError === !0;
}
const qu = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(qu).forEach(([e, n]) => {
  qu[n] = e;
});
function Rb(e) {
  const n = new di(e), r = ub(di.prototype.request, n);
  return ge.extend(r, di.prototype, n, { allOwnKeys: !0 }), ge.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return Rb(fi(e, a));
  }, r;
}
const ut = Rb(eo);
ut.Axios = di;
ut.CanceledError = zi;
ut.CancelToken = SN;
ut.isCancel = wb;
ut.VERSION = $b;
ut.toFormData = Ts;
ut.AxiosError = Fn;
ut.Cancel = ut.CanceledError;
ut.all = function(n) {
  return Promise.all(n);
};
ut.spread = NN;
ut.isAxiosError = jN;
ut.mergeConfig = fi;
ut.AxiosHeaders = Ht;
ut.formToJSON = (e) => jb(ge.isHTMLForm(e) ? new FormData(e) : e);
ut.getAdapter = Tb.getAdapter;
ut.HttpStatusCode = qu;
ut.default = ut;
const {
  Axios: Z4,
  AxiosError: eM,
  CanceledError: nM,
  isCancel: tM,
  CancelToken: rM,
  VERSION: iM,
  all: aM,
  Cancel: oM,
  isAxiosError: wN,
  spread: sM,
  toFormData: lM,
  AxiosHeaders: cM,
  HttpStatusCode: dM,
  formToJSON: uM,
  getAdapter: mM,
  mergeConfig: pM
} = ut;
class CN {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const of = new CN();
function FN(e, n) {
  return sf(e), sf(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function sf(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const IN = Object.prototype.toString;
function EN(e, n) {
  return IN.call(e) === `[object ${n}]`;
}
function TN(e) {
  return EN(e, "Object");
}
function $N(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const Da = "8.36.0", Mr = globalThis;
function Im(e, n, r) {
  const i = r || Mr, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[Da] = a[Da] || {};
  return o[e] || (o[e] = n());
}
const Ob = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, DN = "Sentry Logger ", lf = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], cf = {};
function Pb(e) {
  if (!("console" in Mr))
    return e();
  const n = Mr.console, r = {}, i = Object.keys(cf);
  i.forEach((a) => {
    const o = cf[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function RN() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Ob ? lf.forEach((r) => {
    n[r] = (...i) => {
      e && Pb(() => {
        Mr.console[r](`${DN}[${r}]:`, ...i);
      });
    };
  }) : lf.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const Ho = Im("logger", RN);
function ON(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Ob && Ho.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const Ab = 1e3;
function Em() {
  return Date.now() / Ab;
}
function PN() {
  const { performance: e } = Mr;
  if (!e || !e.now)
    return Em;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / Ab;
}
const AN = PN();
(() => {
  const { performance: e } = Mr;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function Ii() {
  const e = Mr, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function df() {
  return {
    traceId: Ii(),
    spanId: Ii().substring(16)
  };
}
function Tm() {
  return $m(Mr), Mr;
}
function $m(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || Da, n[Da] = n[Da] || {};
}
function LN(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || AN(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : Ii()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Hu = "_sentrySpan";
function uf(e, n) {
  n ? ON(e, Hu, n) : delete e[Hu];
}
function mf(e) {
  return e[Hu];
}
const VN = 100;
class Dm {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = df();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Dm();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, uf(n, mf(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && LN(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof Oi ? [r.getScopeData(), r.getRequestSession()] : TN(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, uf(this, void 0), this._attachments = [], this._propagationContext = df(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : VN;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Em(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: mf(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : Ii();
    if (!this._client)
      return Ho.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : Ii();
    if (!this._client)
      return Ho.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : Ii();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (Ho.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const Oi = Dm;
function zN() {
  return Im("defaultCurrentScope", () => new Oi());
}
function UN() {
  return Im("defaultIsolationScope", () => new Oi());
}
class MN {
  constructor(n, r) {
    let i;
    n ? i = n : i = new Oi();
    let a;
    r ? a = r : a = new Oi(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return $N(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Pi() {
  const e = Tm(), n = $m(e);
  return n.stack = n.stack || new MN(zN(), UN());
}
function BN(e) {
  return Pi().withScope(e);
}
function qN(e, n) {
  const r = Pi();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function pf(e) {
  return Pi().withScope(() => e(Pi().getIsolationScope()));
}
function HN() {
  return {
    withIsolationScope: pf,
    withScope: BN,
    withSetScope: qN,
    withSetIsolationScope: (e, n) => pf(n),
    getCurrentScope: () => Pi().getScope(),
    getIsolationScope: () => Pi().getIsolationScope()
  };
}
function Lb(e) {
  const n = $m(e);
  return n.acs ? n.acs : HN();
}
function Rm() {
  const e = Tm();
  return Lb(e).getCurrentScope();
}
function Vb() {
  const e = Tm();
  return Lb(e).getIsolationScope();
}
function WN() {
  return Rm().getClient();
}
function KN(e) {
  if (e)
    return GN(e) ? { captureContext: e } : JN(e) ? {
      captureContext: e
    } : e;
}
function GN(e) {
  return e instanceof Oi || typeof e == "function";
}
const YN = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function JN(e) {
  return Object.keys(e).some((n) => YN.includes(n));
}
function ff(e, n) {
  return Rm().captureException(e, KN(n));
}
function QN(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return Rm().captureMessage(e, r, i);
}
function XN(e, n) {
  Vb().setContext(e, n);
}
const ZN = 100;
function ti(e, n) {
  const r = WN(), i = Vb();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = ZN } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Em(), ...e }, d = a ? Pb(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var Ha;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Ha || (Ha = {}));
function Ei(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const ej = qa.backendDomain ? {
  "backend-domain": qa.backendDomain
} : void 0;
function Wo() {
  const e = new URLSearchParams({
    noToken: "true",
    ...ej
  }).toString();
  document.location.href = `${qa.url.logIn}?${e}`;
}
const Xs = "authData", Zs = 30, nj = 600, el = 5;
class tj {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= el || this.clientServerTimeDiff <= -el ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + nj, a = Ei(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > el) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(Xs, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(Xs), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(Xs);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - Zs;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = Ei(n), i = r.exp - Zs;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Zs - this.estimatedServerTime()) * 1e3;
  }
}
const bt = new tj();
async function rj(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? Ei(o).exp : "None", l = await Ds.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? Ei(m).exp : "None", h = u ? Ei(u).exp : "None", v = typeof s == "number" ? d - s : "Unknown", S = typeof f == "number" ? d - f : "Unknown", N = typeof h == "number" ? d - h : "Unknown", F = e.response.headers["x-dixa-rid"];
      XN("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: v,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: S,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: N,
        xDixaRid: F,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    QN("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: Ha.Platform,
        domain: n
      }
    });
  }
}
const nl = /* @__PURE__ */ new Map(), ij = 3;
function aj(e) {
  e.interceptors.response.use((n) => (nl.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case Wu.Unauthorized:
          if (!Ds.isRefreshTokenExpired() && n.config) {
            ti({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = nl.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= ij)
              return nl.set(n.config.url, i + 1), e(n.config);
          }
          rj(n), console.error("401 unauthorized interceptor"), Wo();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const zb = ut.create();
aj(zb);
const Pr = console.log;
async function hf(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class oj extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function sj(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const lj = 5;
class cj {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      bt.setAuthData(r);
    else {
      const i = bt.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new oj("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = bt.getAccessToken();
    if (!n)
      return {};
    const r = Ei(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return bt.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = bt.getAuthData();
    return r ? bt.isAccessTokenExpired() ? (ti({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && bt.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return bt.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return bt.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return bt.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = bt.getAuthData();
    return n ? bt.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!of.isElectron())
      return !0;
    const n = await of.getVersion();
    return FN(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = lj) {
    try {
      return await zb.post(`${qa.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Pr("AUTH", "Network connection offline - waiting..."), ti({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await hf(5);
    n && (Pr("AUTH", "Network connection restored"), ti({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = sj(this.retryCount);
    return Pr("AUTH", `Retrying in ${i} seconds`), await hf(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (bt.isRefreshTokenExpired(r))
      return Pr("AUTH", "Refresh token expired"), ti({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), bt.removeAuthData(), Wo(), null;
    if (wN(n)) {
      if (n.message === "timeout exceeded")
        return Pr("AUTH", "Timeout exceeded"), ti({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Pr("AUTH", "Network error"), ti({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Pr("AUTH", "Refresh token invalid (401)"), bt.removeAuthData(), Wo(), null;
      ff(n, {
        level: "error",
        tags: {
          team: Ha.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Pr("AUTH", "Retries exhausted, logging out"), ff(n, {
      level: "error",
      tags: {
        team: Ha.Platform,
        errorSource: "authManager.refresh"
      }
    }), bt.removeAuthData(), Wo(), null) : (Pr("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return bt.accessTokenExpiresInMs();
  }
}
const Ds = new cj();
var Wu;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Wu || (Wu = {}));
const dj = new Nm((e, n) => new cb((r) => {
  Ds.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), uj = new Nm(
  (e, n) => new cb((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Ds.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...mS(qa.url.partnerIntegrations) && d?.access_token && pS(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), mj = new AbortController(), Ub = (e) => new AS({
  queryDeduplication: !1,
  cache: new LS(),
  link: Nm.from([
    dj,
    uj,
    VS({
      uri: `${e}/graphql`,
      fetch: HS,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: mj.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), pj = ({
  configuration: e,
  children: n
}) => {
  const r = et(
    () => Ub(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Ue.jsx(zS, { client: r, children: n });
};
function fj() {
  try {
    return US(), !0;
  } catch {
    return !1;
  }
}
const hj = ({
  configuration: e,
  children: n
}) => fj() ? n : /* @__PURE__ */ Ue.jsx(pj, { configuration: e, children: n }), yj = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Ue.jsx(MS, { children: (o) => /* @__PURE__ */ Ue.jsx(
  fS,
  {
    value: {
      useMutation: kS(e, n),
      useQuery: gS(e, n),
      useLazyQuery: yS(e, n),
      executeQuery: hS(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), Mb = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Ue.jsx(hj, { configuration: r, children: s ? /* @__PURE__ */ Ue.jsx(
    yj,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, gj = Qr`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        settings {
          key
          value
        }
      }
    }
  }
`;
function kj(e) {
  const [n, r] = se([]), [i, a] = se(!1);
  return qe(() => {
    a(!0), Ub(e).query({
      query: gj
    }).then(({ data: o }) => {
      r(o?.Management?.widgetConfigurations), a(!1);
    }).catch(() => a(!1));
  }, [e]), {
    isLoading: i,
    widgets: n
  };
}
const Bb = ({
  headline: e,
  text: n,
  children: r,
  onConfirm: i,
  onCancel: a,
  confirmLabel: o,
  cancelLabel: s = "Cancel",
  confirmVariant: l = "primary",
  cancelVariant: d = "secondary",
  isOpen: m,
  setIsOpen: u,
  showOnClose: f = !1
}) => /* @__PURE__ */ Ue.jsxs(
  gt,
  {
    isOpen: m,
    onClose: () => {
      a && a(), u(!1);
    },
    children: [
      /* @__PURE__ */ Ue.jsx(
        kt,
        {
          title: e,
          onClose: f ? a : void 0
        }
      ),
      /* @__PURE__ */ Ue.jsxs(vt, { children: [
        n && /* @__PURE__ */ Ue.jsx("div", { style: { width: "600px" }, children: n }),
        r
      ] }),
      /* @__PURE__ */ Ue.jsx(
        wt,
        {
          confirmOnClick: i ? () => {
            i(), u(!1);
          } : void 0,
          cancelOnClick: () => {
            a && a(), u(!1);
          },
          confirmName: o,
          cancelName: s,
          confirmProps: { variant: l },
          cancelProps: { variant: d }
        }
      )
    ]
  }
);
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var tl = { exports: {} }, Qi = {}, yf;
function vj() {
  if (yf) return Qi;
  yf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Qi.Fragment = r, Qi.jsx = s, Qi.jsxs = s, Qi;
}
var mo = {}, gf;
function bj() {
  return gf || (gf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var E = !1, j = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || E || j || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function W(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return W(c) + ".Consumer";
          case s:
            var p = t;
            return W(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, ke, ue, ce, he, H, be, Ce;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, ue = console.info, ce = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: ke
            }),
            info: K({}, t, {
              value: ue
            }),
            warn: K({}, t, {
              value: ce
            }),
            error: K({}, t, {
              value: he
            }),
            group: K({}, t, {
              value: H
            }),
            groupCollapsed: K({}, t, {
              value: be
            }),
            groupEnd: K({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              y = te;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), T = y.stack.split(`
`), V = x.length - 1, z = T.length - 1; V >= 1 && z >= 0 && x[V] !== T[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== T[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== T[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var C in t)
          if (L(t, C)) {
            var x = void 0;
            try {
              if (typeof t[C] != "function") {
                var T = Error((y || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              x = t[C](c, C, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, C, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, C) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, C = {}, x = null, T = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (T = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (x || T) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(C, z), T && fn(C, z);
        }
        return pn(t, x, T, R, y, B.current, C);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), C; !(C = L.next()).done; )
              an(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var C = ee(t);
        if (!C) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Hn();
          T ? x += T : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    mo.Fragment = i, mo.jsx = Bn, mo.jsxs = qn;
  })()), mo;
}
var kf;
function _j() {
  return kf || (kf = 1, process.env.NODE_ENV === "production" ? tl.exports = vj() : tl.exports = bj()), tl.exports;
}
var ae = _j();
const xj = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, Sj = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, Nj = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": xj,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": Sj
};
function qb(e) {
  return Nj[e] ?? {};
}
const jj = qb(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), wj = qb(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), Cj = "_copyIcon_1wjfs_48", Fj = "_list_1wjfs_53", Ij = "_listItem_1wjfs_63", Ej = "_collapsible_1wjfs_72", Tj = "_collapsibleIsOpen_1wjfs_80", $j = "_collapsibleHeader_1wjfs_83", Dj = "_collapsibleIconTrue_1wjfs_86", Rj = "_collapsibleIconFalse_1wjfs_89", Dn = {
  copyIcon: Cj,
  list: Fj,
  listItem: Ij,
  collapsible: Ej,
  collapsibleIsOpen: Tj,
  collapsibleHeader: $j,
  collapsibleIconTrue: Dj,
  collapsibleIconFalse: Rj
}, Oj = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ ae.jsxs(
    b,
    {
      className: dt(Dn.collapsible, {
        [Dn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ae.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Dn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ ae.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ae.jsxs(He, { className: Dn.list, children: [
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Pn(d).format(ct) })
          ] }) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Pn(m).format(ct) })
          ] }) })
        ] })
      ]
    }
  );
}, Pj = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ ae.jsx(Un, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ae.jsx(Oj, { app: r, openByDefault: i === 0 }, i))
  ] });
}, Aj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ ae.jsx(He, { className: Dn.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ ae.jsx(
      He.Text,
      {
        variant: "dense",
        className: Dn.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: i }),
          ib(a)
        ] })
      },
      o
    )) })
  ] }) });
}, Lj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ ae.jsx(He, { className: Dn.list, children: r.map((a, o) => /* @__PURE__ */ ae.jsx(
      He.Text,
      {
        variant: "dense",
        className: Dn.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ae.jsx(
            Ke,
            {
              content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsx(b, { children: `First ${Pn(a?.first).format(
                  ct
                )}` }),
                /* @__PURE__ */ ae.jsx(b, { children: `Last ${Pn(a?.last).format(
                  ct
                )}` })
              ] }),
              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, as = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ ae.jsx(Ke, { content: n ? null : l(), children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(me, { size: 14, name: o(), color: s() }) }) });
}, Vj = "_wrapper_1xucg_1", zj = "_externalLink_1xucg_7", rl = {
  wrapper: Vj,
  externalLink: zj
}, Uj = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Xt(), { isCopied: i, copy: a } = Xt(), { isCopied: o, copy: s } = Xt(), { isCopied: l, copy: d } = Xt(), { isCopied: m, copy: u } = Xt();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: v,
    last_name: S,
    home_city: N,
    country: F,
    email: I,
    phone: g,
    dob: q,
    created_at: E,
    email_subscribe: j,
    push_subscribe: $
  } = e, U = 14, Z = `${v || ""} ${S || ""}`.trim() || "A customer has no name", Q = `${N ? `${N} /` : ""} ${F || ""}`.trim(), ee = q ? Pn(q).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ ae.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ae.jsxs(b, { className: rl.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: rl.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-2", children: Z }),
          ee && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    E && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: Pn(E).format(ct) })
    ] }),
    Q && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: U, name: "map-pin" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: Q })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy location", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        me,
        {
          size: U,
          name: o ? "done" : "copy",
          onClick: () => s(Q),
          className: Dn.copyIcon
        }
      ) }) })
    ] }),
    I && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: U, name: "mail" }),
        /* @__PURE__ */ ae.jsx("span", { className: rl.externalLink, children: I })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy email", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        me,
        {
          size: U,
          name: n ? "done" : "copy",
          onClick: () => r(I),
          className: Dn.copyIcon
        }
      ) }) })
    ] }),
    g && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: U, name: "phone" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: g })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        me,
        {
          size: U,
          name: i ? "done" : "copy",
          onClick: () => a(g),
          className: Dn.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: U, name: "user" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ ae.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy Braze ID", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        me,
        {
          size: U,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: Dn.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: U, name: "tag" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ ae.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy External ID", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        me,
        {
          size: U,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: Dn.copyIcon
        }
      ) }) })
    ] }),
    j && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: U, name: "sync" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(as, { state: j })
    ] }),
    $ && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: U, name: "bell" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(as, { isPush: !0, state: $ })
    ] })
  ] }) });
}, Mj = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ ae.jsxs(
    b,
    {
      className: dt(Dn.collapsible, {
        [Dn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ae.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Dn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ ae.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ae.jsxs(He, { className: Dn.list, children: [
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ ae.jsx(
              me,
              {
                size: a,
                className: dt({
                  [Dn.collapsibleIconTrue]: d,
                  [Dn.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ke, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(Ke, { content: "For iOS", children: /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, Bj = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ ae.jsx(Un, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ae.jsx(Mj, { device: r, openByDefault: i === 0 }, i))
  ] });
}, Xi = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, po = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = kn(), { useMutation: a } = mn(), [o, s] = se(!1), [l] = a(
    wj,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: Xi[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ ae.jsx(Ke, { content: Xi[n].tooltipContent, children: /* @__PURE__ */ ae.jsx(
    Wn,
    {
      variant: "secondary",
      color: Xi[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ ae.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(
          as,
          {
            noTooltip: !0,
            state: Xi[n].parameter
          }
        ),
        Xi[n].label
      ] })
    }
  ) });
}, qj = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ ae.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ ae.jsx(He, { className: Dn.list, children: /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: 14, name: "sync" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(as, { state: a })
    ] }) }) }),
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
        /* @__PURE__ */ ae.jsx(
          po,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ ae.jsx(
          po,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ ae.jsx(
        po,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ ae.jsx(
        po,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, Hj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ ae.jsx(He, { className: Dn.list, children: r.map((a, o) => /* @__PURE__ */ ae.jsx(
      He.Text,
      {
        variant: "dense",
        className: Dn.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ae.jsx(
            Ke,
            {
              content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsx(b, { children: `First ${Pn(a?.first).format(
                  ct
                )}` }),
                /* @__PURE__ */ ae.jsx(b, { children: `Last ${Pn(a?.last).format(
                  ct
                )}` })
              ] }),
              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Wj = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = kn(), { useMutation: i } = mn(), [a, o] = se(), [s, l] = se(!1), [d, m] = se(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, v = n.updateEmailSubscriptionState ?? !1, S = n.displayCustomAttributes ?? !1, N = n.displayCustomEvents ?? !1, F = n.displayPuchases ?? !1, I = n.displayDevices ?? !1, g = n.displayApps ?? !1, q = !h && !v && !S && !N && !F, [E, { error: j }] = i(
    jj,
    {
      onError: () => {
      },
      onCompleted: (U) => {
        const Z = U?.Braze?.exportUserDetails?.users?.[0];
        Z ? (o(Z), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), $ = async () => {
    u || f ? await E({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (qe(() => {
    async function U() {
      m(!0), await $();
    }
    U().finally(() => m(!1));
  }, [u, f]), j) {
    const U = j.graphQLErrors;
    return km({ errors: U }) ? /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : vm({ errors: U }) ? /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ae.jsx(wn, { error: j });
  }
  return d ? /* @__PURE__ */ ae.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ae.jsx(un, {}) }) : q ? /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ ae.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ae.jsx(Uj, { customerDetails: a }),
        v && !!a && /* @__PURE__ */ ae.jsx(
          qj,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await $()
          }
        ),
        S && !!a && /* @__PURE__ */ ae.jsx(Aj, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ ae.jsx(Lj, { customerDetails: a }),
        F && !!a && /* @__PURE__ */ ae.jsx(Hj, { customerDetails: a }),
        I && !!a && /* @__PURE__ */ ae.jsx(Bj, { devices: a?.devices }),
        g && !!a && /* @__PURE__ */ ae.jsx(Pj, { apps: a?.apps })
      ]
    }
  );
}, Kj = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => rb(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function Gj() {
  var e = Fi(!1), n = at(function() {
    return e.current;
  }, []);
  return qe(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var Yj = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = at(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, Jj = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, vf = function(e) {
  return NS(Jj, e);
}, il, bf;
function Qj() {
  return bf || (bf = 1, il = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), il;
}
var al, _f;
function Xj() {
  if (_f) return al;
  _f = 1;
  var e = Qj(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, v = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(N) {
        if (N.stopPropagation(), s.format)
          if (N.preventDefault(), typeof N.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var F = n[s.format] || n.default;
            window.clipboardData.setData(F, o);
          } else
            N.clipboardData.clearData(), N.clipboardData.setData(s.format, o);
        s.onCopy && (N.preventDefault(), s.onCopy(N.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var S = document.execCommand("copy");
      if (!S)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (N) {
      l && console.error("unable to copy using execCommand: ", N), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (F) {
        l && console.error("unable to copy using clipboardData: ", F), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return v;
  }
  return al = a, al;
}
var Zj = Xj();
const ew = /* @__PURE__ */ jm(Zj);
var Hb = function() {
  var e = Gj(), n = Yj({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = at(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = ew(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function nw(e, n) {
  var r = Fi(!1), i = Fi(), a = Fi(e), o = at(function() {
    return r.current;
  }, []), s = at(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = at(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return qe(function() {
    a.current = e;
  }, [e]), qe(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function Ui(e, n, r) {
  r === void 0 && (r = []);
  var i = nw(e, n), a = i[0], o = i[1], s = i[2];
  return qe(s, r), [a, o];
}
var tw = function(e) {
  qe(e, []);
}, rw = function(e, n) {
  var r = Fi(function() {
  });
  qe(function() {
    r.current = e;
  }), qe(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, iw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = et(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return Gs(Gs({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = WS(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = Gs({ get: at(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, aw = function(e) {
  var n = Fi(e);
  n.current = e, tw(function() {
    return function() {
      return n.current();
    };
  });
}, no = (e) => e.type === "checkbox", si = (e) => e instanceof Date, Dt = (e) => e == null;
const Wb = (e) => typeof e == "object";
var ot = (e) => !Dt(e) && !Array.isArray(e) && Wb(e) && !si(e), Kb = (e) => ot(e) && e.target ? no(e.target) ? e.target.checked : e.target.value : e, ow = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Gb = (e, n) => e.has(ow(n)), sw = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ot(n) && n.hasOwnProperty("isPrototypeOf");
}, Om = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function xt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Om && (e instanceof Blob || i)) && (r || ot(e)))
    if (n = r ? [] : {}, !r && !sw(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = xt(e[a]));
  else
    return e;
  return n;
}
var Rs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], tt = (e) => e === void 0, Ye = (e, n, r) => {
  if (!n || !ot(e))
    return r;
  const i = Rs(n.split(/[,[\].]+?/)).reduce((a, o) => Dt(a) ? a : a[o], e);
  return tt(i) || i === e ? tt(e[n]) ? r : e[n] : i;
}, Yt = (e) => typeof e == "boolean", Pm = (e) => /^\w*$/.test(e), Yb = (e) => Rs(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Kn = (e, n, r) => {
  let i = -1;
  const a = Pm(n) ? [n] : Yb(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = ot(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const os = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, mr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Ar = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Jb = Se.createContext(null), Rr = () => Se.useContext(Jb), Am = (e) => {
  const { children: n, ...r } = e;
  return Se.createElement(Jb.Provider, { value: r }, n);
};
var Qb = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== mr.all && (n._proxyFormState[s] = !i || mr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function lw(e) {
  const n = Rr(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => Qb(s, r, d.current, !1), [s, r]);
}
var Ir = (e) => typeof e == "string", Xb = (e, n, r, i, a) => Ir(e) ? (i && n.watch.add(e), Ye(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ye(r, o))) : (i && (n.watchAll = !0), r);
function Ko(e) {
  const n = Rr(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(Xb(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function Lm(e) {
  const n = Rr(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Gb(a._names.array, r), l = Ko({
    control: a,
    name: r,
    defaultValue: Ye(a._formValues, r, Ye(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = lw({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Yt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ye(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ye(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ye(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ye(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Ye(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((F) => u.current.onChange({
    target: {
      value: Kb(F),
      name: r
    },
    type: os.CHANGE
  }), [r]), v = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Ye(a._formValues, r),
      name: r
    },
    type: os.BLUR
  }), [r, a._formValues]), S = Se.useCallback((F) => {
    const I = Ye(a._fields, r);
    I && F && (I._f.ref = {
      focus: () => F.focus(),
      select: () => F.select(),
      setCustomValidity: (g) => F.setCustomValidity(g),
      reportValidity: () => F.reportValidity()
    });
  }, [a._fields, r]), N = Se.useMemo(() => ({
    name: r,
    value: l,
    ...Yt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: S
  }), [r, i, d.disabled, h, v, S, l]);
  return Se.useEffect(() => {
    const F = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Yt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const I = (g, q) => {
      const E = Ye(a._fields, g);
      E && E._f && (E._f.mount = q);
    };
    if (I(r, !0), F) {
      const g = xt(Ye(a._options.defaultValues, r));
      Kn(a._defaultValues, r, g), tt(Ye(a._formValues, r)) && Kn(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? F && !a._state.action : F) ? a.unregister(r) : I(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: N,
    formState: d,
    fieldState: f
  }), [N, d, f]);
}
const Pt = (e) => e.render(Lm(e));
var cw = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ra = (e) => Array.isArray(e) ? e : [e], xf = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Ku = (e) => Dt(e) || !Wb(e);
function Gr(e, n) {
  if (Ku(e) || Ku(n))
    return e === n;
  if (si(e) && si(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (si(o) && si(s) || ot(o) && ot(s) || Array.isArray(o) && Array.isArray(s) ? !Gr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Et = (e) => ot(e) && !Object.keys(e).length, Vm = (e) => e.type === "file", pr = (e) => typeof e == "function", ss = (e) => {
  if (!Om)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, Zb = (e) => e.type === "select-multiple", zm = (e) => e.type === "radio", dw = (e) => zm(e) || no(e), ol = (e) => ss(e) && e.isConnected;
function uw(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = tt(e) ? i++ : e[n[i++]];
  return e;
}
function mw(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !tt(e[n]))
      return !1;
  return !0;
}
function ft(e, n) {
  const r = Array.isArray(n) ? n : Pm(n) ? [n] : Yb(n), i = r.length === 1 ? e : uw(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (ot(i) && Et(i) || Array.isArray(i) && mw(i)) && ft(e, r.slice(0, -1)), e;
}
var e_ = (e) => {
  for (const n in e)
    if (pr(e[n]))
      return !0;
  return !1;
};
function ls(e, n = {}) {
  const r = Array.isArray(e);
  if (ot(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || ot(e[i]) && !e_(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, ls(e[i], n[i])) : Dt(e[i]) || (n[i] = !0);
  return n;
}
function n_(e, n, r) {
  const i = Array.isArray(e);
  if (ot(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ot(e[a]) && !e_(e[a]) ? tt(n) || Ku(r[a]) ? r[a] = Array.isArray(e[a]) ? ls(e[a], []) : { ...ls(e[a]) } : n_(e[a], Dt(n) ? {} : n[a], r[a]) : r[a] = !Gr(e[a], n[a]);
  return r;
}
var Zi = (e, n) => n_(e, n, ls(n));
const Sf = {
  value: !1,
  isValid: !1
}, Nf = { value: !0, isValid: !0 };
var t_ = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !tt(e[0].attributes.value) ? tt(e[0].value) || e[0].value === "" ? Nf : { value: e[0].value, isValid: !0 } : Nf
    ) : Sf;
  }
  return Sf;
}, r_ = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => tt(e) ? e : n ? e === "" ? NaN : e && +e : r && Ir(e) ? new Date(e) : i ? i(e) : e;
const jf = {
  isValid: !1,
  value: null
};
var i_ = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, jf) : jf;
function wf(e) {
  const n = e.ref;
  return Vm(n) ? n.files : zm(n) ? i_(e.refs).value : Zb(n) ? [...n.selectedOptions].map(({ value: r }) => r) : no(n) ? t_(e.refs).value : r_(tt(n.value) ? e.ref.value : n.value, e);
}
var pw = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Ye(n, o);
    s && Kn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, cs = (e) => e instanceof RegExp, ea = (e) => tt(e) ? e : cs(e) ? e.source : ot(e) ? cs(e.value) ? e.value.source : e.value : e, Cf = (e) => ({
  isOnSubmit: !e || e === mr.onSubmit,
  isOnBlur: e === mr.onBlur,
  isOnChange: e === mr.onChange,
  isOnAll: e === mr.all,
  isOnTouch: e === mr.onTouched
});
const Ff = "AsyncFunction";
var fw = (e) => !!e && !!e.validate && !!(pr(e.validate) && e.validate.constructor.name === Ff || ot(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Ff)), hw = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), If = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Oa = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Ye(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Oa(l, n))
          break;
      } else if (ot(l) && Oa(l, n))
        break;
    }
  }
};
function Ef(e, n, r) {
  const i = Ye(e, r);
  if (i || Pm(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ye(n, o), l = Ye(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var yw = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Et(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || mr.all));
}, gw = (e, n, r) => !e || !n || e === n || Ra(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), kw = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, vw = (e, n) => !Rs(Ye(e, n)).length && ft(e, n), bw = (e, n, r) => {
  const i = Ra(Ye(e, r));
  return Kn(i, "root", n[r]), Kn(e, r, i), e;
}, Go = (e) => Ir(e);
function Tf(e, n, r = "validate") {
  if (Go(e) || Array.isArray(e) && e.every(Go) || Yt(e) && !e)
    return {
      type: r,
      message: Go(e) ? e : "",
      ref: n
    };
}
var vi = (e) => ot(e) && !cs(e) ? e : {
  value: e,
  message: ""
}, $f = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: S, name: N, valueAsNumber: F, mount: I } = e._f, g = Ye(r, N);
  if (!I || n.has(N))
    return {};
  const q = l ? l[0] : s, E = (W) => {
    a && q.reportValidity && (q.setCustomValidity(Yt(W) ? "" : W || ""), q.reportValidity());
  }, j = {}, $ = zm(s), U = no(s), Z = $ || U, Q = (F || Vm(s)) && tt(s.value) && tt(g) || ss(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, ee = cw.bind(null, N, i, j), J = (W, P, K, ne = Ar.maxLength, ke = Ar.minLength) => {
    const ue = W ? P : K;
    j[N] = {
      type: W ? ne : ke,
      message: ue,
      ref: s,
      ...ee(W ? ne : ke, ue)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!Z && (Q || Dt(g)) || Yt(g) && !g || U && !t_(l).isValid || $ && !i_(l).isValid)) {
    const { value: W, message: P } = Go(d) ? { value: !!d, message: d } : vi(d);
    if (W && (j[N] = {
      type: Ar.required,
      message: P,
      ref: q,
      ...ee(Ar.required, P)
    }, !i))
      return E(P), j;
  }
  if (!Q && (!Dt(f) || !Dt(h))) {
    let W, P;
    const K = vi(h), ne = vi(f);
    if (!Dt(g) && !isNaN(g)) {
      const ke = s.valueAsNumber || g && +g;
      Dt(K.value) || (W = ke > K.value), Dt(ne.value) || (P = ke < ne.value);
    } else {
      const ke = s.valueAsDate || new Date(g), ue = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), ce = s.type == "time", he = s.type == "week";
      Ir(K.value) && g && (W = ce ? ue(g) > ue(K.value) : he ? g > K.value : ke > new Date(K.value)), Ir(ne.value) && g && (P = ce ? ue(g) < ue(ne.value) : he ? g < ne.value : ke < new Date(ne.value));
    }
    if ((W || P) && (J(!!W, K.message, ne.message, Ar.max, Ar.min), !i))
      return E(j[N].message), j;
  }
  if ((m || u) && !Q && (Ir(g) || o && Array.isArray(g))) {
    const W = vi(m), P = vi(u), K = !Dt(W.value) && g.length > +W.value, ne = !Dt(P.value) && g.length < +P.value;
    if ((K || ne) && (J(K, W.message, P.message), !i))
      return E(j[N].message), j;
  }
  if (v && !Q && Ir(g)) {
    const { value: W, message: P } = vi(v);
    if (cs(W) && !g.match(W) && (j[N] = {
      type: Ar.pattern,
      message: P,
      ref: s,
      ...ee(Ar.pattern, P)
    }, !i))
      return E(P), j;
  }
  if (S) {
    if (pr(S)) {
      const W = await S(g, r), P = Tf(W, q);
      if (P && (j[N] = {
        ...P,
        ...ee(Ar.validate, P.message)
      }, !i))
        return E(P.message), j;
    } else if (ot(S)) {
      let W = {};
      for (const P in S) {
        if (!Et(W) && !i)
          break;
        const K = Tf(await S[P](g, r), q, P);
        K && (W = {
          ...K,
          ...ee(P, K.message)
        }, E(K.message), i && (j[N] = W));
      }
      if (!Et(W) && (j[N] = {
        ref: q,
        ...W
      }, !i))
        return j;
    }
  }
  return E(!0), j;
};
const _w = {
  mode: mr.onSubmit,
  reValidateMode: mr.onChange,
  shouldFocusError: !0
};
function xw(e = {}) {
  let n = {
    ..._w,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: pr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ot(n.defaultValues) || ot(n.values) ? xt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : xt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: xf(),
    state: xf()
  }, v = Cf(n.mode), S = Cf(n.reValidateMode), N = n.criteriaMode === mr.all, F = (_) => (D) => {
    clearTimeout(m), m = setTimeout(_, D);
  }, I = async (_) => {
    if (!n.disabled && (u.isValid || f.isValid || _)) {
      const D = n.resolver ? Et((await Q()).errors) : await J(i, !0);
      D !== r.isValid && h.state.next({
        isValid: D
      });
    }
  }, g = (_, D) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((_ || Array.from(l.mount)).forEach((Y) => {
      Y && (D ? Kn(r.validatingFields, Y, D) : ft(r.validatingFields, Y));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Et(r.validatingFields)
    }));
  }, q = (_, D = [], Y, X, O = !0, B = !0) => {
    if (X && Y && !n.disabled) {
      if (s.action = !0, B && Array.isArray(Ye(i, _))) {
        const ie = Y(Ye(i, _), X.argA, X.argB);
        O && Kn(i, _, ie);
      }
      if (B && Array.isArray(Ye(r.errors, _))) {
        const ie = Y(Ye(r.errors, _), X.argA, X.argB);
        O && Kn(r.errors, _, ie), vw(r.errors, _);
      }
      if ((u.touchedFields || f.touchedFields) && B && Array.isArray(Ye(r.touchedFields, _))) {
        const ie = Y(Ye(r.touchedFields, _), X.argA, X.argB);
        O && Kn(r.touchedFields, _, ie);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Zi(a, o)), h.state.next({
        name: _,
        isDirty: P(_, D),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Kn(o, _, D);
  }, E = (_, D) => {
    Kn(r.errors, _, D), h.state.next({
      errors: r.errors
    });
  }, j = (_) => {
    r.errors = _, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, $ = (_, D, Y, X) => {
    const O = Ye(i, _);
    if (O) {
      const B = Ye(o, _, tt(Y) ? Ye(a, _) : Y);
      tt(B) || X && X.defaultChecked || D ? Kn(o, _, D ? B : wf(O._f)) : ke(_, B), s.mount && I();
    }
  }, U = (_, D, Y, X, O) => {
    let B = !1, ie = !1;
    const fe = {
      name: _
    };
    if (!n.disabled) {
      if (!Y || X) {
        (u.isDirty || f.isDirty) && (ie = r.isDirty, r.isDirty = fe.isDirty = P(), B = ie !== fe.isDirty);
        const _e = Gr(Ye(a, _), D);
        ie = !!Ye(r.dirtyFields, _), _e ? ft(r.dirtyFields, _) : Kn(r.dirtyFields, _, !0), fe.dirtyFields = r.dirtyFields, B = B || (u.dirtyFields || f.dirtyFields) && ie !== !_e;
      }
      if (Y) {
        const _e = Ye(r.touchedFields, _);
        _e || (Kn(r.touchedFields, _, Y), fe.touchedFields = r.touchedFields, B = B || (u.touchedFields || f.touchedFields) && _e !== Y);
      }
      B && O && h.state.next(fe);
    }
    return B ? fe : {};
  }, Z = (_, D, Y, X) => {
    const O = Ye(r.errors, _), B = (u.isValid || f.isValid) && Yt(D) && r.isValid !== D;
    if (n.delayError && Y ? (d = F(() => E(_, Y)), d(n.delayError)) : (clearTimeout(m), d = null, Y ? Kn(r.errors, _, Y) : ft(r.errors, _)), (Y ? !Gr(O, Y) : O) || !Et(X) || B) {
      const ie = {
        ...X,
        ...B && Yt(D) ? { isValid: D } : {},
        errors: r.errors,
        name: _
      };
      r = {
        ...r,
        ...ie
      }, h.state.next(ie);
    }
  }, Q = async (_) => {
    g(_, !0);
    const D = await n.resolver(o, n.context, pw(_ || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(_), D;
  }, ee = async (_) => {
    const { errors: D } = await Q(_);
    if (_)
      for (const Y of _) {
        const X = Ye(D, Y);
        X ? Kn(r.errors, Y, X) : ft(r.errors, Y);
      }
    else
      r.errors = D;
    return D;
  }, J = async (_, D, Y = {
    valid: !0
  }) => {
    for (const X in _) {
      const O = _[X];
      if (O) {
        const { _f: B, ...ie } = O;
        if (B) {
          const fe = l.array.has(B.name), _e = O._f && fw(O._f);
          _e && u.validatingFields && g([X], !0);
          const en = await $f(O, l.disabled, o, N, n.shouldUseNativeValidation && !D, fe);
          if (_e && u.validatingFields && g([X]), en[B.name] && (Y.valid = !1, D))
            break;
          !D && (Ye(en, B.name) ? fe ? bw(r.errors, en, B.name) : Kn(r.errors, B.name, en[B.name]) : ft(r.errors, B.name));
        }
        !Et(ie) && await J(ie, D, Y);
      }
    }
    return Y.valid;
  }, W = () => {
    for (const _ of l.unMount) {
      const D = Ye(i, _);
      D && (D._f.refs ? D._f.refs.every((Y) => !ol(Y)) : !ol(D._f.ref)) && Le(_);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (_, D) => !n.disabled && (_ && D && Kn(o, _, D), !Gr(Ce(), a)), K = (_, D, Y) => Xb(_, l, {
    ...s.mount ? o : tt(D) ? a : Ir(_) ? { [_]: D } : D
  }, Y, D), ne = (_) => Rs(Ye(s.mount ? o : a, _, n.shouldUnregister ? Ye(a, _, []) : [])), ke = (_, D, Y = {}) => {
    const X = Ye(i, _);
    let O = D;
    if (X) {
      const B = X._f;
      B && (!B.disabled && Kn(o, _, r_(D, B)), O = ss(B.ref) && Dt(D) ? "" : D, Zb(B.ref) ? [...B.ref.options].forEach((ie) => ie.selected = O.includes(ie.value)) : B.refs ? no(B.ref) ? B.refs.length > 1 ? B.refs.forEach((ie) => (!ie.defaultChecked || !ie.disabled) && (ie.checked = Array.isArray(O) ? !!O.find((fe) => fe === ie.value) : O === ie.value)) : B.refs[0] && (B.refs[0].checked = !!O) : B.refs.forEach((ie) => ie.checked = ie.value === O) : Vm(B.ref) ? B.ref.value = "" : (B.ref.value = O, B.ref.type || h.state.next({
        name: _,
        values: xt(o)
      })));
    }
    (Y.shouldDirty || Y.shouldTouch) && U(_, O, Y.shouldTouch, Y.shouldDirty, !0), Y.shouldValidate && be(_);
  }, ue = (_, D, Y) => {
    for (const X in D) {
      const O = D[X], B = `${_}.${X}`, ie = Ye(i, B);
      (l.array.has(_) || ot(O) || ie && !ie._f) && !si(O) ? ue(B, O, Y) : ke(B, O, Y);
    }
  }, ce = (_, D, Y = {}) => {
    const X = Ye(i, _), O = l.array.has(_), B = xt(D);
    Kn(o, _, B), O ? (h.array.next({
      name: _,
      values: xt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && Y.shouldDirty && h.state.next({
      name: _,
      dirtyFields: Zi(a, o),
      isDirty: P(_, B)
    })) : X && !X._f && !Dt(B) ? ue(_, B, Y) : ke(_, B, Y), If(_, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? _ : void 0,
      values: xt(o)
    });
  }, he = async (_) => {
    s.mount = !0;
    const D = _.target;
    let Y = D.name, X = !0;
    const O = Ye(i, Y), B = (ie) => {
      X = Number.isNaN(ie) || si(ie) && isNaN(ie.getTime()) || Gr(ie, Ye(o, Y, ie));
    };
    if (O) {
      let ie, fe;
      const _e = D.type ? wf(O._f) : Kb(_), en = _.type === os.BLUR || _.type === os.FOCUS_OUT, dn = !hw(O._f) && !n.resolver && !Ye(r.errors, Y) && !O._f.deps || kw(en, Ye(r.touchedFields, Y), r.isSubmitted, S, v), tn = If(Y, l, en);
      Kn(o, Y, _e), en ? (O._f.onBlur && O._f.onBlur(_), d && d(0)) : O._f.onChange && O._f.onChange(_);
      const sn = U(Y, _e, en), fn = !Et(sn) || tn;
      if (!en && h.state.next({
        name: Y,
        type: _.type,
        values: xt(o)
      }), dn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? en && I() : en || I()), fn && h.state.next({ name: Y, ...tn ? {} : sn });
      if (!en && tn && h.state.next({ ...r }), n.resolver) {
        const { errors: pn } = await Q([Y]);
        if (B(_e), X) {
          const yn = Ef(r.errors, i, Y), Xe = Ef(pn, i, yn.name || Y);
          ie = Xe.error, Y = Xe.name, fe = Et(pn);
        }
      } else
        g([Y], !0), ie = (await $f(O, l.disabled, o, N, n.shouldUseNativeValidation))[Y], g([Y]), B(_e), X && (ie ? fe = !1 : (u.isValid || f.isValid) && (fe = await J(i, !0)));
      X && (O._f.deps && be(O._f.deps), Z(Y, fe, ie, sn));
    }
  }, H = (_, D) => {
    if (Ye(r.errors, D) && _.focus)
      return _.focus(), 1;
  }, be = async (_, D = {}) => {
    let Y, X;
    const O = Ra(_);
    if (n.resolver) {
      const B = await ee(tt(_) ? _ : O);
      Y = Et(B), X = _ ? !O.some((ie) => Ye(B, ie)) : Y;
    } else _ ? (X = (await Promise.all(O.map(async (B) => {
      const ie = Ye(i, B);
      return await J(ie && ie._f ? { [B]: ie } : ie);
    }))).every(Boolean), !(!X && !r.isValid) && I()) : X = Y = await J(i);
    return h.state.next({
      ...!Ir(_) || (u.isValid || f.isValid) && Y !== r.isValid ? {} : { name: _ },
      ...n.resolver || !_ ? { isValid: Y } : {},
      errors: r.errors
    }), D.shouldFocus && !X && Oa(i, H, _ ? O : l.mount), X;
  }, Ce = (_) => {
    const D = {
      ...s.mount ? o : a
    };
    return tt(_) ? D : Ir(_) ? Ye(D, _) : _.map((Y) => Ye(D, Y));
  }, G = (_, D) => ({
    invalid: !!Ye((D || r).errors, _),
    isDirty: !!Ye((D || r).dirtyFields, _),
    error: Ye((D || r).errors, _),
    isValidating: !!Ye(r.validatingFields, _),
    isTouched: !!Ye((D || r).touchedFields, _)
  }), ze = (_) => {
    _ && Ra(_).forEach((D) => ft(r.errors, D)), h.state.next({
      errors: _ ? r.errors : {}
    });
  }, Be = (_, D, Y) => {
    const X = (Ye(i, _, { _f: {} })._f || {}).ref, O = Ye(r.errors, _) || {}, { ref: B, message: ie, type: fe, ..._e } = O;
    Kn(r.errors, _, {
      ..._e,
      ...D,
      ref: X
    }), h.state.next({
      name: _,
      errors: r.errors,
      isValid: !1
    }), Y && Y.shouldFocus && X && X.focus && X.focus();
  }, Pe = (_, D) => pr(_) ? h.state.subscribe({
    next: (Y) => _(K(void 0, D), Y)
  }) : K(_, D, !0), Me = (_) => h.state.subscribe({
    next: (D) => {
      gw(_.name, D.name, _.exact) && yw(D, _.formState || u, Ee, _.reRenderRoot) && _.callback({
        values: { ...o },
        ...r,
        ...D
      });
    }
  }).unsubscribe, Ie = (_) => (s.mount = !0, f = {
    ...f,
    ..._.formState
  }, Me({
    ..._,
    formState: f
  })), Le = (_, D = {}) => {
    for (const Y of _ ? Ra(_) : l.mount)
      l.mount.delete(Y), l.array.delete(Y), D.keepValue || (ft(i, Y), ft(o, Y)), !D.keepError && ft(r.errors, Y), !D.keepDirty && ft(r.dirtyFields, Y), !D.keepTouched && ft(r.touchedFields, Y), !D.keepIsValidating && ft(r.validatingFields, Y), !n.shouldUnregister && !D.keepDefaultValue && ft(a, Y);
    h.state.next({
      values: xt(o)
    }), h.state.next({
      ...r,
      ...D.keepDirty ? { isDirty: P() } : {}
    }), !D.keepIsValid && I();
  }, De = ({ disabled: _, name: D }) => {
    (Yt(_) && s.mount || _ || l.disabled.has(D)) && (_ ? l.disabled.add(D) : l.disabled.delete(D));
  }, rn = (_, D = {}) => {
    let Y = Ye(i, _);
    const X = Yt(D.disabled) || Yt(n.disabled);
    return Kn(i, _, {
      ...Y || {},
      _f: {
        ...Y && Y._f ? Y._f : { ref: { name: _ } },
        name: _,
        mount: !0,
        ...D
      }
    }), l.mount.add(_), Y ? De({
      disabled: Yt(D.disabled) ? D.disabled : n.disabled,
      name: _
    }) : $(_, !0, D.value), {
      ...X ? { disabled: D.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!D.required,
        min: ea(D.min),
        max: ea(D.max),
        minLength: ea(D.minLength),
        maxLength: ea(D.maxLength),
        pattern: ea(D.pattern)
      } : {},
      name: _,
      onChange: he,
      onBlur: he,
      ref: (O) => {
        if (O) {
          rn(_, D), Y = Ye(i, _);
          const B = tt(O.value) && O.querySelectorAll && O.querySelectorAll("input,select,textarea")[0] || O, ie = dw(B), fe = Y._f.refs || [];
          if (ie ? fe.find((_e) => _e === B) : B === Y._f.ref)
            return;
          Kn(i, _, {
            _f: {
              ...Y._f,
              ...ie ? {
                refs: [
                  ...fe.filter(ol),
                  B,
                  ...Array.isArray(Ye(a, _)) ? [{}] : []
                ],
                ref: { type: B.type, name: _ }
              } : { ref: B }
            }
          }), $(_, !1, void 0, B);
        } else
          Y = Ye(i, _, {}), Y._f && (Y._f.mount = !1), (n.shouldUnregister || D.shouldUnregister) && !(Gb(l.array, _) && s.action) && l.unMount.add(_);
      }
    };
  }, je = () => n.shouldFocusError && Oa(i, H, l.mount), We = (_) => {
    Yt(_) && (h.state.next({ disabled: _ }), Oa(i, (D, Y) => {
      const X = Ye(i, Y);
      X && (D.disabled = X._f.disabled || _, Array.isArray(X._f.refs) && X._f.refs.forEach((O) => {
        O.disabled = X._f.disabled || _;
      }));
    }, 0, !1));
  }, Ge = (_, D) => async (Y) => {
    let X;
    Y && (Y.preventDefault && Y.preventDefault(), Y.persist && Y.persist());
    let O = xt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: B, values: ie } = await Q();
      r.errors = B, O = ie;
    } else
      await J(i);
    if (l.disabled.size)
      for (const B of l.disabled)
        Kn(O, B, void 0);
    if (ft(r.errors, "root"), Et(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await _(O, Y);
      } catch (B) {
        X = B;
      }
    } else
      D && await D({ ...r.errors }, Y), je(), setTimeout(je);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Et(r.errors) && !X,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), X)
      throw X;
  }, pe = (_, D = {}) => {
    Ye(i, _) && (tt(D.defaultValue) ? ce(_, xt(Ye(a, _))) : (ce(_, D.defaultValue), Kn(a, _, xt(D.defaultValue))), D.keepTouched || ft(r.touchedFields, _), D.keepDirty || (ft(r.dirtyFields, _), r.isDirty = D.defaultValue ? P(_, xt(Ye(a, _))) : P()), D.keepError || (ft(r.errors, _), u.isValid && I()), h.state.next({ ...r }));
  }, le = (_, D = {}) => {
    const Y = _ ? xt(_) : a, X = xt(Y), O = Et(_), B = O ? a : X;
    if (D.keepDefaultValues || (a = Y), !D.keepValues) {
      if (D.keepDirtyValues) {
        const ie = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Zi(a, o))
        ]);
        for (const fe of Array.from(ie))
          Ye(r.dirtyFields, fe) ? Kn(B, fe, Ye(o, fe)) : ce(fe, Ye(B, fe));
      } else {
        if (Om && tt(_))
          for (const ie of l.mount) {
            const fe = Ye(i, ie);
            if (fe && fe._f) {
              const _e = Array.isArray(fe._f.refs) ? fe._f.refs[0] : fe._f.ref;
              if (ss(_e)) {
                const en = _e.closest("form");
                if (en) {
                  en.reset();
                  break;
                }
              }
            }
          }
        for (const ie of l.mount)
          ce(ie, Ye(B, ie));
      }
      o = xt(B), h.array.next({
        values: { ...B }
      }), h.state.next({
        values: { ...B }
      });
    }
    l = {
      mount: D.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!D.keepIsValid || !!D.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: D.keepSubmitCount ? r.submitCount : 0,
      isDirty: O ? !1 : D.keepDirty ? r.isDirty : !!(D.keepDefaultValues && !Gr(_, a)),
      isSubmitted: D.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: O ? {} : D.keepDirtyValues ? D.keepDefaultValues && o ? Zi(a, o) : r.dirtyFields : D.keepDefaultValues && _ ? Zi(a, _) : D.keepDirty ? r.dirtyFields : {},
      touchedFields: D.keepTouched ? r.touchedFields : {},
      errors: D.keepErrors ? r.errors : {},
      isSubmitSuccessful: D.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ne = (_, D) => le(pr(_) ? _(o) : _, D), Ae = (_, D = {}) => {
    const Y = Ye(i, _), X = Y && Y._f;
    if (X) {
      const O = X.refs ? X.refs[0] : X.ref;
      O.focus && (O.focus(), D.shouldSelect && pr(O.select) && O.select());
    }
  }, Ee = (_) => {
    r = {
      ...r,
      ..._
    };
  }, w = {
    control: {
      register: rn,
      unregister: Le,
      getFieldState: G,
      handleSubmit: Ge,
      setError: Be,
      _subscribe: Me,
      _runSchema: Q,
      _getWatch: K,
      _getDirty: P,
      _setValid: I,
      _setFieldArray: q,
      _setDisabledField: De,
      _setErrors: j,
      _getFieldArray: ne,
      _reset: le,
      _resetDefaultValues: () => pr(n.defaultValues) && n.defaultValues().then((_) => {
        Ne(_, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: W,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(_) {
        s = _;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(_) {
        l = _;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(_) {
        n = {
          ...n,
          ..._
        };
      }
    },
    subscribe: Ie,
    trigger: be,
    register: rn,
    handleSubmit: Ge,
    watch: Pe,
    setValue: ce,
    getValues: Ce,
    reset: Ne,
    resetField: pe,
    clearErrors: ze,
    unregister: Le,
    setError: Be,
    setFocus: Ae,
    getFieldState: G
  };
  return {
    ...w,
    formControl: w
  };
}
function sr(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: pr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: pr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : xw(e),
    formState: i
  }, e.formControl && e.defaultValues && !pr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Gr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !Et(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = Qb(i, o), n.current;
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var sl = { exports: {} }, na = {}, Df;
function Sw() {
  if (Df) return na;
  Df = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return na.Fragment = r, na.jsx = s, na.jsxs = s, na;
}
var fo = {}, Rf;
function Nw() {
  return Rf || (Rf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var E = !1, j = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || E || j || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function W(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return W(c) + ".Consumer";
          case s:
            var p = t;
            return W(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, ke, ue, ce, he, H, be, Ce;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, ue = console.info, ce = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: ke
            }),
            info: K({}, t, {
              value: ue
            }),
            warn: K({}, t, {
              value: ce
            }),
            error: K({}, t, {
              value: he
            }),
            group: K({}, t, {
              value: H
            }),
            groupCollapsed: K({}, t, {
              value: be
            }),
            groupEnd: K({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              y = te;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), T = y.stack.split(`
`), V = x.length - 1, z = T.length - 1; V >= 1 && z >= 0 && x[V] !== T[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== T[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== T[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var C in t)
          if (L(t, C)) {
            var x = void 0;
            try {
              if (typeof t[C] != "function") {
                var T = Error((y || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              x = t[C](c, C, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, C, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, C) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, C = {}, x = null, T = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (T = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (x || T) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(C, z), T && fn(C, z);
        }
        return pn(t, x, T, R, y, B.current, C);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), C; !(C = L.next()).done; )
              an(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var C = ee(t);
        if (!C) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Hn();
          T ? x += T : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    fo.Fragment = i, fo.jsx = Bn, fo.jsxs = qn;
  })()), fo;
}
var Of;
function jw() {
  return Of || (Of = 1, process.env.NODE_ENV === "production" ? sl.exports = Sw() : sl.exports = Nw()), sl.exports;
}
var xe = jw();
const ww = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, Cw = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, Fw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, Iw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, Ew = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, Tw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, $w = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, Dw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, Rw = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": Fw,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": Iw,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": Ew,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": ww,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": Cw,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": Tw,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": $w,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": Dw
};
function Mi(e) {
  return Rw[e] ?? {};
}
const Ow = Mi(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), Pw = Mi(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Aw = Mi(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Pf = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, nr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, Lw = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), Af = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, Gu = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ xe.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ xe.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function Vw({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = se(
    []
  ), [o, s] = se([]), [l, d] = se([]), [m, u] = se([]), [f, h] = se(), { showNotification: v, showModal: S, executeQuery: N } = mn(), { track: F } = kn(), {
    loading: I,
    data: g,
    error: q,
    store: E
  } = bm(e ?? null), j = g?.github?.issues || [], $ = g?.github?.pullRequests || [], [U, Z] = se(!1), [Q, ee] = se();
  qe(
    () => h(q || Q || void 0),
    [q, Q]
  ), qe(
    () => {
      !I && (j?.length || $?.length) ? (a(j), s($), W(j, $)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  );
  const J = async (he, H) => {
    await E(he).then(() => {
      v({
        icon: "check-circle-filled",
        severity: "success",
        title: H.success.title,
        text: H.success.text
      });
    }).catch((be) => {
      v({
        title: H.error.title,
        text: `${H.error.text} ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, W = (he, H) => {
    if (!he?.length && !H?.length) {
      d([]), u([]);
      return;
    }
    const be = (he || []).map(
      (ze) => N(Pw, {
        owner: ze.owner,
        repositoryName: ze.repository,
        issueNumber: ze.number
      })
    ), Ce = (H || []).map(
      (ze) => N(Aw, {
        owner: ze.owner,
        repositoryName: ze.repository,
        prNumber: ze.number
      })
    ), G = [...be, ...Ce];
    Z(!0), Promise.all(G).then((ze) => {
      const Be = [], Pe = [];
      ze.forEach((Me) => {
        const Ie = Me?.data?.GitHub;
        if (!Ie) {
          d([]), u([]);
          return;
        }
        Object.keys(Ie).forEach((Le) => {
          if (Le.startsWith("repository")) {
            const De = Ie[Le];
            Object.keys(De).forEach((rn) => {
              const je = De[rn], We = {
                number: je?.number,
                owner: je?.repository?.owner?.login,
                repository: je?.repository?.name
              };
              rn.startsWith("issue") && Be.push({
                ...je,
                type: "ISSUE",
                key: We
              }), rn.startsWith("pullRequest") && Pe.push({
                ...je,
                type: "PR",
                key: We
              });
            });
          }
        });
      }), d(Be), u(Pe);
    }).catch(ee).finally(() => {
      Z(!1);
    });
  }, P = ({ key: he, type: H }) => {
    F("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = g && (j.length || $.length) ? g : r, Ce = H === "ISSUE" ? "issues" : "pullRequests";
    be.github[Ce] = Array.from(
      new Set(be.github[Ce]).add(he)
    ), J(be, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${nr(
          he
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${nr(he)} failed. Please try again.`
      }
    });
  }, K = async ({ key: he, type: H }) => {
    F("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = g && (j.length || $.length) ? g : r, Ce = H === "ISSUE" ? "issues" : "pullRequests";
    be.github[Ce] = Array.from(
      new Set(be.github[Ce]).add(he)
    ), await E(be).catch((G) => {
      v({
        title: "Linking failed",
        text: `Linking ${he} failed. Please try again. ${G.message && " (" + G.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ne = ({ key: he, type: H }) => {
    F("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const be = H === "ISSUE" ? "issue" : "pull request";
    S({
      headline: `Unlink ${be} ${nr(he)}?`,
      text: `You are about to unlink the ${be} ${nr(
        he
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${be}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Ce = H === "ISSUE" ? "issues" : "pullRequests";
        if (!g)
          return;
        const G = {
          ...g,
          github: {
            ...g?.github,
            [Ce]: g?.github?.[Ce].filter(
              (ze) => ze.number !== he.number || ze.owner !== he.owner || ze.repository !== he.repository
            )
          }
        };
        F("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), J(G, {
          success: {
            title: `GitHub ${be} unlinked`,
            text: `You unlinked the GitHub ${be} ${nr(
              he
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${nr(he)} failed.`
          }
        });
      },
      onCancel: () => {
        F("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ke = () => {
    F("github:unlink:all:clicked", {
      githubOrganization: n
    }), S({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        F("github:unlink:all:confirmed", {
          githubOrganization: n
        }), J(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        F("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ue = j.filter(
    (he) => !i?.includes(he)
  ) || [], ce = $.filter(
    (he) => !o?.includes(he)
  ) || [];
  return {
    linkGithubItem: P,
    linkGithubItemQuietly: K,
    unlinkGithubItem: ne,
    loadGithubItems: W,
    removeDanglingGithubItemLinks: () => {
      const he = {
        ...g,
        github: {
          ...g?.github,
          issues: j.filter(
            (H) => !ue.includes(H)
          ) || [],
          pullRequests: $.filter(
            (H) => !ce.includes(H)
          ) || []
        }
      };
      E(he);
    },
    unlinkAllGithubItems: ke,
    isLoadingGithubItemLinks: I,
    danglingIssueLinks: ue,
    danglingPullRequestLinks: ce,
    isLoadingGithubItems: U,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const zw = "_contentWrapper_1vx3c_1", Uw = "_contentWrapperHeadline_1vx3c_4", Mw = "_contentWrapperBody_1vx3c_11", Bw = "_contentWrapperAssigneeIcon_1vx3c_15", qw = "_contentWrapperStatusTag_1vx3c_20", Lr = {
  contentWrapper: zw,
  contentWrapperHeadline: Uw,
  contentWrapperBody: Mw,
  contentWrapperAssigneeIcon: Bw,
  contentWrapperStatusTag: qw
}, a_ = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
  e && /* @__PURE__ */ xe.jsxs(Jn, { className: Lr.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(Jn, { className: Lr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ xe.jsx(Jn, { className: Lr.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ xe.jsxs(Jn, { className: Lr.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(Jn, { className: Lr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ xe.jsx(Jn, { className: Lr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ xe.jsxs(Jn, { margin: "100 0", children: [
        /* @__PURE__ */ xe.jsx(
          "img",
          {
            className: Lr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ xe.jsx(Jn, { className: Lr.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ xe.jsx(
      On,
      {
        className: Lr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), Hw = "_collapse_1bdjy_1", Ww = "_collapseHeader_1bdjy_10", Kw = "_collapseHeaderKey_1bdjy_31", Gw = "_collapseHeaderKeyIcon_1bdjy_36", Yw = "_collapseHeaderKeyLink_1bdjy_41", Jw = "_collapseHeaderIcon_1bdjy_44", Qw = "_collapseHeaderTitle_1bdjy_49", Xw = "_collapseContent_1bdjy_57", Zw = "_collapseContentButtonSpacer_1bdjy_60", eC = "_collapseContentButtonLink_1bdjy_63", Sr = {
  collapse: Hw,
  collapseHeader: Ww,
  collapseHeaderKey: Kw,
  collapseHeaderKeyIcon: Gw,
  collapseHeaderKeyLink: Yw,
  collapseHeaderIcon: Jw,
  collapseHeaderTitle: Qw,
  collapseContent: Xw,
  collapseContentButtonSpacer: Zw,
  collapseContentButtonLink: eC
}, nC = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = se(i), { track: s } = kn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ xe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: v,
      repository: S,
      type: N,
      state: F,
      assignees: I,
      labels: g
    } = d, q = a[m];
    return /* @__PURE__ */ xe.jsxs(
      rr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: q,
        className: Sr.collapse,
        children: [
          /* @__PURE__ */ xe.jsx(rr.Header, { className: Sr.collapseHeader, children: /* @__PURE__ */ xe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ xe.jsx(Jn, { children: /* @__PURE__ */ xe.jsxs(Jn, { as: "span", className: Sr.collapseHeaderKey, children: [
                  Gu(
                    N,
                    F,
                    Sr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ xe.jsxs(
                    "a",
                    {
                      href: Pf(f),
                      className: Sr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (E) => {
                        E.stopPropagation();
                      },
                      children: [
                        nr(f),
                        /* @__PURE__ */ xe.jsx(
                          me,
                          {
                            className: Sr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ xe.jsx(Jn, { className: Sr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ xe.jsx(rr.Content, { className: Sr.collapseContent, children: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ xe.jsx(
              a_,
              {
                description: v,
                assignees: I,
                labels: g
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              Wn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Sr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: S?.owner.login,
                    repository: d.repository.name
                  },
                  type: N
                }),
                children: [
                  "Unlink ",
                  Af(N)
                ]
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              jt,
              {
                slotEnd: /* @__PURE__ */ xe.jsx(me, { name: "external-link" }),
                variant: "tertiary",
                className: Sr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(Pf(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  Af(N),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ xe.jsx(xe.Fragment, {}) });
}, tC = "_result_1uaom_1", rC = "_resultName_1uaom_21", iC = "_resultItemIcon_1uaom_29", aC = "_resultDescription_1uaom_34", oC = "_resultLinkIcon_1uaom_46", sC = "_tooltip_1uaom_55", lC = "_tooltipName_1uaom_61", cC = "_tooltipTag_1uaom_71", Vr = {
  result: tC,
  resultName: rC,
  resultItemIcon: iC,
  resultDescription: aC,
  resultLinkIcon: oC,
  tooltip: sC,
  tooltipName: lC,
  tooltipTag: cC
}, dC = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = se(!1);
  return /* @__PURE__ */ xe.jsx(
    Ke,
    {
      className: Vr.tooltip,
      content: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ xe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ xe.jsxs(Jn, { as: "span", className: Vr.tooltipName, children: [
                Gu(a, o, Vr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ xe.jsx(On, { className: Vr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ xe.jsx(
          a_,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ xe.jsxs(
        "button",
        {
          className: Vr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ xe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsxs(Jn, { as: "span", className: Vr.resultName, children: [
                    Gu(a, o, Vr.resultItemIcon),
                    nr(r)
                  ] }) }),
                  /* @__PURE__ */ xe.jsx(Jn, { className: Vr.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ xe.jsx(
              me,
              {
                className: Vr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, uC = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ xe.jsx(
  jt,
  {
    slotEnd: /* @__PURE__ */ xe.jsx(me, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), ds = "[a-zA-z0-9_.-]+", o_ = "[0-9]+", mC = new RegExp(
  `(${ds})/(${ds})/(?:issues|pull)/(${o_})`,
  "i"
), Lf = new RegExp(`^${mC.source}$`), Vf = new RegExp(
  `https://github.com/(${ds})/(${ds})/(?:issues|pull)/(${o_})`,
  "i"
), pC = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = et(() => r?.map(($) => $.id) || [], [r]), o = et(() => i?.map(($) => $.id) || [], [i]), [s, l] = se([]), { useLazyQuery: d } = mn(), [m, u] = se(), [f, { loading: h, error: v, data: S, networkStatus: N }] = d(Ow, {
    notifyOnNetworkStatusChange: !0
  });
  Ui(
    () => {
      !h && m && N === ar.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), qe(() => {
    let $ = S?.GitHub?.issues?.nodes || [], U = S?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && ($ = $.filter((Z) => !a.includes(Z.id))), o.length > 0 && (U = U.filter(
      (Z) => !o.includes(Z.id)
    )), l([
      ...$.map((Z) => ({
        ...Z,
        type: "ISSUE",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      })),
      ...U.map((Z) => ({
        ...Z,
        type: "PR",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      }))
    ]);
  }, [S, a, o]);
  function F($) {
    const U = $?.trim();
    if (Lf.test(U)) {
      const [Z, Q, ee, J] = U.match(Lf) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ee,
        number: parseInt(J)
      };
    }
    if (Vf.test(U)) {
      const [Z, Q, ee, J] = U.match(Vf) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ee,
        number: parseInt(J)
      };
    }
  }
  const I = ($) => {
    e({
      key: Lw($),
      type: $.type
    }), u(void 0);
  }, g = ($) => {
    const U = F($);
    u(
      U ? `org:${U.owner} repo:${U.repository} ${U.number}` : `org:${n} ${$}`
    );
  }, q = () => {
    u(void 0);
  }, E = ({ className: $, searched: U }) => /* @__PURE__ */ xe.jsx(
    uC,
    {
      className: $,
      searched: U,
      githubOrganization: n
    }
  ), j = ({ item: $, onSelect: U }) => /* @__PURE__ */ xe.jsx(dC, { item: $, onSelect: U });
  return !h && v ? /* @__PURE__ */ xe.jsx(wn, { error: v }) : /* @__PURE__ */ xe.jsx(
    br,
    {
      items: s?.map(($) => ({ name: $.title, ...$ })),
      loading: h,
      onSearch: g,
      onSelect: I,
      onClear: q,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: E,
      itemComponent: j,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, fC = "_itemButton_3sxfy_1", hC = "_result_3sxfy_6", yC = "_resultName_3sxfy_30", gC = "_resultCheckIcon_3sxfy_38", kC = "_resultAssigneeIcon_3sxfy_41", ta = {
  itemButton: fC,
  result: hC,
  resultName: yC,
  resultCheckIcon: gC,
  resultAssigneeIcon: kC
}, s_ = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ xe.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ xe.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: ta.itemButton,
        children: /* @__PURE__ */ xe.jsxs(b, { className: ta.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ xe.jsx(Jn, { margin: "100 0", children: /* @__PURE__ */ xe.jsx(
            "img",
            {
              className: ta.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ xe.jsx(Jn, { className: ta.resultName, children: e.name }),
          n && /* @__PURE__ */ xe.jsx(Jn, { className: ta.resultCheckIcon, children: /* @__PURE__ */ xe.jsx(me, { name: "done" }) })
        ] })
      }
    )
  }
), vC = Mi(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), bC = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(""), m = 2, [u, { loading: f, error: h, data: v, networkStatus: S }] = a(
    vC,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return Ui(
    () => {
      !f && l && l.length >= m && S === ar.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    const N = v?.GitHub?.organization?.teams || { edges: [] }, F = [];
    N?.edges?.forEach((I) => {
      const g = I?.node?.members?.edges;
      (g?.length || 0) > 0 && g?.forEach((q) => {
        const E = q?.node;
        E && (E?.id && F.find((j) => j.id === E.id) || F.push(E));
      });
    }), s(
      F.sort((I, g) => {
        const q = I.name?.toLowerCase() || I.login?.toLowerCase(), E = g.name?.toLowerCase() || g.login?.toLowerCase();
        return q.localeCompare(E, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [v]), !f && h ? /* @__PURE__ */ xe.jsx(wn, { error: h }) : /* @__PURE__ */ xe.jsx(
    br,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: N, name: F, login: I, avatarUrl: g }) => ({
        id: N,
        name: F || I,
        iconUrl: g
      })) || [],
      loading: f,
      onSearch: (N) => d(N),
      onChange: (N, F) => {
        const I = N.id;
        i ? (F && !n.find(
          (g) => g.id === I
        ) && n.push(N), F || (n = n.filter(
          (g) => g.id !== I
        ))) : n = F ? [N] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: N, onSelect: F, checked: I }) => /* @__PURE__ */ xe.jsx(
        s_,
        {
          item: N,
          checked: I,
          onSelectItem: F
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, _C = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ xe.jsx(kr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ xe.jsx(
        br,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ xe.jsx(
        Cs,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ xe.jsx(kr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ xe.jsx(
        br,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ xe.jsx(kr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ xe.jsx(Lu, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ xe.jsx(
        bC,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ xe.jsx(xe.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, xC = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ xe.jsx(xe.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ xe.jsx(
  Pt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ xe.jsx(
      An,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: _C({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), SC = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ xe.jsxs(A.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ xe.jsxs(A.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ xe.jsx(me, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ xe.jsx(An, { label: "GitHub issue link", children: /* @__PURE__ */ xe.jsx(
          kr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, NC = "_modalBody_1hk1o_1", jC = "_modalBodyFormFields_1hk1o_4", ll = {
  modalBody: NC,
  modalBodyFormFields: jC
}, wC = Mi(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), CC = Mi(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), FC = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], IC = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = mn(), { track: d } = kn(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: v
  } = sr(), [S, N] = se(""), [F, I] = se([]), [g, q] = se(), [E, j] = se(!1), [$, U] = se(!1), [Z, Q] = Hb(), [
    ee,
    {
      loading: J,
      error: W,
      networkStatus: P
    }
  ] = s(wC, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Ce) => {
      I(
        Ce.GitHub.search?.edges?.map((G) => G?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), I([]);
    }
  });
  Ui(
    () => {
      !J && S && P === ar.ready ? ee({
        variables: {
          query: S,
          maxResults: 10
        }
      }) : I([]);
    },
    500,
    [S]
  );
  const [K, { error: ne }] = l(
    CC,
    {
      onError: (Ce) => {
        j(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Ce);
      },
      onCompleted: (Ce) => {
        j(!1);
        const G = Ce.GitHub.createIssue?.issue;
        q(G), o({
          title: "Success",
          text: `GitHub issue '${G.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: G.repository.name,
          number: G.number
        });
      }
    }
  ), ke = (Ce) => {
    N(`org:${a} ${Ce}`);
  }, ue = (Ce, G) => {
    G(Ce), N("");
  }, ce = () => {
    N("");
  }, he = (Ce) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), j(!0), K({
      variables: {
        input: {
          repositoryId: Ce.repository.id,
          title: Ce.title,
          body: Ce.body,
          assigneeIds: Ce.assignees?.length > 0 ? Ce.assignees.map((G) => G.id) : void 0
        }
      }
    });
  };
  qe(() => {
    const Ce = $ ? window.setTimeout(() => U(!1), 2e3) : void 0;
    return () => window.clearTimeout(Ce);
  }, [$]);
  const H = () => {
    N(""), I([]), q(void 0), j(!1), U(!1);
  }, be = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), H(), h(), n();
  };
  return /* @__PURE__ */ xe.jsxs(
    gt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: be,
      children: [
        /* @__PURE__ */ xe.jsx(
          kt,
          {
            title: g ? "Issue creation successful" : "Create new GitHub issue",
            onClose: be
          }
        ),
        /* @__PURE__ */ xe.jsxs(vt, { className: ll.modalBody, children: [
          !J && W && /* @__PURE__ */ xe.jsx(wn, { error: W }),
          !E && ne && /* @__PURE__ */ xe.jsx(wn, { error: ne }),
          g ? /* @__PURE__ */ xe.jsx(
            SC,
            {
              createdIssue: g,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: $,
              setIssueLinkCopied: U,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ xe.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(he),
              children: /* @__PURE__ */ xe.jsxs(zt, { children: [
                /* @__PURE__ */ xe.jsx(nn, { children: /* @__PURE__ */ xe.jsx(An, { label: "Repository", required: !0, children: /* @__PURE__ */ xe.jsx(
                  Pt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Ce, value: G } }) => /* @__PURE__ */ xe.jsx(
                      br,
                      {
                        className: ll.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: J,
                        onSearch: ke,
                        onSelect: (ze) => ue(ze, Ce),
                        onClear: ce,
                        selectedItems: [G],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: W ? "No repositories found" : "No repositories available",
                        items: F || [],
                        itemComponent: ({ item: ze, onSelect: Be, checked: Pe }) => /* @__PURE__ */ xe.jsx(
                          s_,
                          {
                            item: ze,
                            checked: Pe,
                            onSelectItem: Be
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ xe.jsx(nn, { className: ll.modalBodyFormFields, children: /* @__PURE__ */ xe.jsx(
                  xC,
                  {
                    control: m,
                    errors: f,
                    getValues: v,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: FC
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ xe.jsx(
          wt,
          {
            confirmOnClick: g ? be : u(he),
            confirmProps: {
              isLoading: E,
              loadingIndicator: /* @__PURE__ */ xe.jsx(un, { size: 16 })
            },
            confirmName: g ? "Close" : "Save",
            cancelOnClick: g ? void 0 : be
          }
        )
      ]
    }
  );
}, EC = "_wrapper_19v8w_1", TC = "_inputWrapper_19v8w_6", $C = "_buttonLink_19v8w_19", DC = "_noItemsFound_19v8w_23", RC = "_createIssueButton_19v8w_28", bi = {
  wrapper: EC,
  inputWrapper: TC,
  buttonLink: $C,
  noItemsFound: DC,
  createIssueButton: RC
}, OC = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se(!1), { track: a } = kn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: v,
    danglingIssueLinks: S,
    danglingPullRequestLinks: N,
    isLoadingGithubItems: F,
    issues: I,
    pullRequests: g,
    error: q
  } = Vw({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), E = (Q) => d({ key: Q, type: "ISSUE" }), j = !(!!I?.length).valueOf() && !(!!g?.length).valueOf() && !(!!S?.length).valueOf() && !(!!N?.length).valueOf(), $ = !v && !F && !!S?.length && !!N?.length && !!n?.showDanglingLinks, U = n?.enableCreateIssue, Z = !!I?.length || !!g?.length;
  return !F && q ? /* @__PURE__ */ xe.jsx(wn, { error: q, retry: () => u() }) : /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
    /* @__PURE__ */ xe.jsxs(b, { className: bi.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ xe.jsxs(b, { className: bi.inputWrapper, flexDirection: "column", children: [
        U && /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
          /* @__PURE__ */ xe.jsx(
            Wn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: bi.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ xe.jsx("div", { className: bi.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ xe.jsx(
          pC,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: I,
            linkedPullRequests: g
          }
        )
      ] }),
      F ? /* @__PURE__ */ xe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ xe.jsx(un, { "data-testid": "github-widget-item-spinner" }) }) : Z ? /* @__PURE__ */ xe.jsx(
        nC,
        {
          items: [...I, ...g],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ xe.jsx(A.Paragraph, { align: "center", className: bi.noItemsFound, children: "No linked items found." }),
      $ && /* @__PURE__ */ xe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ xe.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ xe.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              S.map((Q) => /* @__PURE__ */ xe.jsx(
                On,
                {
                  onDelete: () => m({
                    key: Q,
                    type: "ISSUE"
                  }),
                  children: nr(Q)
                },
                nr(Q)
              )),
              N.map((Q) => /* @__PURE__ */ xe.jsx(
                On,
                {
                  onDelete: () => m({ key: Q, type: "PR" }),
                  children: nr(Q)
                },
                nr(Q)
              ))
            ] }),
            /* @__PURE__ */ xe.jsx(
              Wn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Z && /* @__PURE__ */ xe.jsx(
        Wn,
        {
          variant: "secondary",
          disabled: j,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ xe.jsx(
        jt,
        {
          slotEnd: /* @__PURE__ */ xe.jsx(me, { name: "external-link" }),
          variant: "tertiary",
          className: bi.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ xe.jsx(
      IC,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: E,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, PC = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
    secret: !1,
    type: "input",
    required: !0
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ga
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var cl = { exports: {} }, ra = {}, zf;
function AC() {
  if (zf) return ra;
  zf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ra.Fragment = r, ra.jsx = s, ra.jsxs = s, ra;
}
var ho = {}, Uf;
function LC() {
  return Uf || (Uf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var E = !1, j = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || E || j || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function W(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return W(c) + ".Consumer";
          case s:
            var p = t;
            return W(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, ke, ue, ce, he, H, be, Ce;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, ue = console.info, ce = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: ke
            }),
            info: K({}, t, {
              value: ue
            }),
            warn: K({}, t, {
              value: ce
            }),
            error: K({}, t, {
              value: he
            }),
            group: K({}, t, {
              value: H
            }),
            groupCollapsed: K({}, t, {
              value: be
            }),
            groupEnd: K({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              y = te;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), T = y.stack.split(`
`), V = x.length - 1, z = T.length - 1; V >= 1 && z >= 0 && x[V] !== T[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== T[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== T[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var C in t)
          if (L(t, C)) {
            var x = void 0;
            try {
              if (typeof t[C] != "function") {
                var T = Error((y || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              x = t[C](c, C, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, C, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, C) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, C = {}, x = null, T = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (T = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (x || T) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(C, z), T && fn(C, z);
        }
        return pn(t, x, T, R, y, B.current, C);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), C; !(C = L.next()).done; )
              an(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var C = ee(t);
        if (!C) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Hn();
          T ? x += T : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    ho.Fragment = i, ho.jsx = Bn, ho.jsxs = qn;
  })()), ho;
}
var Mf;
function VC() {
  return Mf || (Mf = 1, process.env.NODE_ENV === "production" ? cl.exports = AC() : cl.exports = LC()), cl.exports;
}
var Te = VC(), Ta = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Ta || {}), ri = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(ri || {}), Ut = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Ut || {});
const zC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, UC = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": zC
};
function MC(e) {
  return UC[e] ?? {};
}
const BC = MC(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Bf = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, l_ = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, qC = "_listItem_16pij_4", HC = "_clickableIcon_16pij_15", us = {
  listItem: qC,
  clickableIcon: HC
}, c_ = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = se(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ Te.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ Te.jsx(me, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ Te.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ Te.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: us.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ Te.jsx(
              me,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ Te.jsx(He, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: v } = l, S = l.currency ?? r;
      return /* @__PURE__ */ Te.jsx(
        He.Item,
        {
          contentLeft: /* @__PURE__ */ Te.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { children: u }),
            /* @__PURE__ */ Te.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: l_(f / 100, S) })
          ] }),
          contentRight: h && /* @__PURE__ */ Te.jsx(Li, { src: h, alt: m ?? "Product image" }),
          className: us.listItem
        },
        `item-${d}-${v}`
      );
    }) })
  ] }) });
}, WC = "_boxWrapper_89s7l_1", KC = "_trackButton_89s7l_10", qf = {
  boxWrapper: WC,
  trackButton: KC
}, GC = {
  [Ut.StepUnknown]: "Unknown",
  [Ut.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Ut.StepPreparedByMerchant]: "Prepared by merchant",
  [Ut.StepSubmittedToCarrier]: "Submitted to carrier",
  [Ut.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Ut.StepOnRoute]: "On route",
  [Ut.StepDeliveredToPickupPoint]: "At pickup point",
  [Ut.StepDeliveredToConsumer]: "Delivered to customer",
  [Ut.StepDeliveredToMerchant]: "Returned to merchant",
  [Ut.StepReturnRequested]: "Return requested",
  [Ut.StepSentBack]: "Sent back",
  [Ut.StepTerminated]: "Terminated",
  [Ut.StepAwaitingSupplier]: "Awaiting supplier"
}, YC = {
  [ri.Delivery]: "Home delivery",
  [ri.Pickup]: "Pickup point",
  [ri.Instore]: "In-store pickup",
  [ri.Mailbox]: "Mailbox",
  [ri.Inwarehouse]: "Warehouse",
  [ri.Unknown]: "Unknown"
}, JC = {
  [Ta.Outbound]: "From merchant to customer",
  [Ta.Return]: "Return from customer to merchant",
  [Ta.Unspecified]: "Unspecified",
  [Ta.UnknownDirectionType]: "Unknown"
}, QC = (e) => e ? GC[e] ?? e : "", XC = (e) => e ? YC[e] ?? e : "", ZC = (e) => e ? JC[e] ?? e : "", e1 = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, n1 = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = Xt();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, v = m || l || i, S = a?.filter((E) => E?.time !== ""), N = QC(S?.[0]?.step), F = XC(u), I = ZC(f), g = e1(e.location?.address), q = 14;
  return /* @__PURE__ */ Te.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: qf.boxWrapper,
      children: [
        /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-4", children: v }),
        /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Te.jsx(
              me,
              {
                size: q,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ Te.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Te.jsx(Ke, { content: "Copy tracking ID", children: /* @__PURE__ */ Te.jsx(
            me,
            {
              size: q,
              name: n ? "done" : "copy",
              className: us.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        N && /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Te.jsx(me, { size: q, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        I && /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Te.jsx(me, { size: q, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: I })
          ] })
        ] }),
        h && /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Te.jsx(me, { size: q, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ Te.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
              Bf(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Bf(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Te.jsx(me, { size: q, name: "info", color: "blue.900" }),
          /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: F })
          ] })
        ] }),
        g && /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Te.jsx(me, { size: q, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: g })
          ] })
        ] }),
        /* @__PURE__ */ Te.jsx(c_, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ Te.jsxs(
          jt,
          {
            variant: "secondary",
            className: qf.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ Te.jsx(me, { name: "external-link" }),
            children: [
              "Track on ",
              v ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, t1 = "_order_135ze_1", r1 = "_orderIsOpen_135ze_9", i1 = "_orderHeader_135ze_12", dl = {
  order: t1,
  orderIsOpen: r1,
  orderHeader: i1
}, a1 = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { isCopied: a, copy: o } = Xt();
  if (!e)
    return null;
  const {
    cart: s,
    parcels: l,
    external_id: d,
    sender_name: m,
    tos_id: u
  } = e, f = s?.currency || "", h = s?.prices?.total?.price ?? 0, v = l_(h / 100, f), S = 14, N = m && m.trim() !== "" ? m : "unknown sender";
  return /* @__PURE__ */ Te.jsxs(
    b,
    {
      className: dt(dl.order, {
        [dl.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Te.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: dl.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Te.jsxs(A.Paragraph, { variant: "4", children: [
                  "From ",
                  N
                ] }),
                /* @__PURE__ */ Te.jsxs(A.Paragraph, { variant: "3", children: [
                  "#",
                  d
                ] })
              ] }),
              /* @__PURE__ */ Te.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ Te.jsx(
                me,
                {
                  size: S,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !u && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  u && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: u })
                ] })
              ] })
            ] }),
            u && /* @__PURE__ */ Te.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Te.jsx(Ke, { content: "Copy tracking ID", children: /* @__PURE__ */ Te.jsx(
              me,
              {
                size: S,
                name: a ? "done" : "copy",
                className: us.clickableIcon,
                onClick: () => o(u)
              }
            ) }) })
          ] }),
          m && /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Te.jsx(me, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: m })
            ] })
          ] }),
          /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Te.jsx(me, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: v })
            ] })
          ] }),
          /* @__PURE__ */ Te.jsx(
            c_,
            {
              openByDefault: !0,
              title: "Order items",
              items: s?.items?.map((F) => F),
              currency: s?.currency
            }
          ),
          l && /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-4", children: "Parcels" }),
              l.length > 0 && /* @__PURE__ */ Te.jsx(Un, { variant: "success", size: "small", children: l.length })
            ] }),
            l.length === 0 && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            l.map((F, I) => /* @__PURE__ */ Te.jsx(
              n1,
              {
                parcel: F
              },
              `parcel-${I}-${F?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, o1 = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, s1 = ({
  customerEmail: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se([]), a = !e, { data: o, loading: s, error: l } = n(BC, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? vS({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? ab({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return qe(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(o1(f.orders));
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Te.jsx(un, {}) }) : m || !d && !l ? /* @__PURE__ */ Te.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ Te.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ Te.jsx(wn, { error: l }) : /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ Te.jsx(Un, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ Te.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ Te.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ Te.jsx(
      a1,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, l1 = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ Te.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ Te.jsx(s1, { customerEmail: n })
    }
  );
}, c1 = [
  {
    key: "ingridUseStagingEnvironment",
    label: "Use Ingrid staging environment",
    required: !0,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    label: "Site ID",
    placeholder: "Site ID from Ingrid",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "ingridApiToken",
    label: "API token",
    placeholder: "API token from Ingrid",
    required: !0,
    secret: !0,
    type: "input"
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ul = { exports: {} }, ia = {}, Hf;
function d1() {
  if (Hf) return ia;
  Hf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ia.Fragment = r, ia.jsx = s, ia.jsxs = s, ia;
}
var yo = {}, Wf;
function u1() {
  return Wf || (Wf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var E = !1, j = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || E || j || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function W(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return W(c) + ".Consumer";
          case s:
            var p = t;
            return W(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, ke, ue, ce, he, H, be, Ce;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, ue = console.info, ce = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: ke
            }),
            info: K({}, t, {
              value: ue
            }),
            warn: K({}, t, {
              value: ce
            }),
            error: K({}, t, {
              value: he
            }),
            group: K({}, t, {
              value: H
            }),
            groupCollapsed: K({}, t, {
              value: be
            }),
            groupEnd: K({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              y = te;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), T = y.stack.split(`
`), V = x.length - 1, z = T.length - 1; V >= 1 && z >= 0 && x[V] !== T[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== T[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== T[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var C in t)
          if (L(t, C)) {
            var x = void 0;
            try {
              if (typeof t[C] != "function") {
                var T = Error((y || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              x = t[C](c, C, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, C, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, C) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, C = {}, x = null, T = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (T = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (x || T) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(C, z), T && fn(C, z);
        }
        return pn(t, x, T, R, y, B.current, C);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), C; !(C = L.next()).done; )
              an(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var C = ee(t);
        if (!C) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Hn();
          T ? x += T : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    yo.Fragment = i, yo.jsx = Bn, yo.jsxs = qn;
  })()), yo;
}
var Kf;
function m1() {
  return Kf || (Kf = 1, process.env.NODE_ENV === "production" ? ul.exports = d1() : ul.exports = u1()), ul.exports;
}
var ye = m1();
const Um = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => Um(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, p1 = "_jiraCode_h30p6_1", f1 = "_jiraCodeInline_h30p6_8", ml = {
  jiraCode: p1,
  jiraCodeInline: f1
}, d_ = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ ye.jsx(ye.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ ye.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ ye.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ ye.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ ye.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ ye.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ ye.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ ye.jsx("pre", { children: /* @__PURE__ */ ye.jsx("code", { className: ml.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ ye.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ ye.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ ye.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ ye.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ ye.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ ye.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ ye.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ ye.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ ye.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ ye.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ ye.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ ye.jsx("code", { className: dt(ml.jiraCode, ml.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, ms = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = se(!1);
  return !e || i ? /* @__PURE__ */ ye.jsx(me, { size: r, name: "question", className: n }) : /* @__PURE__ */ ye.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, h1 = "_collapse_m2gjh_1", y1 = "_collapseHeader_m2gjh_10", g1 = "_collapseHeaderLink_m2gjh_31", k1 = "_collapseHeaderStatus_m2gjh_40", v1 = "_collapseHeaderTitle_m2gjh_51", b1 = "_collapseContent_m2gjh_59", _1 = "_collapseContentHeadline_m2gjh_62", x1 = "_collapseContentButtonSpacer_m2gjh_68", S1 = "_collapseContentButtonLink_m2gjh_71", N1 = "_collapseContentStatusTag_m2gjh_74", j1 = "_collapseContentDescription_m2gjh_77", dr = {
  collapse: h1,
  collapseHeader: y1,
  collapseHeaderLink: g1,
  collapseHeaderStatus: k1,
  collapseHeaderTitle: v1,
  collapseContent: b1,
  collapseContentHeadline: _1,
  collapseContentButtonSpacer: x1,
  collapseContentButtonLink: S1,
  collapseContentStatusTag: N1,
  collapseContentDescription: j1
}, u_ = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, w1 = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = se(i), { track: s } = kn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ ye.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, v = u_({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), S = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ ye.jsxs(
      rr,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: S,
        className: dr.collapse,
        children: [
          /* @__PURE__ */ ye.jsx(rr.Header, { className: dr.collapseHeader, children: /* @__PURE__ */ ye.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ ye.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ ye.jsx(ms, { width: 16, iconUrl: v }),
                    /* @__PURE__ */ ye.jsx(
                      "a",
                      {
                        className: dr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (N) => {
                          N.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ ye.jsx(me, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ ye.jsx("span", { className: dr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ ye.jsx(On, { className: dr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ ye.jsx("div", { className: dr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ ye.jsx(rr.Content, { className: dr.collapseContent, children: /* @__PURE__ */ ye.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ ye.jsx("div", { className: dr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ ye.jsx(Jn, { className: dr.collapseContentDescription, children: u ? Um(u, d_) : "" }),
            /* @__PURE__ */ ye.jsx(
              Wn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: dr.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ ye.jsx(
              jt,
              {
                slotEnd: /* @__PURE__ */ ye.jsx(me, { name: "external-link" }),
                variant: "tertiary",
                className: dr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ ye.jsx(ye.Fragment, {}) });
}, C1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, F1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, I1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, E1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, T1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, $1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, D1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, R1 = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': C1,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": F1,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": I1,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": E1,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': T1,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': $1,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": D1
};
function hi(e) {
  return R1[e] ?? {};
}
const m_ = hi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), O1 = hi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), P1 = hi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), A1 = hi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), L1 = hi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), V1 = hi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), z1 = hi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), Mm = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), U1 = new RegExp(`^${Mm.source}$`), M1 = new RegExp(`/${Mm.source}$`), Gf = new RegExp(
  `.+?[&?]selectedIssue=(${Mm.source})[&?]?.*`
);
function p_(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = se([]), [o, s] = se([]), [l, d] = se(), { track: m } = kn(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: v } = mn(), {
    loading: S,
    data: N,
    error: F,
    store: I
  } = bm(e ?? null), [
    g,
    { loading: q, error: E, data: j }
  ] = h(m_, {
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    const ce = j?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    ce?.length && (s(ce), a(ce.map((he) => he?.key).filter(Boolean)));
  }, [j]), qe(
    () => d(F || E || void 0),
    [F, E]
  ), qe(
    () => {
      S || W();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [N?.jira?.issues, S]
  );
  const $ = async (ce, he) => {
    await I(ce).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: he.success.title,
        text: he.success.text
      });
    }).catch((H) => {
      u({
        title: he.error.title,
        text: `${he.error.text} ${H.message && " (" + H.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [U] = v(O1, {
    onError: (ce) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${ce.message && " (" + ce.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Z = (ce, he) => {
    const H = window.location.href, be = he ? H.replace(
      e?.toString() ?? "",
      he?.toString()
    ) : H, Ce = he ? `# ${he}` : `# ${e}`;
    U({
      variables: {
        issueKey: ce,
        title: Ce,
        url: be,
        globalId: `system=${be}`
      }
    });
  }, [Q] = v(P1, {
    onError: (ce) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${ce.message && " (" + ce.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ee = (ce) => {
    const he = window.location.href;
    Q({
      variables: {
        issueKey: ce,
        globalId: `system=${he}`
      }
    });
  }, J = (ce) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: ce
  }), W = () => {
    N && N.jira?.issues?.length > 0 ? g({
      variables: {
        jql: `key in (${N?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, P = async (ce, he) => {
    m("jira:issue:link:clicked", J(ce));
    const H = N?.jira?.issues ? N : r;
    H.jira.issues = Array.from(
      new Set(H.jira.issues).add(ce)
    ), await I(H, he?.toString()).then(() => Z(ce, he)).catch((be) => {
      u({
        title: "Linking failed",
        text: `Linking ${ce} failed. Please try again. ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, K = (ce) => {
    m("jira:issue:link:clicked", J(ce));
    const he = N?.jira?.issues ? N : r;
    he.jira.issues = Array.from(
      new Set(he.jira.issues).add(ce)
    ), $(he, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${ce} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${ce} failed. Please try again.`
      }
    }).then(() => Z(ce));
  }, ne = (ce) => {
    m("jira:issue:unlink:clicked", J(ce)), f({
      headline: `Unlink issue ${ce}?`,
      text: `You are about to unlink the issue ${ce}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", J(ce));
        const he = {
          ...N,
          jira: {
            ...N?.jira,
            issues: N?.jira?.issues.filter((H) => H !== ce) || []
          }
        };
        $(he, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${ce}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${ce} failed.`
          }
        }).then(() => ee(ce));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", J(ce))
    });
  }, ke = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((ce) => ce?.key && ee(ce.key)), $(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, ue = N?.jira?.issues?.filter(
    (ce) => !i?.includes(ce)
  ) || [];
  return {
    linkIssue: K,
    linkIssueQuietly: P,
    unlinkIssue: ne,
    loadIssues: W,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const ce = {
        ...N,
        jira: {
          ...N?.jira,
          issues: N?.jira?.issues.filter(
            (he) => !ue.includes(he)
          ) || []
        }
      };
      I(ce);
    },
    unlinkAllIssues: ke,
    maybeExtractIssueKey: (ce) => {
      const he = ce.replace(/\s/g, "");
      if (U1.test(he))
        return he;
      if (Gf.test(ce))
        return ce.match(Gf)?.[1];
      if (ce.startsWith(n) && M1.test(ce))
        return ce.substring(ce.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: S,
    danglingIssueLinks: ue,
    isLoadingIssues: q,
    issues: o,
    error: l
  };
}
function B1(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const q1 = "_result_axxxc_48", H1 = "_resultName_axxxc_68", W1 = "_resultNameIcon_axxxc_76", K1 = "_resultDescription_axxxc_81", G1 = "_resultLinkIcon_axxxc_93", Y1 = "_tooltip_axxxc_102", J1 = "_tooltipContent_axxxc_108", Q1 = "_tooltipName_axxxc_115", X1 = "_tooltipNameIcon_axxxc_120", Z1 = "_tooltipDescription_axxxc_125", eF = "_tooltipSummary_axxxc_133", nF = "_tooltipTag_axxxc_137", er = {
  result: q1,
  resultName: H1,
  resultNameIcon: W1,
  resultDescription: K1,
  resultLinkIcon: G1,
  tooltip: Y1,
  tooltipContent: J1,
  tooltipName: Q1,
  tooltipNameIcon: X1,
  tooltipDescription: Z1,
  tooltipSummary: eF,
  tooltipTag: nF
}, tF = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = se(!1), h = u_({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ ye.jsx(
    Ke,
    {
      disabled: i,
      className: er.tooltip,
      content: /* @__PURE__ */ ye.jsxs("div", { className: er.tooltipContent, children: [
        /* @__PURE__ */ ye.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ ye.jsxs("span", { className: er.tooltipName, children: [
                /* @__PURE__ */ ye.jsx(
                  ms,
                  {
                    width: 16,
                    iconUrl: h,
                    className: er.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ ye.jsx(On, { className: er.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ ye.jsx("div", { className: er.tooltipSummary, children: m }),
        d && /* @__PURE__ */ ye.jsx("div", { className: er.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ ye.jsxs(
        "button",
        {
          ...a,
          className: er.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ ye.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ ye.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ye.jsxs("span", { className: er.resultName, children: [
                    /* @__PURE__ */ ye.jsx(
                      ms,
                      {
                        width: 16,
                        iconUrl: h,
                        className: er.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ ye.jsx("div", { className: er.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ ye.jsx(
              me,
              {
                className: er.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, rF = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ ye.jsx(
  jt,
  {
    slotEnd: /* @__PURE__ */ ye.jsx(me, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), iF = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(""), [m, { loading: u, error: f, data: h, networkStatus: v }] = a(m_, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: S } = p_(null, n);
  Ui(
    () => {
      !u && l && v === ar.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    const E = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      E.map((j) => ({
        id: j?.key ?? "",
        name: j?.key ?? "",
        description: j?.fields.summary,
        status: j?.fields.status,
        issuetype: j?.fields.issuetype,
        text: j?.fields.description ? Um(j?.fields.description, d_) : /* @__PURE__ */ ye.jsx(ye.Fragment, {})
      }))
    );
  }, [h]);
  const N = (E) => {
    e(E.id), d("");
  }, F = (E) => {
    const j = E.trim(), $ = S(j);
    if ($) {
      const U = $.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${U}'`);
    } else j !== "" && d(
      `text ~ '${j}'${r ? " and project = " + r : ""}`
    );
  }, I = () => {
    d("");
  }, g = (E) => /* @__PURE__ */ ye.jsx(rF, { ...E, jiraInstanceUrl: n }), q = (E) => /* @__PURE__ */ ye.jsx(
    tF,
    {
      ...E,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ ye.jsx(wn, { error: f }) : /* @__PURE__ */ ye.jsx(
    br,
    {
      items: o,
      loading: u,
      onSearch: F,
      onSelect: N,
      onClear: I,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: g,
      itemComponent: q,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, aF = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = se(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return qe(() => {
    r(i);
  }, [i]), /* @__PURE__ */ ye.jsx(
    br,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, oF = "_itemButton_1hl53_1", sF = "_result_1hl53_6", lF = "_resultIcon_1hl53_26", cF = "_resultName_1hl53_30", dF = "_resultCheckIcon_1hl53_38", aa = {
  itemButton: oF,
  result: sF,
  resultIcon: lF,
  resultName: cF,
  resultCheckIcon: dF
}, Yu = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ ye.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ ye.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: aa.itemButton,
          children: /* @__PURE__ */ ye.jsxs(b, { className: aa.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ ye.jsx(
              ms,
              {
                width: 36,
                iconUrl: o || "",
                className: aa.resultIcon
              }
            ),
            /* @__PURE__ */ ye.jsx(Jn, { className: aa.resultName, children: e.name }),
            n && /* @__PURE__ */ ye.jsx(Jn, { className: aa.resultCheckIcon, children: /* @__PURE__ */ ye.jsx(me, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, uF = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(), m = 2, [u, { loading: f, error: h, data: v, networkStatus: S }] = a(z1, {
    notifyOnNetworkStatusChange: !0
  });
  return Ui(
    () => {
      !f && l && l.length >= m && S === ar.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((N) => {
      if (N?.data?.Jira.findUsers?.length === 1) {
        const F = N?.data?.Jira?.findUsers[0];
        r(F.accountId), s([
          {
            id: F.accountId,
            name: F.displayName
          }
        ]);
      }
    });
  }, []), qe(() => {
    const N = v?.Jira?.findUsers || [];
    s(
      N.filter(({ active: F }) => F).map(({ accountId: F, displayName: I, avatarUrls: g, active: q }) => ({
        id: F,
        name: I,
        avatarUrls: g,
        active: q
      }))
    );
  }, [v]), !f && h ? /* @__PURE__ */ ye.jsx(wn, { error: h }) : /* @__PURE__ */ ye.jsx(
    br,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (N) => d(N),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: N, onSelect: F, checked: I }) => /* @__PURE__ */ ye.jsx(
        Yu,
        {
          item: N,
          checked: I,
          onSelectItem: F,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, Yf = ({
  field: e
}) => {
  const [n, r] = se(!1), [i, a] = Hb();
  return qe(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ ye.jsx(b, { children: /* @__PURE__ */ ye.jsx(me, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ ye.jsx(A.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ ye.jsx(Ke, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ ye.jsx(
      Kt,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, mF = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ ye.jsx(Yf, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ ye.jsx(kr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ ye.jsx(Lu, { onChange: n, value: r }) : /* @__PURE__ */ ye.jsx(kr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ ye.jsx(Lu, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ ye.jsx(kr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ ye.jsx(
        uF,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ ye.jsx(
        br,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ ye.jsx(aF, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ ye.jsx(Yf, { field: e });
  }
}, pF = ["description", "reporter", "summary"], fF = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ ye.jsx(ye.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || pF.includes(o)
).map((o) => /* @__PURE__ */ ye.jsx(
  Pt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ ye.jsx(
      An,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: mF({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), hF = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ ye.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ ye.jsxs(A.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ ye.jsxs(
          A.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ ye.jsx(me, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ ye.jsx(An, { label: "Jira issue link", children: /* @__PURE__ */ ye.jsx(
        kr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), yF = "_modalBody_1hk1o_1", gF = "_modalBodyFormFields_1hk1o_4", Jf = {
  modalBody: yF,
  modalBodyFormFields: gF
}, kF = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), vF = (e) => e?.custom?.split(":")?.[1] || null, bF = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, _F = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = bF(a, n), l = vF(s) ?? a;
        return r.includes(l) ? i[a] = kF(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, xF = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = se([]), [m, u] = se(), [f, h] = se(0), [v, S] = se([]), [N, F] = se([]), [I, g] = se(!1), [q, E] = se(!1), [j, $] = se({}), { track: U } = kn(), { isCopied: Z, copyToClipboard: Q } = B1(), ee = et(() => i?.conversationId, [e]), { useMutation: J, useLazyQuery: W, showNotification: P } = mn(), {
    control: K,
    handleSubmit: ne,
    formState: { errors: ke },
    reset: ue,
    setValue: ce,
    getValues: he
  } = sr({
    defaultValues: s
  }), H = N.length > 0, be = `${a}/browse`, Ce = Object.keys(j).length > 0, [G, { loading: ze, error: Be }] = W(A1, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (le) => {
      d(le.Jira.getAllProjects);
    },
    onError: (le) => {
      P({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", le), d([]);
    }
  }), [
    Pe,
    { loading: Me, error: Ie }
  ] = W(L1, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (le) => {
      h(0);
      const Ne = le?.Jira?.getCreateIssueMeta?.projects[0];
      if (Ne) {
        const Ae = Ne?.issuetypes.filter(
          ({ subtask: Ee }) => !Ee
        );
        S(Ae || []), ce(
          "issuetype",
          Ae.length > 0 ? Ae[0] : void 0
        );
      } else
        P({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), S([]), F([]);
    },
    onError: (le) => {
      P({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", le), S([]), F([]), h(0);
    }
  }), [Le, { error: De }] = J(
    V1,
    {
      onError: () => {
        g(!1), P({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), U("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (le) => {
        if (g(!1), le?.Jira && "key" in le.Jira.createIssue)
          u(le?.Jira?.createIssue), P({
            title: "Success",
            text: `Jira issue '${le.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), U("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: le.Jira.createIssue.key
          }), ee && r(
            le.Jira.createIssue.key,
            ee
          );
        else if ("errorMessages" in le.Jira.createIssue || "errors" in le.Jira.createIssue) {
          const Ne = le?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", Ne), P({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), rn = (le) => {
    g(!0), $({}), Le({
      variables: {
        input: _F(le, N)
      }
    });
  };
  qe(() => {
    if (e)
      try {
        G();
      } catch (le) {
        console.warn("Error when fetching initial projects", le);
      }
  }, [e]), qe(() => {
    const le = q ? window.setTimeout(() => E(!1), 2e3) : void 0;
    return () => window.clearTimeout(le);
  }, [q]), qe(() => {
    if (v?.length > 0) {
      ce("issuetype", v[f]);
      const le = v[f]?.fields?.additionalProperties;
      if (le?.length > 0) {
        const Ne = le.map(
          ({ value: w }) => w
        ), Ae = (o ? Ne.sort(({ name: w }, { name: _ }) => w.localeCompare(_)) : Ne).sort(
          ({ required: w }, { required: _ }) => Number(_) - Number(w)
        ), { project: Ee, issuetype: cn } = he();
        ue({ project: Ee, issuetype: cn }), F(Ae);
      }
    } else
      F([]), ce("issuetype", void 0);
  }, [v, ce, f]), qe(() => {
    if (De && db(De)) {
      if (De?.graphQLErrors?.length > 0) {
        const { graphQLErrors: le } = De, Ne = le[0].extensions?.integration?.responseBody;
        try {
          const Ae = JSON.parse(Ne);
          if (Ae?.errors) {
            const Ee = Object.keys(Ae.errors).reduce(
              (cn, w) => ({
                ...cn,
                [w]: {
                  type: "required",
                  message: Ae.errors[w],
                  ref: {
                    name: w
                  }
                }
              }),
              {}
            );
            $(Ee);
          }
        } catch {
        }
      }
    } else
      $({});
  }, [De]);
  const je = () => {
    d([]), F([]), S([]), u(void 0), h(0), g(!1), $({});
  }, We = () => {
    je(), ue(s), n();
  }, Ge = (le) => {
    le && Pe({
      variables: {
        projectKey: le
      }
    });
  }, pe = (le) => {
    const Ne = v.map((Ae) => Ae.id).indexOf(le);
    h(Ne ?? 0);
  };
  return /* @__PURE__ */ ye.jsxs(
    gt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: We,
      children: [
        /* @__PURE__ */ ye.jsx(
          kt,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: We
          }
        ),
        /* @__PURE__ */ ye.jsxs(vt, { className: Jf.modalBody, children: [
          !ze && Be && /* @__PURE__ */ ye.jsx(wn, { error: Be, retry: G }),
          !Me && Ie && /* @__PURE__ */ ye.jsx(
            wn,
            {
              error: Ie,
              retry: Pe
            }
          ),
          !I && Ce && /* @__PURE__ */ ye.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ye.jsx(
            Ja,
            {
              variant: "warning",
              description: /* @__PURE__ */ ye.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ ye.jsx(A.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ ye.jsx(
                      Wn,
                      {
                        icon: Z ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => Q(JSON.stringify(N, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ ye.jsx(
            hF,
            {
              createdIssue: m,
              issueBaseLink: be,
              issueLinkCopied: q,
              setIssueLinkCopied: E,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ ye.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ne(rn),
              children: /* @__PURE__ */ ye.jsxs(zt, { children: [
                /* @__PURE__ */ ye.jsx(nn, { span: 3, children: /* @__PURE__ */ ye.jsx(An, { label: "Project", required: !0, children: /* @__PURE__ */ ye.jsx(
                  Pt,
                  {
                    control: K,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: le, value: Ne } }) => /* @__PURE__ */ ye.jsx(
                      br,
                      {
                        searchable: !0,
                        loading: ze,
                        onSelect: (Ae) => {
                          Ge(Ae.key), le(Ae);
                        },
                        selectedItems: [Ne],
                        placeholder: "Select Jira project",
                        emptyMessage: Be ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Ae, onSelect: Ee, checked: cn }) => /* @__PURE__ */ ye.jsx(
                          Yu,
                          {
                            item: Ae,
                            checked: cn,
                            onSelectItem: Ee,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ ye.jsx(nn, { span: 3, children: /* @__PURE__ */ ye.jsx(An, { label: "Issue type", required: !0, children: /* @__PURE__ */ ye.jsx(
                  Pt,
                  {
                    control: K,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: le, value: Ne } }) => /* @__PURE__ */ ye.jsx(
                      br,
                      {
                        disabled: v.length === 0,
                        loading: Me,
                        onSelect: (Ae) => {
                          pe(Ae.id), le(Ae);
                        },
                        selectedItems: [Ne],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: Ie ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: Ae, onSelect: Ee, checked: cn }) => /* @__PURE__ */ ye.jsx(
                          Yu,
                          {
                            item: Ae,
                            checked: cn,
                            onSelectItem: Ee,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                H && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ ye.jsx(nn, { className: Jf.modalBodyFormFields, children: /* @__PURE__ */ ye.jsx(
                  fF,
                  {
                    control: K,
                    errors: { ...ke, ...j },
                    getValues: he,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: N
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ ye.jsx(
          wt,
          {
            confirmOnClick: m ? We : ne(rn),
            confirmProps: {
              disabled: !H,
              isLoading: I,
              loadingIndicator: /* @__PURE__ */ ye.jsx(un, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : We
          }
        )
      ]
    }
  );
}, SF = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, NF = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, jF = "_wrapper_1bylq_1", wF = "_inputWrapper_1bylq_6", CF = "_inputSeparator_1bylq_18", FF = "_buttonLink_1bylq_23", IF = "_noIssuesFound_1bylq_27", oa = {
  wrapper: jF,
  inputWrapper: wF,
  inputSeparator: CF,
  buttonLink: FF,
  noIssuesFound: IF
}, EF = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = kn(), i = SF(n?.jiraSiteUrl), [a, o] = se(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: v,
    isLoadingIssueLinks: S,
    isLoadingIssues: N,
    issues: F,
    error: I
  } = p_(
    s ? e.conversationId : null,
    i
  ), g = !!n?.enableCreateIssue, q = !!n?.enableSortIssueTypeByLabel, E = !!(F?.length || v?.length), j = !!n?.enableRemoveAllLinks && E, $ = !S && !N && v?.length > 0 && !!n?.showDanglingLinks;
  return !N && I ? /* @__PURE__ */ ye.jsx(wn, { error: I, retry: () => f() }) : /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
    /* @__PURE__ */ ye.jsxs(b, { className: oa.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ ye.jsxs(b, { className: oa.inputWrapper, flexDirection: "column", children: [
        g && /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
          /* @__PURE__ */ ye.jsx(
            Wn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ ye.jsx("div", { className: oa.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ ye.jsx(
          iF,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      N ? /* @__PURE__ */ ye.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ye.jsx(un, { "data-testid": "jira-widget-issue-spinner" }) }) : F?.length ? /* @__PURE__ */ ye.jsx(
        w1,
        {
          issues: F,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ ye.jsx(A.Paragraph, { align: "center", className: oa.noIssuesFound, children: "No linked issues found" }),
      j && F?.length > 0 && /* @__PURE__ */ ye.jsx(
        Wn,
        {
          variant: "secondary",
          disabled: !F?.length && !v?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      $ && /* @__PURE__ */ ye.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ ye.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ ye.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: v.map((U) => /* @__PURE__ */ ye.jsx(On, { onDelete: () => m(U), children: U }, U)) }),
            /* @__PURE__ */ ye.jsx(
              Wn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ ye.jsx(
        jt,
        {
          slotEnd: /* @__PURE__ */ ye.jsx(me, { name: "external-link" }),
          variant: "tertiary",
          className: oa.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ ye.jsx(
      xF,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: q
      }
    )
  ] });
}, Qf = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
    secret: !1,
    type: "input",
    required: !0,
    customValidation: (e) => NF(e),
    defaultValue: ""
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ga
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    secret: !1,
    type: "switch",
    defaultValue: !1
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var pl = { exports: {} }, sa = {}, Xf;
function TF() {
  if (Xf) return sa;
  Xf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return sa.Fragment = r, sa.jsx = s, sa.jsxs = s, sa;
}
var go = {}, Zf;
function $F() {
  return Zf || (Zf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var E = !1, j = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || E || j || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function W(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return W(c) + ".Consumer";
          case s:
            var p = t;
            return W(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, ke, ue, ce, he, H, be, Ce;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, ue = console.info, ce = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: ke
            }),
            info: K({}, t, {
              value: ue
            }),
            warn: K({}, t, {
              value: ce
            }),
            error: K({}, t, {
              value: he
            }),
            group: K({}, t, {
              value: H
            }),
            groupCollapsed: K({}, t, {
              value: be
            }),
            groupEnd: K({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              y = te;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), T = y.stack.split(`
`), V = x.length - 1, z = T.length - 1; V >= 1 && z >= 0 && x[V] !== T[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== T[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== T[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var C in t)
          if (L(t, C)) {
            var x = void 0;
            try {
              if (typeof t[C] != "function") {
                var T = Error((y || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              x = t[C](c, C, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, C, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, C) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, C = {}, x = null, T = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (T = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (x || T) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(C, z), T && fn(C, z);
        }
        return pn(t, x, T, R, y, B.current, C);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), C; !(C = L.next()).done; )
              an(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var C = ee(t);
        if (!C) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Hn();
          T ? x += T : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    go.Fragment = i, go.jsx = Bn, go.jsxs = qn;
  })()), go;
}
var eh;
function DF() {
  return eh || (eh = 1, process.env.NODE_ENV === "production" ? pl.exports = TF() : pl.exports = $F()), pl.exports;
}
var $e = DF();
function RF({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = mn(), [a, o] = se([]), [s] = i(e, n), [l, d] = se(
    []
  );
  return qe(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((S) => {
        const N = setTimeout(S, r);
        d([...l, N]);
      });
      const v = await s({
        variables: h
      });
      u.push(v);
    }
    o(u);
  }, a];
}
const OF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, PF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, AF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, LF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, VF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, zF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, UF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_EmailMessageContent" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, MF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, BF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, qF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "EnumValue", value: "subscriptions" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, HF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_lists" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, WF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, KF = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": OF,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": PF,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": LF,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": VF,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": AF,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": zF,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              content {\n                ... on Klaviyo_EmailMessageContent {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": UF,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": MF,
  "\n  query getProfileByFilter($emailFilter: String, $phoneNumberFilter: String) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": BF,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": qF,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_lists(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": HF,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_segments(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": WF
};
function Br(e) {
  return KF[e] ?? {};
}
const GF = Br(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), YF = Br(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {
          data {
            id
            type
            attributes {
              content {
                ... on Klaviyo_EmailMessageContent {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), JF = Br(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), QF = Br(
  /* GraphQL */
  `
  query getProfileByFilter($emailFilter: String, $phoneNumberFilter: String) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), XF = Br(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), ZF = Br(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_lists(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), eI = Br(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_segments(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), nI = Br(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), tI = Br(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function Ju(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function nh(e) {
  return Ju(e) && e?.attributes?.event_properties?.$message;
}
function rI(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function th(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function iI(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollection" && e.Klaviyo.get_metrics.data || [];
}
function aI(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function oI(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function sI(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function lI(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function cI(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function rh(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function dI(e) {
  return e?.attributes?.content?.__typename === "Klaviyo_EmailMessageContent" && e.attributes.content.preview_text || void 0;
}
function uI(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const mI = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function pI(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function fI(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function hI({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = mn(), { track: a } = kn(), [o, s] = se(null), [l, d] = se(
    null
  ), [m, u] = se(null), [f, h] = se(null), [v, S] = se(
    null
  ), [N, F] = se([]), {
    data: I,
    error: g,
    loading: q,
    networkStatus: E
  } = i(JF, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    j,
    {
      data: $,
      error: U,
      loading: Z,
      networkStatus: Q
    }
  ] = r(GF, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return qe(() => {
    if (I && !q && E === ar.ready) {
      const ee = iI(I);
      s(
        ee.find((J) => J?.attributes?.name === "Received Email")?.id || null
      ), d(
        ee.find((J) => J?.attributes?.name === "Opened Email")?.id || null
      ), u(
        ee.find((J) => J?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ee.find((J) => J?.attributes?.name === "Bounced Email")?.id || null
      ), S(
        ee.find((J) => J?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), S(null);
  }, [I]), qe(() => {
    o && l && m && f && v && !Z && Q === ar.ready ? j({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        pageSize: n
      }
    }) : F([]);
  }, [
    o,
    l,
    m,
    f,
    v
  ]), qe(() => {
    if (!Z && $) {
      const ee = aI($), J = sI(
        $
      ).map(
        (ue) => ue?.attributes?.event_properties.$message
      ), W = lI(
        $
      ).map(
        (ue) => ue?.attributes?.event_properties.$message
      );
      ee.forEach((ue) => {
        const ce = ue.attributes?.event_properties.$message;
        ue.opened = J.includes(ce), ue.clicked = W.includes(ce);
      });
      const P = oI($), K = cI($), ne = [
        ...ee,
        ...K,
        ...P
      ].sort((ue, ce) => {
        const he = th(ue), H = th(ce);
        return he == null && H == null ? 0 : he == null ? 1 : H == null ? -1 : H - he;
      }).slice(0, n);
      F(ne);
      const ke = ne.map((ue) => ue.id);
      a("klaviyo:messages:received", {
        emailsReceived: ee.filter(
          (ue) => ke.includes(ue.id)
        ).length,
        emailsBounced: K.filter(
          (ue) => ke.includes(ue.id)
        ).length,
        smsReceived: P.filter(
          (ue) => ke.includes(ue.id)
        ).length,
        total: ke.length
      });
    } else
      F([]);
  }, [Z, $]), et(
    () => ({
      receivedMessages: N,
      isLoading: q || Z,
      error: g || U
    }),
    [
      N,
      q,
      Z,
      g,
      U
    ]
  );
}
function yI({ profileId: e }) {
  const { useQuery: n } = mn(), [r, i] = se(), [a, o] = se(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(XF, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  qe(() => {
    l && o(l);
  }, [l]), qe(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return et(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function gI({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = kn(), { useLazyQuery: i } = mn(), [a, o] = se(), [s, l] = se(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(QF, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    if (!f && m) {
      const v = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, S = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(v, S);
    }
  }, [f, m]);
  const h = (v, S) => {
    const N = v?.data?.length === 1 && v.data[0]?.id || void 0, F = S?.data?.length === 1 && S.data[0]?.id || void 0, I = N || F, g = !N || !F || N === F;
    if (I && g) {
      o(N || F), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), g || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${N}) and phone number ${n} (profile ID ${F}).`
      )
    );
  };
  return et(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const ih = 800, kI = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, vI = 3, bI = 1.5, _I = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = vI,
  useDelayRange: a = !1
}) => {
  const o = (U) => Math.floor(Math.random() * (U.max - U.min) + U.min), [s, l] = se(0), [d, m] = se(n || ih), [u, f] = se(r || kI), [h, v] = se(!1), [S, N] = se(!1), F = a || !!r, I = F ? o(u) : n || ih, [g, q] = se(I);
  rw(
    async () => {
      const U = s + 1, Z = bI ** U;
      l(U), q(
        (F ? o(u) : d) * Z
      ), await e().then(() => {
        N(!0), $();
      });
    },
    h ? g : null
  ), aw(() => $());
  const E = at(() => {
    l(0), q(I);
  }, [I]), j = at(
    (U = {}) => {
      const { delay: Z, delayRange: Q } = U;
      N(!1), E(), Q && (f(Q), q(o(Q))), Z && (m(Z), q(Z)), v(!0);
    },
    [E]
  ), $ = at(() => {
    v(!1), E();
  }, [E]);
  return qe(() => {
    s >= i && $();
  }, [s, i, $]), et(
    () => ({ isRunning: h, isSuccessful: S, start: j, stop: $ }),
    [h, S, j, $]
  );
}, xI = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, SI = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function NI({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = mn(), [i, a] = se(), [o, s] = se(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? ZF : eI,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: v,
    stop: S
  } = _I({
    query: u,
    useDelayRange: !0
  }), N = m || h;
  return qe(() => {
    if (d)
      if (xS({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const F = xI(d);
          v({
            ...F && {
              delayRange: SI(F)
            }
          });
        }
      } else
        s(d);
  }, [d]), qe(() => {
    if (!m && l?.Klaviyo) {
      let F = {}, I = {};
      n === "lists" && (F = l?.Klaviyo?.get_profile_lists), n === "segments" && (I = l?.Klaviyo?.get_profile_segments), (F?.data || I?.data) && (S(), a(
        (n === "lists" ? F?.data : I?.data)?.map((g) => ({
          ...g,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), et(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: v,
      isLoading: N,
      error: o,
      networkStatus: f
    }),
    [i, N, o, f, v]
  );
}
const jI = "_notificationText_1polx_1", Bm = {
  notificationText: jI
}, Os = ({ error: e }) => {
  const { track: n } = kn();
  let r = e;
  if (db(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && ab({ error: i[0] }), o = i.length === 1 && _S({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ $e.jsx(wn, { error: e });
  }
  return /* @__PURE__ */ $e.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ $e.jsx(
    He.Item,
    {
      contentLeft: /* @__PURE__ */ $e.jsx(me, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, wI = "_message_1vrar_48", CI = "_messageIsOpen_1vrar_56", FI = "_messageHeader_1vrar_59", II = "_messageLabel_1vrar_65", EI = "_messageText_1vrar_68", Ti = {
  message: wI,
  messageIsOpen: CI,
  messageHeader: FI,
  messageLabel: II,
  messageText: EI
}, TI = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && dI(e.flowMessage);
  return /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
    /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", className: Ti.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ $e.jsx(A.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ $e.jsx(un, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ $e.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ $e.jsx(b, { children: /* @__PURE__ */ $e.jsx(
            A.Paragraph,
            {
              variant: "4",
              className: Ti.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", className: Ti.messageText, children: i })
        ]
      }
    )
  ] });
}, $I = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ $e.jsx($e.Fragment, { children: /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ $e.jsx(b, { children: /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ $e.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, DI = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = se(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = et(
    () => () => l ? Pn(l).format(m) : d ? Pn.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", v = f && e.opened, S = f && e.clicked, N = f && o?.event_properties.Subject, F = h && o?.event_properties["Message Name"], I = f ? "mail" : "sms";
  return /* @__PURE__ */ $e.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: dt(Ti.message, {
        [Ti.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ $e.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: Ti.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ $e.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ $e.jsx(me, { size: 16, name: I }),
                  " ",
                  mI(s),
                  u && /* @__PURE__ */ $e.jsx(Un, { size: "small", variant: "info", children: u })
                ] }),
                N && N,
                F && F
              ] }),
              /* @__PURE__ */ $e.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ $e.jsx(_m, {}),
          rI(e) && /* @__PURE__ */ $e.jsx(b, { children: /* @__PURE__ */ $e.jsx(Un, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
            /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ $e.jsx(On, { children: /* @__PURE__ */ $e.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ $e.jsx(
                  me,
                  {
                    size: 16,
                    color: v ? "green.400" : "red.400",
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ $e.jsx(On, { children: /* @__PURE__ */ $e.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ $e.jsx(
                  me,
                  {
                    size: 16,
                    color: S ? "green.400" : "red.400",
                    name: S ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ $e.jsx(TI, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ $e.jsx($I, { event: e })
        ] })
      ]
    }
  );
}, RI = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, OI = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = se(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = hI({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = RF({
    query: YF,
    options: RI,
    delayMs: 1e3
  }), [m, u] = se([]);
  qe(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((v) => Ju(v)).map((v) => nh(v));
      h.length > 0 && (i(!0), l(
        h.map((v) => ({
          messageId: v
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), qe(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && Ju(h) && !h.flowMessage) {
          const v = nh(h), S = d.find((F) => (F.data && rh(F.data))?.id === v), N = S?.data && rh(S.data);
          if (N)
            return {
              ...uI(h),
              flowMessage: N
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ $e.jsx($e.Fragment, { children: f.map((h, v) => h.graphQLErrors ? /* @__PURE__ */ $e.jsx(
    wn,
    {
      error: h
    },
    `lastMessagesError${v}`
  ) : /* @__PURE__ */ $e.jsx(
    Os,
    {
      error: h
    },
    `lastMessagesError${v}`
  )) }) : /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
    /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(un, {}) }) : /* @__PURE__ */ $e.jsx($e.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ $e.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, v) => /* @__PURE__ */ $e.jsx(
      DI,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: v === 0
      },
      h.id
    )) }) : /* @__PURE__ */ $e.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: Bm.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, PI = "_list_ld0hf_1", AI = "_listItem_ld0hf_4", $a = {
  list: PI,
  listItem: AI
}, ah = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = se(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = NI({ profileId: e, query: n });
  qe(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ $e.jsx(Os, { error: o }) : s ? /* @__PURE__ */ $e.jsx(He.Text, { variant: "dense", className: $a.listItem, children: /* @__PURE__ */ $e.jsx(un, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ $e.jsx($e.Fragment, { children: u.map(
    ({ attributes: f, type: h }, v) => /* @__PURE__ */ $e.jsx(He.Text, { variant: "dense", className: $a.listItem, children: /* @__PURE__ */ $e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ $e.jsx(On, { children: ws(h) })
    ] }) }, v)
  ) }) : r && !a ? /* @__PURE__ */ $e.jsx(He.Text, { variant: "dense", className: $a.listItem, children: /* @__PURE__ */ $e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ $e.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ $e.jsx(me, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ $e.jsxs(A.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ $e.jsx(Ke, { content: "Refresh lists and segments", children: /* @__PURE__ */ $e.jsx(Wn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ $e.jsx(He.Text, { variant: "dense", className: $a.listItem, children: /* @__PURE__ */ $e.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ $e.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, LI = "_tagHover_kzbzk_1", VI = "_channelUnsubscribed_kzbzk_6", oh = {
  tagHover: LI,
  channelUnsubscribed: VI
}, sh = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ $e.jsx(
    Ke,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ $e.jsx(
        On,
        {
          className: oh.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ $e.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: dt({
                [oh.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ $e.jsx(un, { size: 16 }) : /* @__PURE__ */ $e.jsx(me, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, zI = "_subscriptionError_1qhhx_1", UI = {
  subscriptionError: zI
}, MI = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(), { track: h } = kn(), [v, S] = iw({
    channel: null,
    request: null
  }), N = pI(n), F = fI(n), I = !!e, { useMutation: g } = mn(), [q] = g(
    nI
  ), [E] = g(
    tI
  ), j = (Z) => {
    h("klaviyo:profile:subscribe:clicked", { channel: Z }), S.setAll({
      channel: Z,
      request: "subscribed"
    }), ((Q) => q({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: "profile",
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  phone_number: i,
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: e
            }
          }
        }
      }
    }))(Z).then(
      (Q) => U({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !0
      })
    ).catch(
      (Q) => U({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !0
      })
    );
  }, $ = (Z) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: Z }), S.setAll({
      channel: Z,
      request: "unsubscribed"
    }), E({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: "profile",
                attributes: {
                  ...Z === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...Z === "SMS" ? { phone_number: i } : {}
                }
              }
            ]
          }
        }
      }
    }).then(
      (Q) => U({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !1
      })
    ).catch(
      (Q) => U({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !1
      })
    );
  }, U = async ({
    channel: Z,
    mutationResponse: Q,
    mutationErrorResponse: ee,
    isSubscriptionRequest: J
  }) => {
    const W = ee?.networkError, P = W ? W?.statusCode : NaN, K = Q?.errors, ne = !!K && ob({
      errors: K
    });
    P === 202 ? (h(
      J ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: Z }
    ), await o()) : ne ? (h(
      J ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${J ? "opt-in" : "opt-out"}.`
    )) : (h(
      J ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: W?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${J ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return qe(() => {
    if (v.request === "subscribed") {
      const Z = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${v.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      v.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(Z), S.reset()), v.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(Z), S.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ $e.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ $e.jsx(
            sh,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: N,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: I,
              handleAction: () => {
                l(!0), f(void 0), N ? $("EMAIL") : j("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ $e.jsx(
            sh,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: F,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: I,
              handleAction: () => {
                m(!0), f(void 0), F ? $("SMS") : j("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ $e.jsx(b, { className: UI.subscriptionError, children: u })
      ] })
    }
  );
}, BI = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  noOfMessagesToShow: s,
  subscriptionListId: l
}) => {
  const {
    profile: d,
    error: m,
    isLoading: u,
    refetchProfile: f
  } = yI({ profileId: e });
  return m ? /* @__PURE__ */ $e.jsx(Os, { error: m }) : u ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(un, {}) }) : !d && !u ? /* @__PURE__ */ $e.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: Bm.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ $e.jsxs(He, { className: $a.list, children: [
        i && /* @__PURE__ */ $e.jsx(ah, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ $e.jsx(
          ah,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    d && e && o && /* @__PURE__ */ $e.jsx(
      MI,
      {
        profile: d,
        profileId: e,
        subscriptionListId: l,
        refetchProfile: f,
        email: n,
        phoneNumber: r
      }
    ),
    /* @__PURE__ */ $e.jsx(
      OI,
      {
        profileId: e,
        noOfMessagesToShow: s
      }
    )
  ] });
}, qI = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = Number(n?.noOfMessagesToShow), d = n?.subscriptionListId, {
    profileId: m,
    getProfileId: u,
    isLoading: f,
    error: h
  } = gI({ email: r, phoneNumber: i });
  return jS(() => {
    (r || i) && u({
      variables: {
        emailFilter: `equals(email,"${r}")`,
        phoneNumberFilter: `equals(phone_number,"${i}")`
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : f ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(un, {}) }) : h ? /* @__PURE__ */ $e.jsx(Os, { error: h }) : m ? /* @__PURE__ */ $e.jsx(
    BI,
    {
      profileId: m,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      noOfMessagesToShow: l,
      subscriptionListId: d
    }
  ) : /* @__PURE__ */ $e.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: Bm.notificationText,
      children: "No profile ID found"
    }
  );
}, HI = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: bS
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
];
function WI(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const KI = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, GI = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, YI = {};
function lh(e, n) {
  return (YI.jsx ? GI : KI).test(e);
}
const JI = /[ \t\n\f\r]/g;
function QI(e) {
  return typeof e == "object" ? e.type === "text" ? ch(e.value) : !1 : ch(e);
}
function ch(e) {
  return e.replace(JI, "") === "";
}
class to {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
to.prototype.property = {};
to.prototype.normal = {};
to.prototype.space = null;
function f_(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new to(r, i, n);
}
function Qu(e) {
  return e.toLowerCase();
}
class lr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
lr.prototype.space = null;
lr.prototype.boolean = !1;
lr.prototype.booleanish = !1;
lr.prototype.overloadedBoolean = !1;
lr.prototype.number = !1;
lr.prototype.commaSeparated = !1;
lr.prototype.spaceSeparated = !1;
lr.prototype.commaOrSpaceSeparated = !1;
lr.prototype.mustUseProperty = !1;
lr.prototype.defined = !1;
let XI = 0;
const Cn = yi(), mt = yi(), h_ = yi(), Ve = yi(), Xn = yi(), $i = yi(), Gt = yi();
function yi() {
  return 2 ** ++XI;
}
const Xu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Cn,
  booleanish: mt,
  commaOrSpaceSeparated: Gt,
  commaSeparated: $i,
  number: Ve,
  overloadedBoolean: h_,
  spaceSeparated: Xn
}, Symbol.toStringTag, { value: "Module" })), fl = Object.keys(Xu);
class qm extends lr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), dh(this, "space", a), typeof i == "number")
      for (; ++o < fl.length; ) {
        const s = fl[o];
        dh(this, fl[o], (i & Xu[s]) === Xu[s]);
      }
  }
}
qm.prototype.defined = !0;
function dh(e, n, r) {
  r && (e[n] = r);
}
const ZI = {}.hasOwnProperty;
function Bi(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (ZI.call(e.properties, i)) {
      const a = e.properties[i], o = new qm(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[Qu(i)] = i, r[Qu(o.attribute)] = i;
    }
  return new to(n, r, e.space);
}
const y_ = Bi({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), g_ = Bi({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function k_(e, n) {
  return n in e ? e[n] : n;
}
function v_(e, n) {
  return k_(e, n.toLowerCase());
}
const b_ = Bi({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: v_,
  properties: { xmlns: null, xmlnsXLink: null }
}), __ = Bi({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: mt,
    ariaAutoComplete: null,
    ariaBusy: mt,
    ariaChecked: mt,
    ariaColCount: Ve,
    ariaColIndex: Ve,
    ariaColSpan: Ve,
    ariaControls: Xn,
    ariaCurrent: null,
    ariaDescribedBy: Xn,
    ariaDetails: null,
    ariaDisabled: mt,
    ariaDropEffect: Xn,
    ariaErrorMessage: null,
    ariaExpanded: mt,
    ariaFlowTo: Xn,
    ariaGrabbed: mt,
    ariaHasPopup: null,
    ariaHidden: mt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Xn,
    ariaLevel: Ve,
    ariaLive: null,
    ariaModal: mt,
    ariaMultiLine: mt,
    ariaMultiSelectable: mt,
    ariaOrientation: null,
    ariaOwns: Xn,
    ariaPlaceholder: null,
    ariaPosInSet: Ve,
    ariaPressed: mt,
    ariaReadOnly: mt,
    ariaRelevant: null,
    ariaRequired: mt,
    ariaRoleDescription: Xn,
    ariaRowCount: Ve,
    ariaRowIndex: Ve,
    ariaRowSpan: Ve,
    ariaSelected: mt,
    ariaSetSize: Ve,
    ariaSort: null,
    ariaValueMax: Ve,
    ariaValueMin: Ve,
    ariaValueNow: Ve,
    ariaValueText: null,
    role: null
  }
}), eE = Bi({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: v_,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: $i,
    acceptCharset: Xn,
    accessKey: Xn,
    action: null,
    allow: null,
    allowFullScreen: Cn,
    allowPaymentRequest: Cn,
    allowUserMedia: Cn,
    alt: null,
    as: null,
    async: Cn,
    autoCapitalize: null,
    autoComplete: Xn,
    autoFocus: Cn,
    autoPlay: Cn,
    blocking: Xn,
    capture: null,
    charSet: null,
    checked: Cn,
    cite: null,
    className: Xn,
    cols: Ve,
    colSpan: null,
    content: null,
    contentEditable: mt,
    controls: Cn,
    controlsList: Xn,
    coords: Ve | $i,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Cn,
    defer: Cn,
    dir: null,
    dirName: null,
    disabled: Cn,
    download: h_,
    draggable: mt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Cn,
    formTarget: null,
    headers: Xn,
    height: Ve,
    hidden: Cn,
    high: Ve,
    href: null,
    hrefLang: null,
    htmlFor: Xn,
    httpEquiv: Xn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Cn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Cn,
    itemId: null,
    itemProp: Xn,
    itemRef: Xn,
    itemScope: Cn,
    itemType: Xn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Cn,
    low: Ve,
    manifest: null,
    max: null,
    maxLength: Ve,
    media: null,
    method: null,
    min: null,
    minLength: Ve,
    multiple: Cn,
    muted: Cn,
    name: null,
    nonce: null,
    noModule: Cn,
    noValidate: Cn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Cn,
    optimum: Ve,
    pattern: null,
    ping: Xn,
    placeholder: null,
    playsInline: Cn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Cn,
    referrerPolicy: null,
    rel: Xn,
    required: Cn,
    reversed: Cn,
    rows: Ve,
    rowSpan: Ve,
    sandbox: Xn,
    scope: null,
    scoped: Cn,
    seamless: Cn,
    selected: Cn,
    shadowRootClonable: Cn,
    shadowRootDelegatesFocus: Cn,
    shadowRootMode: null,
    shape: null,
    size: Ve,
    sizes: null,
    slot: null,
    span: Ve,
    spellCheck: mt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ve,
    step: null,
    style: null,
    tabIndex: Ve,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Cn,
    useMap: null,
    value: mt,
    width: Ve,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Xn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ve,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ve,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Cn,
    // Lists. Use CSS to reduce space between items instead
    declare: Cn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ve,
    // `<img>` and `<object>`
    leftMargin: Ve,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ve,
    // `<body>`
    marginWidth: Ve,
    // `<body>`
    noResize: Cn,
    // `<frame>`
    noHref: Cn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Cn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Cn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ve,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: mt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ve,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ve,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Cn,
    disableRemotePlayback: Cn,
    prefix: null,
    property: null,
    results: Ve,
    security: null,
    unselectable: null
  }
}), nE = Bi({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: k_,
  properties: {
    about: Gt,
    accentHeight: Ve,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ve,
    amplitude: Ve,
    arabicForm: null,
    ascent: Ve,
    attributeName: null,
    attributeType: null,
    azimuth: Ve,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ve,
    by: null,
    calcMode: null,
    capHeight: Ve,
    className: Xn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ve,
    diffuseConstant: Ve,
    direction: null,
    display: null,
    dur: null,
    divisor: Ve,
    dominantBaseline: null,
    download: Cn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ve,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ve,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ve,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: $i,
    g2: $i,
    glyphName: $i,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ve,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ve,
    horizOriginX: Ve,
    horizOriginY: Ve,
    id: null,
    ideographic: Ve,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ve,
    k: Ve,
    k1: Ve,
    k2: Ve,
    k3: Ve,
    k4: Ve,
    kernelMatrix: Gt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ve,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ve,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ve,
    overlineThickness: Ve,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ve,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Xn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ve,
    pointsAtY: Ve,
    pointsAtZ: Ve,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Gt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Gt,
    rev: Gt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Gt,
    requiredFeatures: Gt,
    requiredFonts: Gt,
    requiredFormats: Gt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ve,
    specularExponent: Ve,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ve,
    strikethroughThickness: Ve,
    string: null,
    stroke: null,
    strokeDashArray: Gt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ve,
    strokeOpacity: Ve,
    strokeWidth: null,
    style: null,
    surfaceScale: Ve,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Gt,
    tabIndex: Ve,
    tableValues: null,
    target: null,
    targetX: Ve,
    targetY: Ve,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Gt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ve,
    underlineThickness: Ve,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ve,
    values: null,
    vAlphabetic: Ve,
    vMathematical: Ve,
    vectorEffect: null,
    vHanging: Ve,
    vIdeographic: Ve,
    version: null,
    vertAdvY: Ve,
    vertOriginX: Ve,
    vertOriginY: Ve,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ve,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), tE = /^data[-\w.:]+$/i, uh = /-[a-z]/g, rE = /[A-Z]/g;
function iE(e, n) {
  const r = Qu(n);
  let i = n, a = lr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && tE.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(uh, oE);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!uh.test(o)) {
        let s = o.replace(rE, aE);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = qm;
  }
  return new a(i, n);
}
function aE(e) {
  return "-" + e.toLowerCase();
}
function oE(e) {
  return e.charAt(1).toUpperCase();
}
const sE = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, lE = f_([g_, y_, b_, __, eE], "html"), Hm = f_([g_, y_, b_, __, nE], "svg");
function cE(e) {
  return e.join(" ").trim();
}
var _i = {}, hl, mh;
function dE() {
  if (mh) return hl;
  mh = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", v = "declaration";
  hl = function(N, F) {
    if (typeof N != "string")
      throw new TypeError("First argument must be a string");
    if (!N) return [];
    F = F || {};
    var I = 1, g = 1;
    function q(P) {
      var K = P.match(n);
      K && (I += K.length);
      var ne = P.lastIndexOf(d);
      g = ~ne ? P.length - ne : g + P.length;
    }
    function E() {
      var P = { line: I, column: g };
      return function(K) {
        return K.position = new j(P), Z(), K;
      };
    }
    function j(P) {
      this.start = P, this.end = { line: I, column: g }, this.source = F.source;
    }
    j.prototype.content = N;
    function $(P) {
      var K = new Error(
        F.source + ":" + I + ":" + g + ": " + P
      );
      if (K.reason = P, K.filename = F.source, K.line = I, K.column = g, K.source = N, !F.silent) throw K;
    }
    function U(P) {
      var K = P.exec(N);
      if (K) {
        var ne = K[0];
        return q(ne), N = N.slice(ne.length), K;
      }
    }
    function Z() {
      U(r);
    }
    function Q(P) {
      var K;
      for (P = P || []; K = ee(); )
        K !== !1 && P.push(K);
      return P;
    }
    function ee() {
      var P = E();
      if (!(m != N.charAt(0) || u != N.charAt(1))) {
        for (var K = 2; f != N.charAt(K) && (u != N.charAt(K) || m != N.charAt(K + 1)); )
          ++K;
        if (K += 2, f === N.charAt(K - 1))
          return $("End of comment missing");
        var ne = N.slice(2, K - 2);
        return g += 2, q(ne), N = N.slice(K), g += 2, P({
          type: h,
          comment: ne
        });
      }
    }
    function J() {
      var P = E(), K = U(i);
      if (K) {
        if (ee(), !U(a)) return $("property missing ':'");
        var ne = U(o), ke = P({
          type: v,
          property: S(K[0].replace(e, f)),
          value: ne ? S(ne[0].replace(e, f)) : f
        });
        return U(s), ke;
      }
    }
    function W() {
      var P = [];
      Q(P);
      for (var K; K = J(); )
        K !== !1 && (P.push(K), Q(P));
      return P;
    }
    return Z(), W();
  };
  function S(N) {
    return N ? N.replace(l, f) : f;
  }
  return hl;
}
var ph;
function uE() {
  if (ph) return _i;
  ph = 1;
  var e = _i && _i.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(_i, "__esModule", { value: !0 }), _i.default = r;
  var n = e(dE());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return _i;
}
var mE = uE();
const fh = /* @__PURE__ */ jm(mE), pE = fh.default || fh, x_ = S_("end"), Wm = S_("start");
function S_(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function fE(e) {
  const n = Wm(e), r = x_(e);
  if (n && r)
    return { start: n, end: r };
}
function Pa(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? hh(e.position) : "start" in e || "end" in e ? hh(e) : "line" in e || "column" in e ? Zu(e) : "";
}
function Zu(e) {
  return yh(e && e.line) + ":" + yh(e && e.column);
}
function hh(e) {
  return Zu(e && e.start) + "-" + Zu(e && e.end);
}
function yh(e) {
  return e && typeof e == "number" ? e : 1;
}
class Ft extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = Pa(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Ft.prototype.file = "";
Ft.prototype.name = "";
Ft.prototype.reason = "";
Ft.prototype.message = "";
Ft.prototype.stack = "";
Ft.prototype.column = void 0;
Ft.prototype.line = void 0;
Ft.prototype.ancestors = void 0;
Ft.prototype.cause = void 0;
Ft.prototype.fatal = void 0;
Ft.prototype.place = void 0;
Ft.prototype.ruleId = void 0;
Ft.prototype.source = void 0;
const Km = {}.hasOwnProperty, hE = /* @__PURE__ */ new Map(), yE = /[A-Z]/g, gE = /-([a-z])/g, kE = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), vE = /* @__PURE__ */ new Set(["td", "th"]), N_ = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function bE(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = FE(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = CE(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? Hm : lE,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = j_(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function j_(e, n, r) {
  if (n.type === "element")
    return _E(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return xE(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return NE(e, n, r);
  if (n.type === "mdxjsEsm")
    return SE(e, n);
  if (n.type === "root")
    return jE(e, n, r);
  if (n.type === "text")
    return wE(e, n);
}
function _E(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = Hm, e.schema = a), e.ancestors.push(n);
  const o = C_(e, n.tagName, !1), s = IE(e, n);
  let l = Ym(e, n);
  return kE.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !QI(d) : !0;
  })), w_(e, s, o, n), Gm(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function xE(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Wa(e, n.position);
}
function SE(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Wa(e, n.position);
}
function NE(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = Hm, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : C_(e, n.name, !0), s = EE(e, n), l = Ym(e, n);
  return w_(e, s, o, n), Gm(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function jE(e, n, r) {
  const i = {};
  return Gm(i, Ym(e, n)), e.create(n, e.Fragment, i, r);
}
function wE(e, n) {
  return n.value;
}
function w_(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function Gm(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function CE(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function FE(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = Wm(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function IE(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && Km.call(n.properties, a)) {
      const o = TE(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && vE.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function EE(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Wa(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Wa(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function Ym(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : hE;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = j_(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function TE(e, n, r) {
  const i = iE(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? WI(r) : cE(r)), i.property === "style") {
      let a = typeof r == "object" ? r : $E(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = DE(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? sE[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function $E(e, n) {
  const r = {};
  try {
    pE(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Ft("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = N_ + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(gE, OE)), r[s] = o;
  }
}
function C_(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = lh(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = lh(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return Km.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Wa(e);
}
function Wa(e, n) {
  const r = new Ft(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = N_ + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function DE(e) {
  const n = {};
  let r;
  for (r in e)
    Km.call(e, r) && (n[RE(r)] = e[r]);
  return n;
}
function RE(e) {
  let n = e.replace(yE, PE);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function OE(e, n) {
  return n.toUpperCase();
}
function PE(e) {
  return "-" + e.toLowerCase();
}
const yl = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, AE = {};
function LE(e, n) {
  const r = AE, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return F_(e, i, a);
}
function F_(e, n, r) {
  if (VE(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return gh(e.children, n, r);
  }
  return Array.isArray(e) ? gh(e, n, r) : "";
}
function gh(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = F_(e[a], n, r);
  return i.join("");
}
function VE(e) {
  return !!(e && typeof e == "object");
}
const kh = document.createElement("i");
function Jm(e) {
  const n = "&" + e + ";";
  kh.innerHTML = n;
  const r = kh.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Dr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function tr(e, n) {
  return e.length > 0 ? (Dr(e, e.length, 0, n), e) : n;
}
const vh = {}.hasOwnProperty;
function zE(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    UE(n, e[r]);
  return n;
}
function UE(e, n) {
  let r;
  for (r in n) {
    const a = (vh.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        vh.call(a, s) || (a[s] = []);
        const l = o[s];
        ME(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function ME(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Dr(e, 0, 0, i);
}
function I_(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function Di(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Cr = Xr(/[A-Za-z]/), Zt = Xr(/[\dA-Za-z]/), BE = Xr(/[#-'*+\--9=?A-Z^-~]/);
function em(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const nm = Xr(/\d/), qE = Xr(/[\dA-Fa-f]/), HE = Xr(/[!-/:-@[-`{-~]/);
function hn(e) {
  return e !== null && e < -2;
}
function Wt(e) {
  return e !== null && (e < 0 || e === 32);
}
function zn(e) {
  return e === -2 || e === -1 || e === 32;
}
const WE = Xr(new RegExp("\\p{P}|\\p{S}", "u")), KE = Xr(/\s/);
function Xr(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function qi(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && Zt(e.charCodeAt(r + 1)) && Zt(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function Zn(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return zn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return zn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const GE = {
  tokenize: YE
};
function YE(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), Zn(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return hn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const JE = {
  tokenize: QE
}, bh = {
  tokenize: XE
};
function QE(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(q) {
    if (i < r.length) {
      const E = r[i];
      return n.containerState = E[1], e.attempt(E[0].continuation, d, m)(q);
    }
    return m(q);
  }
  function d(q) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && g();
      const E = n.events.length;
      let j = E, $;
      for (; j--; )
        if (n.events[j][0] === "exit" && n.events[j][1].type === "chunkFlow") {
          $ = n.events[j][1].end;
          break;
        }
      I(i);
      let U = E;
      for (; U < n.events.length; )
        n.events[U][1].end = {
          ...$
        }, U++;
      return Dr(n.events, j + 1, 0, n.events.slice(E)), n.events.length = U, m(q);
    }
    return l(q);
  }
  function m(q) {
    if (i === r.length) {
      if (!a)
        return h(q);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return S(q);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(bh, u, f)(q);
  }
  function u(q) {
    return a && g(), I(i), h(q);
  }
  function f(q) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, S(q);
  }
  function h(q) {
    return n.containerState = {}, e.attempt(bh, v, S)(q);
  }
  function v(q) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(q);
  }
  function S(q) {
    if (q === null) {
      a && g(), I(0), e.consume(q);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), N(q);
  }
  function N(q) {
    if (q === null) {
      F(e.exit("chunkFlow"), !0), I(0), e.consume(q);
      return;
    }
    return hn(q) ? (e.consume(q), F(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(q), N);
  }
  function F(q, E) {
    const j = n.sliceStream(q);
    if (E && j.push(null), q.previous = o, o && (o.next = q), o = q, a.defineSkip(q.start), a.write(j), n.parser.lazy[q.start.line]) {
      let $ = a.events.length;
      for (; $--; )
        if (
          // The token starts before the line ending…
          a.events[$][1].start.offset < s && // …and either is not ended yet…
          (!a.events[$][1].end || // …or ends after it.
          a.events[$][1].end.offset > s)
        )
          return;
      const U = n.events.length;
      let Z = U, Q, ee;
      for (; Z--; )
        if (n.events[Z][0] === "exit" && n.events[Z][1].type === "chunkFlow") {
          if (Q) {
            ee = n.events[Z][1].end;
            break;
          }
          Q = !0;
        }
      for (I(i), $ = U; $ < n.events.length; )
        n.events[$][1].end = {
          ...ee
        }, $++;
      Dr(n.events, Z + 1, 0, n.events.slice(U)), n.events.length = $;
    }
  }
  function I(q) {
    let E = r.length;
    for (; E-- > q; ) {
      const j = r[E];
      n.containerState = j[1], j[0].exit.call(n, e);
    }
    r.length = q;
  }
  function g() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function XE(e, n, r) {
  return Zn(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function _h(e) {
  if (e === null || Wt(e) || KE(e))
    return 1;
  if (WE(e))
    return 2;
}
function Qm(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const tm = {
  name: "attention",
  resolveAll: ZE,
  tokenize: eT
};
function ZE(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          xh(f, -d), xh(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = tr(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = tr(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = tr(m, Qm(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = tr(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = tr(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Dr(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function eT(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = _h(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = _h(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function xh(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const nT = {
  name: "autolink",
  tokenize: tT
};
function tT(e, n, r) {
  let i = 0;
  return a;
  function a(v) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(v) {
    return Cr(v) ? (e.consume(v), s) : v === 64 ? r(v) : m(v);
  }
  function s(v) {
    return v === 43 || v === 45 || v === 46 || Zt(v) ? (i = 1, l(v)) : m(v);
  }
  function l(v) {
    return v === 58 ? (e.consume(v), i = 0, d) : (v === 43 || v === 45 || v === 46 || Zt(v)) && i++ < 32 ? (e.consume(v), l) : (i = 0, m(v));
  }
  function d(v) {
    return v === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : v === null || v === 32 || v === 60 || em(v) ? r(v) : (e.consume(v), d);
  }
  function m(v) {
    return v === 64 ? (e.consume(v), u) : BE(v) ? (e.consume(v), m) : r(v);
  }
  function u(v) {
    return Zt(v) ? f(v) : r(v);
  }
  function f(v) {
    return v === 46 ? (e.consume(v), i = 0, u) : v === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(v);
  }
  function h(v) {
    if ((v === 45 || Zt(v)) && i++ < 63) {
      const S = v === 45 ? h : f;
      return e.consume(v), S;
    }
    return r(v);
  }
}
const Ps = {
  partial: !0,
  tokenize: rT
};
function rT(e, n, r) {
  return i;
  function i(o) {
    return zn(o) ? Zn(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || hn(o) ? n(o) : r(o);
  }
}
const E_ = {
  continuation: {
    tokenize: aT
  },
  exit: oT,
  name: "blockQuote",
  tokenize: iT
};
function iT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return zn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function aT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return zn(s) ? Zn(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(E_, n, r)(s);
  }
}
function oT(e) {
  e.exit("blockQuote");
}
const T_ = {
  name: "characterEscape",
  tokenize: sT
};
function sT(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return HE(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const $_ = {
  name: "characterReference",
  tokenize: lT
};
function lT(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = Zt, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = qE, u) : (e.enter("characterReferenceValue"), o = 7, s = nm, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === Zt && !Jm(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const Sh = {
  partial: !0,
  tokenize: dT
}, Nh = {
  concrete: !0,
  name: "codeFenced",
  tokenize: cT
};
function cT(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: j
  };
  let o = 0, s = 0, l;
  return d;
  function d($) {
    return m($);
  }
  function m($) {
    const U = i.events[i.events.length - 1];
    return o = U && U[1].type === "linePrefix" ? U[2].sliceSerialize(U[1], !0).length : 0, l = $, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u($);
  }
  function u($) {
    return $ === l ? (s++, e.consume($), u) : s < 3 ? r($) : (e.exit("codeFencedFenceSequence"), zn($) ? Zn(e, f, "whitespace")($) : f($));
  }
  function f($) {
    return $ === null || hn($) ? (e.exit("codeFencedFence"), i.interrupt ? n($) : e.check(Sh, N, E)($)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h($));
  }
  function h($) {
    return $ === null || hn($) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f($)) : zn($) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Zn(e, v, "whitespace")($)) : $ === 96 && $ === l ? r($) : (e.consume($), h);
  }
  function v($) {
    return $ === null || hn($) ? f($) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), S($));
  }
  function S($) {
    return $ === null || hn($) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f($)) : $ === 96 && $ === l ? r($) : (e.consume($), S);
  }
  function N($) {
    return e.attempt(a, E, F)($);
  }
  function F($) {
    return e.enter("lineEnding"), e.consume($), e.exit("lineEnding"), I;
  }
  function I($) {
    return o > 0 && zn($) ? Zn(e, g, "linePrefix", o + 1)($) : g($);
  }
  function g($) {
    return $ === null || hn($) ? e.check(Sh, N, E)($) : (e.enter("codeFlowValue"), q($));
  }
  function q($) {
    return $ === null || hn($) ? (e.exit("codeFlowValue"), g($)) : (e.consume($), q);
  }
  function E($) {
    return e.exit("codeFenced"), n($);
  }
  function j($, U, Z) {
    let Q = 0;
    return ee;
    function ee(ne) {
      return $.enter("lineEnding"), $.consume(ne), $.exit("lineEnding"), J;
    }
    function J(ne) {
      return $.enter("codeFencedFence"), zn(ne) ? Zn($, W, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ne) : W(ne);
    }
    function W(ne) {
      return ne === l ? ($.enter("codeFencedFenceSequence"), P(ne)) : Z(ne);
    }
    function P(ne) {
      return ne === l ? (Q++, $.consume(ne), P) : Q >= s ? ($.exit("codeFencedFenceSequence"), zn(ne) ? Zn($, K, "whitespace")(ne) : K(ne)) : Z(ne);
    }
    function K(ne) {
      return ne === null || hn(ne) ? ($.exit("codeFencedFence"), U(ne)) : Z(ne);
    }
  }
}
function dT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const gl = {
  name: "codeIndented",
  tokenize: mT
}, uT = {
  partial: !0,
  tokenize: pT
};
function mT(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), Zn(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : hn(m) ? e.attempt(uT, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || hn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function pT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : hn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : Zn(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : hn(s) ? a(s) : r(s);
  }
}
const fT = {
  name: "codeText",
  previous: yT,
  resolve: hT,
  tokenize: gT
};
function hT(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function yT(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function gT(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : hn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || hn(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class kT {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && la(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), la(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), la(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        la(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        la(this.left, r.reverse());
      }
  }
}
function la(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function D_(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new kT(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, vT(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Dr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function vT(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, v = r, S = 0, N = 0;
  const F = [N];
  for (; v; ) {
    for (; e.get(++a)[1] !== v; )
      ;
    o.push(a), v._tokenizer || (u = i.sliceStream(v), v.next || u.push(null), f && s.defineSkip(v.start), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = v, v = v.next;
  }
  for (v = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (N = h + 1, F.push(N), v._tokenizer = void 0, v.previous = void 0, v = v.next);
  for (s.events = [], v ? (v._tokenizer = void 0, v.previous = void 0) : F.pop(), h = F.length; h--; ) {
    const I = l.slice(F[h], F[h + 1]), g = o.pop();
    d.push([g, g + I.length - 1]), e.splice(g, 2, I);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[S + d[h][0]] = S + d[h][1], S += d[h][1] - d[h][0] - 1;
  return m;
}
const bT = {
  resolve: xT,
  tokenize: ST
}, _T = {
  partial: !0,
  tokenize: NT
};
function xT(e) {
  return D_(e), e;
}
function ST(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : hn(l) ? e.check(_T, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function NT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), Zn(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || hn(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function R_(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(I) {
    return I === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(I), e.exit(o), h) : I === null || I === 32 || I === 41 || em(I) ? r(I) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), N(I));
  }
  function h(I) {
    return I === 62 ? (e.enter(o), e.consume(I), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(I));
  }
  function v(I) {
    return I === 62 ? (e.exit("chunkString"), e.exit(l), h(I)) : I === null || I === 60 || hn(I) ? r(I) : (e.consume(I), I === 92 ? S : v);
  }
  function S(I) {
    return I === 60 || I === 62 || I === 92 ? (e.consume(I), v) : v(I);
  }
  function N(I) {
    return !u && (I === null || I === 41 || Wt(I)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(I)) : u < m && I === 40 ? (e.consume(I), u++, N) : I === 41 ? (e.consume(I), u--, N) : I === null || I === 32 || I === 40 || em(I) ? r(I) : (e.consume(I), I === 92 ? F : N);
  }
  function F(I) {
    return I === 40 || I === 41 || I === 92 ? (e.consume(I), N) : N(I);
  }
}
function O_(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(v) {
    return e.enter(i), e.enter(a), e.consume(v), e.exit(a), e.enter(o), u;
  }
  function u(v) {
    return l > 999 || v === null || v === 91 || v === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    v === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(v) : v === 93 ? (e.exit(o), e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : hn(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === null || v === 91 || v === 93 || hn(v) || l++ > 999 ? (e.exit("chunkString"), u(v)) : (e.consume(v), d || (d = !zn(v)), v === 92 ? h : f);
  }
  function h(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), l++, f) : f(v);
  }
}
function P_(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : hn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), Zn(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || hn(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function Aa(e, n) {
  let r;
  return i;
  function i(a) {
    return hn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : zn(a) ? Zn(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const jT = {
  name: "definition",
  tokenize: CT
}, wT = {
  partial: !0,
  tokenize: FT
};
function CT(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(v) {
    return e.enter("definition"), s(v);
  }
  function s(v) {
    return O_.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(v);
  }
  function l(v) {
    return a = Di(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), d) : r(v);
  }
  function d(v) {
    return Wt(v) ? Aa(e, m)(v) : m(v);
  }
  function m(v) {
    return R_(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(v);
  }
  function u(v) {
    return e.attempt(wT, f, f)(v);
  }
  function f(v) {
    return zn(v) ? Zn(e, h, "whitespace")(v) : h(v);
  }
  function h(v) {
    return v === null || hn(v) ? (e.exit("definition"), i.parser.defined.push(a), n(v)) : r(v);
  }
}
function FT(e, n, r) {
  return i;
  function i(l) {
    return Wt(l) ? Aa(e, a)(l) : r(l);
  }
  function a(l) {
    return P_(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return zn(l) ? Zn(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || hn(l) ? n(l) : r(l);
  }
}
const IT = {
  name: "hardBreakEscape",
  tokenize: ET
};
function ET(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return hn(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const TT = {
  name: "headingAtx",
  resolve: $T,
  tokenize: DT
};
function $T(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Dr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function DT(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || Wt(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || hn(u) ? (e.exit("atxHeading"), n(u)) : zn(u) ? Zn(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || Wt(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const RT = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], jh = ["pre", "script", "style", "textarea"], OT = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: LT,
  tokenize: VT
}, PT = {
  partial: !0,
  tokenize: UT
}, AT = {
  partial: !0,
  tokenize: zT
};
function LT(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function VT(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(G) {
    return u(G);
  }
  function u(G) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(G), f;
  }
  function f(G) {
    return G === 33 ? (e.consume(G), h) : G === 47 ? (e.consume(G), o = !0, N) : G === 63 ? (e.consume(G), a = 3, i.interrupt ? n : H) : Cr(G) ? (e.consume(G), s = String.fromCharCode(G), F) : r(G);
  }
  function h(G) {
    return G === 45 ? (e.consume(G), a = 2, v) : G === 91 ? (e.consume(G), a = 5, l = 0, S) : Cr(G) ? (e.consume(G), a = 4, i.interrupt ? n : H) : r(G);
  }
  function v(G) {
    return G === 45 ? (e.consume(G), i.interrupt ? n : H) : r(G);
  }
  function S(G) {
    const ze = "CDATA[";
    return G === ze.charCodeAt(l++) ? (e.consume(G), l === ze.length ? i.interrupt ? n : W : S) : r(G);
  }
  function N(G) {
    return Cr(G) ? (e.consume(G), s = String.fromCharCode(G), F) : r(G);
  }
  function F(G) {
    if (G === null || G === 47 || G === 62 || Wt(G)) {
      const ze = G === 47, Be = s.toLowerCase();
      return !ze && !o && jh.includes(Be) ? (a = 1, i.interrupt ? n(G) : W(G)) : RT.includes(s.toLowerCase()) ? (a = 6, ze ? (e.consume(G), I) : i.interrupt ? n(G) : W(G)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(G) : o ? g(G) : q(G));
    }
    return G === 45 || Zt(G) ? (e.consume(G), s += String.fromCharCode(G), F) : r(G);
  }
  function I(G) {
    return G === 62 ? (e.consume(G), i.interrupt ? n : W) : r(G);
  }
  function g(G) {
    return zn(G) ? (e.consume(G), g) : ee(G);
  }
  function q(G) {
    return G === 47 ? (e.consume(G), ee) : G === 58 || G === 95 || Cr(G) ? (e.consume(G), E) : zn(G) ? (e.consume(G), q) : ee(G);
  }
  function E(G) {
    return G === 45 || G === 46 || G === 58 || G === 95 || Zt(G) ? (e.consume(G), E) : j(G);
  }
  function j(G) {
    return G === 61 ? (e.consume(G), $) : zn(G) ? (e.consume(G), j) : q(G);
  }
  function $(G) {
    return G === null || G === 60 || G === 61 || G === 62 || G === 96 ? r(G) : G === 34 || G === 39 ? (e.consume(G), d = G, U) : zn(G) ? (e.consume(G), $) : Z(G);
  }
  function U(G) {
    return G === d ? (e.consume(G), d = null, Q) : G === null || hn(G) ? r(G) : (e.consume(G), U);
  }
  function Z(G) {
    return G === null || G === 34 || G === 39 || G === 47 || G === 60 || G === 61 || G === 62 || G === 96 || Wt(G) ? j(G) : (e.consume(G), Z);
  }
  function Q(G) {
    return G === 47 || G === 62 || zn(G) ? q(G) : r(G);
  }
  function ee(G) {
    return G === 62 ? (e.consume(G), J) : r(G);
  }
  function J(G) {
    return G === null || hn(G) ? W(G) : zn(G) ? (e.consume(G), J) : r(G);
  }
  function W(G) {
    return G === 45 && a === 2 ? (e.consume(G), ke) : G === 60 && a === 1 ? (e.consume(G), ue) : G === 62 && a === 4 ? (e.consume(G), be) : G === 63 && a === 3 ? (e.consume(G), H) : G === 93 && a === 5 ? (e.consume(G), he) : hn(G) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(PT, Ce, P)(G)) : G === null || hn(G) ? (e.exit("htmlFlowData"), P(G)) : (e.consume(G), W);
  }
  function P(G) {
    return e.check(AT, K, Ce)(G);
  }
  function K(G) {
    return e.enter("lineEnding"), e.consume(G), e.exit("lineEnding"), ne;
  }
  function ne(G) {
    return G === null || hn(G) ? P(G) : (e.enter("htmlFlowData"), W(G));
  }
  function ke(G) {
    return G === 45 ? (e.consume(G), H) : W(G);
  }
  function ue(G) {
    return G === 47 ? (e.consume(G), s = "", ce) : W(G);
  }
  function ce(G) {
    if (G === 62) {
      const ze = s.toLowerCase();
      return jh.includes(ze) ? (e.consume(G), be) : W(G);
    }
    return Cr(G) && s.length < 8 ? (e.consume(G), s += String.fromCharCode(G), ce) : W(G);
  }
  function he(G) {
    return G === 93 ? (e.consume(G), H) : W(G);
  }
  function H(G) {
    return G === 62 ? (e.consume(G), be) : G === 45 && a === 2 ? (e.consume(G), H) : W(G);
  }
  function be(G) {
    return G === null || hn(G) ? (e.exit("htmlFlowData"), Ce(G)) : (e.consume(G), be);
  }
  function Ce(G) {
    return e.exit("htmlFlow"), n(G);
  }
}
function zT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return hn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function UT(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(Ps, n, r);
  }
}
const MT = {
  name: "htmlText",
  tokenize: BT
};
function BT(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(H) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(H), d;
  }
  function d(H) {
    return H === 33 ? (e.consume(H), m) : H === 47 ? (e.consume(H), j) : H === 63 ? (e.consume(H), q) : Cr(H) ? (e.consume(H), Z) : r(H);
  }
  function m(H) {
    return H === 45 ? (e.consume(H), u) : H === 91 ? (e.consume(H), o = 0, S) : Cr(H) ? (e.consume(H), g) : r(H);
  }
  function u(H) {
    return H === 45 ? (e.consume(H), v) : r(H);
  }
  function f(H) {
    return H === null ? r(H) : H === 45 ? (e.consume(H), h) : hn(H) ? (s = f, ue(H)) : (e.consume(H), f);
  }
  function h(H) {
    return H === 45 ? (e.consume(H), v) : f(H);
  }
  function v(H) {
    return H === 62 ? ke(H) : H === 45 ? h(H) : f(H);
  }
  function S(H) {
    const be = "CDATA[";
    return H === be.charCodeAt(o++) ? (e.consume(H), o === be.length ? N : S) : r(H);
  }
  function N(H) {
    return H === null ? r(H) : H === 93 ? (e.consume(H), F) : hn(H) ? (s = N, ue(H)) : (e.consume(H), N);
  }
  function F(H) {
    return H === 93 ? (e.consume(H), I) : N(H);
  }
  function I(H) {
    return H === 62 ? ke(H) : H === 93 ? (e.consume(H), I) : N(H);
  }
  function g(H) {
    return H === null || H === 62 ? ke(H) : hn(H) ? (s = g, ue(H)) : (e.consume(H), g);
  }
  function q(H) {
    return H === null ? r(H) : H === 63 ? (e.consume(H), E) : hn(H) ? (s = q, ue(H)) : (e.consume(H), q);
  }
  function E(H) {
    return H === 62 ? ke(H) : q(H);
  }
  function j(H) {
    return Cr(H) ? (e.consume(H), $) : r(H);
  }
  function $(H) {
    return H === 45 || Zt(H) ? (e.consume(H), $) : U(H);
  }
  function U(H) {
    return hn(H) ? (s = U, ue(H)) : zn(H) ? (e.consume(H), U) : ke(H);
  }
  function Z(H) {
    return H === 45 || Zt(H) ? (e.consume(H), Z) : H === 47 || H === 62 || Wt(H) ? Q(H) : r(H);
  }
  function Q(H) {
    return H === 47 ? (e.consume(H), ke) : H === 58 || H === 95 || Cr(H) ? (e.consume(H), ee) : hn(H) ? (s = Q, ue(H)) : zn(H) ? (e.consume(H), Q) : ke(H);
  }
  function ee(H) {
    return H === 45 || H === 46 || H === 58 || H === 95 || Zt(H) ? (e.consume(H), ee) : J(H);
  }
  function J(H) {
    return H === 61 ? (e.consume(H), W) : hn(H) ? (s = J, ue(H)) : zn(H) ? (e.consume(H), J) : Q(H);
  }
  function W(H) {
    return H === null || H === 60 || H === 61 || H === 62 || H === 96 ? r(H) : H === 34 || H === 39 ? (e.consume(H), a = H, P) : hn(H) ? (s = W, ue(H)) : zn(H) ? (e.consume(H), W) : (e.consume(H), K);
  }
  function P(H) {
    return H === a ? (e.consume(H), a = void 0, ne) : H === null ? r(H) : hn(H) ? (s = P, ue(H)) : (e.consume(H), P);
  }
  function K(H) {
    return H === null || H === 34 || H === 39 || H === 60 || H === 61 || H === 96 ? r(H) : H === 47 || H === 62 || Wt(H) ? Q(H) : (e.consume(H), K);
  }
  function ne(H) {
    return H === 47 || H === 62 || Wt(H) ? Q(H) : r(H);
  }
  function ke(H) {
    return H === 62 ? (e.consume(H), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(H);
  }
  function ue(H) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(H), e.exit("lineEnding"), ce;
  }
  function ce(H) {
    return zn(H) ? Zn(e, he, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(H) : he(H);
  }
  function he(H) {
    return e.enter("htmlTextData"), s(H);
  }
}
const Xm = {
  name: "labelEnd",
  resolveAll: KT,
  resolveTo: GT,
  tokenize: YT
}, qT = {
  tokenize: JT
}, HT = {
  tokenize: QT
}, WT = {
  tokenize: XT
};
function KT(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Dr(e, 0, e.length, r), e;
}
function GT(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = tr(l, e.slice(o + 1, o + i + 3)), l = tr(l, [["enter", u, n]]), l = tr(l, Qm(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = tr(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = tr(l, e.slice(s + 1)), l = tr(l, [["exit", d, n]]), Dr(e, o, e.length, l), e;
}
function YT(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(Di(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(qT, u, s ? u : f)(h) : h === 91 ? e.attempt(HT, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(WT, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function JT(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return Wt(f) ? Aa(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : R_(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Wt(f) ? Aa(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? P_(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return Wt(f) ? Aa(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function QT(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return O_.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(Di(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function XT(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const ZT = {
  name: "labelStartImage",
  resolveAll: Xm.resolveAll,
  tokenize: e$
};
function e$(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const n$ = {
  name: "labelStartLink",
  resolveAll: Xm.resolveAll,
  tokenize: t$
};
function t$(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const kl = {
  name: "lineEnding",
  tokenize: r$
};
function r$(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), Zn(e, n, "linePrefix");
  }
}
const Yo = {
  name: "thematicBreak",
  tokenize: i$
};
function i$(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || hn(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), zn(m) ? Zn(e, l, "whitespace")(m) : l(m));
  }
}
const Mt = {
  continuation: {
    tokenize: l$
  },
  exit: d$,
  name: "list",
  tokenize: s$
}, a$ = {
  partial: !0,
  tokenize: u$
}, o$ = {
  partial: !0,
  tokenize: c$
};
function s$(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(v) {
    const S = i.containerState.type || (v === 42 || v === 43 || v === 45 ? "listUnordered" : "listOrdered");
    if (S === "listUnordered" ? !i.containerState.marker || v === i.containerState.marker : nm(v)) {
      if (i.containerState.type || (i.containerState.type = S, e.enter(S, {
        _container: !0
      })), S === "listUnordered")
        return e.enter("listItemPrefix"), v === 42 || v === 45 ? e.check(Yo, r, m)(v) : m(v);
      if (!i.interrupt || v === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(v);
    }
    return r(v);
  }
  function d(v) {
    return nm(v) && ++s < 10 ? (e.consume(v), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? v === i.containerState.marker : v === 41 || v === 46) ? (e.exit("listItemValue"), m(v)) : r(v);
  }
  function m(v) {
    return e.enter("listItemMarker"), e.consume(v), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || v, e.check(
      Ps,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(a$, h, f)
    );
  }
  function u(v) {
    return i.containerState.initialBlankLine = !0, o++, h(v);
  }
  function f(v) {
    return zn(v) ? (e.enter("listItemPrefixWhitespace"), e.consume(v), e.exit("listItemPrefixWhitespace"), h) : r(v);
  }
  function h(v) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(v);
  }
}
function l$(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(Ps, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, Zn(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !zn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(o$, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, Zn(e, e.attempt(Mt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function c$(e, n, r) {
  const i = this;
  return Zn(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function d$(e) {
  e.exit(this.containerState.type);
}
function u$(e, n, r) {
  const i = this;
  return Zn(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !zn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const wh = {
  name: "setextUnderline",
  resolveTo: m$,
  tokenize: p$
};
function m$(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function p$(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), zn(m) ? Zn(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || hn(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const f$ = {
  tokenize: h$
};
function h$(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    Ps,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, Zn(e, e.attempt(this.parser.constructs.flow, a, e.attempt(bT, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const y$ = {
  resolveAll: L_()
}, g$ = A_("string"), k$ = A_("text");
function A_(e) {
  return {
    resolveAll: L_(e === "text" ? v$ : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const v = f[h];
          if (!v.previous || v.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function L_(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function v$(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const b$ = {
  42: Mt,
  43: Mt,
  45: Mt,
  48: Mt,
  49: Mt,
  50: Mt,
  51: Mt,
  52: Mt,
  53: Mt,
  54: Mt,
  55: Mt,
  56: Mt,
  57: Mt,
  62: E_
}, _$ = {
  91: jT
}, x$ = {
  [-2]: gl,
  [-1]: gl,
  32: gl
}, S$ = {
  35: TT,
  42: Yo,
  45: [wh, Yo],
  60: OT,
  61: wh,
  95: Yo,
  96: Nh,
  126: Nh
}, N$ = {
  38: $_,
  92: T_
}, j$ = {
  [-5]: kl,
  [-4]: kl,
  [-3]: kl,
  33: ZT,
  38: $_,
  42: tm,
  60: [nT, MT],
  91: n$,
  92: [IT, T_],
  93: Xm,
  95: tm,
  96: fT
}, w$ = {
  null: [tm, y$]
}, C$ = {
  null: [42, 95]
}, F$ = {
  null: []
}, I$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: C$,
  contentInitial: _$,
  disable: F$,
  document: b$,
  flow: S$,
  flowInitial: x$,
  insideSpan: w$,
  string: N$,
  text: j$
}, Symbol.toStringTag, { value: "Module" }));
function E$(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: U(j),
    check: U($),
    consume: g,
    enter: q,
    exit: E,
    interrupt: U($, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: N,
    events: [],
    now: S,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: v,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(J) {
    return s = tr(s, J), F(), s[s.length - 1] !== null ? [] : (Z(n, 0), m.events = Qm(o, m.events, m), m.events);
  }
  function h(J, W) {
    return $$(v(J), W);
  }
  function v(J) {
    return T$(s, J);
  }
  function S() {
    const {
      _bufferIndex: J,
      _index: W,
      line: P,
      column: K,
      offset: ne
    } = i;
    return {
      _bufferIndex: J,
      _index: W,
      line: P,
      column: K,
      offset: ne
    };
  }
  function N(J) {
    a[J.line] = J.column, ee();
  }
  function F() {
    let J;
    for (; i._index < s.length; ) {
      const W = s[i._index];
      if (typeof W == "string")
        for (J = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === J && i._bufferIndex < W.length; )
          I(W.charCodeAt(i._bufferIndex));
      else
        I(W);
    }
  }
  function I(J) {
    u = u(J);
  }
  function g(J) {
    hn(J) ? (i.line++, i.column = 1, i.offset += J === -3 ? 2 : 1, ee()) : J !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = J;
  }
  function q(J, W) {
    const P = W || {};
    return P.type = J, P.start = S(), m.events.push(["enter", P, m]), l.push(P), P;
  }
  function E(J) {
    const W = l.pop();
    return W.end = S(), m.events.push(["exit", W, m]), W;
  }
  function j(J, W) {
    Z(J, W.from);
  }
  function $(J, W) {
    W.restore();
  }
  function U(J, W) {
    return P;
    function P(K, ne, ke) {
      let ue, ce, he, H;
      return Array.isArray(K) ? (
        /* c8 ignore next 1 */
        Ce(K)
      ) : "tokenize" in K ? (
        // Looks like a construct.
        Ce([
          /** @type {Construct} */
          K
        ])
      ) : be(K);
      function be(Pe) {
        return Me;
        function Me(Ie) {
          const Le = Ie !== null && Pe[Ie], De = Ie !== null && Pe.null, rn = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Le) ? Le : Le ? [Le] : [],
            ...Array.isArray(De) ? De : De ? [De] : []
          ];
          return Ce(rn)(Ie);
        }
      }
      function Ce(Pe) {
        return ue = Pe, ce = 0, Pe.length === 0 ? ke : G(Pe[ce]);
      }
      function G(Pe) {
        return Me;
        function Me(Ie) {
          return H = Q(), he = Pe, Pe.partial || (m.currentConstruct = Pe), Pe.name && m.parser.constructs.disable.null.includes(Pe.name) ? Be() : Pe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            W ? Object.assign(Object.create(m), W) : m,
            d,
            ze,
            Be
          )(Ie);
        }
      }
      function ze(Pe) {
        return J(he, H), ne;
      }
      function Be(Pe) {
        return H.restore(), ++ce < ue.length ? G(ue[ce]) : ke;
      }
    }
  }
  function Z(J, W) {
    J.resolveAll && !o.includes(J) && o.push(J), J.resolve && Dr(m.events, W, m.events.length - W, J.resolve(m.events.slice(W), m)), J.resolveTo && (m.events = J.resolveTo(m.events, m));
  }
  function Q() {
    const J = S(), W = m.previous, P = m.currentConstruct, K = m.events.length, ne = Array.from(l);
    return {
      from: K,
      restore: ke
    };
    function ke() {
      i = J, m.previous = W, m.currentConstruct = P, m.events.length = K, l = ne, ee();
    }
  }
  function ee() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function T$(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function $$(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function D$(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      zE([I$, ...(e || {}).extensions || []])
    ),
    content: a(GE),
    defined: [],
    document: a(JE),
    flow: a(f$),
    lazy: {},
    string: a(g$),
    text: a(k$)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return E$(i, o, l);
    }
  }
}
function R$(e) {
  for (; !D_(e); )
    ;
  return e;
}
const Ch = /[\0\t\n\r]/g;
function O$() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, v;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (Ch.lastIndex = f, m = Ch.exec(o), h = m && m.index !== void 0 ? m.index : o.length, v = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (v === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), v) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const P$ = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function A$(e) {
  return e.replace(P$, L$);
}
function L$(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return I_(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Jm(r) || e;
}
const V_ = {}.hasOwnProperty;
function V$(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), z$(r)(R$(D$(r).document().write(O$()(e, n, !0))));
}
function z$(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Ee),
      autolinkProtocol: Q,
      autolinkEmail: Q,
      atxHeading: o(pe),
      blockQuote: o(De),
      characterEscape: Q,
      characterReference: Q,
      codeFenced: o(rn),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(rn, s),
      codeText: o(je, s),
      codeTextData: Q,
      data: Q,
      codeFlowValue: Q,
      definition: o(We),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Ge),
      hardBreakEscape: o(le),
      hardBreakTrailing: o(le),
      htmlFlow: o(Ne, s),
      htmlFlowData: Q,
      htmlText: o(Ne, s),
      htmlTextData: Q,
      image: o(Ae),
      label: s,
      link: o(Ee),
      listItem: o(w),
      listItemValue: h,
      listOrdered: o(cn, f),
      listUnordered: o(cn),
      paragraph: o(_),
      reference: G,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(pe),
      strong: o(D),
      thematicBreak: o(X)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: j,
      autolink: d(),
      autolinkEmail: Le,
      autolinkProtocol: Ie,
      blockQuote: d(),
      characterEscapeValue: ee,
      characterReferenceMarkerHexadecimal: Be,
      characterReferenceMarkerNumeric: Be,
      characterReferenceValue: Pe,
      characterReference: Me,
      codeFenced: d(F),
      codeFencedFence: N,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: S,
      codeFlowValue: ee,
      codeIndented: d(I),
      codeText: d(ne),
      codeTextData: ee,
      data: ee,
      definition: d(),
      definitionDestinationString: E,
      definitionLabelString: g,
      definitionTitleString: q,
      emphasis: d(),
      hardBreakEscape: d(W),
      hardBreakTrailing: d(W),
      htmlFlow: d(P),
      htmlFlowData: ee,
      htmlText: d(K),
      htmlTextData: ee,
      image: d(ue),
      label: he,
      labelText: ce,
      lineEnding: J,
      link: d(ke),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: ze,
      resourceDestinationString: H,
      resourceTitleString: be,
      resource: Ce,
      setextHeading: d(Z),
      setextHeadingLineSequence: U,
      setextHeadingText: $,
      strong: d(),
      thematicBreak: d()
    }
  };
  z_(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(O) {
    let B = {
      type: "root",
      children: []
    };
    const ie = {
      stack: [B],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, fe = [];
    let _e = -1;
    for (; ++_e < O.length; )
      if (O[_e][1].type === "listOrdered" || O[_e][1].type === "listUnordered")
        if (O[_e][0] === "enter")
          fe.push(_e);
        else {
          const en = fe.pop();
          _e = a(O, en, _e);
        }
    for (_e = -1; ++_e < O.length; ) {
      const en = n[O[_e][0]];
      V_.call(en, O[_e][1].type) && en[O[_e][1].type].call(Object.assign({
        sliceSerialize: O[_e][2].sliceSerialize
      }, ie), O[_e][1]);
    }
    if (ie.tokenStack.length > 0) {
      const en = ie.tokenStack[ie.tokenStack.length - 1];
      (en[1] || Fh).call(ie, void 0, en[0]);
    }
    for (B.position = {
      start: Hr(O.length > 0 ? O[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Hr(O.length > 0 ? O[O.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, _e = -1; ++_e < n.transforms.length; )
      B = n.transforms[_e](B) || B;
    return B;
  }
  function a(O, B, ie) {
    let fe = B - 1, _e = -1, en = !1, dn, tn, sn, fn;
    for (; ++fe <= ie; ) {
      const pn = O[fe];
      switch (pn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          pn[0] === "enter" ? _e++ : _e--, fn = void 0;
          break;
        }
        case "lineEndingBlank": {
          pn[0] === "enter" && (dn && !fn && !_e && !sn && (sn = fe), fn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          fn = void 0;
      }
      if (!_e && pn[0] === "enter" && pn[1].type === "listItemPrefix" || _e === -1 && pn[0] === "exit" && (pn[1].type === "listUnordered" || pn[1].type === "listOrdered")) {
        if (dn) {
          let yn = fe;
          for (tn = void 0; yn--; ) {
            const Xe = O[yn];
            if (Xe[1].type === "lineEnding" || Xe[1].type === "lineEndingBlank") {
              if (Xe[0] === "exit") continue;
              tn && (O[tn][1].type = "lineEndingBlank", en = !0), Xe[1].type = "lineEnding", tn = yn;
            } else if (!(Xe[1].type === "linePrefix" || Xe[1].type === "blockQuotePrefix" || Xe[1].type === "blockQuotePrefixWhitespace" || Xe[1].type === "blockQuoteMarker" || Xe[1].type === "listItemIndent")) break;
          }
          sn && (!tn || sn < tn) && (dn._spread = !0), dn.end = Object.assign({}, tn ? O[tn][1].start : pn[1].end), O.splice(tn || fe, 0, ["exit", dn, pn[2]]), fe++, ie++;
        }
        if (pn[1].type === "listItemPrefix") {
          const yn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, pn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          dn = yn, O.splice(fe, 0, ["enter", yn, pn[2]]), fe++, ie++, sn = void 0, fn = !0;
        }
      }
    }
    return O[B][1]._spread = en, ie;
  }
  function o(O, B) {
    return ie;
    function ie(fe) {
      l.call(this, O(fe), fe), B && B.call(this, fe);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(O, B, ie) {
    this.stack[this.stack.length - 1].children.push(O), this.stack.push(O), this.tokenStack.push([B, ie || void 0]), O.position = {
      start: Hr(B.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(O) {
    return B;
    function B(ie) {
      O && O.call(this, ie), m.call(this, ie);
    }
  }
  function m(O, B) {
    const ie = this.stack.pop(), fe = this.tokenStack.pop();
    if (fe)
      fe[0].type !== O.type && (B ? B.call(this, O, fe[0]) : (fe[1] || Fh).call(this, O, fe[0]));
    else throw new Error("Cannot close `" + O.type + "` (" + Pa({
      start: O.start,
      end: O.end
    }) + "): it’s not open");
    ie.position.end = Hr(O.end);
  }
  function u() {
    return LE(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(O) {
    if (this.data.expectingFirstListItemValue) {
      const B = this.stack[this.stack.length - 2];
      B.start = Number.parseInt(this.sliceSerialize(O), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function v() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.lang = O;
  }
  function S() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.meta = O;
  }
  function N() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function F() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = O.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function I() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = O.replace(/(\r?\n|\r)$/g, "");
  }
  function g(O) {
    const B = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = B, ie.identifier = Di(this.sliceSerialize(O)).toLowerCase();
  }
  function q() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.title = O;
  }
  function E() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.url = O;
  }
  function j(O) {
    const B = this.stack[this.stack.length - 1];
    if (!B.depth) {
      const ie = this.sliceSerialize(O).length;
      B.depth = ie;
    }
  }
  function $() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function U(O) {
    const B = this.stack[this.stack.length - 1];
    B.depth = this.sliceSerialize(O).codePointAt(0) === 61 ? 1 : 2;
  }
  function Z() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Q(O) {
    const ie = this.stack[this.stack.length - 1].children;
    let fe = ie[ie.length - 1];
    (!fe || fe.type !== "text") && (fe = Y(), fe.position = {
      start: Hr(O.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ie.push(fe)), this.stack.push(fe);
  }
  function ee(O) {
    const B = this.stack.pop();
    B.value += this.sliceSerialize(O), B.position.end = Hr(O.end);
  }
  function J(O) {
    const B = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ie = B.children[B.children.length - 1];
      ie.position.end = Hr(O.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(B.type) && (Q.call(this, O), ee.call(this, O));
  }
  function W() {
    this.data.atHardBreak = !0;
  }
  function P() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = O;
  }
  function K() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = O;
  }
  function ne() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = O;
  }
  function ke() {
    const O = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const B = this.data.referenceType || "shortcut";
      O.type += "Reference", O.referenceType = B, delete O.url, delete O.title;
    } else
      delete O.identifier, delete O.label;
    this.data.referenceType = void 0;
  }
  function ue() {
    const O = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const B = this.data.referenceType || "shortcut";
      O.type += "Reference", O.referenceType = B, delete O.url, delete O.title;
    } else
      delete O.identifier, delete O.label;
    this.data.referenceType = void 0;
  }
  function ce(O) {
    const B = this.sliceSerialize(O), ie = this.stack[this.stack.length - 2];
    ie.label = A$(B), ie.identifier = Di(B).toLowerCase();
  }
  function he() {
    const O = this.stack[this.stack.length - 1], B = this.resume(), ie = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ie.type === "link") {
      const fe = O.children;
      ie.children = fe;
    } else
      ie.alt = B;
  }
  function H() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.url = O;
  }
  function be() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.title = O;
  }
  function Ce() {
    this.data.inReference = void 0;
  }
  function G() {
    this.data.referenceType = "collapsed";
  }
  function ze(O) {
    const B = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = B, ie.identifier = Di(this.sliceSerialize(O)).toLowerCase(), this.data.referenceType = "full";
  }
  function Be(O) {
    this.data.characterReferenceType = O.type;
  }
  function Pe(O) {
    const B = this.sliceSerialize(O), ie = this.data.characterReferenceType;
    let fe;
    ie ? (fe = I_(B, ie === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : fe = Jm(B);
    const _e = this.stack[this.stack.length - 1];
    _e.value += fe;
  }
  function Me(O) {
    const B = this.stack.pop();
    B.position.end = Hr(O.end);
  }
  function Ie(O) {
    ee.call(this, O);
    const B = this.stack[this.stack.length - 1];
    B.url = this.sliceSerialize(O);
  }
  function Le(O) {
    ee.call(this, O);
    const B = this.stack[this.stack.length - 1];
    B.url = "mailto:" + this.sliceSerialize(O);
  }
  function De() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function rn() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function je() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function We() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ge() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function pe() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function le() {
    return {
      type: "break"
    };
  }
  function Ne() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ae() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Ee() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function cn(O) {
    return {
      type: "list",
      ordered: O.type === "listOrdered",
      start: null,
      spread: O._spread,
      children: []
    };
  }
  function w(O) {
    return {
      type: "listItem",
      spread: O._spread,
      checked: null,
      children: []
    };
  }
  function _() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function D() {
    return {
      type: "strong",
      children: []
    };
  }
  function Y() {
    return {
      type: "text",
      value: ""
    };
  }
  function X() {
    return {
      type: "thematicBreak"
    };
  }
}
function Hr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function z_(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? z_(e, i) : U$(e, i);
  }
}
function U$(e, n) {
  let r;
  for (r in n)
    if (V_.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Fh(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Pa({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Pa({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Pa({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function M$(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return V$(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function B$(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function q$(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function H$(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function W$(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function K$(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function G$(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = qi(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function Y$(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function J$(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function U_(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function Q$(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return U_(e, n);
  const a = { src: qi(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function X$(e, n) {
  const r = { src: qi(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function Z$(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function eD(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return U_(e, n);
  const a = { href: qi(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function nD(e, n) {
  const r = { href: qi(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function tD(e, n, r) {
  const i = e.all(n), a = r ? rD(r) : M_(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function rD(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = M_(r[i]);
  }
  return n;
}
function M_(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function iD(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function aD(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function oD(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function sD(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function lD(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = Wm(n.children[1]), d = x_(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function cD(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, v = s ? s[d] : void 0;
    v && (h.align = v);
    let S = { type: "element", tagName: o, properties: h, children: [] };
    f && (S.children = e.all(f), e.patch(f, S), S = e.applyData(f, S)), m.push(S);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function dD(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const Ih = 9, Eh = 32;
function uD(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      Th(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(Th(n.slice(a), a > 0, !1)), o.join("");
}
function Th(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Ih || o === Eh; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === Ih || o === Eh; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function mD(e, n) {
  const r = { type: "text", value: uD(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function pD(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const fD = {
  blockquote: B$,
  break: q$,
  code: H$,
  delete: W$,
  emphasis: K$,
  footnoteReference: G$,
  heading: Y$,
  html: J$,
  imageReference: Q$,
  image: X$,
  inlineCode: Z$,
  linkReference: eD,
  link: nD,
  listItem: tD,
  list: iD,
  paragraph: aD,
  // @ts-expect-error: root is different, but hard to type.
  root: oD,
  strong: sD,
  table: lD,
  tableCell: dD,
  tableRow: cD,
  text: mD,
  thematicBreak: pD,
  toml: ko,
  yaml: ko,
  definition: ko,
  footnoteDefinition: ko
};
function ko() {
}
const B_ = -1, As = 0, ps = 1, fs = 2, Zm = 3, ep = 4, np = 5, tp = 6, q_ = 7, H_ = 8, $h = typeof self == "object" ? self : globalThis, hD = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case As:
      case B_:
        return r(s, a);
      case ps: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case fs: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case Zm:
        return r(new Date(s), a);
      case ep: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case np: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case tp: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case q_: {
        const { name: l, message: d } = s;
        return r(new $h[l](d), a);
      }
      case H_:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new $h[o](s), a);
  };
  return i;
}, Dh = (e) => hD(/* @__PURE__ */ new Map(), e)(0), xi = "", { toString: yD } = {}, { keys: gD } = Object, ca = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [As, n];
  const r = yD.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [ps, xi];
    case "Object":
      return [fs, xi];
    case "Date":
      return [Zm, xi];
    case "RegExp":
      return [ep, xi];
    case "Map":
      return [np, xi];
    case "Set":
      return [tp, xi];
  }
  return r.includes("Array") ? [ps, r] : r.includes("Error") ? [q_, r] : [fs, r];
}, vo = ([e, n]) => e === As && (n === "function" || n === "symbol"), kD = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = ca(s);
    switch (l) {
      case As: {
        let u = s;
        switch (d) {
          case "bigint":
            l = H_, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([B_], s);
        }
        return a([l, u], s);
      }
      case ps: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case fs: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of gD(s))
          (e || !vo(ca(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case Zm:
        return a([l, s.toISOString()], s);
      case ep: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case np: {
        const u = [], f = a([l, u], s);
        for (const [h, v] of s)
          (e || !(vo(ca(h)) || vo(ca(v)))) && u.push([o(h), o(v)]);
        return f;
      }
      case tp: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !vo(ca(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, Rh = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return kD(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, hs = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Dh(Rh(e, n)) : structuredClone(e)
) : (e, n) => Dh(Rh(e, n));
function vD(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function bD(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function _D(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || vD, i = e.options.footnoteBackLabel || bD, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = qi(f.toLowerCase());
    let v = 0;
    const S = [], N = e.footnoteCounts.get(f);
    for (; N !== void 0 && ++v <= N; ) {
      S.length > 0 && S.push({ type: "text", value: " " });
      let g = typeof r == "string" ? r : r(d, v);
      typeof g == "string" && (g = { type: "text", value: g }), S.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (v > 1 ? "-" + v : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, v),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(g) ? g : [g]
      });
    }
    const F = u[u.length - 1];
    if (F && F.type === "element" && F.tagName === "p") {
      const g = F.children[F.children.length - 1];
      g && g.type === "text" ? g.value += " " : F.children.push({ type: "text", value: " " }), F.children.push(...S);
    } else
      u.push(...S);
    const I = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, I), l.push(I);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...hs(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const W_ = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return jD;
    if (typeof e == "function")
      return Ls(e);
    if (typeof e == "object")
      return Array.isArray(e) ? xD(e) : SD(e);
    if (typeof e == "string")
      return ND(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function xD(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = W_(e[r]);
  return Ls(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function SD(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Ls(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function ND(e) {
  return Ls(n);
  function n(r) {
    return r && r.type === e;
  }
}
function Ls(e) {
  return n;
  function n(r, i, a) {
    return !!(wD(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function jD() {
  return !0;
}
function wD(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const K_ = [], CD = !0, Oh = !1, FD = "skip";
function ID(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = W_(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const v = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (v ? "<" + v + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let v = K_, S, N, F;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (v = ED(r(d, u)), v[0] === Oh))
        return v;
      if ("children" in d && d.children) {
        const I = (
          /** @type {UnistParent} */
          d
        );
        if (I.children && v[0] !== FD)
          for (N = (i ? I.children.length : -1) + s, F = u.concat(I); N > -1 && N < I.children.length; ) {
            const g = I.children[N];
            if (S = l(g, N, F)(), S[0] === Oh)
              return S;
            N = typeof S[1] == "number" ? S[1] : N + s;
          }
      }
      return v;
    }
  }
}
function ED(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [CD, e] : e == null ? K_ : [e];
}
function G_(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), ID(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const rm = {}.hasOwnProperty, TD = {};
function $D(e, n) {
  const r = n || TD, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...fD, ...r.handlers }, l = {
    all: m,
    applyData: RD,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: DD,
    wrap: PD
  };
  return G_(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, v = l.handlers[h];
    if (rm.call(l.handlers, h) && v)
      return v(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: N, ...F } = u, I = hs(F);
        return I.children = l.all(u), I;
      }
      return hs(u);
    }
    return (l.options.unknownHandler || OD)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let v = -1;
      for (; ++v < h.length; ) {
        const S = l.one(h[v], u);
        if (S) {
          if (v && h[v - 1].type === "break" && (!Array.isArray(S) && S.type === "text" && (S.value = Ph(S.value)), !Array.isArray(S) && S.type === "element")) {
            const N = S.children[0];
            N && N.type === "text" && (N.value = Ph(N.value));
          }
          Array.isArray(S) ? f.push(...S) : f.push(S);
        }
      }
    }
    return f;
  }
}
function DD(e, n) {
  e.position && (n.position = fE(e));
}
function RD(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, hs(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function OD(e, n) {
  const r = n.data || {}, i = "value" in n && !(rm.call(r, "hProperties") || rm.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function PD(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function Ph(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Ah(e, n) {
  const r = $D(e, n), i = r.one(e, void 0), a = _D(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function AD(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Ah(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Ah(r, { file: i, ...e || n })
    );
  };
}
function Lh(e) {
  if (e)
    throw e;
}
var vl, Vh;
function LD() {
  if (Vh) return vl;
  Vh = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return vl = function d() {
    var m, u, f, h, v, S, N = arguments[0], F = 1, I = arguments.length, g = !1;
    for (typeof N == "boolean" && (g = N, N = arguments[1] || {}, F = 2), (N == null || typeof N != "object" && typeof N != "function") && (N = {}); F < I; ++F)
      if (m = arguments[F], m != null)
        for (u in m)
          f = l(N, u), h = l(m, u), N !== h && (g && h && (o(h) || (v = a(h))) ? (v ? (v = !1, S = f && a(f) ? f : []) : S = f && o(f) ? f : {}, s(N, { name: u, newValue: d(g, S, h) })) : typeof h < "u" && s(N, { name: u, newValue: h }));
    return N;
  }, vl;
}
var VD = LD();
const bl = /* @__PURE__ */ jm(VD);
function im(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function zD() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? UD(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function UD(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Nr = { basename: MD, dirname: BD, extname: qD, join: HD, sep: "/" };
function MD(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  ro(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function BD(e) {
  if (ro(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function qD(e) {
  ro(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function HD(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    ro(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : WD(r);
}
function WD(e) {
  ro(e);
  const n = e.codePointAt(0) === 47;
  let r = KD(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function KD(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function ro(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const GD = { cwd: YD };
function YD() {
  return "/";
}
function am(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function JD(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!am(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return QD(e);
}
function QD(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const _l = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class Y_ {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? am(n) ? r = { path: n } : typeof n == "string" || XD(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : GD.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < _l.length; ) {
      const o = _l[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      _l.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Nr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Sl(n, "basename"), xl(n, "basename"), this.path = Nr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Nr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    zh(this.basename, "dirname"), this.path = Nr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Nr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (xl(n, "extname"), zh(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Nr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    am(n) && (n = JD(n)), Sl(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Nr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Sl(n, "stem"), xl(n, "stem"), this.path = Nr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Ft(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function xl(e, n) {
  if (e && e.includes(Nr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Nr.sep + "`"
    );
}
function Sl(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function zh(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function XD(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const ZD = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), eR = {}.hasOwnProperty;
class rp extends ZD {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = zD();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new rp()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(bl(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (wl("data", this.frozen), this.namespace[n] = r, this) : eR.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (wl("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = bo(n), i = this.parser || this.Parser;
    return Nl("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), Nl("process", this.parser || this.Parser), jl("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = bo(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const v = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), S = i.stringify(v, h);
        rR(S) ? h.value = S : h.result = S, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), Nl("processSync", this.parser || this.Parser), jl("processSync", this.compiler || this.Compiler), this.process(n, a), Mh("processSync", "process", r), i;
    function a(o, s) {
      r = !0, Lh(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    Uh(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = bo(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const v = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(v) : i(void 0, v, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), Mh("runSync", "run", i), a;
    function o(s, l) {
      Lh(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = bo(r), a = this.compiler || this.Compiler;
    return jl("stringify", a), Uh(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (wl("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = bl(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [v, ...S] = u;
        const N = i[h][1];
        im(N) && im(v) && (v = bl(!0, N, v)), i[h] = [m, v, ...S];
      }
    }
  }
}
const nR = new rp().freeze();
function Nl(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function jl(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function wl(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Uh(e) {
  if (!im(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Mh(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function bo(e) {
  return tR(e) ? e : new Y_(e);
}
function tR(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function rR(e) {
  return typeof e == "string" || iR(e);
}
function iR(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const aR = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Bh = [], qh = { allowDangerousHtml: !0 }, oR = /^(https?|ircs?|mailto|xmpp)$/i, sR = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function lR(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || Bh, d = e.remarkPlugins || Bh, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...qh } : qh, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || cR, v = nR().use(M$).use(d).use(AD, m).use(l), S = new Y_();
  typeof i == "string" && (S.value = i);
  for (const g of sR)
    Object.hasOwn(e, g.from) && ("" + g.from + (g.to ? "use `" + g.to + "` instead" : "remove it") + aR + g.id, void 0);
  const N = v.parse(S);
  let F = v.runSync(N, S);
  return a && (F = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      F.type === "root" ? F.children : [F]
    )
  }), G_(F, I), bE(F, {
    Fragment: Ue.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Ue.jsx,
    jsxs: Ue.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function I(g, q, E) {
    if (g.type === "raw" && E && typeof q == "number")
      return u ? E.children.splice(q, 1) : E.children[q] = { type: "text", value: g.value }, q;
    if (g.type === "element") {
      let j;
      for (j in yl)
        if (Object.hasOwn(yl, j) && Object.hasOwn(g.properties, j)) {
          const $ = g.properties[j], U = yl[j];
          (U === null || U.includes(g.tagName)) && (g.properties[j] = h(String($ || ""), j, g));
        }
    }
    if (g.type === "element") {
      let j = n ? !n.includes(g.tagName) : s ? s.includes(g.tagName) : !1;
      if (!j && r && typeof q == "number" && (j = !r(g, q, E)), j && E && typeof q == "number")
        return f && g.children ? E.children.splice(q, 1, ...g.children) : E.children.splice(q, 1), q;
    }
  }
}
function cR(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    oR.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Cl = { exports: {} }, da = {}, Hh;
function dR() {
  if (Hh) return da;
  Hh = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return da.Fragment = r, da.jsx = s, da.jsxs = s, da;
}
var _o = {}, Wh;
function uR() {
  return Wh || (Wh = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var E = !1, j = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || E || j || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function W(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return W(c) + ".Consumer";
          case s:
            var p = t;
            return W(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, ke, ue, ce, he, H, be, Ce;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, ue = console.info, ce = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: ke
            }),
            info: K({}, t, {
              value: ue
            }),
            warn: K({}, t, {
              value: ce
            }),
            error: K({}, t, {
              value: he
            }),
            group: K({}, t, {
              value: H
            }),
            groupCollapsed: K({}, t, {
              value: be
            }),
            groupEnd: K({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              y = te;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), T = y.stack.split(`
`), V = x.length - 1, z = T.length - 1; V >= 1 && z >= 0 && x[V] !== T[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== T[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== T[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var C in t)
          if (L(t, C)) {
            var x = void 0;
            try {
              if (typeof t[C] != "function") {
                var T = Error((y || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              x = t[C](c, C, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, C, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, C) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, C = {}, x = null, T = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (T = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (x || T) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(C, z), T && fn(C, z);
        }
        return pn(t, x, T, R, y, B.current, C);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), C; !(C = L.next()).done; )
              an(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var C = ee(t);
        if (!C) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Hn();
          T ? x += T : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    _o.Fragment = i, _o.jsx = Bn, _o.jsxs = qn;
  })()), _o;
}
var Kh;
function mR() {
  return Kh || (Kh = 1, process.env.NODE_ENV === "production" ? Cl.exports = dR() : Cl.exports = uR()), Cl.exports;
}
var oe = mR();
const pR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, fR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, hR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, yR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, gR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, kR = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": pR,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": fR,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": hR,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": yR,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": gR
};
function io(e) {
  return kR[e] ?? {};
}
const vR = io(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), bR = io(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), xo = ({
  title: e,
  children: n
}) => /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), _R = "_issueAvatar_kc0sw_1", xR = "_issueField_kc0sw_9", SR = "_issueDescription_kc0sw_12", So = {
  issueAvatar: _R,
  issueField: xR,
  issueDescription: SR
}, J_ = ({ issue: e }) => /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
  /* @__PURE__ */ oe.jsx(xo, { title: "Assignee", children: /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: So.issueAvatar,
      children: [
        /* @__PURE__ */ oe.jsx(
          xm,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ oe.jsx(xo, { title: "Team", children: /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: So.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ oe.jsx(xo, { title: "Project", children: /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: So.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ oe.jsx(xo, { title: "Description", children: /* @__PURE__ */ oe.jsx(lR, { className: So.issueDescription, children: e.description }) })
] }), NR = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), jR = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), wR = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), CR = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), FR = /* @__PURE__ */ oe.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), Q_ = {
  0: NR,
  1: FR,
  2: CR,
  3: wR,
  4: jR
}, IR = (e) => e in Q_, ys = ({ priority: e }) => IR(e) ? Q_[e] : /* @__PURE__ */ oe.jsx(On, { "data-testid": "defaultPriorityTag", children: e }), ER = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), TR = (e, n) => /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ oe.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ oe.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), $R = (e, n) => /* @__PURE__ */ oe.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ oe.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ oe.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), DR = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), RR = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), OR = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), om = {
  backlog: (e, n) => ER(e, n),
  unstarted: (e, n) => TR(e, n),
  started: (e, n) => $R(e, n),
  done: (e, n) => DR(e, n),
  canceled: (e, n) => RR(e, n),
  completed: (e, n) => OR(e, n)
}, PR = (e) => e in om, gs = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => PR(e) ? om[e](n, r) : om.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), AR = "_wrapper_e0qj3_1", LR = "_resultTitle_e0qj3_21", VR = "_resultTooltipTitle_e0qj3_28", zR = "_resultLinkIcon_e0qj3_31", ua = {
  wrapper: AR,
  resultTitle: LR,
  resultTooltipTitle: VR,
  resultLinkIcon: zR
}, UR = ({
  issue: e
}) => {
  const [n, r] = se(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = wS($S()), o = at(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ oe.jsx(
    Ke,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", className: ua.wrapper, children: [
        /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ oe.jsx(
              gs,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ oe.jsx(ys, { priority: e.priority })
          ] }),
          /* @__PURE__ */ oe.jsx(On, { children: e.state.name })
        ] }),
        /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ oe.jsx(
            A.Heading,
            {
              variant: "heading-3",
              className: ua.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ oe.jsx(J_, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ oe.jsx(
        pt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: ua.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ oe.jsx(
                    gs,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ oe.jsx(ys, { priority: e.priority })
                ] }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", className: ua.resultTitle, children: e.title }),
                n && /* @__PURE__ */ oe.jsx(
                  me,
                  {
                    className: ua.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, MR = "_loader_13xpk_1", BR = "_dropdown_13xpk_8", qR = "_loadMore_13xpk_13", Fl = {
  loader: MR,
  dropdown: BR,
  loadMore: qR
}, HR = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = se(), [a, o] = se([]), [s, l] = se(""), [d, m] = se(!1), { useLazyQuery: u } = mn(), [f, { data: h, loading: v, networkStatus: S }] = u(
    vR,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  Ui(
    () => {
      !v && s !== "" && S === ar.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), qe(() => {
    v || o([]);
  }, [s]), qe(() => {
    if (h && Object.keys(h).length > 0) {
      const F = h.Linear.searchIssues.edges.map(
        ({ node: E }) => E
      ), I = a.filter(
        (E) => !n.find((j) => j.id === E.id)
      ), g = I.filter(
        (E) => !F.find(
          (j) => j.id === E.id
        )
      ), q = F.filter(
        (E) => !n.find((j) => j.id === E.id)
      );
      n.length > 0 ? o(
        d ? [...g, ...q] : q
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [...I, ...F] : F
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const N = () => {
    !v && s !== "" && S === ar.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ oe.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ oe.jsxs(
    Kr,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (F) => F?.title,
      onChange: (F) => e(F.selectedValues[0]),
      dropdownProps: { className: Fl.dropdown },
      filter: {
        value: s,
        onChange: (F) => {
          const I = F.target.value;
          l(I);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((F) => /* @__PURE__ */ oe.jsx(UR, { issue: F }, F.id)),
        r?.hasNextPage && !v && s !== "" && a.length && /* @__PURE__ */ oe.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => N(),
            className: Fl.loadMore,
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        v && s !== "" && /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", className: Fl.loader, children: /* @__PURE__ */ oe.jsx(un, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !v && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, WR = "_collapse_su0f9_1", KR = "_collapseHeader_su0f9_8", GR = "_collapseContent_su0f9_31", YR = "_url_su0f9_35", JR = "_externalLink_su0f9_51", QR = "_emptyState_su0f9_55", Wr = {
  collapse: WR,
  collapseHeader: KR,
  collapseContent: GR,
  url: YR,
  externalLink: JR,
  emptyState: QR
}, XR = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = se(s), { track: m } = kn();
  return n ? /* @__PURE__ */ oe.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ oe.jsx(un, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ oe.jsx(
          A.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: Wr.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          jt,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(me, { name: "external-link" }),
            variant: "tertiary",
            className: Wr.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ oe.jsxs(
            rr,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: Wr.collapse,
              children: [
                /* @__PURE__ */ oe.jsx(rr.Header, { className: Wr.collapseHeader, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ oe.jsx(Ke, { content: /* @__PURE__ */ oe.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(
                        gs,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ oe.jsxs(
                        A.ExternalLink,
                        {
                          className: Wr.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ oe.jsx(me, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ oe.jsx(Ke, { content: /* @__PURE__ */ oe.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(ys, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ oe.jsx(On, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ oe.jsx(rr.Content, { className: Wr.collapseContent, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ oe.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ oe.jsx(On, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(J_, { issue: u }),
                  /* @__PURE__ */ oe.jsx(
                    Wn,
                    {
                      slotStart: /* @__PURE__ */ oe.jsx(me, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ oe.jsxs(
                    jt,
                    {
                      slotEnd: /* @__PURE__ */ oe.jsx(me, { name: "external-link" }),
                      variant: "tertiary",
                      className: Wr.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ oe.jsx(
          Wn,
          {
            slotStart: /* @__PURE__ */ oe.jsx(me, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          jt,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(me, { name: "external-link" }),
            variant: "tertiary",
            className: Wr.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, ZR = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, X_ = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => X_(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, eO = "_modalBody_iv3ua_1", nO = "_error_iv3ua_5", tO = "_dropdown_iv3ua_16", Si = {
  modalBody: eO,
  error: nO,
  dropdown: tO
}, rO = io(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), iO = io(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), aO = io(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), oO = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = mn(), { control: m, handleSubmit: u, reset: f } = sr(), [h, v] = se([]), [S, N] = se(), [F, I] = se([]), [g, q] = se(), [E, j] = se([]), [$, U] = se(), [Z, Q] = se([]), [ee, J] = se(), [W, P] = se([]), [K, ne] = se(), [ke, ue] = se(!1), { useMutation: ce } = mn(), { track: he } = kn(), [H, { loading: be }] = ce(
    rO,
    {
      onError: () => {
        ue(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (je) => {
        const We = {
          identifier: je.Linear?.issueCreate?.issue?.identifier,
          url: je.Linear?.issueCreate?.issue?.url
        };
        je.Linear && je.Linear?.issueCreate?.issue?.id && (a(je.Linear?.issueCreate?.issue?.id), Le(We), ue(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${je.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), he("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Ce,
    { data: G, loading: ze, error: Be }
  ] = l(iO, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (je) => {
      const We = je.Linear.teams.edges.map(
        ({ node: Ge }) => Ge
      );
      v(We), Q(je.Linear.issuePriorityValues), s(`${hO}${je.Linear.organization.urlKey}`);
    }
  }), [Pe, { data: Me, loading: Ie }] = l(aO, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (je) => {
      const We = je?.Linear?.team?.projects?.edges?.map(
        ({ node: le }) => le
      );
      I(We);
      const Ge = je?.Linear?.team?.states?.edges?.map(
        ({ node: le }) => le
      );
      j(Ge);
      const pe = je?.Linear?.team?.templates?.edges?.map(
        ({ node: le }) => le
      );
      P(
        pe.filter(
          (le) => le.type === "issue"
        )
      );
    }
  }), Le = (je) => {
    r(!1), q(void 0), N(void 0), U(void 0), J(void 0), ne(void 0), je && (e(je), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, De = (je) => {
    G && !ze && (H({
      variables: {
        issueTitle: je.title,
        issueDescription: je?.description,
        teamId: je.team.id,
        projectId: je?.project?.id,
        statusId: je?.status?.id,
        priority: je?.priority?.priority
      }
    }), ue(!0));
  };
  qe(() => {
    n && Ce();
  }, [n]);
  const rn = () => {
    he("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ oe.jsxs(
    gt,
    {
      isOpen: n,
      onClose: () => {
        rn(), Le();
      },
      children: [
        /* @__PURE__ */ oe.jsx(
          kt,
          {
            title: "Create new Linear issue",
            onClose: () => {
              rn(), Le();
            }
          }
        ),
        /* @__PURE__ */ oe.jsx(
          vt,
          {
            className: Si.modalBody,
            "data-testid": "createIssueModalBody",
            children: Be ? /* @__PURE__ */ oe.jsx(wn, { error: Be }) : /* @__PURE__ */ oe.jsx("form", { onSubmit: u(De), id: "issueCreationForm", children: /* @__PURE__ */ oe.jsxs(zt, { children: [
              /* @__PURE__ */ oe.jsx(nn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Pt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: je, onChange: We },
                    fieldState: { error: Ge }
                  }) => /* @__PURE__ */ oe.jsx(
                    An,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: Ge?.message ?? null
                      },
                      children: /* @__PURE__ */ oe.jsx(
                        Kr,
                        {
                          dropdownProps: { className: Si.dropdown },
                          placeholder: "Select Linear team",
                          className: dt({ [Si.error]: Ge }),
                          getItemTitleByValue: (pe) => pe?.name,
                          onChange: (pe) => {
                            q(void 0), U(void 0), J(void 0), ne(void 0), N(pe.selectedValues[0]), Pe({
                              variables: { teamId: pe.selectedValues[0].id }
                            }), We(pe.selectedValues[0]);
                          },
                          value: S ? [je] : void 0,
                          children: h?.map((pe) => /* @__PURE__ */ oe.jsx(
                            pt.Item,
                            {
                              value: pe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: pe.name })
                            },
                            pe.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(nn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Pt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: je, onChange: We } }) => {
                    const Ge = Ie ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ oe.jsx(An, { label: "Project", children: /* @__PURE__ */ oe.jsx(
                      Kr,
                      {
                        dropdownProps: { className: Si.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (pe) => pe?.name,
                        disabled: S === void 0,
                        placeholder: S ? "Select Linear project" : "Select a Team first",
                        onChange: (pe) => {
                          q(pe.selectedValues[0]), We(pe.selectedValues[0]);
                        },
                        value: g ? [je] : Ge,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Ie && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(un, { size: 24 })
                            }
                          ),
                          Me && !Ie && F.map((pe) => /* @__PURE__ */ oe.jsx(
                            pt.Item,
                            {
                              value: pe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: pe.name })
                            },
                            pe.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(nn, { span: 6, children: /* @__PURE__ */ oe.jsx(An, { label: "Template", children: /* @__PURE__ */ oe.jsx(
                Kr,
                {
                  clearable: !0,
                  dropdownProps: { className: Si.dropdown },
                  disabled: !S || Ie,
                  placeholder: S ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (je) => je?.name,
                  onChange: (je) => {
                    if (je.selectedValues.length > 0) {
                      ne(je.selectedValues[0]);
                      const We = JSON.parse(
                        je.selectedValues[0].templateData
                      ), Ge = Z.filter(
                        (Ae) => Ae.priority === We.priority
                      );
                      J(
                        Ge ? Ge[0] : void 0
                      );
                      const pe = E.filter(
                        (Ae) => Ae.id === We.stateId
                      );
                      U(
                        pe ? pe[0] : void 0
                      );
                      const le = F.filter(
                        (Ae) => Ae.id === We.projectId
                      );
                      q(
                        le ? le[0] : void 0
                      );
                      const Ne = We.description;
                      f({
                        title: We?.title,
                        priority: Ge[0],
                        status: pe[0],
                        project: le[0],
                        description: Ne ? X_(Ne, ZR) : "",
                        team: S
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: S
                      }), q(void 0), J(void 0), U(void 0), ne(void 0);
                  },
                  value: K ? [K] : void 0,
                  children: W?.map((je) => /* @__PURE__ */ oe.jsx(
                    pt.Item,
                    {
                      value: je,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: je.name })
                    },
                    je.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ oe.jsx(nn, { span: 6, children: /* @__PURE__ */ oe.jsx(
                Pt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: je, value: We },
                    fieldState: { error: Ge }
                  }) => /* @__PURE__ */ oe.jsx(
                    ir,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: We || "",
                        onChange: je
                      },
                      meta: {
                        error: Ge?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(nn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Pt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: je, onChange: We } }) => {
                    const Ge = Ie ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(An, { label: "Status", children: /* @__PURE__ */ oe.jsx(
                      Kr,
                      {
                        dropdownProps: { className: Si.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (pe) => pe?.name,
                        disabled: S === void 0,
                        placeholder: S ? "Select Issue status" : "Select a Team first",
                        onChange: (pe) => {
                          U(pe.selectedValues[0]), We(pe.selectedValues[0]);
                        },
                        value: $ ? [je] : Ge,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Ie && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(un, { size: 24 })
                            }
                          ),
                          Me && !Ie && E.map((pe) => /* @__PURE__ */ oe.jsx(
                            pt.Item,
                            {
                              value: pe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      gs,
                                      {
                                        type: pe.type,
                                        color: pe.color,
                                        name: pe.name
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(A.Paragraph, { children: pe.name })
                                  ]
                                }
                              )
                            },
                            pe.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(nn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Pt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: je, onChange: We } }) => {
                    const Ge = ze ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(An, { label: "Priority", children: /* @__PURE__ */ oe.jsx(
                      Kr,
                      {
                        clearable: !0,
                        getItemTitleByValue: (pe) => pe?.label,
                        disabled: S === void 0,
                        placeholder: S ? "Select Issue priority" : "Select a Team first",
                        onChange: (pe) => {
                          J(pe.selectedValues[0]), We(pe.selectedValues[0]);
                        },
                        value: ee ? [je] : Ge,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Ie && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(un, { size: 24 })
                            }
                          ),
                          G && !ze && Z.map((pe) => /* @__PURE__ */ oe.jsx(
                            pt.Item,
                            {
                              value: pe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      ys,
                                      {
                                        priority: pe.priority
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(A.Paragraph, { children: pe.label })
                                  ]
                                }
                              )
                            },
                            pe.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(nn, { children: /* @__PURE__ */ oe.jsx(
                Pt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: je, value: We },
                    fieldState: { error: Ge }
                  }) => /* @__PURE__ */ oe.jsx(
                    ES,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: We || "",
                        onChange: je
                      },
                      meta: {
                        error: Ge?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ oe.jsx(
          wt,
          {
            confirmOnClick: u(De),
            confirmProps: {
              disabled: be || !G,
              isLoading: ke || ze || Ie,
              loadingIndicator: /* @__PURE__ */ oe.jsx(un, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              rn(), Le();
            }
          }
        )
      ]
    }
  );
}, sO = "_modalWrapper_4kh9u_1", lO = "_copyButton_4kh9u_6", cO = "_copyWrapper_4kh9u_15", dO = "_copyField_4kh9u_24", uO = "_externalLink_4kh9u_47", mO = "_externalLinkIcon_4kh9u_52", pO = "_textWrapper_4kh9u_56", ei = {
  modalWrapper: sO,
  copyButton: lO,
  copyWrapper: cO,
  copyField: dO,
  externalLink: uO,
  externalLinkIcon: mO,
  textWrapper: pO
}, fO = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ oe.jsxs(
  gt,
  {
    isOpen: !!n && e,
    className: ei.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ oe.jsx(
        kt,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ oe.jsx(vt, { children: /* @__PURE__ */ oe.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ oe.jsxs(A.Paragraph, { className: ei.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ oe.jsxs(
                A.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: ei.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ oe.jsx(me, { name: "external-link", className: ei.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ oe.jsx(An, { label: "Linear issue link", children: /* @__PURE__ */ oe.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: ei.copyWrapper,
                children: [
                  /* @__PURE__ */ oe.jsx(
                    kr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: ei.copyField
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(
                    TS,
                    {
                      className: ei.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ oe.jsx(
        wt,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), hO = "https://linear.app/", yO = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), [a, o] = se([]), [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(!1), [h, v] = se(), { useLazyQuery: S } = mn(), [N, F] = se(""), I = n?.enableCreateIssue, g = !!n?.enableUnlinkAll, { track: q } = kn(), {
    loading: E,
    data: j,
    error: $,
    store: U
  } = bm(e?.conversationId ?? null), [
    Z,
    {
      data: Q,
      loading: ee,
      networkStatus: J,
      error: W
    }
  ] = S(bR, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    !E && !$ && j && j?.linear?.issues?.length > 0 ? (o(j.linear.issues), Z({
      variables: {
        linkedIssues: j.linear.issues
      }
    })) : !E && !$ && (i([]), o([]));
  }, [j, E, $]), qe(() => {
    Q && Q?.Linear && !ee && J === ar.ready && Object.keys(Q).length > 0 && i(Q.Linear.issues?.edges?.map(({ node: ue }) => ue));
  }, [Q, ee, J]);
  const P = (ue) => {
    ue && ue?.team?.organization?.urlKey && q("linear:link:issue:clicked", {
      linearInstanceUrl: N,
      linearIssueKey: ue.id
    });
    const ce = (he) => he.id === ue?.id;
    r.some((he) => he && ce(he)) || (j && a.length === 0 && o([]), U({
      linear: {
        issues: [...a, ue.id]
      }
    }));
  }, K = (ue) => {
    const ce = j?.linear.issues.filter((he) => he !== ue) || [];
    q("linear:unlink:issue:clicked", {
      linearInstanceUrl: N,
      linearIssueKey: ue
    }), i(r.filter(({ id: he }) => he !== ue)), o(ce), U({
      linear: {
        issues: ce
      }
    });
  }, ne = () => {
    l(!1), i([]), o([]), U({
      linear: {
        issues: []
      }
    });
  }, ke = E || ee || !j && !$ || (j?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !E && !ee && (W || $) ? /* @__PURE__ */ oe.jsx(wn, { error: W || $ }) : /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ oe.jsxs(
      gt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ oe.jsx(
            kt,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ oe.jsx(vt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ oe.jsx(
            wt,
            {
              confirmOnClick: () => ne(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      oO,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (ue) => m(ue),
        setIsCreationSuccessfulModalOpen: (ue) => f(ue),
        addToLinkedIssueIds: (ue) => {
          U({
            linear: {
              issues: [...a, ue]
            }
          });
        },
        setCreatedIssue: (ue) => v(ue),
        organizationUrl: N,
        setOrganizationUrl: (ue) => F(ue)
      }
    ),
    /* @__PURE__ */ oe.jsx(
      fO,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (ue) => f(ue),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          I && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
            /* @__PURE__ */ oe.jsx(
              Wn,
              {
                variant: "primary",
                onClick: () => {
                  q("linear:create:new:issue:clicked", {
                    linearInstanceUrl: N
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ oe.jsx(HR, { handleSelect: P, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      XR,
      {
        linkedIssues: r,
        isLoading: ke,
        handleUnlinkIssue: K,
        showUnlinkAllModal: (ue) => l(ue),
        showUnlinkAllButton: g,
        organizationUrl: N
      }
    )
  ] });
}, gO = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ga
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Il = { exports: {} }, ma = {}, Gh;
function kO() {
  if (Gh) return ma;
  Gh = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ma.Fragment = r, ma.jsx = s, ma.jsxs = s, ma;
}
var No = {}, Yh;
function vO() {
  return Yh || (Yh = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var E = !1, j = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || E || j || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function W(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return W(c) + ".Consumer";
          case s:
            var p = t;
            return W(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, ke, ue, ce, he, H, be, Ce;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, ue = console.info, ce = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: ke
            }),
            info: K({}, t, {
              value: ue
            }),
            warn: K({}, t, {
              value: ce
            }),
            error: K({}, t, {
              value: he
            }),
            group: K({}, t, {
              value: H
            }),
            groupCollapsed: K({}, t, {
              value: be
            }),
            groupEnd: K({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              y = te;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), T = y.stack.split(`
`), V = x.length - 1, z = T.length - 1; V >= 1 && z >= 0 && x[V] !== T[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== T[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== T[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var C in t)
          if (L(t, C)) {
            var x = void 0;
            try {
              if (typeof t[C] != "function") {
                var T = Error((y || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              x = t[C](c, C, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, C, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, C) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, C = {}, x = null, T = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (T = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (x || T) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(C, z), T && fn(C, z);
        }
        return pn(t, x, T, R, y, B.current, C);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), C; !(C = L.next()).done; )
              an(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var C = ee(t);
        if (!C) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Hn();
          T ? x += T : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    No.Fragment = i, No.jsx = Bn, No.jsxs = qn;
  })()), No;
}
var Jh;
function bO() {
  return Jh || (Jh = 1, process.env.NODE_ENV === "production" ? Il.exports = kO() : Il.exports = vO()), Il.exports;
}
var Re = bO();
const _O = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, xO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, SO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, NO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, jO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, wO = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": _O,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": xO,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": SO,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": NO,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": jO
};
function Vs(e) {
  return wO[e] ?? {};
}
const CO = Vs(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), FO = Vs(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), IO = Vs(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), EO = Vs(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function El(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const TO = "_wrapper_27vny_1", $O = "_copyIcon_27vny_12", pa = {
  wrapper: TO,
  copyIcon: $O
}, DO = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = El(), { isCopied: i, copy: a } = El(), { isCopied: o, copy: s } = El();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: v,
    enrolled_at: S,
    referral_url: N
  } = e, F = f ? Pn(f).isSame(Date.now(), "day") : !1, { name: I, first_name: g, last_name: q } = m ?? {}, E = I ?? (`${g} ${q}`.trim() || "A customer has no name"), j = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ Re.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Re.jsxs(b, { className: pa.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Re.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: pa.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Re.jsx(A.Heading, { variant: "heading-2", children: E }),
          F && /* @__PURE__ */ Re.jsx(A.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Re.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Pn(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    v && /* @__PURE__ */ Re.jsx(b, { gap: "200", children: /* @__PURE__ */ Re.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Pn(S).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Re.jsx(me, { size: l, name: "mail" }),
        /* @__PURE__ */ Re.jsx(A.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ Re.jsx(Ke, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Re.jsx(
        me,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: pa.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ Re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Re.jsx(me, { size: l, name: "link" }),
        /* @__PURE__ */ Re.jsx(Ke, { content: "Shopify shop", children: /* @__PURE__ */ Re.jsx(
          A.ExternalLink,
          {
            href: j,
            target: "_blank",
            rel: "noreferrer",
            children: j.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Re.jsx(Ke, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Re.jsx(
        me,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(j),
          className: pa.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ Re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Re.jsx(me, { size: l, name: "external-link" }),
        /* @__PURE__ */ Re.jsx(Ke, { content: "Referral link", children: /* @__PURE__ */ Re.jsx(
          A.ExternalLink,
          {
            href: N,
            target: "_blank",
            rel: "noreferrer",
            children: N.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Re.jsx(Ke, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Re.jsx(
        me,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: pa.copyIcon
        }
      ) })
    ] })
  ] }) });
}, RO = "_list_1q5b5_5", OO = "_listItem_1q5b5_8", PO = "_listItemEdit_1q5b5_15", AO = "_notificationText_1q5b5_19", Ai = {
  list: RO,
  listItem: OO,
  listItemEdit: PO,
  notificationText: AO
}, LO = "_modalBody_1clhs_1", VO = {
  modalBody: LO
}, zO = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = kn(), [d, m] = se(n), [u, f] = se(""), [h, v] = se(), [S, { loading: N }] = o(
    IO,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), J();
      }
    }
  ), [F, { loading: I }] = o(EO), g = N || I, q = !!h, E = n === d ? "Change the value to update the points" : "", j = isNaN(d), $ = j ? "Points can not be empty" : "", U = d > n && d - n > 1e6, Z = U ? "Points can not exceed 1,000,000" : "", Q = () => {
    d > n && S({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((W) => {
      const P = W?.networkError;
      (P ? P?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), J()) : (l("loyaltylion:add:points:failed"), v(["Failed to add points, try again later."]));
    }), d < n && F({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((W) => {
      W.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), J()) : "errors" in W && (l("loyaltylion:remove:points:failed"), v(
        W.errors?.map((P) => P.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), v(["Failed to remove points, try again later."]);
    });
  }, ee = () => {
    j && m(n), f(""), i();
  }, J = () => {
    a(), ee();
  };
  return /* @__PURE__ */ Re.jsxs(
    gt,
    {
      isOpen: e,
      onClose: ee,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Re.jsx(kt, { title: "Change points", onClose: ee }),
        /* @__PURE__ */ Re.jsxs(vt, { className: VO.modalBody, children: [
          /* @__PURE__ */ Re.jsxs(zt, { children: [
            /* @__PURE__ */ Re.jsx(nn, { span: 6, children: /* @__PURE__ */ Re.jsx(
              ir,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Z || $,
                  warning: E
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (W) => m(W?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Re.jsx(nn, { span: 6, children: /* @__PURE__ */ Re.jsx(
              ir,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (W) => f(W?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !g && q && /* @__PURE__ */ Re.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Re.jsx(He, { children: h?.map((W, P) => /* @__PURE__ */ Re.jsx(
            He.Item,
            {
              variant: "dense",
              title: W,
              contentLeft: /* @__PURE__ */ Re.jsx(
                me,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            P
          )) }) })
        ] }),
        /* @__PURE__ */ Re.jsx(
          wt,
          {
            confirmName: "Save",
            confirmOnClick: () => Q(),
            confirmProps: {
              isLoading: g,
              disabled: j || U || n === d,
              loadingIndicator: /* @__PURE__ */ Re.jsx(un, { size: 16 })
            },
            cancelOnClick: ee
          }
        )
      ]
    }
  );
}, UO = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Re.jsx(He.Text, { variant: "dense", className: Ai.listItem, children: /* @__PURE__ */ Re.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(me, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Re.jsx(A.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ Re.jsx(Ke, { content: "Edit points", children: /* @__PURE__ */ Re.jsx(
        me,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: Ai.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ Re.jsx(Un, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, MO = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = se(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ Re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Re.jsx(A.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Re.jsx(He, { className: Ai.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: v }) => /* @__PURE__ */ Re.jsx(
      UO,
      {
        points: f,
        label: h,
        setIsModalOpen: v
      },
      u
    )) }),
    /* @__PURE__ */ Re.jsx(
      zO,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, BO = "_reward_1wxia_1", qO = {
  reward: BO
}, HO = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Re.jsx(b, { gap: "100", flexDirection: "column", className: qO.reward, children: /* @__PURE__ */ Re.jsx(Ke, { content: a ?? "No description", children: /* @__PURE__ */ Re.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Re.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Re.jsx(me, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Re.jsxs(Un, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Re.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(me, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Re.jsx(
        A.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, WO = ({ customer: e }) => {
  const { useQuery: n } = mn(), [r, i] = se(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(FO, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (qe(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return Ya({ errors: d }) ? /* @__PURE__ */ Re.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Ai.notificationText,
        children: "No rewards found"
      }
    ) : ob({ errors: d }) ? /* @__PURE__ */ Re.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Ai.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ Re.jsx(wn, { error: s });
  }
  return /* @__PURE__ */ Re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Re.jsx(A.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Re.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Re.jsx(un, {}) }) : /* @__PURE__ */ Re.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ Re.jsx(HO, { reward: d }, d.id)) })
  ] });
}, KO = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ Re.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Re.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Re.jsx(On, { children: /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(
        me,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ Re.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Re.jsx(On, { children: /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(me, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Re.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Re.jsx(Ke, { content: "Insights segment", children: /* @__PURE__ */ Re.jsx(On, { children: /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(me, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, GO = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), { track: i } = kn(), [a, o] = se(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: v,
    data: S,
    refetch: N
  } = r(CO, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return qe(() => {
    if (S && !h) {
      const F = (S?.LoyaltyLion?.getCustomers).customers;
      F && F.length > 0 && (o(F[0]), i("loyaltylion:customer:received"));
    }
  }, [S, h]), s?.email ? v ? Ya({
    errors: v.graphQLErrors
  }) ? /* @__PURE__ */ Re.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Ai.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Re.jsx(wn, { error: v }) : h ? /* @__PURE__ */ Re.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Re.jsx(un, {}) }) : f ? /* @__PURE__ */ Re.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Re.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Re.jsxs(Re.Fragment, { children: [
        l && /* @__PURE__ */ Re.jsx(DO, { customer: a }),
        d && /* @__PURE__ */ Re.jsx(KO, { customer: a }),
        m && /* @__PURE__ */ Re.jsx(
          MO,
          {
            customer: a,
            refetchCustomerData: N
          }
        ),
        u && /* @__PURE__ */ Re.jsx(WO, { customer: a })
      ] }) : /* @__PURE__ */ Re.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Re.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, YO = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    required: !0,
    secret: !0,
    type: "basicAuthInput",
    defaultValue: "",
    additionalProperties: {
      username: {
        label: "Token"
      },
      password: {
        label: "Secret"
      }
    }
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Tl = { exports: {} }, fa = {}, Qh;
function JO() {
  if (Qh) return fa;
  Qh = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return fa.Fragment = r, fa.jsx = s, fa.jsxs = s, fa;
}
var jo = {}, Xh;
function QO() {
  return Xh || (Xh = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var E = !1, j = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || E || j || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function W(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return W(c) + ".Consumer";
          case s:
            var p = t;
            return W(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, ke, ue, ce, he, H, be, Ce;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, ue = console.info, ce = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: ke
            }),
            info: K({}, t, {
              value: ue
            }),
            warn: K({}, t, {
              value: ce
            }),
            error: K({}, t, {
              value: he
            }),
            group: K({}, t, {
              value: H
            }),
            groupCollapsed: K({}, t, {
              value: be
            }),
            groupEnd: K({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              y = te;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), T = y.stack.split(`
`), V = x.length - 1, z = T.length - 1; V >= 1 && z >= 0 && x[V] !== T[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== T[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== T[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var C in t)
          if (L(t, C)) {
            var x = void 0;
            try {
              if (typeof t[C] != "function") {
                var T = Error((y || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              x = t[C](c, C, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, C, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, C) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, C = {}, x = null, T = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (T = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (x || T) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(C, z), T && fn(C, z);
        }
        return pn(t, x, T, R, y, B.current, C);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), C; !(C = L.next()).done; )
              an(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var C = ee(t);
        if (!C) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Hn();
          T ? x += T : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    jo.Fragment = i, jo.jsx = Bn, jo.jsxs = qn;
  })()), jo;
}
var Zh;
function XO() {
  return Zh || (Zh = 1, process.env.NODE_ENV === "production" ? Tl.exports = JO() : Tl.exports = QO()), Tl.exports;
}
var jn = XO();
const ZO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, eP = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": ZO
};
function nP(e) {
  return eP[e] ?? {};
}
const {
  entries: Z_,
  setPrototypeOf: ey,
  isFrozen: tP,
  getPrototypeOf: rP,
  getOwnPropertyDescriptor: iP
} = Object;
let {
  freeze: Lt,
  seal: or,
  create: ex
} = Object, {
  apply: sm,
  construct: lm
} = typeof Reflect < "u" && Reflect;
Lt || (Lt = function(e) {
  return e;
});
or || (or = function(e) {
  return e;
});
sm || (sm = function(e, n, r) {
  return e.apply(n, r);
});
lm || (lm = function(e, n) {
  return new e(...n);
});
const wo = Vt(Array.prototype.forEach), aP = Vt(Array.prototype.lastIndexOf), ny = Vt(Array.prototype.pop), ha = Vt(Array.prototype.push), oP = Vt(Array.prototype.splice), Jo = Vt(String.prototype.toLowerCase), $l = Vt(String.prototype.toString), ty = Vt(String.prototype.match), ya = Vt(String.prototype.replace), sP = Vt(String.prototype.indexOf), lP = Vt(String.prototype.trim), ur = Vt(Object.prototype.hasOwnProperty), It = Vt(RegExp.prototype.test), ga = cP(TypeError);
function Vt(e) {
  return function(n) {
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return sm(e, n, i);
  };
}
function cP(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return lm(e, r);
  };
}
function Tn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Jo;
  ey && ey(e, null);
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (tP(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function dP(e) {
  for (let n = 0; n < e.length; n++)
    ur(e, n) || (e[n] = null);
  return e;
}
function ii(e) {
  const n = ex(null);
  for (const [r, i] of Z_(e))
    ur(e, r) && (Array.isArray(i) ? n[r] = dP(i) : i && typeof i == "object" && i.constructor === Object ? n[r] = ii(i) : n[r] = i);
  return n;
}
function ka(e, n) {
  for (; e !== null; ) {
    const i = iP(e, n);
    if (i) {
      if (i.get)
        return Vt(i.get);
      if (typeof i.value == "function")
        return Vt(i.value);
    }
    e = rP(e);
  }
  function r() {
    return null;
  }
  return r;
}
const ry = Lt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Dl = Lt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Rl = Lt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), uP = Lt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Ol = Lt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), mP = Lt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), iy = Lt(["#text"]), ay = Lt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Pl = Lt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), oy = Lt(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Co = Lt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), pP = or(/\{\{[\w\W]*|[\w\W]*\}\}/gm), fP = or(/<%[\w\W]*|[\w\W]*%>/gm), hP = or(/\$\{[\w\W]*/gm), yP = or(/^data-[\-\w.\u00B7-\uFFFF]+$/), gP = or(/^aria-[\-\w]+$/), nx = or(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), kP = or(/^(?:\w+script|data):/i), vP = or(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), tx = or(/^html$/i), bP = or(/^[a-z][.\w]*(-[.\w]+)+$/i);
var sy = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: gP,
  ATTR_WHITESPACE: vP,
  CUSTOM_ELEMENT: bP,
  DATA_ATTR: yP,
  DOCTYPE_NAME: tx,
  ERB_EXPR: fP,
  IS_ALLOWED_URI: nx,
  IS_SCRIPT_OR_DATA: kP,
  MUSTACHE_EXPR: pP,
  TMPLIT_EXPR: hP
});
const va = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, _P = function() {
  return typeof window > "u" ? null : window;
}, xP = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, ly = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function rx() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _P();
  const n = (T) => rx(T);
  if (n.version = "3.2.4", n.removed = [], !e || !e.document || e.document.nodeType !== va.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: r
  } = e;
  const i = r, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: d,
    NodeFilter: m,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: v
  } = e, S = d.prototype, N = ka(S, "cloneNode"), F = ka(S, "remove"), I = ka(S, "nextSibling"), g = ka(S, "childNodes"), q = ka(S, "parentNode");
  if (typeof s == "function") {
    const T = r.createElement("template");
    T.content && T.content.ownerDocument && (r = T.content.ownerDocument);
  }
  let E, j = "";
  const {
    implementation: $,
    createNodeIterator: U,
    createDocumentFragment: Z,
    getElementsByTagName: Q
  } = r, {
    importNode: ee
  } = i;
  let J = ly();
  n.isSupported = typeof Z_ == "function" && typeof q == "function" && $ && $.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: W,
    ERB_EXPR: P,
    TMPLIT_EXPR: K,
    DATA_ATTR: ne,
    ARIA_ATTR: ke,
    IS_SCRIPT_OR_DATA: ue,
    ATTR_WHITESPACE: ce,
    CUSTOM_ELEMENT: he
  } = sy;
  let {
    IS_ALLOWED_URI: H
  } = sy, be = null;
  const Ce = Tn({}, [...ry, ...Dl, ...Rl, ...Ol, ...iy]);
  let G = null;
  const ze = Tn({}, [...ay, ...Pl, ...oy, ...Co]);
  let Be = Object.seal(ex(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Pe = null, Me = null, Ie = !0, Le = !0, De = !1, rn = !0, je = !1, We = !0, Ge = !1, pe = !1, le = !1, Ne = !1, Ae = !1, Ee = !1, cn = !0, w = !1;
  const _ = "user-content-";
  let D = !0, Y = !1, X = {}, O = null;
  const B = Tn({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let ie = null;
  const fe = Tn({}, ["audio", "video", "img", "source", "image", "track"]);
  let _e = null;
  const en = Tn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), dn = "http://www.w3.org/1998/Math/MathML", tn = "http://www.w3.org/2000/svg", sn = "http://www.w3.org/1999/xhtml";
  let fn = sn, pn = !1, yn = null;
  const Xe = Tn({}, [dn, tn, sn], $l);
  let gn = Tn({}, ["mi", "mo", "mn", "ms", "mtext"]), Oe = Tn({}, ["annotation-xml"]);
  const ln = Tn({}, ["title", "style", "font", "a", "script"]);
  let an = null;
  const _n = ["application/xhtml+xml", "text/html"], Hn = "text/html";
  let on = null, Rn = null;
  const xn = r.createElement("form"), vn = function(T) {
    return T instanceof RegExp || T instanceof Function;
  }, Vn = function() {
    let T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Rn && Rn === T)) {
      if ((!T || typeof T != "object") && (T = {}), T = ii(T), an = // eslint-disable-next-line unicorn/prefer-includes
      _n.indexOf(T.PARSER_MEDIA_TYPE) === -1 ? Hn : T.PARSER_MEDIA_TYPE, on = an === "application/xhtml+xml" ? $l : Jo, be = ur(T, "ALLOWED_TAGS") ? Tn({}, T.ALLOWED_TAGS, on) : Ce, G = ur(T, "ALLOWED_ATTR") ? Tn({}, T.ALLOWED_ATTR, on) : ze, yn = ur(T, "ALLOWED_NAMESPACES") ? Tn({}, T.ALLOWED_NAMESPACES, $l) : Xe, _e = ur(T, "ADD_URI_SAFE_ATTR") ? Tn(ii(en), T.ADD_URI_SAFE_ATTR, on) : en, ie = ur(T, "ADD_DATA_URI_TAGS") ? Tn(ii(fe), T.ADD_DATA_URI_TAGS, on) : fe, O = ur(T, "FORBID_CONTENTS") ? Tn({}, T.FORBID_CONTENTS, on) : B, Pe = ur(T, "FORBID_TAGS") ? Tn({}, T.FORBID_TAGS, on) : {}, Me = ur(T, "FORBID_ATTR") ? Tn({}, T.FORBID_ATTR, on) : {}, X = ur(T, "USE_PROFILES") ? T.USE_PROFILES : !1, Ie = T.ALLOW_ARIA_ATTR !== !1, Le = T.ALLOW_DATA_ATTR !== !1, De = T.ALLOW_UNKNOWN_PROTOCOLS || !1, rn = T.ALLOW_SELF_CLOSE_IN_ATTR !== !1, je = T.SAFE_FOR_TEMPLATES || !1, We = T.SAFE_FOR_XML !== !1, Ge = T.WHOLE_DOCUMENT || !1, Ne = T.RETURN_DOM || !1, Ae = T.RETURN_DOM_FRAGMENT || !1, Ee = T.RETURN_TRUSTED_TYPE || !1, le = T.FORCE_BODY || !1, cn = T.SANITIZE_DOM !== !1, w = T.SANITIZE_NAMED_PROPS || !1, D = T.KEEP_CONTENT !== !1, Y = T.IN_PLACE || !1, H = T.ALLOWED_URI_REGEXP || nx, fn = T.NAMESPACE || sn, gn = T.MATHML_TEXT_INTEGRATION_POINTS || gn, Oe = T.HTML_INTEGRATION_POINTS || Oe, Be = T.CUSTOM_ELEMENT_HANDLING || {}, T.CUSTOM_ELEMENT_HANDLING && vn(T.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Be.tagNameCheck = T.CUSTOM_ELEMENT_HANDLING.tagNameCheck), T.CUSTOM_ELEMENT_HANDLING && vn(T.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Be.attributeNameCheck = T.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), T.CUSTOM_ELEMENT_HANDLING && typeof T.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Be.allowCustomizedBuiltInElements = T.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), je && (Le = !1), Ae && (Ne = !0), X && (be = Tn({}, iy), G = [], X.html === !0 && (Tn(be, ry), Tn(G, ay)), X.svg === !0 && (Tn(be, Dl), Tn(G, Pl), Tn(G, Co)), X.svgFilters === !0 && (Tn(be, Rl), Tn(G, Pl), Tn(G, Co)), X.mathMl === !0 && (Tn(be, Ol), Tn(G, oy), Tn(G, Co))), T.ADD_TAGS && (be === Ce && (be = ii(be)), Tn(be, T.ADD_TAGS, on)), T.ADD_ATTR && (G === ze && (G = ii(G)), Tn(G, T.ADD_ATTR, on)), T.ADD_URI_SAFE_ATTR && Tn(_e, T.ADD_URI_SAFE_ATTR, on), T.FORBID_CONTENTS && (O === B && (O = ii(O)), Tn(O, T.FORBID_CONTENTS, on)), D && (be["#text"] = !0), Ge && Tn(be, ["html", "head", "body"]), be.table && (Tn(be, ["tbody"]), delete Pe.tbody), T.TRUSTED_TYPES_POLICY) {
        if (typeof T.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw ga('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof T.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw ga('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        E = T.TRUSTED_TYPES_POLICY, j = E.createHTML("");
      } else
        E === void 0 && (E = xP(v, a)), E !== null && typeof j == "string" && (j = E.createHTML(""));
      Lt && Lt(T), Rn = T;
    }
  }, Mn = Tn({}, [...Dl, ...Rl, ...uP]), bn = Tn({}, [...Ol, ...mP]), Sn = function(T) {
    let V = q(T);
    (!V || !V.tagName) && (V = {
      namespaceURI: fn,
      tagName: "template"
    });
    const z = Jo(T.tagName), re = Jo(V.tagName);
    return yn[T.namespaceURI] ? T.namespaceURI === tn ? V.namespaceURI === sn ? z === "svg" : V.namespaceURI === dn ? z === "svg" && (re === "annotation-xml" || gn[re]) : !!Mn[z] : T.namespaceURI === dn ? V.namespaceURI === sn ? z === "math" : V.namespaceURI === tn ? z === "math" && Oe[re] : !!bn[z] : T.namespaceURI === sn ? V.namespaceURI === tn && !Oe[re] || V.namespaceURI === dn && !gn[re] ? !1 : !bn[z] && (ln[z] || !Mn[z]) : !!(an === "application/xhtml+xml" && yn[T.namespaceURI]) : !1;
  }, $n = function(T) {
    ha(n.removed, {
      element: T
    });
    try {
      q(T).removeChild(T);
    } catch {
      F(T);
    }
  }, Ln = function(T, V) {
    try {
      ha(n.removed, {
        attribute: V.getAttributeNode(T),
        from: V
      });
    } catch {
      ha(n.removed, {
        attribute: null,
        from: V
      });
    }
    if (V.removeAttribute(T), T === "is")
      if (Ne || Ae)
        try {
          $n(V);
        } catch {
        }
      else
        try {
          V.setAttribute(T, "");
        } catch {
        }
  }, Bn = function(T) {
    let V = null, z = null;
    if (le)
      T = "<remove></remove>" + T;
    else {
      const ve = ty(T, /^[\r\n\t ]+/);
      z = ve && ve[0];
    }
    an === "application/xhtml+xml" && fn === sn && (T = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + T + "</body></html>");
    const re = E ? E.createHTML(T) : T;
    if (fn === sn)
      try {
        V = new h().parseFromString(re, an);
      } catch {
      }
    if (!V || !V.documentElement) {
      V = $.createDocument(fn, "template", null);
      try {
        V.documentElement.innerHTML = pn ? j : re;
      } catch {
      }
    }
    const we = V.body || V.documentElement;
    return T && z && we.insertBefore(r.createTextNode(z), we.childNodes[0] || null), fn === sn ? Q.call(V, Ge ? "html" : "body")[0] : Ge ? V.documentElement : we;
  }, qn = function(T) {
    return U.call(
      T.ownerDocument || T,
      T,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, t = function(T) {
    return T instanceof f && (typeof T.nodeName != "string" || typeof T.textContent != "string" || typeof T.removeChild != "function" || !(T.attributes instanceof u) || typeof T.removeAttribute != "function" || typeof T.setAttribute != "function" || typeof T.namespaceURI != "string" || typeof T.insertBefore != "function" || typeof T.hasChildNodes != "function");
  }, c = function(T) {
    return typeof l == "function" && T instanceof l;
  };
  function p(T, V, z) {
    wo(T, (re) => {
      re.call(n, V, z, Rn);
    });
  }
  const y = function(T) {
    let V = null;
    if (p(J.beforeSanitizeElements, T, null), t(T))
      return $n(T), !0;
    const z = on(T.nodeName);
    if (p(J.uponSanitizeElement, T, {
      tagName: z,
      allowedTags: be
    }), T.hasChildNodes() && !c(T.firstElementChild) && It(/<[/\w]/g, T.innerHTML) && It(/<[/\w]/g, T.textContent) || T.nodeType === va.progressingInstruction || We && T.nodeType === va.comment && It(/<[/\w]/g, T.data))
      return $n(T), !0;
    if (!be[z] || Pe[z]) {
      if (!Pe[z] && L(z) && (Be.tagNameCheck instanceof RegExp && It(Be.tagNameCheck, z) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(z)))
        return !1;
      if (D && !O[z]) {
        const re = q(T) || T.parentNode, we = g(T) || T.childNodes;
        if (we && re) {
          const ve = we.length;
          for (let te = ve - 1; te >= 0; --te) {
            const Ze = N(we[te], !0);
            Ze.__removalCount = (T.__removalCount || 0) + 1, re.insertBefore(Ze, I(T));
          }
        }
      }
      return $n(T), !0;
    }
    return T instanceof d && !Sn(T) || (z === "noscript" || z === "noembed" || z === "noframes") && It(/<\/no(script|embed|frames)/i, T.innerHTML) ? ($n(T), !0) : (je && T.nodeType === va.text && (V = T.textContent, wo([W, P, K], (re) => {
      V = ya(V, re, " ");
    }), T.textContent !== V && (ha(n.removed, {
      element: T.cloneNode()
    }), T.textContent = V)), p(J.afterSanitizeElements, T, null), !1);
  }, R = function(T, V, z) {
    if (cn && (V === "id" || V === "name") && (z in r || z in xn))
      return !1;
    if (!(Le && !Me[V] && It(ne, V)) && !(Ie && It(ke, V))) {
      if (!G[V] || Me[V]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(L(T) && (Be.tagNameCheck instanceof RegExp && It(Be.tagNameCheck, T) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(T)) && (Be.attributeNameCheck instanceof RegExp && It(Be.attributeNameCheck, V) || Be.attributeNameCheck instanceof Function && Be.attributeNameCheck(V)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          V === "is" && Be.allowCustomizedBuiltInElements && (Be.tagNameCheck instanceof RegExp && It(Be.tagNameCheck, z) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(z)))
        ) return !1;
      } else if (!_e[V] && !It(H, ya(z, ce, "")) && !((V === "src" || V === "xlink:href" || V === "href") && T !== "script" && sP(z, "data:") === 0 && ie[T]) && !(De && !It(ue, ya(z, ce, ""))) && z)
        return !1;
    }
    return !0;
  }, L = function(T) {
    return T !== "annotation-xml" && ty(T, he);
  }, C = function(T) {
    p(J.beforeSanitizeAttributes, T, null);
    const {
      attributes: V
    } = T;
    if (!V || t(T))
      return;
    const z = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: G,
      forceKeepAttr: void 0
    };
    let re = V.length;
    for (; re--; ) {
      const we = V[re], {
        name: ve,
        namespaceURI: te,
        value: Ze
      } = we, In = on(ve);
      let Nn = ve === "value" ? Ze : lP(Ze);
      if (z.attrName = In, z.attrValue = Nn, z.keepAttr = !0, z.forceKeepAttr = void 0, p(J.uponSanitizeAttribute, T, z), Nn = z.attrValue, w && (In === "id" || In === "name") && (Ln(ve, T), Nn = _ + Nn), We && It(/((--!?|])>)|<\/(style|title)/i, Nn)) {
        Ln(ve, T);
        continue;
      }
      if (z.forceKeepAttr || (Ln(ve, T), !z.keepAttr))
        continue;
      if (!rn && It(/\/>/i, Nn)) {
        Ln(ve, T);
        continue;
      }
      je && wo([W, P, K], (uS) => {
        Nn = ya(Nn, uS, " ");
      });
      const Ap = on(T.nodeName);
      if (R(Ap, In, Nn)) {
        if (E && typeof v == "object" && typeof v.getAttributeType == "function" && !te)
          switch (v.getAttributeType(Ap, In)) {
            case "TrustedHTML": {
              Nn = E.createHTML(Nn);
              break;
            }
            case "TrustedScriptURL": {
              Nn = E.createScriptURL(Nn);
              break;
            }
          }
        try {
          te ? T.setAttributeNS(te, ve, Nn) : T.setAttribute(ve, Nn), t(T) ? $n(T) : ny(n.removed);
        } catch {
        }
      }
    }
    p(J.afterSanitizeAttributes, T, null);
  }, x = function T(V) {
    let z = null;
    const re = qn(V);
    for (p(J.beforeSanitizeShadowDOM, V, null); z = re.nextNode(); )
      p(J.uponSanitizeShadowNode, z, null), y(z), C(z), z.content instanceof o && T(z.content);
    p(J.afterSanitizeShadowDOM, V, null);
  };
  return n.sanitize = function(T) {
    let V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, z = null, re = null, we = null, ve = null;
    if (pn = !T, pn && (T = "<!-->"), typeof T != "string" && !c(T))
      if (typeof T.toString == "function") {
        if (T = T.toString(), typeof T != "string")
          throw ga("dirty is not a string, aborting");
      } else
        throw ga("toString is not a function");
    if (!n.isSupported)
      return T;
    if (pe || Vn(V), n.removed = [], typeof T == "string" && (Y = !1), Y) {
      if (T.nodeName) {
        const In = on(T.nodeName);
        if (!be[In] || Pe[In])
          throw ga("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (T instanceof l)
      z = Bn("<!---->"), re = z.ownerDocument.importNode(T, !0), re.nodeType === va.element && re.nodeName === "BODY" || re.nodeName === "HTML" ? z = re : z.appendChild(re);
    else {
      if (!Ne && !je && !Ge && // eslint-disable-next-line unicorn/prefer-includes
      T.indexOf("<") === -1)
        return E && Ee ? E.createHTML(T) : T;
      if (z = Bn(T), !z)
        return Ne ? null : Ee ? j : "";
    }
    z && le && $n(z.firstChild);
    const te = qn(Y ? T : z);
    for (; we = te.nextNode(); )
      y(we), C(we), we.content instanceof o && x(we.content);
    if (Y)
      return T;
    if (Ne) {
      if (Ae)
        for (ve = Z.call(z.ownerDocument); z.firstChild; )
          ve.appendChild(z.firstChild);
      else
        ve = z;
      return (G.shadowroot || G.shadowrootmode) && (ve = ee.call(i, ve, !0)), ve;
    }
    let Ze = Ge ? z.outerHTML : z.innerHTML;
    return Ge && be["!doctype"] && z.ownerDocument && z.ownerDocument.doctype && z.ownerDocument.doctype.name && It(tx, z.ownerDocument.doctype.name) && (Ze = "<!DOCTYPE " + z.ownerDocument.doctype.name + `>
` + Ze), je && wo([W, P, K], (In) => {
      Ze = ya(Ze, In, " ");
    }), E && Ee ? E.createHTML(Ze) : Ze;
  }, n.setConfig = function() {
    let T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vn(T), pe = !0;
  }, n.clearConfig = function() {
    Rn = null, pe = !1;
  }, n.isValidAttribute = function(T, V, z) {
    Rn || Vn({});
    const re = on(T), we = on(V);
    return R(re, we, z);
  }, n.addHook = function(T, V) {
    typeof V == "function" && ha(J[T], V);
  }, n.removeHook = function(T, V) {
    if (V !== void 0) {
      const z = aP(J[T], V);
      return z === -1 ? void 0 : oP(J[T], z, 1)[0];
    }
    return ny(J[T]);
  }, n.removeHooks = function(T) {
    J[T] = [];
  }, n.removeAllHooks = function() {
    J = ly();
  }, n;
}
var SP = rx();
const NP = "_messageContainer_1rxr4_1", jP = "_chip_1rxr4_7", wP = "_chipLabel_1rxr4_10", CP = "_chipValue_1rxr4_13", Fo = {
  messageContainer: NP,
  chip: jP,
  chipLabel: wP,
  chipValue: CP
}, cy = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, FP = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  qe(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ jn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ jn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ jn.jsx(Ke, { content: "Conversation Attributes", children: /* @__PURE__ */ jn.jsx(
        xm,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ jn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ jn.jsx(On, { className: Fo.chip, children: /* @__PURE__ */ jn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ jn.jsxs(Jn, { className: Fo.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ jn.jsx(Jn, { className: Fo.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ jn.jsx(
      b,
      {
        className: Fo.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? cy[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? cy[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ jn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ jn.jsx(A.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ jn.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ jn.jsx(DS, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ jn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: SP.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ jn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ jn.jsx(
      RS,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ jn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, IP = "_conversation_1draa_1", EP = "_conversationSubLine_1draa_9", TP = "_modal_1draa_14", Al = {
  conversation: IP,
  conversationSubLine: EP,
  modal: TP
}, $P = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), DP = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), RP = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = se(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ jn.jsxs(b, { className: Al.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ jn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ jn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ jn.jsx(A.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ jn.jsx(Un, { size: "small", variant: "info", children: Pn(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ jn.jsx(
          A.Heading,
          {
            variant: "heading-4",
            className: Al.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ jn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ jn.jsx(On, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ jn.jsx(Ke, { content: "Show conversation preview", children: /* @__PURE__ */ jn.jsx(
        Kt,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ jn.jsxs(
      gt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Al.modal,
        children: [
          /* @__PURE__ */ jn.jsx(
            kt,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ jn.jsx(vt, { children: /* @__PURE__ */ jn.jsx(
            FP,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: $P(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: DP(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, OP = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = se(!1), o = r > 0 ? r : 1, s = e?.length > o, l = et(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ jn.jsx(
      RP,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ jn.jsxs(
      Wn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, PP = nP(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), AP = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = mn(), { data: l, loading: d, error: m } = s(PP, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return qe(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ jn.jsx(wn, { error: m }) : d ? /* @__PURE__ */ jn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ jn.jsx(un, {}) }) : r?.length === 0 ? /* @__PURE__ */ jn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ jn.jsx(
    OP,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, LP = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    placeholder: "Insert client ID",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client Secret",
    placeholder: "Insert client secret",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ga
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    placeholder: "Enter number",
    required: !0,
    defaultValue: "1",
    secret: !1,
    type: "input",
    customValidation: (e) => isNaN(Number.parseInt(e)) ? "Please enter a number" : void 0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ll = { exports: {} }, ba = {}, dy;
function VP() {
  if (dy) return ba;
  dy = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ba.Fragment = r, ba.jsx = s, ba.jsxs = s, ba;
}
var Io = {}, uy;
function zP() {
  return uy || (uy = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var E = !1, j = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || E || j || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function W(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return W(c) + ".Consumer";
          case s:
            var p = t;
            return W(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, ke, ue, ce, he, H, be, Ce;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, ue = console.info, ce = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: ke
            }),
            info: K({}, t, {
              value: ue
            }),
            warn: K({}, t, {
              value: ce
            }),
            error: K({}, t, {
              value: he
            }),
            group: K({}, t, {
              value: H
            }),
            groupCollapsed: K({}, t, {
              value: be
            }),
            groupEnd: K({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              y = te;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), T = y.stack.split(`
`), V = x.length - 1, z = T.length - 1; V >= 1 && z >= 0 && x[V] !== T[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== T[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== T[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var C in t)
          if (L(t, C)) {
            var x = void 0;
            try {
              if (typeof t[C] != "function") {
                var T = Error((y || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              x = t[C](c, C, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, C, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, C) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, C = {}, x = null, T = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (T = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (x || T) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(C, z), T && fn(C, z);
        }
        return pn(t, x, T, R, y, B.current, C);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), C; !(C = L.next()).done; )
              an(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var C = ee(t);
        if (!C) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Hn();
          T ? x += T : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    Io.Fragment = i, Io.jsx = Bn, Io.jsxs = qn;
  })()), Io;
}
var my;
function UP() {
  return my || (my = 1, process.env.NODE_ENV === "production" ? Ll.exports = VP() : Ll.exports = zP()), Ll.exports;
}
var Fe = UP();
const MP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, BP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, qP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, HP = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": MP,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": BP,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": qP
};
function ip(e) {
  return HP[e] ?? {};
}
const WP = ip(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), KP = ip(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), GP = ip(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function cm(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const YP = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, ix = "DD MMM YYYY @ HH:mm", JP = "_list_2c4dq_1", QP = "_listItem_2c4dq_4", XP = "_copyIcon_2c4dq_12", ui = {
  list: JP,
  listItem: QP,
  copyIcon: XP
}, dm = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = cm(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: v,
    country_code: S
  } = e ?? {}, N = `${d} ${m}`.trim() || void 0, F = `${h} ${v}`.trim() || void 0, I = [N, u, f, F, S].filter(
    Boolean
  );
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(me, { size: l, name: n }),
      i ? /* @__PURE__ */ Fe.jsx(un, { size: l }) : /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: I.map((g, q) => /* @__PURE__ */ Fe.jsx(Jn, { children: g }, q)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Fe.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Fe.jsx(Ke, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Fe.jsx(
        me,
        {
          size: l,
          name: "exclamation",
          className: ui.copyIcon
        }
      ) }),
      /* @__PURE__ */ Fe.jsx(Ke, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Fe.jsx(
        me,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(I.join(", ")),
          className: ui.copyIcon
        }
      ) })
    ] })
  ] });
}, ZP = "_wrapper_1nher_1", eA = {
  wrapper: ZP
}, nA = ({
  customer: e,
  store: n
}) => {
  const { track: r } = kn(), { isCopied: i, copy: a } = cm(), { isCopied: o, copy: s } = cm(), { useQuery: l } = mn(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(KP, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, v = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, S = (h?.addresses?.length ?? 0) > 1;
  if (qe(() => {
    v && r("recharge:profile:received");
  }, [v, r]), u)
    return /* @__PURE__ */ Fe.jsx(wn, { error: u });
  if (!e)
    return null;
  const {
    id: N,
    phone: F,
    email: I,
    first_name: g,
    last_name: q,
    created_at: E,
    has_valid_payment_method: j
  } = e, $ = 14, U = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${N}` : null, Z = `${g || ""} ${q || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Fe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Fe.jsxs(b, { className: eA.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-2", children: Z }),
    E && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: Pn(E).format(ix) })
    ] }),
    I && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(me, { size: $, name: "mail" }),
        /* @__PURE__ */ Fe.jsx(A.ExternalLink, { href: `mailto:${I}`, children: I })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ke, { content: "Copy email", children: /* @__PURE__ */ Fe.jsx(
        me,
        {
          size: $,
          name: i ? "done" : "copy",
          onClick: () => a(I),
          className: ui.copyIcon
        }
      ) })
    ] }),
    F && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(me, { size: $, name: "phone" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: F })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ Fe.jsx(
        me,
        {
          size: $,
          name: o ? "done" : "copy",
          onClick: () => s(F),
          className: ui.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Fe.jsx(
      dm,
      {
        address: v,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: S
      }
    ),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(me, { size: $, name: "credit-card" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Fe.jsx(
        me,
        {
          size: $,
          name: j ? "check-circle" : "close-circle-filled",
          color: j ? "green.500" : "red.500"
        }
      )
    ] }),
    U && /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(me, { size: $, name: "external-link" }),
      /* @__PURE__ */ Fe.jsx(
        A.ExternalLink,
        {
          href: U,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, tA = "_order_1dlaa_1", rA = "_orderIsOpen_1dlaa_9", iA = "_orderHeader_1dlaa_12", aA = "_note_1dlaa_16", Eo = {
  order: tA,
  orderIsOpen: rA,
  orderHeader: iA,
  note: aA
}, oA = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = kn(), [a, o] = se(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: v,
    total_price: S,
    is_prepaid: N
  } = e, F = 14, I = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, g = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Fe.jsxs(
    b,
    {
      className: dt(Eo.order, {
        [Eo.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Fe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Eo.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Fe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: Pn(f).format(ix) }) }),
                /* @__PURE__ */ Fe.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Fe.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ Fe.jsx(Ke, { content: "Note", children: /* @__PURE__ */ Fe.jsx(
            A.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: Eo.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(me, { size: F, name: "activity" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: YP(l) })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(me, { size: F, name: "credit-card" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: N ? "Yes" : "No" })
            ] })
          ] }),
          g && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(me, { size: F, name: "cog" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: g })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(me, { size: F, name: "chart-bar" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Fe.jsxs(A.Paragraph, { variant: "4", children: [
                S,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsx(
            dm,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Fe.jsx(
            dm,
            {
              address: v,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          I && /* @__PURE__ */ Fe.jsx(
            jt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(I, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Fe.jsx(me, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, sA = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = kn(), { useQuery: i } = mn(), {
    loading: a,
    error: o,
    data: s
  } = i(GP, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Fe.jsx(wn, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Fe.jsx(Un, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(un, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ Fe.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Fe.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ Fe.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ Fe.jsx(
        oA,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ Fe.jsx(
        jt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Fe.jsx(me, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, lA = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Fe.jsxs(He, { className: ui.list, children: [
      /* @__PURE__ */ Fe.jsx(He.Text, { variant: "dense", className: ui.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Fe.jsx(He.Text, { variant: "dense", className: ui.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, cA = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = r(WP, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const v = m.graphQLErrors;
    return km({ errors: v }) ? /* @__PURE__ */ Fe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : vm({ errors: v }) ? /* @__PURE__ */ Fe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Fe.jsx(wn, { error: m });
  }
  return d ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(un, {}) }) : f ? l ? /* @__PURE__ */ Fe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Fe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Fe.jsx(nA, { customer: f, store: h }),
        o && /* @__PURE__ */ Fe.jsx(lA, { customer: f }),
        s && /* @__PURE__ */ Fe.jsx(sA, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Fe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, dA = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    placeholder: "Insert the Admin API token for Recharge",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
var To = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ax(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Vl = { exports: {} }, _a = {}, py;
function uA() {
  if (py) return _a;
  py = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return _a.Fragment = r, _a.jsx = s, _a.jsxs = s, _a;
}
var $o = {}, fy;
function mA() {
  return fy || (fy = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var E = !1, j = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || E || j || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function W(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return W(c) + ".Consumer";
          case s:
            var p = t;
            return W(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, ke, ue, ce, he, H, be, Ce;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, ue = console.info, ce = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: ke
            }),
            info: K({}, t, {
              value: ue
            }),
            warn: K({}, t, {
              value: ce
            }),
            error: K({}, t, {
              value: he
            }),
            group: K({}, t, {
              value: H
            }),
            groupCollapsed: K({}, t, {
              value: be
            }),
            groupEnd: K({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              y = te;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), T = y.stack.split(`
`), V = x.length - 1, z = T.length - 1; V >= 1 && z >= 0 && x[V] !== T[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== T[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== T[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var C in t)
          if (L(t, C)) {
            var x = void 0;
            try {
              if (typeof t[C] != "function") {
                var T = Error((y || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              x = t[C](c, C, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, C, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, C) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, C = {}, x = null, T = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (T = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (x || T) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(C, z), T && fn(C, z);
        }
        return pn(t, x, T, R, y, B.current, C);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), C; !(C = L.next()).done; )
              an(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var C = ee(t);
        if (!C) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Hn();
          T ? x += T : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    $o.Fragment = i, $o.jsx = Bn, $o.jsxs = qn;
  })()), $o;
}
var hy;
function pA() {
  return hy || (hy = 1, process.env.NODE_ENV === "production" ? Vl.exports = uA() : Vl.exports = mA()), Vl.exports;
}
var mi = pA();
function fA(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var zl, yy;
function Zr() {
  if (yy) return zl;
  yy = 1;
  var e = Array.isArray;
  return zl = e, zl;
}
var Ul, gy;
function ox() {
  if (gy) return Ul;
  gy = 1;
  var e = typeof To == "object" && To && To.Object === Object && To;
  return Ul = e, Ul;
}
var Ml, ky;
function Or() {
  if (ky) return Ml;
  ky = 1;
  var e = ox(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Ml = r, Ml;
}
var Bl, vy;
function ao() {
  if (vy) return Bl;
  vy = 1;
  var e = Or(), n = e.Symbol;
  return Bl = n, Bl;
}
var ql, by;
function hA() {
  if (by) return ql;
  by = 1;
  var e = ao(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return ql = o, ql;
}
var Hl, _y;
function yA() {
  if (_y) return Hl;
  _y = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Hl = r, Hl;
}
var Wl, xy;
function Hi() {
  if (xy) return Wl;
  xy = 1;
  var e = ao(), n = hA(), r = yA(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Wl = s, Wl;
}
var Kl, Sy;
function gi() {
  if (Sy) return Kl;
  Sy = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Kl = e, Kl;
}
var Gl, Ny;
function ap() {
  if (Ny) return Gl;
  Ny = 1;
  var e = Hi(), n = gi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Gl = i, Gl;
}
var Yl, jy;
function gA() {
  if (jy) return Yl;
  jy = 1;
  var e = Zr(), n = ap(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Yl = a, Yl;
}
var Jl, wy;
function Wi() {
  if (wy) return Jl;
  wy = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return Jl = e, Jl;
}
var Ql, Cy;
function sx() {
  if (Cy) return Ql;
  Cy = 1;
  var e = Hi(), n = Wi(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return Ql = s, Ql;
}
var Xl, Fy;
function kA() {
  if (Fy) return Xl;
  Fy = 1;
  var e = Or(), n = e["__core-js_shared__"];
  return Xl = n, Xl;
}
var Zl, Iy;
function vA() {
  if (Iy) return Zl;
  Iy = 1;
  var e = kA(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Zl = r, Zl;
}
var ec, Ey;
function lx() {
  if (Ey) return ec;
  Ey = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return ec = r, ec;
}
var nc, Ty;
function bA() {
  if (Ty) return nc;
  Ty = 1;
  var e = sx(), n = vA(), r = Wi(), i = lx(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? u : o;
    return v.test(i(h));
  }
  return nc = f, nc;
}
var tc, $y;
function _A() {
  if ($y) return tc;
  $y = 1;
  function e(n, r) {
    return n?.[r];
  }
  return tc = e, tc;
}
var rc, Dy;
function ki() {
  if (Dy) return rc;
  Dy = 1;
  var e = bA(), n = _A();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return rc = r, rc;
}
var ic, Ry;
function zs() {
  if (Ry) return ic;
  Ry = 1;
  var e = ki(), n = e(Object, "create");
  return ic = n, ic;
}
var ac, Oy;
function xA() {
  if (Oy) return ac;
  Oy = 1;
  var e = zs();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return ac = n, ac;
}
var oc, Py;
function SA() {
  if (Py) return oc;
  Py = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return oc = e, oc;
}
var sc, Ay;
function NA() {
  if (Ay) return sc;
  Ay = 1;
  var e = zs(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return sc = a, sc;
}
var lc, Ly;
function jA() {
  if (Ly) return lc;
  Ly = 1;
  var e = zs(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return lc = i, lc;
}
var cc, Vy;
function wA() {
  if (Vy) return cc;
  Vy = 1;
  var e = zs(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return cc = r, cc;
}
var dc, zy;
function CA() {
  if (zy) return dc;
  zy = 1;
  var e = xA(), n = SA(), r = NA(), i = jA(), a = wA();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, dc = o, dc;
}
var uc, Uy;
function FA() {
  if (Uy) return uc;
  Uy = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return uc = e, uc;
}
var mc, My;
function cx() {
  if (My) return mc;
  My = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return mc = e, mc;
}
var pc, By;
function Us() {
  if (By) return pc;
  By = 1;
  var e = cx();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return pc = n, pc;
}
var fc, qy;
function IA() {
  if (qy) return fc;
  qy = 1;
  var e = Us(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return fc = i, fc;
}
var hc, Hy;
function EA() {
  if (Hy) return hc;
  Hy = 1;
  var e = Us();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return hc = n, hc;
}
var yc, Wy;
function TA() {
  if (Wy) return yc;
  Wy = 1;
  var e = Us();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return yc = n, yc;
}
var gc, Ky;
function $A() {
  if (Ky) return gc;
  Ky = 1;
  var e = Us();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return gc = n, gc;
}
var kc, Gy;
function Ms() {
  if (Gy) return kc;
  Gy = 1;
  var e = FA(), n = IA(), r = EA(), i = TA(), a = $A();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, kc = o, kc;
}
var vc, Yy;
function op() {
  if (Yy) return vc;
  Yy = 1;
  var e = ki(), n = Or(), r = e(n, "Map");
  return vc = r, vc;
}
var bc, Jy;
function DA() {
  if (Jy) return bc;
  Jy = 1;
  var e = CA(), n = Ms(), r = op();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return bc = i, bc;
}
var _c, Qy;
function RA() {
  if (Qy) return _c;
  Qy = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return _c = e, _c;
}
var xc, Xy;
function Bs() {
  if (Xy) return xc;
  Xy = 1;
  var e = RA();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return xc = n, xc;
}
var Sc, Zy;
function OA() {
  if (Zy) return Sc;
  Zy = 1;
  var e = Bs();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Sc = n, Sc;
}
var Nc, eg;
function PA() {
  if (eg) return Nc;
  eg = 1;
  var e = Bs();
  function n(r) {
    return e(this, r).get(r);
  }
  return Nc = n, Nc;
}
var jc, ng;
function AA() {
  if (ng) return jc;
  ng = 1;
  var e = Bs();
  function n(r) {
    return e(this, r).has(r);
  }
  return jc = n, jc;
}
var wc, tg;
function LA() {
  if (tg) return wc;
  tg = 1;
  var e = Bs();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return wc = n, wc;
}
var Cc, rg;
function dx() {
  if (rg) return Cc;
  rg = 1;
  var e = DA(), n = OA(), r = PA(), i = AA(), a = LA();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Cc = o, Cc;
}
var Fc, ig;
function VA() {
  if (ig) return Fc;
  ig = 1;
  var e = dx(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Fc = r, Fc;
}
var Ic, ag;
function zA() {
  if (ag) return Ic;
  ag = 1;
  var e = VA(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return Ic = r, Ic;
}
var Ec, og;
function UA() {
  if (og) return Ec;
  og = 1;
  var e = zA(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return Ec = i, Ec;
}
var Tc, sg;
function ux() {
  if (sg) return Tc;
  sg = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return Tc = e, Tc;
}
var $c, lg;
function MA() {
  if (lg) return $c;
  lg = 1;
  var e = ao(), n = ux(), r = Zr(), i = ap(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return $c = s, $c;
}
var Dc, cg;
function BA() {
  if (cg) return Dc;
  cg = 1;
  var e = MA();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Dc = n, Dc;
}
var Rc, dg;
function Ki() {
  if (dg) return Rc;
  dg = 1;
  var e = Zr(), n = gA(), r = UA(), i = BA();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return Rc = a, Rc;
}
var Oc, ug;
function qs() {
  if (ug) return Oc;
  ug = 1;
  var e = ap();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Oc = n, Oc;
}
var Pc, mg;
function mx() {
  if (mg) return Pc;
  mg = 1;
  var e = Ki(), n = qs();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Pc = r, Pc;
}
var Ac, pg;
function px() {
  if (pg) return Ac;
  pg = 1;
  var e = ki(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Ac = n, Ac;
}
var Lc, fg;
function fx() {
  if (fg) return Lc;
  fg = 1;
  var e = px();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Lc = n, Lc;
}
var Vc, hg;
function sp() {
  if (hg) return Vc;
  hg = 1;
  var e = fx(), n = cx(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Vc = a, Vc;
}
var zc, yg;
function lp() {
  if (yg) return zc;
  yg = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return zc = r, zc;
}
var Uc, gg;
function qA() {
  if (gg) return Uc;
  gg = 1;
  var e = sp(), n = Ki(), r = lp(), i = Wi(), a = qs();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, v = s; v != null && ++u < f; ) {
      var S = a(l[u]), N = d;
      if (S === "__proto__" || S === "constructor" || S === "prototype")
        return s;
      if (u != h) {
        var F = v[S];
        N = m ? m(F, S, v) : void 0, N === void 0 && (N = i(F) ? F : r(l[u + 1]) ? [] : {});
      }
      e(v, S, N), v = v[S];
    }
    return s;
  }
  return Uc = o, Uc;
}
var Mc, kg;
function HA() {
  if (kg) return Mc;
  kg = 1;
  var e = mx(), n = qA(), r = Ki();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return Mc = i, Mc;
}
var Bc, vg;
function WA() {
  if (vg) return Bc;
  vg = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Bc = e, Bc;
}
var qc, bg;
function KA() {
  if (bg) return qc;
  bg = 1;
  var e = Hi(), n = gi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return qc = i, qc;
}
var Hc, _g;
function cp() {
  if (_g) return Hc;
  _g = 1;
  var e = KA(), n = gi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Hc = o, Hc;
}
var Wc, xg;
function dp() {
  if (xg) return Wc;
  xg = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Wc = n, Wc;
}
var Kc, Sg;
function GA() {
  if (Sg) return Kc;
  Sg = 1;
  var e = Ki(), n = cp(), r = Zr(), i = lp(), a = dp(), o = qs();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var v = o(d[u]);
      if (!(h = l != null && m(l, v)))
        break;
      l = l[v];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return Kc = s, Kc;
}
var Gc, Ng;
function YA() {
  if (Ng) return Gc;
  Ng = 1;
  var e = WA(), n = GA();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Gc = r, Gc;
}
var Yc, jg;
function JA() {
  if (jg) return Yc;
  jg = 1;
  var e = HA(), n = YA();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Yc = r, Yc;
}
var Jc, wg;
function up() {
  if (wg) return Jc;
  wg = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return Jc = e, Jc;
}
var Qc, Cg;
function QA() {
  if (Cg) return Qc;
  Cg = 1;
  var e = ao(), n = cp(), r = Zr(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Qc = a, Qc;
}
var Xc, Fg;
function XA() {
  if (Fg) return Xc;
  Fg = 1;
  var e = up(), n = QA();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return Xc = r, Xc;
}
var Zc, Ig;
function ZA() {
  if (Ig) return Zc;
  Ig = 1;
  var e = XA();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Zc = n, Zc;
}
var ed, Eg;
function e2() {
  if (Eg) return ed;
  Eg = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return ed = e, ed;
}
var nd, Tg;
function n2() {
  if (Tg) return nd;
  Tg = 1;
  var e = e2(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return nd = r, nd;
}
var td, $g;
function t2() {
  if ($g) return td;
  $g = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return td = e, td;
}
var rd, Dg;
function hx() {
  if (Dg) return rd;
  Dg = 1;
  function e(n) {
    return n;
  }
  return rd = e, rd;
}
var id, Rg;
function r2() {
  if (Rg) return id;
  Rg = 1;
  var e = t2(), n = px(), r = hx(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return id = i, id;
}
var ad, Og;
function i2() {
  if (Og) return ad;
  Og = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return ad = i, ad;
}
var od, Pg;
function a2() {
  if (Pg) return od;
  Pg = 1;
  var e = r2(), n = i2(), r = n(e);
  return od = r, od;
}
var sd, Ag;
function yx() {
  if (Ag) return sd;
  Ag = 1;
  var e = ZA(), n = n2(), r = a2();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return sd = i, sd;
}
var ld, Lg;
function o2() {
  if (Lg) return ld;
  Lg = 1;
  var e = JA(), n = yx(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return ld = r, ld;
}
var s2 = o2();
const gx = /* @__PURE__ */ ax(s2), l2 = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function kx(e) {
  const n = gx(e, l2);
  return {
    controller: Lm(n),
    controllerProps: n
  };
}
const c2 = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function vx(e) {
  const { controller: n, controllerProps: r } = kx(e), i = {
    ...gx(e, c2),
    required: fA(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var cd, Vg;
function d2() {
  if (Vg) return cd;
  Vg = 1;
  var e = Ms();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return cd = n, cd;
}
var dd, zg;
function u2() {
  if (zg) return dd;
  zg = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return dd = e, dd;
}
var ud, Ug;
function m2() {
  if (Ug) return ud;
  Ug = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return ud = e, ud;
}
var md, Mg;
function p2() {
  if (Mg) return md;
  Mg = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return md = e, md;
}
var pd, Bg;
function f2() {
  if (Bg) return pd;
  Bg = 1;
  var e = Ms(), n = op(), r = dx(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return pd = a, pd;
}
var fd, qg;
function h2() {
  if (qg) return fd;
  qg = 1;
  var e = Ms(), n = d2(), r = u2(), i = m2(), a = p2(), o = f2();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, fd = s, fd;
}
var hd, Hg;
function y2() {
  if (Hg) return hd;
  Hg = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return hd = e, hd;
}
var yd, Wg;
function oo() {
  if (Wg) return yd;
  Wg = 1;
  var e = sp(), n = fx();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return yd = r, yd;
}
var gd, Kg;
function g2() {
  if (Kg) return gd;
  Kg = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return gd = e, gd;
}
var Qo = { exports: {} }, kd, Gg;
function k2() {
  if (Gg) return kd;
  Gg = 1;
  function e() {
    return !1;
  }
  return kd = e, kd;
}
Qo.exports;
var Yg;
function bx() {
  return Yg || (Yg = 1, (function(e, n) {
    var r = Or(), i = k2(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(Qo, Qo.exports)), Qo.exports;
}
var vd, Jg;
function v2() {
  if (Jg) return vd;
  Jg = 1;
  var e = Hi(), n = dp(), r = gi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", S = "[object String]", N = "[object WeakMap]", F = "[object ArrayBuffer]", I = "[object DataView]", g = "[object Float32Array]", q = "[object Float64Array]", E = "[object Int8Array]", j = "[object Int16Array]", $ = "[object Int32Array]", U = "[object Uint8Array]", Z = "[object Uint8ClampedArray]", Q = "[object Uint16Array]", ee = "[object Uint32Array]", J = {};
  J[g] = J[q] = J[E] = J[j] = J[$] = J[U] = J[Z] = J[Q] = J[ee] = !0, J[i] = J[a] = J[F] = J[o] = J[I] = J[s] = J[l] = J[d] = J[m] = J[u] = J[f] = J[h] = J[v] = J[S] = J[N] = !1;
  function W(P) {
    return r(P) && n(P.length) && !!J[e(P)];
  }
  return vd = W, vd;
}
var bd, Qg;
function mp() {
  if (Qg) return bd;
  Qg = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return bd = e, bd;
}
var Xo = { exports: {} };
Xo.exports;
var Xg;
function pp() {
  return Xg || (Xg = 1, (function(e, n) {
    var r = ox(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(Xo, Xo.exports)), Xo.exports;
}
var _d, Zg;
function b2() {
  if (Zg) return _d;
  Zg = 1;
  var e = v2(), n = mp(), r = pp(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return _d = a, _d;
}
var xd, ek;
function _x() {
  if (ek) return xd;
  ek = 1;
  var e = g2(), n = cp(), r = Zr(), i = bx(), a = lp(), o = b2(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), v = !f && !h && i(m), S = !f && !h && !v && o(m), N = f || h || v || S, F = N ? e(m.length, String) : [], I = F.length;
    for (var g in m)
      (u || l.call(m, g)) && !(N && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      S && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, I))) && F.push(g);
    return F;
  }
  return xd = d, xd;
}
var Sd, nk;
function fp() {
  if (nk) return Sd;
  nk = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return Sd = n, Sd;
}
var Nd, tk;
function xx() {
  if (tk) return Nd;
  tk = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Nd = e, Nd;
}
var jd, rk;
function _2() {
  if (rk) return jd;
  rk = 1;
  var e = xx(), n = e(Object.keys, Object);
  return jd = n, jd;
}
var wd, ik;
function x2() {
  if (ik) return wd;
  ik = 1;
  var e = fp(), n = _2(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return wd = a, wd;
}
var Cd, ak;
function Sx() {
  if (ak) return Cd;
  ak = 1;
  var e = sx(), n = dp();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Cd = r, Cd;
}
var Fd, ok;
function hp() {
  if (ok) return Fd;
  ok = 1;
  var e = _x(), n = x2(), r = Sx();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return Fd = i, Fd;
}
var Id, sk;
function S2() {
  if (sk) return Id;
  sk = 1;
  var e = oo(), n = hp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Id = r, Id;
}
var Ed, lk;
function N2() {
  if (lk) return Ed;
  lk = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return Ed = e, Ed;
}
var Td, ck;
function j2() {
  if (ck) return Td;
  ck = 1;
  var e = Wi(), n = fp(), r = N2(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return Td = o, Td;
}
var $d, dk;
function yp() {
  if (dk) return $d;
  dk = 1;
  var e = _x(), n = j2(), r = Sx();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return $d = i, $d;
}
var Dd, uk;
function w2() {
  if (uk) return Dd;
  uk = 1;
  var e = oo(), n = yp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Dd = r, Dd;
}
var Zo = { exports: {} };
Zo.exports;
var mk;
function C2() {
  return mk || (mk = 1, (function(e, n) {
    var r = Or(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(Zo, Zo.exports)), Zo.exports;
}
var Rd, pk;
function F2() {
  if (pk) return Rd;
  pk = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return Rd = e, Rd;
}
var Od, fk;
function I2() {
  if (fk) return Od;
  fk = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Od = e, Od;
}
var Pd, hk;
function Nx() {
  if (hk) return Pd;
  hk = 1;
  function e() {
    return [];
  }
  return Pd = e, Pd;
}
var Ad, yk;
function gp() {
  if (yk) return Ad;
  yk = 1;
  var e = I2(), n = Nx(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Ad = o, Ad;
}
var Ld, gk;
function E2() {
  if (gk) return Ld;
  gk = 1;
  var e = oo(), n = gp();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Ld = r, Ld;
}
var Vd, kk;
function kp() {
  if (kk) return Vd;
  kk = 1;
  var e = xx(), n = e(Object.getPrototypeOf, Object);
  return Vd = n, Vd;
}
var zd, vk;
function jx() {
  if (vk) return zd;
  vk = 1;
  var e = up(), n = kp(), r = gp(), i = Nx(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return zd = o, zd;
}
var Ud, bk;
function T2() {
  if (bk) return Ud;
  bk = 1;
  var e = oo(), n = jx();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Ud = r, Ud;
}
var Md, _k;
function wx() {
  if (_k) return Md;
  _k = 1;
  var e = up(), n = Zr();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Md = r, Md;
}
var Bd, xk;
function $2() {
  if (xk) return Bd;
  xk = 1;
  var e = wx(), n = gp(), r = hp();
  function i(a) {
    return e(a, r, n);
  }
  return Bd = i, Bd;
}
var qd, Sk;
function Cx() {
  if (Sk) return qd;
  Sk = 1;
  var e = wx(), n = jx(), r = yp();
  function i(a) {
    return e(a, r, n);
  }
  return qd = i, qd;
}
var Hd, Nk;
function D2() {
  if (Nk) return Hd;
  Nk = 1;
  var e = ki(), n = Or(), r = e(n, "DataView");
  return Hd = r, Hd;
}
var Wd, jk;
function R2() {
  if (jk) return Wd;
  jk = 1;
  var e = ki(), n = Or(), r = e(n, "Promise");
  return Wd = r, Wd;
}
var Kd, wk;
function O2() {
  if (wk) return Kd;
  wk = 1;
  var e = ki(), n = Or(), r = e(n, "Set");
  return Kd = r, Kd;
}
var Gd, Ck;
function P2() {
  if (Ck) return Gd;
  Ck = 1;
  var e = ki(), n = Or(), r = e(n, "WeakMap");
  return Gd = r, Gd;
}
var Yd, Fk;
function vp() {
  if (Fk) return Yd;
  Fk = 1;
  var e = D2(), n = op(), r = R2(), i = O2(), a = P2(), o = Hi(), s = lx(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), S = s(n), N = s(r), F = s(i), I = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != m || i && g(new i()) != u || a && g(new a()) != f) && (g = function(q) {
    var E = o(q), j = E == d ? q.constructor : void 0, $ = j ? s(j) : "";
    if ($)
      switch ($) {
        case v:
          return h;
        case S:
          return l;
        case N:
          return m;
        case F:
          return u;
        case I:
          return f;
      }
    return E;
  }), Yd = g, Yd;
}
var Jd, Ik;
function A2() {
  if (Ik) return Jd;
  Ik = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Jd = r, Jd;
}
var Qd, Ek;
function L2() {
  if (Ek) return Qd;
  Ek = 1;
  var e = Or(), n = e.Uint8Array;
  return Qd = n, Qd;
}
var Xd, Tk;
function bp() {
  if (Tk) return Xd;
  Tk = 1;
  var e = L2();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Xd = n, Xd;
}
var Zd, $k;
function V2() {
  if ($k) return Zd;
  $k = 1;
  var e = bp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Zd = n, Zd;
}
var eu, Dk;
function z2() {
  if (Dk) return eu;
  Dk = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return eu = n, eu;
}
var nu, Rk;
function U2() {
  if (Rk) return nu;
  Rk = 1;
  var e = ao(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return nu = i, nu;
}
var tu, Ok;
function M2() {
  if (Ok) return tu;
  Ok = 1;
  var e = bp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return tu = n, tu;
}
var ru, Pk;
function B2() {
  if (Pk) return ru;
  Pk = 1;
  var e = bp(), n = V2(), r = z2(), i = U2(), a = M2(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", S = "[object DataView]", N = "[object Float32Array]", F = "[object Float64Array]", I = "[object Int8Array]", g = "[object Int16Array]", q = "[object Int32Array]", E = "[object Uint8Array]", j = "[object Uint8ClampedArray]", $ = "[object Uint16Array]", U = "[object Uint32Array]";
  function Z(Q, ee, J) {
    var W = Q.constructor;
    switch (ee) {
      case v:
        return e(Q);
      case o:
      case s:
        return new W(+Q);
      case S:
        return n(Q, J);
      case N:
      case F:
      case I:
      case g:
      case q:
      case E:
      case j:
      case $:
      case U:
        return a(Q, J);
      case l:
        return new W();
      case d:
      case f:
        return new W(Q);
      case m:
        return r(Q);
      case u:
        return new W();
      case h:
        return i(Q);
    }
  }
  return ru = Z, ru;
}
var iu, Ak;
function q2() {
  if (Ak) return iu;
  Ak = 1;
  var e = Wi(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return iu = r, iu;
}
var au, Lk;
function H2() {
  if (Lk) return au;
  Lk = 1;
  var e = q2(), n = kp(), r = fp();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return au = i, au;
}
var ou, Vk;
function W2() {
  if (Vk) return ou;
  Vk = 1;
  var e = vp(), n = gi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return ou = i, ou;
}
var su, zk;
function K2() {
  if (zk) return su;
  zk = 1;
  var e = W2(), n = mp(), r = pp(), i = r && r.isMap, a = i ? n(i) : e;
  return su = a, su;
}
var lu, Uk;
function G2() {
  if (Uk) return lu;
  Uk = 1;
  var e = vp(), n = gi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return lu = i, lu;
}
var cu, Mk;
function Y2() {
  if (Mk) return cu;
  Mk = 1;
  var e = G2(), n = mp(), r = pp(), i = r && r.isSet, a = i ? n(i) : e;
  return cu = a, cu;
}
var du, Bk;
function J2() {
  if (Bk) return du;
  Bk = 1;
  var e = h2(), n = y2(), r = sp(), i = S2(), a = w2(), o = C2(), s = F2(), l = E2(), d = T2(), m = $2(), u = Cx(), f = vp(), h = A2(), v = B2(), S = H2(), N = Zr(), F = bx(), I = K2(), g = Wi(), q = Y2(), E = hp(), j = yp(), $ = 1, U = 2, Z = 4, Q = "[object Arguments]", ee = "[object Array]", J = "[object Boolean]", W = "[object Date]", P = "[object Error]", K = "[object Function]", ne = "[object GeneratorFunction]", ke = "[object Map]", ue = "[object Number]", ce = "[object Object]", he = "[object RegExp]", H = "[object Set]", be = "[object String]", Ce = "[object Symbol]", G = "[object WeakMap]", ze = "[object ArrayBuffer]", Be = "[object DataView]", Pe = "[object Float32Array]", Me = "[object Float64Array]", Ie = "[object Int8Array]", Le = "[object Int16Array]", De = "[object Int32Array]", rn = "[object Uint8Array]", je = "[object Uint8ClampedArray]", We = "[object Uint16Array]", Ge = "[object Uint32Array]", pe = {};
  pe[Q] = pe[ee] = pe[ze] = pe[Be] = pe[J] = pe[W] = pe[Pe] = pe[Me] = pe[Ie] = pe[Le] = pe[De] = pe[ke] = pe[ue] = pe[ce] = pe[he] = pe[H] = pe[be] = pe[Ce] = pe[rn] = pe[je] = pe[We] = pe[Ge] = !0, pe[P] = pe[K] = pe[G] = !1;
  function le(Ne, Ae, Ee, cn, w, _) {
    var D, Y = Ae & $, X = Ae & U, O = Ae & Z;
    if (Ee && (D = w ? Ee(Ne, cn, w, _) : Ee(Ne)), D !== void 0)
      return D;
    if (!g(Ne))
      return Ne;
    var B = N(Ne);
    if (B) {
      if (D = h(Ne), !Y)
        return s(Ne, D);
    } else {
      var ie = f(Ne), fe = ie == K || ie == ne;
      if (F(Ne))
        return o(Ne, Y);
      if (ie == ce || ie == Q || fe && !w) {
        if (D = X || fe ? {} : S(Ne), !Y)
          return X ? d(Ne, a(D, Ne)) : l(Ne, i(D, Ne));
      } else {
        if (!pe[ie])
          return w ? Ne : {};
        D = v(Ne, ie, Y);
      }
    }
    _ || (_ = new e());
    var _e = _.get(Ne);
    if (_e)
      return _e;
    _.set(Ne, D), q(Ne) ? Ne.forEach(function(tn) {
      D.add(le(tn, Ae, Ee, tn, Ne, _));
    }) : I(Ne) && Ne.forEach(function(tn, sn) {
      D.set(sn, le(tn, Ae, Ee, sn, Ne, _));
    });
    var en = O ? X ? u : m : X ? j : E, dn = B ? void 0 : en(Ne);
    return n(dn || Ne, function(tn, sn) {
      dn && (sn = tn, tn = Ne[sn]), r(D, sn, le(tn, Ae, Ee, sn, Ne, _));
    }), D;
  }
  return du = le, du;
}
var uu, qk;
function Q2() {
  if (qk) return uu;
  qk = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return uu = e, uu;
}
var mu, Hk;
function X2() {
  if (Hk) return mu;
  Hk = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return mu = e, mu;
}
var pu, Wk;
function Z2() {
  if (Wk) return pu;
  Wk = 1;
  var e = mx(), n = X2();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return pu = r, pu;
}
var fu, Kk;
function eL() {
  if (Kk) return fu;
  Kk = 1;
  var e = Ki(), n = Q2(), r = Z2(), i = qs(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (var f = l == null || typeof l != "object" && typeof l != "function"; ++m < u; ) {
      var h = d[m];
      if (typeof h == "string") {
        if (h === "__proto__" && !o.call(l, "__proto__"))
          return !1;
        if (h === "constructor" && m + 1 < u && typeof d[m + 1] == "string" && d[m + 1] === "prototype") {
          if (f && m === 0)
            continue;
          return !1;
        }
      }
    }
    var v = r(l, d);
    return v == null || delete v[i(n(d))];
  }
  return fu = s, fu;
}
var hu, Gk;
function nL() {
  if (Gk) return hu;
  Gk = 1;
  var e = Hi(), n = kp(), r = gi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return hu = m, hu;
}
var yu, Yk;
function tL() {
  if (Yk) return yu;
  Yk = 1;
  var e = nL();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return yu = n, yu;
}
var gu, Jk;
function rL() {
  if (Jk) return gu;
  Jk = 1;
  var e = ux(), n = J2(), r = eL(), i = Ki(), a = oo(), o = tL(), s = yx(), l = Cx(), d = 1, m = 2, u = 4, f = s(function(h, v) {
    var S = {};
    if (h == null)
      return S;
    var N = !1;
    v = e(v, function(I) {
      return I = i(I, h), N || (N = I.length > 1), I;
    }), a(h, l(h), S), N && (S = n(S, d | m | u, o));
    for (var F = v.length; F--; )
      r(S, v[F]);
    return S;
  });
  return gu = f, gu;
}
rL();
const vr = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = vx(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ mi.jsx(An, { ...a, children: /* @__PURE__ */ mi.jsx(
    Kr,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: An.getStatus(a.meta),
      children: e
    }
  ) });
};
var iL = hx();
const aL = /* @__PURE__ */ ax(iL), ku = ({
  transformValue: e = aL,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = kx(a);
  return /* @__PURE__ */ mi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ mi.jsx(
      Vu,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ mi.jsx(OS, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, Bt = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = vx(e);
  return /* @__PURE__ */ mi.jsx(An, { ...i, children: /* @__PURE__ */ mi.jsx(
    kr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: An.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._link_egbmi_1{color:var(--dixa-typography-color-link);text-decoration-line:none;cursor:pointer}._link_egbmi_1:hover,._link_egbmi_1:focus{color:var(--dixa-color-blue-700);text-decoration-line:underline}._link_egbmi_1:active{color:var(--dixa-color-blue-900)}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1dntr_1,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var vu = { exports: {} }, xa = {}, Qk;
function oL() {
  if (Qk) return xa;
  Qk = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return xa.Fragment = r, xa.jsx = s, xa.jsxs = s, xa;
}
var Do = {}, Xk;
function sL() {
  return Xk || (Xk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var E = !1, j = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || E || j || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function W(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return W(c) + ".Consumer";
          case s:
            var p = t;
            return W(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, ke, ue, ce, he, H, be, Ce;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, ue = console.info, ce = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: ke
            }),
            info: K({}, t, {
              value: ue
            }),
            warn: K({}, t, {
              value: ce
            }),
            error: K({}, t, {
              value: he
            }),
            group: K({}, t, {
              value: H
            }),
            groupCollapsed: K({}, t, {
              value: be
            }),
            groupEnd: K({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              y = te;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), T = y.stack.split(`
`), V = x.length - 1, z = T.length - 1; V >= 1 && z >= 0 && x[V] !== T[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== T[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== T[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var C in t)
          if (L(t, C)) {
            var x = void 0;
            try {
              if (typeof t[C] != "function") {
                var T = Error((y || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              x = t[C](c, C, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, C, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, C) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, C = {}, x = null, T = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (T = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (x || T) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(C, z), T && fn(C, z);
        }
        return pn(t, x, T, R, y, B.current, C);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), C; !(C = L.next()).done; )
              an(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var C = ee(t);
        if (!C) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Hn();
          T ? x += T : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    Do.Fragment = i, Do.jsx = Bn, Do.jsxs = qn;
  })()), Do;
}
var Zk;
function lL() {
  return Zk || (Zk = 1, process.env.NODE_ENV === "production" ? vu.exports = oL() : vu.exports = sL()), vu.exports;
}
var k = lL();
const cL = "_link_egbmi_1", dL = {
  link: cL
}, uL = "https://apps.shopify.com/dixa-dashboard", mL = (e) => ({
  install: {
    variant: "info",
    description: "To connect your Shopify store, install the Dixa app from the Shopify App Store. The app will automatically set up the connection for you.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        "Copy an API Token from the",
        " ",
        /* @__PURE__ */ k.jsx("span", { className: dL.link, onClick: e.onNavigateToApiTokens, children: "API tokens tab" })
      ] }),
      "Click the button below to go to the Shopify App Store",
      "Install the Dixa app on your Shopify store",
      "In the app, paste your Dixa API token to complete the connection",
      "In case you have already one or more Shopify integrations configured in Dixa, you can select one (or create a new one) to connect your store to",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install from Shopify App Store",
    buttonVariant: "primary"
  },
  migration: {
    variant: "warning",
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "secondary"
  }
}), pL = "/settings/integrations/api-tokens", Fx = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const r = KS(), i = mL({
    onNavigateToApiTokens: () => {
      r(pL);
    }
  })[n], a = () => {
    window.open(uL, "_blank", "noopener,noreferrer");
  }, o = i.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(nn, { span: 6, children: /* @__PURE__ */ k.jsx(
    Ja,
    {
      variant: i.variant,
      headline: e,
      description: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { children: i.description }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: i.listHeading }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(o, { style: { margin: 0, paddingLeft: "1.25rem" }, children: i.listItems.map((s, l) => /* @__PURE__ */ k.jsx("li", { children: s }, l)) }) })
        ] }),
        /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
          Wn,
          {
            onClick: a,
            icon: "external-link",
            variant: i.buttonVariant,
            children: i.buttonText
          }
        ) })
      ] })
    }
  ) });
}, fL = (e) => /* @__PURE__ */ k.jsx(Fx, { ...e, bannerVariant: "install" }), hL = (e) => /* @__PURE__ */ k.jsx(Fx, { ...e, bannerVariant: "migration" }), yL = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], gL = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], kL = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: fL
  }
], vL = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], ev = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: hL
  }
], Ix = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], nv = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => rb(e)
  },
  ...Ix
];
var Ci = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Ci || {}), pi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(pi || {}), Fr = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Fr || {}), Ex = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(Ex || {}), ai = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(ai || {}), jr = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(jr || {}), es = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(es || {});
const bL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, _L = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, xL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, SL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, NL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, jL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, wL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, CL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, FL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, IL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, EL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, TL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, $L = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, DL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, RL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, OL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, PL = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": bL,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": _L,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": xL,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": SL,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": NL,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": jL,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": wL,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": CL,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": FL,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": IL,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": EL,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": TL,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": $L,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": DL,
  "\n  query getProducts($productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": RL,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": OL
};
function cr(e) {
  return PL[e] ?? {};
}
const AL = cr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), LL = cr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  image {
                    url
                  }
                  product {
                    id
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), VL = cr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), zL = cr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), _p = cr(
  /* GraphQL */
  `
  query getProducts($productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), UL = cr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), ML = cr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), BL = cr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), qL = cr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), HL = cr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), WL = cr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), KL = cr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), Tx = Qr`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, GL = Qr`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, YL = ({
  conversationContext: e
}) => {
  const { useQuery: n } = mn(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: d,
    data: m,
    refetch: u,
    networkStatus: f
  } = n(AL, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: d,
    customerData: m,
    refetchCustomer: u,
    customerNetworkStatus: f
  };
}, JL = () => {
  const { useLazyQuery: e } = mn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(LL);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Ka(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const QL = "_list_alvh6_1", XL = "_listItem_alvh6_4", ZL = "_fullWidth_alvh6_15", eV = "_boxWrapper_alvh6_19", At = {
  list: QL,
  listItem: XL,
  fullWidth: ZL,
  boxWrapper: eV
}, nV = "_modal_1vkwz_1", tV = "_disabled_1vkwz_5", bu = {
  modal: nV,
  disabled: tV
}, tv = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: pi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: pi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: pi.Unknown
  }
], rv = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Fr.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Fr.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Fr.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Fr.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Fr.Unsubscribed
  }
], rV = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = kn(), { useMutation: l, showNotification: d } = mn(), [m, u] = se(), [f, h] = se(), [v, S] = vf(!0), [N, F] = vf(!0), I = !!m, g = e.customer?.email, q = e.customer?.phone_number, E = e.customer?.given_name, j = e.customer?.family_name, $ = {
    email: g ?? "",
    phone: q ?? "",
    firstName: E ?? "",
    lastName: j ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, U = sr({
    defaultValues: $
  });
  qe(() => {
    f?.forEach((P) => {
      const K = P?.field?.[0];
      K && (U.setError(K, {
        type: "server",
        message: P.message
      }), U.setFocus(K));
    });
  }, [f, U]);
  const [Z, { error: Q, reset: ee }] = l(WL, {
    onError: (P) => {
      u(P.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (P) => {
      const K = P?.Shopify?.customerCreate?.userErrors || [];
      K.length > 0 ? (h(K), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), J = at(
    (P) => {
      a(!0), u(void 0), Z({
        variables: {
          input: {
            firstName: P.firstName,
            lastName: P.lastName,
            defaultEmailAddress: {
              ...v && { emailAddress: P.email }
            },
            defaultPhoneNumber: {
              ...N && { phoneNumber: P.phone },
              marketingState: P.smsMarketingState,
              marketingOptInLevel: P.smsMarketingOptInLevel
            }
          }
        }
      });
    },
    [Z, a, N, v]
  ), W = () => {
    r(!1), ee(), u(void 0), U.reset($);
  };
  return /* @__PURE__ */ k.jsxs(gt, { isOpen: n, onClose: W, className: bu.modal, children: [
    /* @__PURE__ */ k.jsx(kt, { title: "Create new customer", onClose: W }),
    /* @__PURE__ */ k.jsx(vt, { children: /* @__PURE__ */ k.jsxs(zt, { children: [
      /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
        Bt,
        {
          label: "First name",
          name: "firstName",
          control: U.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
        Bt,
        {
          label: "Last name",
          name: "lastName",
          control: U.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
        Bt,
        {
          label: "Email",
          name: "email",
          control: U.control,
          rules: {
            required: v ? "Email is required" : void 0
          },
          componentProps: {
            className: dt({
              [bu.disabled]: !v
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Vu,
                {
                  disabled: !N,
                  name: "hasEmail",
                  value: "email",
                  checked: v,
                  onChange: () => S()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
        Bt,
        {
          label: "Phone",
          name: "phone",
          control: U.control,
          rules: {
            required: N ? "Phone is required" : void 0
          },
          componentProps: {
            className: dt({
              [bu.disabled]: !N
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Vu,
                {
                  disabled: !v,
                  name: "hasPhone",
                  value: "phone",
                  checked: N,
                  onChange: () => F()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
        vr,
        {
          control: U.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (P, K) => P === K,
            getItemTitleByValue: (P) => {
              const K = rv.find(
                (ne) => ne.value === P
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: K.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: K.description })
                  ]
                }
              );
            }
          },
          children: rv.map((P) => /* @__PURE__ */ k.jsx(pt.Item, { value: P.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: P.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: P.description })
          ] }) }, P.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
        vr,
        {
          control: U.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (P, K) => P === K,
            getItemTitleByValue: (P) => {
              const K = tv.find(
                (ne) => ne.value === P
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: K.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: K.description })
                  ]
                }
              );
            }
          },
          children: tv.map((P) => /* @__PURE__ */ k.jsx(pt.Item, { value: P.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: P.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: P.description })
          ] }) }, P.value))
        }
      ) }),
      I && /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(me, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      wt,
      {
        confirmProps: {
          disabled: !(U.formState.isValid && U.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
        },
        confirmOnClick: U.handleSubmit(J),
        cancelOnClick: W,
        confirmName: Q ? "Close" : "Save",
        cancelName: Q ? void 0 : "Cancel"
      }
    )
  ] });
}, iV = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = se(!1), [a, o] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      Wn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(me, { size: 14, name: "user-plus", color: "green.500" }),
        className: At.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      rV,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, xp = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, um = "DD MMM YYYY @ HH:mm", aV = "_wrapper_10fld_1", oV = "_copyIcon_10fld_7", Ro = {
  wrapper: aV,
  copyIcon: oV
}, sV = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Ka(), { isCopied: l, copy: d } = Ka(), { track: m } = kn();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: v,
    tags: S = [],
    verifiedEmail: N
  } = e, F = h?.emailAddress, I = v?.phoneNumber, g = xp(u), q = `https://${n}/admin/customers/${g ?? ""}`, E = i && a === ar.refetch, j = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: Ro.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: f }),
        E ? /* @__PURE__ */ k.jsx(un, { size: j }) : /* @__PURE__ */ k.jsx(Ke, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: j,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: Ro.copyIcon
          }
        ) })
      ] }),
      F && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(me, { size: j, name: "mail" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `mailto:${F}`, children: F }),
          /* @__PURE__ */ k.jsx(
            Ke,
            {
              content: N ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                me,
                {
                  size: j,
                  color: N ? "green.500" : "red.500",
                  name: N ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: j,
            name: o ? "done" : "copy",
            onClick: () => s(F),
            className: Ro.copyIcon
          }
        ) })
      ] }),
      I && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(me, { size: j, name: "phone" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `tel:${I}`, children: I })
        ] }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: j,
            name: l ? "done" : "copy",
            onClick: () => d(I),
            className: Ro.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(me, { size: j, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          A.ExternalLink,
          {
            href: q,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    S.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: S.map(($) => /* @__PURE__ */ k.jsx(On, { children: $ }, `${u}-${$}`)) })
    ] })
  ] });
}, lV = "_creationModal_pbe64_1", cV = "_detailsModal_pbe64_5", dV = "_percentageSuffix_pbe64_9", _u = {
  creationModal: lV,
  detailsModal: cV,
  percentageSuffix: dV
}, uV = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, mV = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: Ex.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, iv = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], av = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], ov = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], pV = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = Xt(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(He, { children: [
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            me,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: Pn(e?.startsAt).format(ct) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(An, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      kr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, fV = "shopify-discount-code-form", sv = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, hV = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = kn(), { useMutation: i, showNotification: a } = mn(), [o, s] = se(
    []
  ), [l, d] = se(), m = sr({
    mode: "all",
    defaultValues: sv
  });
  qe(() => {
    o?.forEach((j) => {
      const $ = j?.field?.[1];
      $ && m.setError($, {
        type: "server",
        message: j.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), v = et(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    S,
    {
      loading: N,
      error: F,
      reset: I
    }
  ] = i(KL, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (j) => {
      const $ = j?.Shopify?.discountCodeBasicCreate?.userErrors;
      if ($ && $.length > 0)
        s($);
      else {
        const U = j?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        U && "codes" in U && d(U), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), g = () => {
    m.setValue("code", uV(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, q = (j) => {
    S({
      variables: {
        input: mV(j)
      }
    });
  }, E = () => {
    m.reset(sv), s([]), I(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    gt,
    {
      isOpen: e,
      onClose: E,
      className: dt({
        [_u.creationModal]: !u,
        [_u.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          kt,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: E
          }
        ),
        /* @__PURE__ */ k.jsxs(vt, { children: [
          u && /* @__PURE__ */ k.jsx(pV, { codeDiscount: l }),
          !u && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: fV, onSubmit: m.handleSubmit(q), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              Ja,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(zt, { children: [
              /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
                Bt,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
                vr,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (j, $) => j === $,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (j) => {
                      const $ = iv.find(
                        (U) => U.value === j
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $?.label }) });
                    }
                  },
                  children: iv.map((j) => /* @__PURE__ */ k.jsx(pt.Item, { value: j.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: j.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: j.description })
                  ] }) }, j.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
                Bt,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (j) => {
                      if (j) {
                        if (h === "percentage" && (j < 0 || j > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && j < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: _u.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
                Bt,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: g
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
                vr,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (j, $) => j === $,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (j) => {
                      const $ = av.find(
                        (U) => U.value === j
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $?.label }) });
                    }
                  },
                  children: av.map((j) => /* @__PURE__ */ k.jsx(pt.Item, { value: j.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: j.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: j.description })
                  ] }) }, j.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
                Bt,
                {
                  name: "minimumRequirementValue",
                  label: v,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (j) => {
                      if (j && f !== "none" && j < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
                vr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (j, $) => j === $,
                    getItemTitleByValue: (j) => {
                      const $ = ov.find(
                        (U) => U.value === j
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $?.label }) });
                    }
                  },
                  children: ov.map((j) => /* @__PURE__ */ k.jsx(pt.Item, { value: j.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: j.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: j.description })
                  ] }) }, j.value))
                }
              ) })
            ] })
          ] }),
          F && /* @__PURE__ */ k.jsx(wn, { error: F })
        ] }),
        /* @__PURE__ */ k.jsx(
          wt,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: N,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? E : m.handleSubmit(q),
            cancelOnClick: u ? void 0 : E
          }
        )
      ]
    }
  );
}, yV = ({ code: e }) => {
  const { isCopied: n, copy: r } = Ka();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(me, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          Kt,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, gV = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(He, { children: i.map((a) => /* @__PURE__ */ k.jsx(He.Item, { className: At.listItem, children: /* @__PURE__ */ k.jsx(yV, { code: a.code }, a.id) }, a.id)) })
  ] });
}, kV = "_modal_11d6e_1", vV = "_modalBody_11d6e_4", bV = "_codeContainer_11d6e_9", xu = {
  modal: kV,
  modalBody: vV,
  codeContainer: bV
}, _V = [50, 100, 250], $x = 50, xV = {
  maxNumberOfCodesToDisplay: $x
}, SV = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = mn(), [i, a] = se(
    $x
  ), [o, s] = se([]), l = o.length === 0, d = o.length > i, m = sr({
    mode: "all",
    defaultValues: xV
  }), { loading: u, error: f } = r(UL, {
    variables: {
      first: i
    },
    onCompleted: (v) => {
      const S = v?.Shopify?.codeDiscountNodes?.nodes ?? [];
      S && S.length > 0 && s(S);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs(gt, { isOpen: e, onClose: h, className: xu.modal, children: [
    /* @__PURE__ */ k.jsx(kt, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs(vt, { className: xu.modalBody, children: [
      d && /* @__PURE__ */ k.jsx(zt, { children: /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
        vr,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (v) => {
              a(v.selectedValues[0]);
            },
            getItemTitleByValue: (v) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: v }) })
          },
          children: _V.map((v) => /* @__PURE__ */ k.jsx(pt.Item, { value: v, children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: v }) }, v))
        }
      ) }) }),
      u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(un, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !u && l && /* @__PURE__ */ k.jsx(
        Sm,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !u && !f && !l && o.map((v) => /* @__PURE__ */ k.jsx("div", { className: xu.codeContainer, children: /* @__PURE__ */ k.jsx(gV, { discountCode: v }) }, v.id))
    ] }),
    /* @__PURE__ */ k.jsx(wt, { confirmName: "Close", confirmOnClick: h })
  ] });
}, NV = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = se(!1), [i, a] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Wn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Wn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      SV,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      hV,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, jV = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? ws(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case Ci.Invalid:
      case Ci.NotSubscribed:
      case Fr.NotSubscribed:
        return "red.500";
      case Ci.Pending:
      case Fr.Pending:
      case Ci.Unsubscribed:
      case Fr.Unsubscribed:
        return "orange.500";
      case Ci.Subscribed:
      case Fr.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case pi.SingleOptIn:
      case pi.ConfirmedOptIn:
        return "green.500";
      case pi.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(me, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(Ke, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "info", children: Pn(l).format(um) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ke, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(On, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(On, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(me, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ k.jsx(Ke, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "info", children: Pn(u).format(um) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ke, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(On, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(On, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, wV = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a || void 0,
          kind: "REFUND",
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    tags: r.tags,
    refunds: r.refunds
  }));
}, lv = [
  {
    value: jr.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: jr.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: jr.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: jr.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: jr.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: jr.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: jr.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], cv = [
  {
    value: es.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: es.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: es.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], Oo = (e) => mm(CV(e)), mm = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), CV = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, ni = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  Pt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      ir,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), FV = "_modal_1wlra_1", IV = {
  modal: FV
};
function dv(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const uv = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], mv = "shopify-shiping-address-form", EV = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = mn(), { track: f } = kn(), [h, v] = se(!1), [S, N] = se({}), F = !l, [
    I,
    { error: g, reset: q }
  ] = m(ML, {
    onError: () => {
      v(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (J) => {
      v(!1);
      const W = J?.Shopify?.orderUpdate?.userErrors;
      if (W?.length > 0) {
        const P = W.reduce((K, ne) => (K[ne.field[ne.field.length - 1]] = ne.message, K), {});
        N(P);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), ee();
    }
  }), E = at(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: uv.find(
        (J) => J === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: j, handleSubmit: $, formState: U, reset: Z } = sr({
    mode: "all",
    defaultValues: E()
  }), Q = $((J) => {
    if (F) {
      v(!0), o && a && f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: W, ...P } = J, K = { ...P, countryCode: W };
      I({
        variables: {
          input: {
            id: a,
            shippingAddress: K
          }
        }
      });
    } else
      l(J), ee();
  });
  qe(() => {
    r && Z(E());
  }, [r, n, Z, E]);
  const ee = () => {
    Z(E()), N({}), q(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    gt,
    {
      isOpen: r,
      onClose: ee,
      className: IV.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx(kt, { title: e, onClose: () => ee() }),
        /* @__PURE__ */ k.jsx(vt, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: mv, onSubmit: Q, children: [
          g && /* @__PURE__ */ k.jsx(wn, { error: g }),
          /* @__PURE__ */ k.jsxs(zt, { children: [
            /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ni,
              {
                required: !0,
                control: j,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: S
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ni,
              {
                required: !0,
                control: j,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: S
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 6, children: /* @__PURE__ */ k.jsx(
              ni,
              {
                control: j,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 6, children: /* @__PURE__ */ k.jsx(
              ni,
              {
                required: !0,
                control: j,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: S
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 6, children: /* @__PURE__ */ k.jsx(
              ni,
              {
                control: j,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ni,
              {
                required: !0,
                control: j,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: S
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ni,
              {
                required: !0,
                control: j,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: S
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 6, children: /* @__PURE__ */ k.jsx(
              vr,
              {
                name: "countryCodeV2",
                control: j,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (J) => J ? dv(J) : ""
                },
                children: uv.filter((J) => s.includes(J)).map((J) => /* @__PURE__ */ k.jsx(pt.Item, { value: J, children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: dv(J) }) }, J))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          wt,
          {
            confirmProps: {
              disabled: !(U.isValid && U.isDirty),
              type: "submit",
              form: mv,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
            },
            confirmOnClick: () => {
              g && ee();
            },
            cancelOnClick: () => {
              o && a && !g && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ee();
            },
            confirmName: g ? "Close" : "Save",
            cancelName: g ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, TV = "_clickableIcon_33mqm_1", Su = {
  clickableIcon: TV
}, pv = ({
  formFieldName: e,
  ...n
}) => {
  const r = Rr(), { field: i } = Lm({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    pm,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, pm = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = se(!1), [h, v] = se(m), { isCopied: S, copy: N } = Ka(), { track: F } = kn(), I = 14, g = o && (!!r || !!l), q = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), E = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), j = n?.countryCodeV2 && SS(n.countryCodeV2), $ = at(() => [
    E,
    n?.company,
    n?.address1,
    n?.address2,
    q,
    n?.province,
    j
  ].filter(Boolean).join(`
`), [n, E, q, j]);
  if (!n)
    return null;
  const U = () => {
    i && r && F("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(me, { size: I, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!h),
              className: Su.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  me,
                  {
                    size: I,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            E && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: E }),
            n?.company && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address2 }),
            q && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: q }),
            n?.province && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.province }),
            j && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: j })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        g && /* @__PURE__ */ k.jsx(Ke, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: I,
            name: "pen",
            onClick: () => U(),
            className: Su.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(Ke, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: I,
            name: S ? "done" : "copy",
            onClick: () => N($()),
            className: Su.clickableIcon
          }
        ) })
      ] })
    ] }),
    g && /* @__PURE__ */ k.jsx(
      EV,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, Sp = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Rr(), i = Ko({ control: r.control, name: "lineItems" }), a = Ko({
    control: r.control,
    name: "billingAddress"
  }), o = Ko({
    control: r.control,
    name: "shippingAddress"
  }), s = et(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = et(() => !s || s.length === 0 ? 0 : s.reduce((m, u) => {
    const f = u.priceRangeV2?.minVariantPrice?.amount || 0, h = u.quantity || 0;
    return m + f * h;
  }, 0), [s]), d = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        pv,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        pv,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${d}` })
    ] }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, $V = "_productTableHeader_6h6pl_1", DV = "_productImage_6h6pl_5", La = {
  productTableHeader: $V,
  productImage: DV
}, Np = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, RV = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Rr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = Np(e);
  return /* @__PURE__ */ k.jsxs(Qn.Tr, { children: [
    /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ k.jsx(
        Li,
        {
          src: d,
          alt: e.title,
          className: La.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(
      Bt,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(Kt, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, OV = ({
  products: e,
  isLoadingProducts: n
}) => {
  const [r, i] = se(""), a = Rr(), o = et(() => {
    if (!r.trim())
      return e;
    const l = r.toLowerCase();
    return e.filter(
      (d) => d.title.toLowerCase().includes(l)
    );
  }, [e, r]), s = !o.length && !n;
  return /* @__PURE__ */ k.jsx(
    vr,
    {
      noAlert: !0,
      label: "Product selection",
      control: a.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: n ? "Loading products..." : "Select or search products",
        tabIndex: 0,
        getItemTitleByValue: (l) => {
          const d = e.find((m) => m.id === l);
          return d ? /* @__PURE__ */ k.jsx(A.Paragraph, { children: d.title }) : null;
        },
        filter: {
          value: r,
          onChange: (l) => {
            i(l.target.value);
          }
        },
        onToggleDropdown: (l) => {
          !l && r !== "" && i("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        n && /* @__PURE__ */ k.jsx(pt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(un, {}) }) }),
        !n && o.map((l) => {
          const d = l.totalInventory <= 0, m = Np(l);
          return /* @__PURE__ */ k.jsx(
            pt.Item,
            {
              value: l.id,
              isDisabled: d,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  m && /* @__PURE__ */ k.jsx(
                    Li,
                    {
                      src: m,
                      alt: l.title,
                      className: La.productImage
                    }
                  ),
                  r ? /* @__PURE__ */ k.jsx(
                    PS,
                    {
                      text: l.title,
                      highlight: r
                    }
                  ) : /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: l.title })
                ] }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: d ? "Out of stock" : `${l.totalInventory} in stock` })
              ] })
            },
            l.id
          );
        }),
        s && /* @__PURE__ */ k.jsx(pt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          Sm,
          {
            title: "No products found",
            description: r ? "Try changing your search criteria." : "No products available."
          }
        ) })
      ] })
    }
  );
}, jp = ({
  isAlreadyLoadedProducts: e = !1,
  contextProducts: n = [],
  selectionMode: r = !1,
  hideDeleteButton: i = !1,
  selectedProductIds: a = [],
  onToggleSelect: o,
  onToggleSelectAll: s
}) => {
  const { useQuery: l } = mn(), d = Rr(), m = d.watch("lineItems"), u = d.watch("selectedProductId"), f = m && m?.length > 0, h = r && f ? m.every((q) => a.includes(q?.id)) : !1, v = r && f ? m.some(
    (q) => a.includes(q?.id)
  ) && !h : !1, {
    data: S,
    loading: N,
    error: F
  } = l(_p, {
    skip: e || n.length > 0,
    variables: {
      productCount: 250,
      mediaCount: 1
    }
  }), I = et(() => {
    const q = S?.Shopify?.products?.nodes || n;
    return !q || q.length === 0 ? [] : q.filter((E) => !!E).sort((E, j) => E.title.localeCompare(j.title));
  }, [S, n]);
  if (qe(() => {
    if (!u) return;
    const q = I.find(
      (j) => j.id === u
    );
    if (!q) {
      d.setValue("selectedProductId", void 0);
      return;
    }
    const E = m.findIndex(
      (j) => j?.id === q.id
    );
    if (E > -1) {
      const j = d.getValues(`lineItems.${E}.quantity`) || 0, $ = [...m];
      $[E] = {
        ...q,
        quantity: j + 1
      }, d.setValue("lineItems", $);
    } else
      d.setValue("lineItems", [
        ...m,
        { ...q, quantity: 1 }
      ]);
    d.setValue("selectedProductId", void 0);
  }, [u, I, d, m]), F)
    return /* @__PURE__ */ k.jsx(wn, { error: F });
  const g = e || N;
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(OV, { products: I, isLoadingProducts: g }),
    !f && !g && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: At.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          Sm,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    (f || g) && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      Qn,
      {
        hoverable: !0,
        loading: g,
        framed: !1,
        headerWithBackground: !1,
        className: La.productTable,
        children: [
          /* @__PURE__ */ k.jsx(Qn.Thead, { className: La.productTableHeader, children: /* @__PURE__ */ k.jsxs(Qn.Tr, { children: [
            r && /* @__PURE__ */ k.jsx(Qn.Th, { children: /* @__PURE__ */ k.jsx(
              Lp,
              {
                checked: h,
                indeterminate: v,
                onChange: () => s?.(!h)
              }
            ) }),
            /* @__PURE__ */ k.jsx(Qn.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(Qn.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(Qn.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(Qn.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(Qn.Th, { children: "Total" }),
            !i && /* @__PURE__ */ k.jsx(Qn.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(Qn.Tbody, { children: m?.map((q, E) => {
            if (!r)
              return /* @__PURE__ */ k.jsx(
                RV,
                {
                  product: q,
                  index: E,
                  onRemove: () => {
                    const P = m.filter(
                      (K, ne) => ne !== E
                    );
                    d.setValue("lineItems", P);
                  }
                },
                `${q?.id}-${E}`
              );
            const j = q, $ = j.priceRangeV2.minVariantPrice.amount, U = j.priceRangeV2.minVariantPrice.currencyCode, Z = `lineItems.${E}.quantity`, Q = d.watch(Z) || 0, ee = $ * Q, J = Np(j), W = a.includes(j.id);
            return /* @__PURE__ */ k.jsxs(Qn.Tr, { children: [
              /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(
                Lp,
                {
                  checked: W,
                  onChange: () => o?.(j.id, !W)
                }
              ) }),
              /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                J && /* @__PURE__ */ k.jsx(
                  Li,
                  {
                    src: J,
                    alt: j.title,
                    className: La.productImage
                  }
                ),
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: j.title })
              ] }) }),
              /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: j.totalInventory }) }),
              /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${$} ${U}` }) }),
              /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(
                Bt,
                {
                  noLabel: !0,
                  noAlert: !0,
                  name: Z,
                  control: d.control,
                  componentProps: {
                    type: "number",
                    min: 1,
                    max: j.totalInventory,
                    tabIndex: 0
                  }
                },
                `${Z}-${d.watch(Z)}`
              ) }),
              /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${ee} ${U}` }) }),
              !i && /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                Kt,
                {
                  icon: "trash",
                  variant: "secondary",
                  onClick: () => {
                    const P = m.filter(
                      (K, ne) => ne !== E
                    );
                    d.setValue("lineItems", P), W && o?.(j.id, !1);
                  }
                }
              ) }) })
            ] }, `${j.id}-${E}`);
          }) })
        ]
      }
    ) })
  ] });
}, Dx = () => {
  const e = Rr();
  return /* @__PURE__ */ k.jsx(
    vr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: e.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = lv.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  r.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: lv.map((n) => /* @__PURE__ */ k.jsx(pt.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, Rx = () => {
  const e = Rr();
  return /* @__PURE__ */ k.jsx(
    vr,
    {
      label: "Fulfillment Status",
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = cv.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: cv.map((n) => /* @__PURE__ */ k.jsx(pt.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, PV = "_modal_1mprq_1", AV = {
  modal: PV
}, Nu = "create-shopify-order-form", LV = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = kn(), [d, m] = se(!1), [
    u,
    f
  ] = se(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, v = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: jr.Pending,
    fulfillmentStatus: void 0
  }, [S, N] = se([]), F = sr({
    mode: "all",
    defaultValues: v
  }), I = F.watch("lineItems").length > 0, g = () => {
    F.reset(v), N([]), i(!1);
  };
  qe(() => {
    S.length > 0 && F.setValue("tags", S, { shouldDirty: !0 });
  }, [S, F]);
  const [q, { error: E }] = o(
    Tx,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), g();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), g();
      }
    }
  ), [j, { error: $ }] = o(
    GL,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), g();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), g();
      }
    }
  ), U = (Q) => {
    const ee = Q.lineItems.map((P) => ({
      productId: P.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: P.priceRangeV2.maxVariantPrice.amount,
          currencyCode: P.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: P.quantity
    }));
    m(!0);
    const J = Oo(Q?.billingAddress), W = Oo(
      Q?.shippingAddress
    );
    q({
      variables: {
        order: {
          lineItems: ee,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: Q.customNote,
          tags: Q.tags,
          financialStatus: Q.financialStatus,
          fulfillmentStatus: Q.fulfillmentStatus,
          shippingAddress: W,
          billingAddress: J
        }
      }
    });
  }, Z = (Q) => {
    const ee = Q.lineItems.map((P) => ({
      title: P.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: P.priceRangeV2.maxVariantPrice.amount,
        currencyCode: P.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: P.quantity
    }));
    f(!0);
    const J = Oo(Q?.billingAddress), W = Oo(
      Q?.shippingAddress
    );
    j({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: Q.customNote,
          tags: Q.tags,
          lineItems: ee,
          shippingAddress: W,
          billingAddress: J
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    gt,
    {
      isOpen: e,
      onClose: g,
      className: AV.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(kt, { title: "Create new order", onClose: g }),
        /* @__PURE__ */ k.jsxs(vt, { children: [
          /* @__PURE__ */ k.jsx(Am, { ...F, children: /* @__PURE__ */ k.jsx("form", { id: Nu, children: /* @__PURE__ */ k.jsxs(zt, { children: [
            /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(jp, {}) }),
            /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
              Pt,
              {
                name: "tags",
                render: ({ fieldState: { error: Q } }) => /* @__PURE__ */ k.jsx(
                  An,
                  {
                    label: "Tags",
                    meta: {
                      error: Q?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ee) => {
                          ee.key === "Enter" && (ee.preventDefault(), ee.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Cs,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: S,
                            onChange: (ee) => {
                              N(ee);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(Dx, {}),
              /* @__PURE__ */ k.jsx(Rx, {}),
              /* @__PURE__ */ k.jsx(
                Bt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(nn, { span: 2, children: /* @__PURE__ */ k.jsx(An, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: At.boxWrapper,
                children: /* @__PURE__ */ k.jsx(Sp, {})
              }
            ) }) })
          ] }) }) }),
          (E || $) && /* @__PURE__ */ k.jsx(wn, { error: E || $ })
        ] }),
        /* @__PURE__ */ k.jsx(
          wt,
          {
            confirmProps: {
              type: "submit",
              form: Nu,
              disabled: !I || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: F.handleSubmit(U),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                F.handleSubmit(Z)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: Nu,
                disabled: !I || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, VV = "_modal_al73g_1", zV = {
  modal: VV
}, fv = [
  {
    label: "Customer",
    value: ai.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: ai.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: ai.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: ai.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: ai.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: ai.Staff,
    description: "Staff made an error."
  }
], UV = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = kn(), { useMutation: d, showNotification: m } = mn(), [u, f] = se([]), h = u.length > 0, v = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, S = sr({
    defaultValues: v
  }), [N, { error: F, reset: I }] = d(qL, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (E) => {
      const j = E.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (j.length > 0)
        o(!1), f(j), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const $ = E.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, $ ? 0 : 4e3), m({
          title: "Success",
          text: `${$ ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), g = at(
    (E) => {
      o(!0), N({
        variables: E
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), q = () => {
    i(!1), I(), f([]), S.reset(v);
  };
  return /* @__PURE__ */ k.jsxs(gt, { isOpen: n, onClose: q, className: zV.modal, children: [
    /* @__PURE__ */ k.jsx(kt, { title: `Cancel order ${r}`, onClose: q }),
    /* @__PURE__ */ k.jsx(vt, { children: /* @__PURE__ */ k.jsxs(zt, { children: [
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
        vr,
        {
          control: S.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (E, j) => E === j,
            getItemTitleByValue: (E) => {
              if (!E)
                return "";
              const j = fv.find(
                ($) => $.value === E
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: j.label }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: j.description })
              ] });
            }
          },
          children: fv.map((E) => /* @__PURE__ */ k.jsx(pt.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
          ] }) }, E.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(An, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        ku,
        {
          control: S.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(An, { label: "Restock items", children: /* @__PURE__ */ k.jsx(ku, { control: S.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(An, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(ku, { control: S.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
        Bt,
        {
          name: "staffNote",
          label: "Staff note",
          control: S.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: u.map((E) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(me, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.code }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
              "(",
              E.field?.join(","),
              ") ",
              E.message
            ] })
          ]
        },
        E.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      wt,
      {
        confirmProps: {
          disabled: !(S.formState.isValid && S.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
        },
        confirmOnClick: S.handleSubmit(g),
        cancelOnClick: q,
        confirmName: F ? "Close" : "Cancel order",
        cancelName: F ? void 0 : "Cancel"
      }
    )
  ] });
}, MV = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = se(!1), [s, l] = se(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      Wn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          me,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: At.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      UV,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, BV = "_modal_1mprq_1", qV = {
  modal: BV
}, HV = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = mn(), { track: m } = kn(), [u, f] = se(!1), [h, v] = se(e?.tags || []), S = "duplicate-shopify-order-form", N = (ee) => ({
    firstName: ee?.firstName,
    lastName: ee?.lastName,
    address1: ee?.address1,
    address2: ee?.address2,
    city: ee?.city,
    provinceCode: ee?.provinceCode,
    zip: ee?.zip,
    countryCode: ee?.countryCodeV2
  }), F = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: N(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: N(e?.shippingAddress),
    financialStatus: jr.Pending,
    fulfillmentStatus: void 0
  }, I = sr({
    mode: "all",
    defaultValues: F
  }), g = I.watch("lineItems").length > 0, { data: q, loading: E } = d(
    _p,
    {
      variables: { productCount: 250, mediaCount: 1 }
    }
  ), j = et(() => {
    const ee = q?.Shopify?.products?.nodes;
    return !ee || ee.length === 0 ? [] : ee.filter((J) => !!J).sort((J, W) => J.title.localeCompare(W.title));
  }, [q]);
  qe(() => {
    if (!r || !j?.length || I.getValues("lineItems")?.length)
      return;
    const ee = [];
    e?.lineItems?.forEach((J) => {
      const W = j.find(
        (P) => P.id === J.product?.id
      );
      W && ee.push({ ...W, quantity: J.quantity || 1 });
    }), ee.length > 0 && I.setValue("lineItems", ee, { shouldDirty: !0 });
  }, [r, j, e, I]), qe(() => {
    (h.length > 0 || (I.getValues("tags") || []).length > 0) && I.setValue("tags", h, { shouldDirty: !0 });
  }, [h, I]);
  const [$, { error: U }] = s(
    Tx,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), Q();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), Q();
      }
    }
  ), Z = (ee) => {
    const J = ee.lineItems.map((W) => ({
      productId: W.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: W.priceRangeV2.maxVariantPrice.amount,
          currencyCode: W.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: W.quantity
    }));
    f(!0), $({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: J,
          note: ee.customNote,
          tags: ee.tags,
          financialStatus: ee.financialStatus,
          fulfillmentStatus: ee.fulfillmentStatus,
          shippingAddress: mm(ee?.shippingAddress),
          billingAddress: mm(ee?.billingAddress)
        }
      }
    });
  }, Q = () => {
    I.reset(F), v(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    gt,
    {
      isOpen: r,
      onClose: Q,
      className: qV.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(kt, { title: `Duplicate order ${n}`, onClose: Q }),
        /* @__PURE__ */ k.jsxs(vt, { children: [
          /* @__PURE__ */ k.jsx(Am, { ...I, children: /* @__PURE__ */ k.jsx("form", { id: S, children: /* @__PURE__ */ k.jsxs(zt, { children: [
            /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
              jp,
              {
                isAlreadyLoadedProducts: E,
                contextProducts: j
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
              Pt,
              {
                name: "tags",
                render: ({ fieldState: { error: ee } }) => /* @__PURE__ */ k.jsx(
                  An,
                  {
                    label: "Tags",
                    meta: {
                      error: ee?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (J) => {
                          J.key === "Enter" && (J.preventDefault(), J.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Cs,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (J) => {
                              v(J);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(Dx, {}),
              /* @__PURE__ */ k.jsx(Rx, {}),
              /* @__PURE__ */ k.jsx(
                Bt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(nn, { span: 2, children: /* @__PURE__ */ k.jsx(An, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: At.boxWrapper,
                children: /* @__PURE__ */ k.jsx(Sp, {})
              }
            ) }) })
          ] }) }) }),
          U && /* @__PURE__ */ k.jsx(wn, { error: U })
        ] }),
        /* @__PURE__ */ k.jsx(
          wt,
          {
            confirmProps: {
              type: "submit",
              form: S,
              disabled: !g || u,
              isLoading: u,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: I.handleSubmit(Z)
          }
        )
      ]
    }
  );
}, WV = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  if (!n || n?.length === 0)
    return null;
  const i = Object.values(r).some(
    (a) => a > 0
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ k.jsx(me, { size: 14, name: "shopify", color: "green.500" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    i && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(On, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(He, { children: n.map(({ id: a, title: o, quantity: s, variantTitle: l, image: d }) => {
      const m = r[a], u = m > 0, f = m > 1 ? `Refunded (${m} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        He.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: s }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "4", children: [
            o,
            " ",
            l && `(${l})`,
            u && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", color: "red.500", children: f })
          ] }),
          contentRight: d?.url && /* @__PURE__ */ k.jsx(Li, { src: `${d?.url}&height=48`, alt: o })
        },
        `list-${e}-${a}`
      );
    }) })
  ] });
}, KV = Qr`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, GV = "_modal_21e62_1", YV = {
  modal: GV
}, hv = "partial-refund-shopify-order-form", JV = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = kn(), { useQuery: d } = mn(), [m, u] = se(!1), [f, h] = se([]), { data: v, loading: S } = d(
    _p,
    {
      variables: { productCount: 250, mediaCount: 1 }
    }
  ), N = et(() => {
    const U = v?.Shopify?.products?.nodes;
    return !U || U.length === 0 ? [] : U.filter((Z) => !!Z).sort((Z, Q) => Z.title.localeCompare(Q.title));
  }, [v]), F = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, I = sr({
    mode: "all",
    defaultValues: F
  }), g = f.length > 0, [q, { error: E }] = o(
    KV,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), $();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), $();
      }
    }
  );
  qe(() => {
    if (!r || !N?.length || I.getValues("lineItems")?.length)
      return;
    const U = [];
    e?.lineItems?.forEach((Z) => {
      const Q = N.find(
        (ee) => ee.id === Z.product?.id
      );
      Q && U.push({ ...Q, quantity: Z.quantity || 1 });
    }), U.length > 0 && (I.setValue("lineItems", U, { shouldDirty: !0 }), h([]));
  }, [r, N, e, I]);
  const j = (U) => {
    u(!0);
    const Z = (U.lineItems || []).filter(
      (Q) => f.includes(Q.id)
    ).map((Q) => {
      const ee = e?.lineItems?.find(
        (P) => P.product?.id === Q.id
      ), J = ee?.quantity || 0, W = Math.max(
        0,
        Math.min(J, Q.quantity || 0)
      );
      return ee && W > 0 ? { lineItemId: ee.id, quantity: W } : void 0;
    }).filter((Q) => !!Q);
    q({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: Z,
          note: U.customNote || void 0,
          notify: !0
        }
      }
    });
  }, $ = () => {
    I.reset(F), u(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(gt, { isOpen: r, onClose: $, className: YV.modal, children: [
    /* @__PURE__ */ k.jsx(kt, { title: `Refund order ${n}`, onClose: $ }),
    /* @__PURE__ */ k.jsxs(vt, { children: [
      /* @__PURE__ */ k.jsx(Am, { ...I, children: /* @__PURE__ */ k.jsx("form", { id: hv, children: /* @__PURE__ */ k.jsxs(zt, { children: [
        /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
          jp,
          {
            selectionMode: !0,
            hideDeleteButton: !0,
            isAlreadyLoadedProducts: S,
            contextProducts: N,
            selectedProductIds: f,
            onToggleSelect: (U, Z) => {
              h((Q) => Z ? Array.from(/* @__PURE__ */ new Set([...Q, U])) : Q.filter((ee) => ee !== U));
            },
            onToggleSelectAll: (U) => {
              const Z = (I.getValues("lineItems") || []).map((Q) => Q.id);
              h(U ? Z : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(nn, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          Bt,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(nn, { span: 2, children: /* @__PURE__ */ k.jsx(An, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: At.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              Sp,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      E && /* @__PURE__ */ k.jsx(wn, { error: E })
    ] }),
    /* @__PURE__ */ k.jsx(
      wt,
      {
        confirmProps: {
          type: "submit",
          form: hv,
          disabled: !g || m,
          isLoading: m,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: I.handleSubmit(j)
      }
    )
  ] });
}, QV = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = mn(), { track: l } = kn(), { suggestedRefund: d, currencyCode: m, id: u, name: f } = e, [h] = a(BL, {
    onError: (N) => {
      setTimeout(() => S(N), 500);
    },
    onCompleted: (N) => {
      const F = N.Shopify?.refundCreate?.userErrors;
      F && F.length > 0 ? S(
        new BS({
          graphQLErrors: F.map((I) => ({
            message: I.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), v = at(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: u });
    const { amount: N, ...F } = d;
    s({
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
        "You are about to refund ",
        N,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: u }), h({
          variables: {
            input: F
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: u })
    });
  }, [n, u]), S = at(
    (N) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(wn, { error: N }),
          /* @__PURE__ */ k.jsx(
            jt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    Wn,
    {
      variant: "secondary",
      onClick: v,
      disabled: d?.refundLineItems?.length === 0,
      slotStart: /* @__PURE__ */ k.jsx(me, { size: 14, name: "undo" }),
      className: At.fullWidth,
      children: "Full refund"
    }
  ) });
}, XV = "_modal_al73g_1", ZV = {
  modal: XV
}, ez = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = kn(), { useMutation: s, showNotification: l } = mn(), [d, m] = se(n), [u, f] = se(!1), h = sr({
    defaultValues: {
      tags: n
    }
  });
  qe(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [v, { error: S, reset: N }] = s(HL, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), F = at(
    (g) => {
      f(!0), v({
        variables: {
          input: {
            id: e,
            tags: g.tags
          }
        }
      }).then((q) => {
        h.reset({ tags: q.data.Shopify.orderUpdate.order.tags });
      });
    },
    [e]
  ), I = () => {
    i(!1), N();
  };
  return /* @__PURE__ */ k.jsxs(gt, { isOpen: r, onClose: I, className: ZV.modal, children: [
    /* @__PURE__ */ k.jsx(kt, { title: "Manage tags for order", onClose: I }),
    /* @__PURE__ */ k.jsxs(vt, { children: [
      /* @__PURE__ */ k.jsx(zt, { children: /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
        Pt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: g } }) => /* @__PURE__ */ k.jsx(
            An,
            {
              label: "Tags",
              meta: {
                error: g?.message
              },
              children: /* @__PURE__ */ k.jsx(
                Cs,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (q) => m(q)
                }
              )
            }
          )
        }
      ) }) }),
      S && /* @__PURE__ */ k.jsx(wn, { error: S })
    ] }),
    /* @__PURE__ */ k.jsx(
      wt,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(F),
        cancelOnClick: I,
        confirmName: S ? "Close" : "Save",
        cancelName: S ? void 0 : "Cancel"
      }
    )
  ] });
}, nz = "_editIcon_1dntr_1", tz = {
  editIcon: nz
}, rz = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = se(!1), o = 14, s = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(me, { size: o, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !s && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            s && n.map((l, d) => /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "primary", children: l }, d))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsx(b, { gap: "250", flexDirection: "row", children: /* @__PURE__ */ k.jsx(Ke, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
        me,
        {
          size: o,
          name: "pen",
          className: tz.editIcon,
          onClick: () => a(!0)
        }
      ) }) })
    ] }),
    /* @__PURE__ */ k.jsx(
      ez,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, iz = "_icon_cddi1_1", az = "_link_cddi1_6", yv = {
  icon: iz,
  link: az
}, oz = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Ka(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    He.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        A.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: yv.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(Ke, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        me,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: yv.icon
        }
      ) })
    }
  );
}, sz = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(me, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(He, { children: e.map((n) => /* @__PURE__ */ k.jsx(oz, { trackingInfo: n }, n.number)) })
] }), lz = "_order_135ze_1", cz = "_orderIsOpen_135ze_9", dz = "_orderHeader_135ze_12", ju = {
  order: lz,
  orderIsOpen: cz,
  orderHeader: dz
}, uz = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, mz = (e) => {
  const n = {}, r = uz(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, pz = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = kn(), [h, v] = se(!1), [S, N] = se(!1), [F, I] = se(r), {
    id: g,
    name: q,
    createdAt: E,
    status: j,
    currentTotalPriceSet: $,
    currencyCode: U,
    lineItems: Z,
    billingAddress: Q,
    shippingAddress: ee,
    trackingInfos: J,
    tags: W
  } = e, P = !!ee, K = xp(g), ne = `https://${l}/admin/orders/${K ?? ""}`, ke = $?.shopMoney?.amount ?? 0, ue = j.includes("cancelled"), ce = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: U
  }).format(ke), he = e?.refunds ? mz(e) : {};
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: dt(ju.order, {
        [ju.orderIsOpen]: F
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ju.orderHeader,
            onClick: () => I(!F),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                E && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: Pn(E).format(um) }) }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order ",
                  q
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: F ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        F && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(me, { size: 14, name: "activity", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: j })
            ] })
          ] }),
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(me, { size: 14, name: "chart-bar", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: ce })
            ] })
          ] }),
          /* @__PURE__ */ k.jsx(
            rz,
            {
              orderId: g,
              tags: W,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            pm,
            {
              openByDefault: !P,
              labelText: "Billing address",
              address: Q,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            pm,
            {
              openByDefault: P,
              shopifyId: n,
              orderId: g,
              icon: "map-pin",
              labelText: "Shipping address",
              address: ee,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            WV,
            {
              orderId: g,
              lineItems: Z,
              refundedQuantities: he
            }
          ),
          /* @__PURE__ */ k.jsx(sz, { trackingInfos: J }),
          (o || m) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              QV,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: ne
              }
            ),
            m && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Wn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => N(!0),
                className: At.fullWidth,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Wn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => v(!0),
                className: At.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              MV,
              {
                orderId: g,
                orderName: q,
                disabled: ue,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            jt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(ne, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: g
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        h && /* @__PURE__ */ k.jsx(
          HV,
          {
            order: e,
            shopifyId: n,
            orderName: q,
            isOpen: h,
            setIsOpen: v,
            refetchOrders: u
          }
        ),
        S && /* @__PURE__ */ k.jsx(
          JV,
          {
            order: e,
            orderName: q,
            isOpen: S,
            setIsOpen: N,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, fz = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = kn(), [f, h] = se([]), [v, S] = se(!1), N = xp(m?.id), F = `https://${n}/admin/orders?customer_id=${N ?? ""}`, {
    getCustomerOrders: I,
    isCustomerOrdersLoading: g,
    customerOrdersError: q,
    customerOrders: E,
    refetchCustomerOrders: j
  } = JL();
  return qe(() => {
    !g && N && I({
      variables: {
        query: `customer_id:${N}`
      }
    });
  }, [N]), qe(() => {
    const $ = E?.Shopify?.orders?.edges;
    $ && h(wV({ ordersData: $ }));
  }, [E]), m ? q ? /* @__PURE__ */ k.jsx(wn, { error: q }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !g && /* @__PURE__ */ k.jsx(Un, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Wn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => S(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      g && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(un, {}) }),
      !g && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !g && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map(($, U) => /* @__PURE__ */ k.jsx(
        pz,
        {
          order: $,
          openByDefault: U === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: j,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${U}-${$.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        jt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(F, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      LV,
      {
        isOpen: v,
        setIsOpen: S,
        shopifyCustomer: m,
        refetchCustomerOrders: j,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, hz = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(He, { className: At.list, children: [
      /* @__PURE__ */ k.jsx(He.Text, { variant: "dense", className: At.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { variant: "dense", className: At.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, yz = "_segmentName_1dkhk_1", gz = {
  segmentName: yz
}, kz = 100, Po = 10, vz = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = mn(), [i, a] = se([]), [o, s] = se(Po), [l, d] = se(!1), m = et(
    () => i.filter((N) => N.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    VL,
    {
      skip: !e,
      variables: {
        first: kz
      },
      onCompleted: (N) => {
        const F = N?.Shopify?.segments?.edges;
        if (F && F.length > 0) {
          const I = F.map(({ node: g }) => ({
            ...g,
            isMember: !1
          })).sort((g, q) => g.name.localeCompare(q.name));
          a(I), h({
            variables: {
              customerId: e,
              segmentIds: I.map((g) => g.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: v, error: S }
  ] = r(zL, {
    onCompleted: (N) => {
      const F = N?.Shopify?.customerSegmentMembership?.memberships;
      if (F && F.length > 0) {
        const I = i.map((g) => {
          const q = F.find(
            (E) => E.segmentId === g.id
          );
          return {
            ...g,
            ...q?.isMember && { isMember: q.isMember }
          };
        }).sort(
          (g, q) => g.isMember === q.isMember ? 0 : g.isMember ? -1 : 1
        );
        a(I);
      }
    }
  });
  return qe(() => {
    s(l ? i.length : Po);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ k.jsx(Un, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(un, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(wn, { error: f }),
    S && /* @__PURE__ */ k.jsx(wn, { error: S }),
    !u && i.length > 0 && /* @__PURE__ */ k.jsxs(He, { className: At.list, children: [
      i.slice(0, o).map(({ id: N, name: F, isMember: I }) => /* @__PURE__ */ k.jsx(He.Text, { className: At.listItem, children: /* @__PURE__ */ k.jsx(
        Ke,
        {
          content: `${I ? "Member of" : "Not a member of"} ${F}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", className: gz.segmentName, children: F }),
            v && /* @__PURE__ */ k.jsx(un, { size: 12 }),
            !v && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              me,
              {
                color: I ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, N)),
      i.length > Po && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        Wn,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Po} more`
        }
      ) })
    ] })
  ] }) : null;
}, bz = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: r,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = YL({ conversationContext: e }), [l, d] = se(), [m, u] = se(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, v = n.displayCancelOrder ?? !1, S = n.enableEditShippingAddress ?? !1, N = n.displayEmailMarketingConsent ?? !1, F = n.displayOrdersOverview ?? !1, I = n.displaySegmentMembership ?? !1, g = n.displayDiscountCodeCreation ?? !1, q = n.displayDiscountCodes ?? !1, E = n.displayCreateOrder ?? !1, j = n.displayDuplicateOrder ?? !1, $ = n.displayCreateDraftOrder ?? !1, U = n.displayPartialRefundOrder ?? !1;
  if (qe(() => {
    const Z = a?.Shopify?.customers?.edges[0]?.node;
    Z && !r ? (u(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), d(Z)) : d(void 0);
  }, [a]), !r && i)
    return /* @__PURE__ */ k.jsx(wn, { error: i, retry: o });
  if (!r && !i && !l) {
    const Z = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              iV,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              jt,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(Z, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return r && s !== ar.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(un, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          sV,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: r,
            networkStatus: s
          }
        ),
        F && /* @__PURE__ */ k.jsx(
          hz,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        I && /* @__PURE__ */ k.jsx(vz, { shopifyId: l?.id }),
        N && /* @__PURE__ */ k.jsx(jV, { customer: l }),
        q && /* @__PURE__ */ k.jsx(
          NV,
          {
            displayDiscountCodeCreation: g
          }
        ),
        /* @__PURE__ */ k.jsx(
          fz,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: v,
            displayCreateOrder: E,
            displayCreateDraftOrder: $,
            enableEditShippingAddress: S,
            customerCountryCodes: m,
            displayDuplicateOrder: j,
            displayPartialRefundOrder: U
          }
        )
      ]
    }
  );
}, _t = [];
for (let e = 0; e < 256; ++e)
  _t.push((e + 256).toString(16).slice(1));
function _z(e, n = 0) {
  return (_t[e[n + 0]] + _t[e[n + 1]] + _t[e[n + 2]] + _t[e[n + 3]] + "-" + _t[e[n + 4]] + _t[e[n + 5]] + "-" + _t[e[n + 6]] + _t[e[n + 7]] + "-" + _t[e[n + 8]] + _t[e[n + 9]] + "-" + _t[e[n + 10]] + _t[e[n + 11]] + _t[e[n + 12]] + _t[e[n + 13]] + _t[e[n + 14]] + _t[e[n + 15]]).toLowerCase();
}
let wu;
const xz = new Uint8Array(16);
function Sz() {
  if (!wu) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    wu = crypto.getRandomValues.bind(crypto);
  }
  return wu(xz);
}
const Nz = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), gv = { randomUUID: Nz };
function jz(e, n, r) {
  if (gv.randomUUID && !e)
    return gv.randomUUID();
  e = e || {};
  const i = e.random ?? e.rng?.() ?? Sz();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, _z(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Cu = { exports: {} }, Sa = {}, kv;
function wz() {
  if (kv) return Sa;
  kv = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Sa.Fragment = r, Sa.jsx = s, Sa.jsxs = s, Sa;
}
var Ao = {}, vv;
function Cz() {
  return vv || (vv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var E = !1, j = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || E || j || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function W(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return W(c) + ".Consumer";
          case s:
            var p = t;
            return W(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, ke, ue, ce, he, H, be, Ce;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, ue = console.info, ce = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: ke
            }),
            info: K({}, t, {
              value: ue
            }),
            warn: K({}, t, {
              value: ce
            }),
            error: K({}, t, {
              value: he
            }),
            group: K({}, t, {
              value: H
            }),
            groupCollapsed: K({}, t, {
              value: be
            }),
            groupEnd: K({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              y = te;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), T = y.stack.split(`
`), V = x.length - 1, z = T.length - 1; V >= 1 && z >= 0 && x[V] !== T[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== T[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== T[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var C in t)
          if (L(t, C)) {
            var x = void 0;
            try {
              if (typeof t[C] != "function") {
                var T = Error((y || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              x = t[C](c, C, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, C, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, C) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, C = {}, x = null, T = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (T = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (x || T) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(C, z), T && fn(C, z);
        }
        return pn(t, x, T, R, y, B.current, C);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), C; !(C = L.next()).done; )
              an(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var C = ee(t);
        if (!C) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Hn();
          T ? x += T : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    Ao.Fragment = i, Ao.jsx = Bn, Ao.jsxs = qn;
  })()), Ao;
}
var bv;
function Fz() {
  return bv || (bv = 1, process.env.NODE_ENV === "production" ? Cu.exports = wz() : Cu.exports = Cz()), Cu.exports;
}
var M = Fz(), Ox = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(Ox || {}), fm = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(fm || {});
const Iz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, Ez = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, Tz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, $z = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, Dz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, Rz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, Oz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, Pz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, Az = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, Lz = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": Iz,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": Ez,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": Tz,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": $z,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": Dz,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": Rz,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": Oz,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": Pz,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": Az
};
function qr(e) {
  return Lz[e] ?? {};
}
const Vz = qr(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), zz = qr(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), Uz = qr(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), Mz = qr(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), Bz = qr(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), qz = qr(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), Hz = qr(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), Wz = qr(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), Kz = qr(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), Gz = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = kn(), [i, a] = se(), [o, s] = se(), [l, d] = se(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(Vz, {
    skip: !e,
    variables: { contactId: e }
  });
  return qe(() => {
    const v = f?.Voyado?.ContactsV_GetContactById;
    !m && v && typeof v == "object" && ("id" in v && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in v && a(v.attributes), "preferences" in v && s(v.preferences), "consents" in v && d(
      v?.consents?.filter(
        (S) => S !== null
      ) || void 0
    )), !m && (!v || typeof v != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), et(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function ns(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const Yz = {
  count: 0,
  items: []
}, Jz = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = kn(), [i, a] = se(Yz), {
    loading: o,
    error: s,
    data: l
  } = n(Mz, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return qe(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, Qz = {
  count: 0,
  totalCount: 0,
  items: []
}, Xz = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = kn(), [i, a] = se(
    Qz
  ), {
    loading: o,
    error: s,
    data: l
  } = n(Bz, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return qe(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, Zz = ({
  conversationContext: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se(void 0), [a, o] = se(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(Uz, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return qe(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, e3 = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = mn(), [i, a] = se(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(zz, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return qe(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), et(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, n3 = "_pointer_ls8kj_48", t3 = "_list_ls8kj_53", r3 = "_listItem_ls8kj_63", nt = {
  pointer: n3,
  list: t3,
  listItem: r3
};
var so = (e) => e.type === "checkbox", li = (e) => e instanceof Date, Rt = (e) => e == null;
const Px = (e) => typeof e == "object";
var st = (e) => !Rt(e) && !Array.isArray(e) && Px(e) && !li(e), Ax = (e) => st(e) && e.target ? so(e.target) ? e.target.checked : e.target.value : e, i3 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Lx = (e, n) => e.has(i3(n)), a3 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return st(n) && n.hasOwnProperty("isPrototypeOf");
}, wp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function St(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(wp && (e instanceof Blob || i)) && (r || st(e)))
    if (n = r ? [] : {}, !r && !a3(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = St(e[a]));
  else
    return e;
  return n;
}
var Hs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], rt = (e) => e === void 0, Je = (e, n, r) => {
  if (!n || !st(e))
    return r;
  const i = Hs(n.split(/[,[\].]+?/)).reduce((a, o) => Rt(a) ? a : a[o], e);
  return rt(i) || i === e ? rt(e[n]) ? r : e[n] : i;
}, Jt = (e) => typeof e == "boolean", Cp = (e) => /^\w*$/.test(e), Vx = (e) => Hs(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Gn = (e, n, r) => {
  let i = -1;
  const a = Cp(n) ? [n] : Vx(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = st(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const ks = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, fr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, zr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, o3 = Se.createContext(null), Fp = () => Se.useContext(o3);
var zx = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== fr.all && (n._proxyFormState[s] = !i || fr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function s3(e) {
  const n = Fp(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => zx(s, r, d.current, !1), [s, r]);
}
var Er = (e) => typeof e == "string", Ux = (e, n, r, i, a) => Er(e) ? (i && n.watch.add(e), Je(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Je(r, o))) : (i && (n.watchAll = !0), r);
function Mx(e) {
  const n = Fp(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(Ux(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function l3(e) {
  const n = Fp(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Lx(a._names.array, r), l = Mx({
    control: a,
    name: r,
    defaultValue: Je(a._formValues, r, Je(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = s3({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Jt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Je(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Je(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Je(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Je(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Je(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((F) => u.current.onChange({
    target: {
      value: Ax(F),
      name: r
    },
    type: ks.CHANGE
  }), [r]), v = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Je(a._formValues, r),
      name: r
    },
    type: ks.BLUR
  }), [r, a._formValues]), S = Se.useCallback((F) => {
    const I = Je(a._fields, r);
    I && F && (I._f.ref = {
      focus: () => F.focus(),
      select: () => F.select(),
      setCustomValidity: (g) => F.setCustomValidity(g),
      reportValidity: () => F.reportValidity()
    });
  }, [a._fields, r]), N = Se.useMemo(() => ({
    name: r,
    value: l,
    ...Jt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: S
  }), [r, i, d.disabled, h, v, S, l]);
  return Se.useEffect(() => {
    const F = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Jt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const I = (g, q) => {
      const E = Je(a._fields, g);
      E && E._f && (E._f.mount = q);
    };
    if (I(r, !0), F) {
      const g = St(Je(a._options.defaultValues, r));
      Gn(a._defaultValues, r, g), rt(Je(a._formValues, r)) && Gn(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? F && !a._state.action : F) ? a.unregister(r) : I(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: N,
    formState: d,
    fieldState: f
  }), [N, d, f]);
}
const _v = (e) => e.render(l3(e));
var c3 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Va = (e) => Array.isArray(e) ? e : [e], xv = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, hm = (e) => Rt(e) || !Px(e);
function Yr(e, n) {
  if (hm(e) || hm(n))
    return e === n;
  if (li(e) && li(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (li(o) && li(s) || st(o) && st(s) || Array.isArray(o) && Array.isArray(s) ? !Yr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Tt = (e) => st(e) && !Object.keys(e).length, Ip = (e) => e.type === "file", hr = (e) => typeof e == "function", vs = (e) => {
  if (!wp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, Bx = (e) => e.type === "select-multiple", Ep = (e) => e.type === "radio", d3 = (e) => Ep(e) || so(e), Fu = (e) => vs(e) && e.isConnected;
function u3(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = rt(e) ? i++ : e[n[i++]];
  return e;
}
function m3(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !rt(e[n]))
      return !1;
  return !0;
}
function ht(e, n) {
  const r = Array.isArray(n) ? n : Cp(n) ? [n] : Vx(n), i = r.length === 1 ? e : u3(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (st(i) && Tt(i) || Array.isArray(i) && m3(i)) && ht(e, r.slice(0, -1)), e;
}
var qx = (e) => {
  for (const n in e)
    if (hr(e[n]))
      return !0;
  return !1;
};
function bs(e, n = {}) {
  const r = Array.isArray(e);
  if (st(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || st(e[i]) && !qx(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, bs(e[i], n[i])) : Rt(e[i]) || (n[i] = !0);
  return n;
}
function Hx(e, n, r) {
  const i = Array.isArray(e);
  if (st(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || st(e[a]) && !qx(e[a]) ? rt(n) || hm(r[a]) ? r[a] = Array.isArray(e[a]) ? bs(e[a], []) : { ...bs(e[a]) } : Hx(e[a], Rt(n) ? {} : n[a], r[a]) : r[a] = !Yr(e[a], n[a]);
  return r;
}
var Na = (e, n) => Hx(e, n, bs(n));
const Sv = {
  value: !1,
  isValid: !1
}, Nv = { value: !0, isValid: !0 };
var Wx = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !rt(e[0].attributes.value) ? rt(e[0].value) || e[0].value === "" ? Nv : { value: e[0].value, isValid: !0 } : Nv
    ) : Sv;
  }
  return Sv;
}, Kx = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => rt(e) ? e : n ? e === "" ? NaN : e && +e : r && Er(e) ? new Date(e) : i ? i(e) : e;
const jv = {
  isValid: !1,
  value: null
};
var Gx = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, jv) : jv;
function wv(e) {
  const n = e.ref;
  return Ip(n) ? n.files : Ep(n) ? Gx(e.refs).value : Bx(n) ? [...n.selectedOptions].map(({ value: r }) => r) : so(n) ? Wx(e.refs).value : Kx(rt(n.value) ? e.ref.value : n.value, e);
}
var p3 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Je(n, o);
    s && Gn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, _s = (e) => e instanceof RegExp, ja = (e) => rt(e) ? e : _s(e) ? e.source : st(e) ? _s(e.value) ? e.value.source : e.value : e, Cv = (e) => ({
  isOnSubmit: !e || e === fr.onSubmit,
  isOnBlur: e === fr.onBlur,
  isOnChange: e === fr.onChange,
  isOnAll: e === fr.all,
  isOnTouch: e === fr.onTouched
});
const Fv = "AsyncFunction";
var f3 = (e) => !!e && !!e.validate && !!(hr(e.validate) && e.validate.constructor.name === Fv || st(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Fv)), h3 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Iv = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const za = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Je(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (za(l, n))
          break;
      } else if (st(l) && za(l, n))
        break;
    }
  }
};
function Ev(e, n, r) {
  const i = Je(e, r);
  if (i || Cp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Je(n, o), l = Je(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var y3 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Tt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || fr.all));
}, g3 = (e, n, r) => !e || !n || e === n || Va(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), k3 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, v3 = (e, n) => !Hs(Je(e, n)).length && ht(e, n), b3 = (e, n, r) => {
  const i = Va(Je(e, r));
  return Gn(i, "root", n[r]), Gn(e, r, i), e;
}, ts = (e) => Er(e);
function Tv(e, n, r = "validate") {
  if (ts(e) || Array.isArray(e) && e.every(ts) || Jt(e) && !e)
    return {
      type: r,
      message: ts(e) ? e : "",
      ref: n
    };
}
var Ni = (e) => st(e) && !_s(e) ? e : {
  value: e,
  message: ""
}, $v = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: S, name: N, valueAsNumber: F, mount: I } = e._f, g = Je(r, N);
  if (!I || n.has(N))
    return {};
  const q = l ? l[0] : s, E = (W) => {
    a && q.reportValidity && (q.setCustomValidity(Jt(W) ? "" : W || ""), q.reportValidity());
  }, j = {}, $ = Ep(s), U = so(s), Z = $ || U, Q = (F || Ip(s)) && rt(s.value) && rt(g) || vs(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, ee = c3.bind(null, N, i, j), J = (W, P, K, ne = zr.maxLength, ke = zr.minLength) => {
    const ue = W ? P : K;
    j[N] = {
      type: W ? ne : ke,
      message: ue,
      ref: s,
      ...ee(W ? ne : ke, ue)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!Z && (Q || Rt(g)) || Jt(g) && !g || U && !Wx(l).isValid || $ && !Gx(l).isValid)) {
    const { value: W, message: P } = ts(d) ? { value: !!d, message: d } : Ni(d);
    if (W && (j[N] = {
      type: zr.required,
      message: P,
      ref: q,
      ...ee(zr.required, P)
    }, !i))
      return E(P), j;
  }
  if (!Q && (!Rt(f) || !Rt(h))) {
    let W, P;
    const K = Ni(h), ne = Ni(f);
    if (!Rt(g) && !isNaN(g)) {
      const ke = s.valueAsNumber || g && +g;
      Rt(K.value) || (W = ke > K.value), Rt(ne.value) || (P = ke < ne.value);
    } else {
      const ke = s.valueAsDate || new Date(g), ue = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), ce = s.type == "time", he = s.type == "week";
      Er(K.value) && g && (W = ce ? ue(g) > ue(K.value) : he ? g > K.value : ke > new Date(K.value)), Er(ne.value) && g && (P = ce ? ue(g) < ue(ne.value) : he ? g < ne.value : ke < new Date(ne.value));
    }
    if ((W || P) && (J(!!W, K.message, ne.message, zr.max, zr.min), !i))
      return E(j[N].message), j;
  }
  if ((m || u) && !Q && (Er(g) || o && Array.isArray(g))) {
    const W = Ni(m), P = Ni(u), K = !Rt(W.value) && g.length > +W.value, ne = !Rt(P.value) && g.length < +P.value;
    if ((K || ne) && (J(K, W.message, P.message), !i))
      return E(j[N].message), j;
  }
  if (v && !Q && Er(g)) {
    const { value: W, message: P } = Ni(v);
    if (_s(W) && !g.match(W) && (j[N] = {
      type: zr.pattern,
      message: P,
      ref: s,
      ...ee(zr.pattern, P)
    }, !i))
      return E(P), j;
  }
  if (S) {
    if (hr(S)) {
      const W = await S(g, r), P = Tv(W, q);
      if (P && (j[N] = {
        ...P,
        ...ee(zr.validate, P.message)
      }, !i))
        return E(P.message), j;
    } else if (st(S)) {
      let W = {};
      for (const P in S) {
        if (!Tt(W) && !i)
          break;
        const K = Tv(await S[P](g, r), q, P);
        K && (W = {
          ...K,
          ...ee(P, K.message)
        }, E(K.message), i && (j[N] = W));
      }
      if (!Tt(W) && (j[N] = {
        ref: q,
        ...W
      }, !i))
        return j;
    }
  }
  return E(!0), j;
};
const _3 = {
  mode: fr.onSubmit,
  reValidateMode: fr.onChange,
  shouldFocusError: !0
};
function x3(e = {}) {
  let n = {
    ..._3,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: hr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = st(n.defaultValues) || st(n.values) ? St(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : St(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: xv(),
    state: xv()
  }, v = Cv(n.mode), S = Cv(n.reValidateMode), N = n.criteriaMode === fr.all, F = (w) => (_) => {
    clearTimeout(m), m = setTimeout(w, _);
  }, I = async (w) => {
    if (!n.disabled && (u.isValid || f.isValid || w)) {
      const _ = n.resolver ? Tt((await Q()).errors) : await J(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, g = (w, _) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((w || Array.from(l.mount)).forEach((D) => {
      D && (_ ? Gn(r.validatingFields, D, _) : ht(r.validatingFields, D));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Tt(r.validatingFields)
    }));
  }, q = (w, _ = [], D, Y, X = !0, O = !0) => {
    if (Y && D && !n.disabled) {
      if (s.action = !0, O && Array.isArray(Je(i, w))) {
        const B = D(Je(i, w), Y.argA, Y.argB);
        X && Gn(i, w, B);
      }
      if (O && Array.isArray(Je(r.errors, w))) {
        const B = D(Je(r.errors, w), Y.argA, Y.argB);
        X && Gn(r.errors, w, B), v3(r.errors, w);
      }
      if ((u.touchedFields || f.touchedFields) && O && Array.isArray(Je(r.touchedFields, w))) {
        const B = D(Je(r.touchedFields, w), Y.argA, Y.argB);
        X && Gn(r.touchedFields, w, B);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Na(a, o)), h.state.next({
        name: w,
        isDirty: P(w, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Gn(o, w, _);
  }, E = (w, _) => {
    Gn(r.errors, w, _), h.state.next({
      errors: r.errors
    });
  }, j = (w) => {
    r.errors = w, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, $ = (w, _, D, Y) => {
    const X = Je(i, w);
    if (X) {
      const O = Je(o, w, rt(D) ? Je(a, w) : D);
      rt(O) || Y && Y.defaultChecked || _ ? Gn(o, w, _ ? O : wv(X._f)) : ke(w, O), s.mount && I();
    }
  }, U = (w, _, D, Y, X) => {
    let O = !1, B = !1;
    const ie = {
      name: w
    };
    if (!n.disabled) {
      if (!D || Y) {
        (u.isDirty || f.isDirty) && (B = r.isDirty, r.isDirty = ie.isDirty = P(), O = B !== ie.isDirty);
        const fe = Yr(Je(a, w), _);
        B = !!Je(r.dirtyFields, w), fe ? ht(r.dirtyFields, w) : Gn(r.dirtyFields, w, !0), ie.dirtyFields = r.dirtyFields, O = O || (u.dirtyFields || f.dirtyFields) && B !== !fe;
      }
      if (D) {
        const fe = Je(r.touchedFields, w);
        fe || (Gn(r.touchedFields, w, D), ie.touchedFields = r.touchedFields, O = O || (u.touchedFields || f.touchedFields) && fe !== D);
      }
      O && X && h.state.next(ie);
    }
    return O ? ie : {};
  }, Z = (w, _, D, Y) => {
    const X = Je(r.errors, w), O = (u.isValid || f.isValid) && Jt(_) && r.isValid !== _;
    if (n.delayError && D ? (d = F(() => E(w, D)), d(n.delayError)) : (clearTimeout(m), d = null, D ? Gn(r.errors, w, D) : ht(r.errors, w)), (D ? !Yr(X, D) : X) || !Tt(Y) || O) {
      const B = {
        ...Y,
        ...O && Jt(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: w
      };
      r = {
        ...r,
        ...B
      }, h.state.next(B);
    }
  }, Q = async (w) => {
    g(w, !0);
    const _ = await n.resolver(o, n.context, p3(w || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(w), _;
  }, ee = async (w) => {
    const { errors: _ } = await Q(w);
    if (w)
      for (const D of w) {
        const Y = Je(_, D);
        Y ? Gn(r.errors, D, Y) : ht(r.errors, D);
      }
    else
      r.errors = _;
    return _;
  }, J = async (w, _, D = {
    valid: !0
  }) => {
    for (const Y in w) {
      const X = w[Y];
      if (X) {
        const { _f: O, ...B } = X;
        if (O) {
          const ie = l.array.has(O.name), fe = X._f && f3(X._f);
          fe && u.validatingFields && g([Y], !0);
          const _e = await $v(X, l.disabled, o, N, n.shouldUseNativeValidation && !_, ie);
          if (fe && u.validatingFields && g([Y]), _e[O.name] && (D.valid = !1, _))
            break;
          !_ && (Je(_e, O.name) ? ie ? b3(r.errors, _e, O.name) : Gn(r.errors, O.name, _e[O.name]) : ht(r.errors, O.name));
        }
        !Tt(B) && await J(B, _, D);
      }
    }
    return D.valid;
  }, W = () => {
    for (const w of l.unMount) {
      const _ = Je(i, w);
      _ && (_._f.refs ? _._f.refs.every((D) => !Fu(D)) : !Fu(_._f.ref)) && Le(w);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (w, _) => !n.disabled && (w && _ && Gn(o, w, _), !Yr(Ce(), a)), K = (w, _, D) => Ux(w, l, {
    ...s.mount ? o : rt(_) ? a : Er(w) ? { [w]: _ } : _
  }, D, _), ne = (w) => Hs(Je(s.mount ? o : a, w, n.shouldUnregister ? Je(a, w, []) : [])), ke = (w, _, D = {}) => {
    const Y = Je(i, w);
    let X = _;
    if (Y) {
      const O = Y._f;
      O && (!O.disabled && Gn(o, w, Kx(_, O)), X = vs(O.ref) && Rt(_) ? "" : _, Bx(O.ref) ? [...O.ref.options].forEach((B) => B.selected = X.includes(B.value)) : O.refs ? so(O.ref) ? O.refs.length > 1 ? O.refs.forEach((B) => (!B.defaultChecked || !B.disabled) && (B.checked = Array.isArray(X) ? !!X.find((ie) => ie === B.value) : X === B.value)) : O.refs[0] && (O.refs[0].checked = !!X) : O.refs.forEach((B) => B.checked = B.value === X) : Ip(O.ref) ? O.ref.value = "" : (O.ref.value = X, O.ref.type || h.state.next({
        name: w,
        values: St(o)
      })));
    }
    (D.shouldDirty || D.shouldTouch) && U(w, X, D.shouldTouch, D.shouldDirty, !0), D.shouldValidate && be(w);
  }, ue = (w, _, D) => {
    for (const Y in _) {
      const X = _[Y], O = `${w}.${Y}`, B = Je(i, O);
      (l.array.has(w) || st(X) || B && !B._f) && !li(X) ? ue(O, X, D) : ke(O, X, D);
    }
  }, ce = (w, _, D = {}) => {
    const Y = Je(i, w), X = l.array.has(w), O = St(_);
    Gn(o, w, O), X ? (h.array.next({
      name: w,
      values: St(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && D.shouldDirty && h.state.next({
      name: w,
      dirtyFields: Na(a, o),
      isDirty: P(w, O)
    })) : Y && !Y._f && !Rt(O) ? ue(w, O, D) : ke(w, O, D), Iv(w, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? w : void 0,
      values: St(o)
    });
  }, he = async (w) => {
    s.mount = !0;
    const _ = w.target;
    let D = _.name, Y = !0;
    const X = Je(i, D), O = (B) => {
      Y = Number.isNaN(B) || li(B) && isNaN(B.getTime()) || Yr(B, Je(o, D, B));
    };
    if (X) {
      let B, ie;
      const fe = _.type ? wv(X._f) : Ax(w), _e = w.type === ks.BLUR || w.type === ks.FOCUS_OUT, en = !h3(X._f) && !n.resolver && !Je(r.errors, D) && !X._f.deps || k3(_e, Je(r.touchedFields, D), r.isSubmitted, S, v), dn = Iv(D, l, _e);
      Gn(o, D, fe), _e ? (X._f.onBlur && X._f.onBlur(w), d && d(0)) : X._f.onChange && X._f.onChange(w);
      const tn = U(D, fe, _e), sn = !Tt(tn) || dn;
      if (!_e && h.state.next({
        name: D,
        type: w.type,
        values: St(o)
      }), en)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? _e && I() : _e || I()), sn && h.state.next({ name: D, ...dn ? {} : tn });
      if (!_e && dn && h.state.next({ ...r }), n.resolver) {
        const { errors: fn } = await Q([D]);
        if (O(fe), Y) {
          const pn = Ev(r.errors, i, D), yn = Ev(fn, i, pn.name || D);
          B = yn.error, D = yn.name, ie = Tt(fn);
        }
      } else
        g([D], !0), B = (await $v(X, l.disabled, o, N, n.shouldUseNativeValidation))[D], g([D]), O(fe), Y && (B ? ie = !1 : (u.isValid || f.isValid) && (ie = await J(i, !0)));
      Y && (X._f.deps && be(X._f.deps), Z(D, ie, B, tn));
    }
  }, H = (w, _) => {
    if (Je(r.errors, _) && w.focus)
      return w.focus(), 1;
  }, be = async (w, _ = {}) => {
    let D, Y;
    const X = Va(w);
    if (n.resolver) {
      const O = await ee(rt(w) ? w : X);
      D = Tt(O), Y = w ? !X.some((B) => Je(O, B)) : D;
    } else w ? (Y = (await Promise.all(X.map(async (O) => {
      const B = Je(i, O);
      return await J(B && B._f ? { [O]: B } : B);
    }))).every(Boolean), !(!Y && !r.isValid) && I()) : Y = D = await J(i);
    return h.state.next({
      ...!Er(w) || (u.isValid || f.isValid) && D !== r.isValid ? {} : { name: w },
      ...n.resolver || !w ? { isValid: D } : {},
      errors: r.errors
    }), _.shouldFocus && !Y && za(i, H, w ? X : l.mount), Y;
  }, Ce = (w) => {
    const _ = {
      ...s.mount ? o : a
    };
    return rt(w) ? _ : Er(w) ? Je(_, w) : w.map((D) => Je(_, D));
  }, G = (w, _) => ({
    invalid: !!Je((_ || r).errors, w),
    isDirty: !!Je((_ || r).dirtyFields, w),
    error: Je((_ || r).errors, w),
    isValidating: !!Je(r.validatingFields, w),
    isTouched: !!Je((_ || r).touchedFields, w)
  }), ze = (w) => {
    w && Va(w).forEach((_) => ht(r.errors, _)), h.state.next({
      errors: w ? r.errors : {}
    });
  }, Be = (w, _, D) => {
    const Y = (Je(i, w, { _f: {} })._f || {}).ref, X = Je(r.errors, w) || {}, { ref: O, message: B, type: ie, ...fe } = X;
    Gn(r.errors, w, {
      ...fe,
      ..._,
      ref: Y
    }), h.state.next({
      name: w,
      errors: r.errors,
      isValid: !1
    }), D && D.shouldFocus && Y && Y.focus && Y.focus();
  }, Pe = (w, _) => hr(w) ? h.state.subscribe({
    next: (D) => w(K(void 0, _), D)
  }) : K(w, _, !0), Me = (w) => h.state.subscribe({
    next: (_) => {
      g3(w.name, _.name, w.exact) && y3(_, w.formState || u, Ee, w.reRenderRoot) && w.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, Ie = (w) => (s.mount = !0, f = {
    ...f,
    ...w.formState
  }, Me({
    ...w,
    formState: f
  })), Le = (w, _ = {}) => {
    for (const D of w ? Va(w) : l.mount)
      l.mount.delete(D), l.array.delete(D), _.keepValue || (ht(i, D), ht(o, D)), !_.keepError && ht(r.errors, D), !_.keepDirty && ht(r.dirtyFields, D), !_.keepTouched && ht(r.touchedFields, D), !_.keepIsValidating && ht(r.validatingFields, D), !n.shouldUnregister && !_.keepDefaultValue && ht(a, D);
    h.state.next({
      values: St(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: P() } : {}
    }), !_.keepIsValid && I();
  }, De = ({ disabled: w, name: _ }) => {
    (Jt(w) && s.mount || w || l.disabled.has(_)) && (w ? l.disabled.add(_) : l.disabled.delete(_));
  }, rn = (w, _ = {}) => {
    let D = Je(i, w);
    const Y = Jt(_.disabled) || Jt(n.disabled);
    return Gn(i, w, {
      ...D || {},
      _f: {
        ...D && D._f ? D._f : { ref: { name: w } },
        name: w,
        mount: !0,
        ..._
      }
    }), l.mount.add(w), D ? De({
      disabled: Jt(_.disabled) ? _.disabled : n.disabled,
      name: w
    }) : $(w, !0, _.value), {
      ...Y ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: ja(_.min),
        max: ja(_.max),
        minLength: ja(_.minLength),
        maxLength: ja(_.maxLength),
        pattern: ja(_.pattern)
      } : {},
      name: w,
      onChange: he,
      onBlur: he,
      ref: (X) => {
        if (X) {
          rn(w, _), D = Je(i, w);
          const O = rt(X.value) && X.querySelectorAll && X.querySelectorAll("input,select,textarea")[0] || X, B = d3(O), ie = D._f.refs || [];
          if (B ? ie.find((fe) => fe === O) : O === D._f.ref)
            return;
          Gn(i, w, {
            _f: {
              ...D._f,
              ...B ? {
                refs: [
                  ...ie.filter(Fu),
                  O,
                  ...Array.isArray(Je(a, w)) ? [{}] : []
                ],
                ref: { type: O.type, name: w }
              } : { ref: O }
            }
          }), $(w, !1, void 0, O);
        } else
          D = Je(i, w, {}), D._f && (D._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(Lx(l.array, w) && s.action) && l.unMount.add(w);
      }
    };
  }, je = () => n.shouldFocusError && za(i, H, l.mount), We = (w) => {
    Jt(w) && (h.state.next({ disabled: w }), za(i, (_, D) => {
      const Y = Je(i, D);
      Y && (_.disabled = Y._f.disabled || w, Array.isArray(Y._f.refs) && Y._f.refs.forEach((X) => {
        X.disabled = Y._f.disabled || w;
      }));
    }, 0, !1));
  }, Ge = (w, _) => async (D) => {
    let Y;
    D && (D.preventDefault && D.preventDefault(), D.persist && D.persist());
    let X = St(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: O, values: B } = await Q();
      r.errors = O, X = B;
    } else
      await J(i);
    if (l.disabled.size)
      for (const O of l.disabled)
        Gn(X, O, void 0);
    if (ht(r.errors, "root"), Tt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await w(X, D);
      } catch (O) {
        Y = O;
      }
    } else
      _ && await _({ ...r.errors }, D), je(), setTimeout(je);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Tt(r.errors) && !Y,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), Y)
      throw Y;
  }, pe = (w, _ = {}) => {
    Je(i, w) && (rt(_.defaultValue) ? ce(w, St(Je(a, w))) : (ce(w, _.defaultValue), Gn(a, w, St(_.defaultValue))), _.keepTouched || ht(r.touchedFields, w), _.keepDirty || (ht(r.dirtyFields, w), r.isDirty = _.defaultValue ? P(w, St(Je(a, w))) : P()), _.keepError || (ht(r.errors, w), u.isValid && I()), h.state.next({ ...r }));
  }, le = (w, _ = {}) => {
    const D = w ? St(w) : a, Y = St(D), X = Tt(w), O = X ? a : Y;
    if (_.keepDefaultValues || (a = D), !_.keepValues) {
      if (_.keepDirtyValues) {
        const B = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Na(a, o))
        ]);
        for (const ie of Array.from(B))
          Je(r.dirtyFields, ie) ? Gn(O, ie, Je(o, ie)) : ce(ie, Je(O, ie));
      } else {
        if (wp && rt(w))
          for (const B of l.mount) {
            const ie = Je(i, B);
            if (ie && ie._f) {
              const fe = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (vs(fe)) {
                const _e = fe.closest("form");
                if (_e) {
                  _e.reset();
                  break;
                }
              }
            }
          }
        for (const B of l.mount)
          ce(B, Je(O, B));
      }
      o = St(O), h.array.next({
        values: { ...O }
      }), h.state.next({
        values: { ...O }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: X ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !Yr(w, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: X ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? Na(a, o) : r.dirtyFields : _.keepDefaultValues && w ? Na(a, w) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ne = (w, _) => le(hr(w) ? w(o) : w, _), Ae = (w, _ = {}) => {
    const D = Je(i, w), Y = D && D._f;
    if (Y) {
      const X = Y.refs ? Y.refs[0] : Y.ref;
      X.focus && (X.focus(), _.shouldSelect && hr(X.select) && X.select());
    }
  }, Ee = (w) => {
    r = {
      ...r,
      ...w
    };
  }, cn = {
    control: {
      register: rn,
      unregister: Le,
      getFieldState: G,
      handleSubmit: Ge,
      setError: Be,
      _subscribe: Me,
      _runSchema: Q,
      _getWatch: K,
      _getDirty: P,
      _setValid: I,
      _setFieldArray: q,
      _setDisabledField: De,
      _setErrors: j,
      _getFieldArray: ne,
      _reset: le,
      _resetDefaultValues: () => hr(n.defaultValues) && n.defaultValues().then((w) => {
        Ne(w, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: W,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(w) {
        s = w;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(w) {
        l = w;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(w) {
        n = {
          ...n,
          ...w
        };
      }
    },
    subscribe: Ie,
    trigger: be,
    register: rn,
    handleSubmit: Ge,
    watch: Pe,
    setValue: ce,
    getValues: Ce,
    reset: Ne,
    resetField: pe,
    clearErrors: ze,
    unregister: Le,
    setError: Be,
    setFocus: Ae,
    getFieldState: G
  };
  return {
    ...cn,
    formControl: cn
  };
}
function S3(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: hr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: hr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : x3(e),
    formState: i
  }, e.formControl && e.defaultValues && !hr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Yr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !Tt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = zx(i, o), n.current;
}
const N3 = "_modalBody_1clhs_1", j3 = {
  modalBody: N3
}, w3 = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = kn(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: v } = S3({
    defaultValues: u,
    mode: "onChange"
  }), S = Mx({ control: f }), N = parseInt(S?.balance ?? "0", 10), F = m === N, I = F ? "Change the value to update the points" : "", g = N < 0, q = g ? "Points can not be negative" : "", E = S.description === "", j = E ? "Description can not be empty" : "";
  qe(() => {
    N > m ? h(
      "transactionType",
      fm.Addition
    ) : N < m && h(
      "transactionType",
      fm.Deduction
    );
  }, [m, N, h]);
  const [$, { loading: U, error: Z, reset: Q }] = o(Kz, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ee = () => {
    if (d) {
      const W = jz();
      $({
        variables: {
          input: {
            accountId: d,
            transactionId: W,
            amount: Math.abs(N - m),
            transactionType: S.transactionType,
            description: S.description,
            source: Ox.UpdateBalance
          }
        }
      }).then(async (P) => {
        P?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), J());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, J = () => {
    v(u), Q(), n();
  };
  return /* @__PURE__ */ M.jsxs(
    gt,
    {
      isOpen: e,
      onClose: J,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ M.jsx(kt, { title: "Update points balance", onClose: J }),
        /* @__PURE__ */ M.jsxs(vt, { className: j3.modalBody, children: [
          /* @__PURE__ */ M.jsxs(zt, { children: [
            /* @__PURE__ */ M.jsx(nn, { span: 6, children: /* @__PURE__ */ M.jsx(
              _v,
              {
                name: "balance",
                control: f,
                render: ({ field: W }) => /* @__PURE__ */ M.jsx(
                  ir,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: I || q
                    },
                    input: {
                      ...W,
                      value: W.value.toString(),
                      onChange: (P) => W.onChange(P)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ M.jsx(nn, { span: 6, children: /* @__PURE__ */ M.jsx(
              _v,
              {
                name: "description",
                control: f,
                render: ({ field: W }) => /* @__PURE__ */ M.jsx(
                  ir,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: W,
                    meta: {
                      warning: j
                    }
                  }
                )
              }
            ) })
          ] }),
          Z && /* @__PURE__ */ M.jsx(wn, { error: Z })
        ] }),
        /* @__PURE__ */ M.jsx(
          wt,
          {
            confirmName: "Save",
            confirmOnClick: () => ee(),
            confirmProps: {
              isLoading: U,
              disabled: F || g || E,
              loadingIndicator: /* @__PURE__ */ M.jsx(un, { size: 16 })
            },
            cancelOnClick: J
          }
        )
      ]
    }
  );
}, C3 = "_wrapper_1ge6c_1", F3 = "_block_1ge6c_12", Dv = {
  wrapper: C3,
  block: F3
}, I3 = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = mn(), { isCopied: i, copy: a } = ns(), { isCopied: o, copy: s } = ns(), { isCopied: l, copy: d } = ns(), [m, u] = se(!1), [f, h] = se(), [v, S] = se(!1), {
    loading: N,
    data: F,
    refetch: I
  } = r(Hz, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  qe(() => {
    if (F) {
      const ne = F?.Voyado?.PointAccountV_GetPointAccounts;
      ne && ne?.length > 0 && h(ne[0]);
    }
  }, [F]);
  const g = !!f?.id, q = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: E,
    lastName: j,
    street: $,
    zipCode: U,
    city: Z,
    country: Q,
    isRegistrationCompleted: ee,
    email: J,
    mobilePhone: W
  } = e, P = 14, K = `${E || ""} ${j || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", className: Dv.wrapper, children: [
    /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Dv.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: K }),
          N && /* @__PURE__ */ M.jsx(un, { size: 12 }),
          g && !N && /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ M.jsxs(Un, { size: "small", variant: "warning", children: [
              q,
              " points"
            ] }),
            /* @__PURE__ */ M.jsx(Ke, { content: "Update points balance", children: /* @__PURE__ */ M.jsx(
              me,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: nt.pointer
              }
            ) }),
            v && /* @__PURE__ */ M.jsx(Ke, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ M.jsx(
              me,
              {
                name: "info",
                size: 12,
                className: nt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    ($ || Z || U || Q || W || J) && /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
      W && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(me, { size: P, name: "phone" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: W })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            size: P,
            name: o ? "done" : "copy",
            onClick: () => s(W),
            className: nt.pointer
          }
        )
      ] }),
      J && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(me, { size: P, name: "mail" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: J })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            size: P,
            name: i ? "done" : "copy",
            onClick: () => a(J),
            className: nt.pointer
          }
        )
      ] }),
      ($ || Z || U || Q) && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(me, { size: P, name: "home" }),
          /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ M.jsx(Jn, { children: $ }),
            /* @__PURE__ */ M.jsxs(Jn, { children: [
              U,
              " ",
              Z
            ] }),
            /* @__PURE__ */ M.jsx(Jn, { children: Q })
          ] })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            size: P,
            name: l ? "done" : "copy",
            onClick: () => d(`${$}, ${U} ${Z}, ${Q}`),
            className: nt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(me, { size: P, name: "sign-in" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            name: ee ? "check-circle-filled" : "close-circle-filled",
            color: ee ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    g && /* @__PURE__ */ M.jsx(
      w3,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: S,
        refetchPointsQuery: I
      }
    )
  ] });
}, E3 = "_list_yud4a_7", T3 = "_listItem_yud4a_11", $3 = "_listItemTooltip_yud4a_15", D3 = "_listItemTimestamp_yud4a_18", Lo = {
  list: E3,
  listItem: T3,
  listItemTooltip: $3,
  listItemTimestamp: D3
}, R3 = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ M.jsx(He, { className: Lo.list, children: e.map((n, r) => /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: Lo.listItem, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ M.jsx(Ke, { content: n?.comment, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: dt({
          [Lo.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { className: Lo.listItemTimestamp, children: Pn(n.date).format(ct) }),
          n?.comment && /* @__PURE__ */ M.jsx(me, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ M.jsx(
      me,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), O3 = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Pn(e.latestChange).format(ct) : null, o = e?.expires ? `${Pn(e.expires).fromNow()} (${Pn(e.expires).format(ct)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ M.jsx(Ke, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ M.jsx(
        me,
        {
          name: "question",
          size: 14,
          className: nt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsxs(He, { className: nt.list, children: [
      s && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ke, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ M.jsx(Un, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ke, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ M.jsx(Un, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ke, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ M.jsx(Un, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ke, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ke, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, P3 = "_tagHover_kzbzk_1", A3 = "_channelUnsubscribed_kzbzk_6", Rv = {
  tagHover: P3,
  channelUnsubscribed: A3
}, Iu = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = kn(), { useMutation: l } = mn(), [d, m] = se(!1), [u, { loading: f }] = l(Wz), h = async ({
    newPreference: S,
    isSubscribed: N,
    channelType: F
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...S
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? N ? s("voyado:channel:unsubscribe:succeeded", { channel: F }) : s("voyado:channel:subscribe:succeeded", { channel: F }) : N ? s("voyado:channel:unsubscribe:failed", { channel: F }) : s("voyado:channel:subscribe:failed", { channel: F }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, v = d || f;
  return /* @__PURE__ */ M.jsx(Ke, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ M.jsx(
    On,
    {
      className: Rv.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ M.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: dt({
            [Rv.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            v ? /* @__PURE__ */ M.jsx(un, { size: 16 }) : /* @__PURE__ */ M.jsx(me, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, L3 = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        Iu,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ M.jsx(
        Iu,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ M.jsx(
        Iu,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, V3 = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = Gz({ contactId: e }), {
    isLoading: v,
    error: S,
    memberLevel: N
  } = e3({ contactId: e, skip: !s }), F = v || l, I = et(
    () => h?.filter(
      (g) => g !== null
    ),
    [h]
  );
  return d || S ? Ya({
    errors: d?.graphQLErrors || S?.graphQLErrors || []
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ M.jsx(wn, { error: d || S }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : F ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    r && /* @__PURE__ */ M.jsx(
      I3,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ M.jsx(O3, { memberLevel: N }),
    i && /* @__PURE__ */ M.jsx(
      L3,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ M.jsx(R3, { contactConsents: I })
  ] });
}, ym = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, z3 = "_list_zu4s7_1", U3 = "_listItem_zu4s7_4", M3 = "_listSum_zu4s7_7", Vo = {
  list: z3,
  listItem: U3,
  listSum: M3
}, B3 = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ M.jsxs(He, { className: Vo.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: Vo.listItem, children: /* @__PURE__ */ M.jsx(Ke, { content: s, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ M.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flex: "auto", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ M.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: ym(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ M.jsx(
    He.Text,
    {
      variant: "dense",
      className: dt(Vo.listItem, Vo.listSum),
      children: /* @__PURE__ */ M.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: ym(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), q3 = "_transaction_1kr8d_1", H3 = "_transactionIsOpen_1kr8d_9", W3 = "_transactionHeader_1kr8d_12", K3 = "_transactionHeaderSubLine_1kr8d_15", G3 = "_transactionHeaderAlignItemRight_1kr8d_19", ji = {
  transaction: q3,
  transactionIsOpen: H3,
  transactionHeader: W3,
  transactionHeaderSubLine: K3,
  transactionHeaderAlignItemRight: G3
}, Y3 = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", v = f ?? 0, S = m?.length ? m : [];
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: dt(ji.transaction, {
        [ji.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ji.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ M.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: Pn(o).format(ct) }),
                  /* @__PURE__ */ M.jsxs(
                    A.Heading,
                    {
                      variant: "heading-4",
                      className: ji.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: ji.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-4", children: ym(v, h) }),
                      /* @__PURE__ */ M.jsxs(
                        A.Heading,
                        {
                          variant: "heading-4",
                          className: ji.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ M.jsx(_m, {}),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ M.jsx(On, { children: /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ M.jsx(
                  B3,
                  {
                    lineItems: S,
                    localCurrency: h,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, J3 = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = Xz({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ M.jsx(wn, { error: r }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
          s === 0 && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ M.jsx(
            Y3,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, Q3 = "_message_unsvt_48", X3 = "_messageIsOpen_unsvt_56", Z3 = "_messageHeader_unsvt_60", eU = "_messageText_unsvt_64", nU = "_buttonLink_unsvt_86", wa = {
  message: Q3,
  messageIsOpen: X3,
  messageHeader: Z3,
  messageText: eU,
  buttonLink: nU
}, Eu = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Tu = (e, n) => n && e in Eu && n in Eu[e] ? Eu[e][n] : null, tU = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { track: a } = kn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, v = l ? Tu("type", l) : null, S = d ? Tu("source", d) : null, N = u ? Tu("status", u) : null, F = l?.replace("Message", "");
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: dt(wa.message, {
        [wa.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: wa.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
                  v && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
                    /* @__PURE__ */ M.jsx(me, { name: v, size: 16 }),
                    " ",
                    F
                  ] }),
                  s && /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: Pn(s).format(ct) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ M.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ M.jsx(_m, {}),
          /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            N && /* @__PURE__ */ M.jsx(On, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(me, { name: N }),
              " ",
              u
            ] }) }),
            S && /* @__PURE__ */ M.jsx(On, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(me, { name: S }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ M.jsx(On, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(me, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", className: wa.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ M.jsx(
            jt,
            {
              slotEnd: /* @__PURE__ */ M.jsx(me, { name: "external-link" }),
              variant: "tertiary",
              className: wa.buttonLink,
              navigate: () => {
                F && a("voyado:message:external-link:opened", {
                  channel: F.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, rU = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = Jz({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ M.jsx(wn, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ M.jsx(Un, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ M.jsx(
        tU,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, Ws = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, Ov = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = ns(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = at(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(me, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ M.jsx(Ke, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ M.jsx(
      me,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: nt.pointer
      }
    ) })
  ] });
}, iU = "_order_19t4p_1", aU = "_orderIsOpen_19t4p_9", oU = "_orderHeader_19t4p_12", sU = "_orderIconColor_19t4p_15", wr = {
  order: iU,
  orderIsOpen: aU,
  orderHeader: oU,
  orderIconColor: sU
}, lU = "_delivery_1m9nb_1", cU = "_deliveryCode_1m9nb_4", $u = {
  delivery: lU,
  deliveryCode: cU
}, dU = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = Xt();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ M.jsx(
      me,
      {
        size: l,
        name: "eye",
        className: wr.orderIconColor
      }
    ),
    /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ M.jsx(
        Ke,
        {
          content: /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Pn(s).format(ct)
          ] }),
          children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ M.jsx(
              A.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: $u.delivery,
                    children: [
                      /* @__PURE__ */ M.jsx(me, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ M.jsx(
              A.Paragraph,
              {
                variant: "4",
                className: dt($u.delivery, $u.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ M.jsx(Ke, { content: "Copy tracking code", children: /* @__PURE__ */ M.jsx(
      me,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: nt.pointer
      }
    ) })
  ] });
}, uU = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        me,
        {
          size: 14,
          name: "file-text",
          className: wr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ M.jsx(He, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ M.jsx(He.Item, { className: nt.listItem, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ M.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ M.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: nt.listItemAlignRight,
              children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Ws({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, mU = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        me,
        {
          size: 14,
          name: "tag",
          className: wr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ M.jsx(He, { className: nt.list, children: r?.map((i) => /* @__PURE__ */ M.jsx(
      He.Item,
      {
        className: nt.listItem,
        contentLeft: /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ M.jsx(
          Ke,
          {
            content: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ M.jsx(b, { children: /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: Ws({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ M.jsx(
          Li,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, pU = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        me,
        {
          size: 14,
          name: "credit-card",
          className: wr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ M.jsx(He, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ M.jsx(
      He.Item,
      {
        className: nt.listItem,
        children: /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ M.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: nt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: Pn(i?.paidAt).format(ct) }),
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Ws({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, fU = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: v,
    totalPrice: S
  } = e, N = 14;
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: dt(wr.order, {
        [wr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: wr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Pn(m).format(ct) }) }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ M.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              me,
              {
                size: N,
                name: "activity",
                className: wr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ M.jsx(Ke, { content: "Internal status", children: /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ M.jsx(Ke, { content: "External status", children: /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: s }) }) }),
                /* @__PURE__ */ M.jsx(Ke, { content: "Last updated at", children: /* @__PURE__ */ M.jsx(A.Paragraph, { as: "span", variant: "5", children: Pn(u).format(ct) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              me,
              {
                size: N,
                name: "chart-bar",
                className: wr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Ws({
                value: S,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              me,
              {
                size: N,
                name: "channels",
                className: wr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ M.jsx(Ov, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ M.jsx(
            Ov,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: v
            }
          ),
          /* @__PURE__ */ M.jsx(dU, { delivery: e.delivery }),
          /* @__PURE__ */ M.jsx(mU, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ M.jsx(uU, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ M.jsx(
            pU,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, hU = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || Ya({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ M.jsx(wn, { error: e }) : /* @__PURE__ */ M.jsx(M.Fragment, { children: r }), yU = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se([]), { track: a } = kn(), {
    loading: o,
    error: s,
    data: l
  } = n(qz, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return qe(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsx(hU, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ M.jsx(
      fU,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, gU = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = Zz({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: v,
    showOrders: S
  } = n;
  return s ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? Ya({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ M.jsx(wn, { error: o }) : !d && !m && !u && !f && !h && !v ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ M.jsx(V3, { contactId: i, settings: n }),
        h && /* @__PURE__ */ M.jsx(rU, { contactId: i }),
        v && /* @__PURE__ */ M.jsx(J3, { contactId: i }),
        S && /* @__PURE__ */ M.jsx(yU, { contactId: i }),
        !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, kU = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_nr4rl_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_nr4rl_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_nr4rl_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_nr4rl_63:last-child{border-bottom:none}._channelHeadline_yeqqp_1{padding:var(--dixa-size-spacer-200);border-bottom:var(--dixa-size-border-200) solid var(--dixa-color-neutral-200)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Du = { exports: {} }, Ca = {}, Pv;
function vU() {
  if (Pv) return Ca;
  Pv = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ca.Fragment = r, Ca.jsx = s, Ca.jsxs = s, Ca;
}
var zo = {}, Av;
function bU() {
  return Av || (Av = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var E = !1, j = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || E || j || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function W(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return W(c) + ".Consumer";
          case s:
            var p = t;
            return W(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, ke, ue, ce, he, H, be, Ce;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, ue = console.info, ce = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: ke
            }),
            info: K({}, t, {
              value: ue
            }),
            warn: K({}, t, {
              value: ce
            }),
            error: K({}, t, {
              value: he
            }),
            group: K({}, t, {
              value: H
            }),
            groupCollapsed: K({}, t, {
              value: be
            }),
            groupEnd: K({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              y = te;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), T = y.stack.split(`
`), V = x.length - 1, z = T.length - 1; V >= 1 && z >= 0 && x[V] !== T[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== T[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== T[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var C in t)
          if (L(t, C)) {
            var x = void 0;
            try {
              if (typeof t[C] != "function") {
                var T = Error((y || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              x = t[C](c, C, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, C, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, C) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, C = {}, x = null, T = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (T = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (x || T) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(C, z), T && fn(C, z);
        }
        return pn(t, x, T, R, y, B.current, C);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), C; !(C = L.next()).done; )
              an(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var C = ee(t);
        if (!C) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Hn();
          T ? x += T : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    zo.Fragment = i, zo.jsx = Bn, zo.jsxs = qn;
  })()), zo;
}
var Lv;
function _U() {
  return Lv || (Lv = 1, process.env.NODE_ENV === "production" ? Du.exports = vU() : Du.exports = bU()), Du.exports;
}
var de = _U();
const xU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "account_status" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "accepts_sms_marketing" } }, { kind: "Field", name: { kind: "Name", value: "accepts_email_marketing" } }, { kind: "Field", name: { kind: "Name", value: "channels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "suppressions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "province_code" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }] } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "response_messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "keyword" } }, { kind: "Field", name: { kind: "Name", value: "flowId" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }, { kind: "Field", name: { kind: "Name", value: "converted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_promotional_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_delivered" } }, { kind: "Field", name: { kind: "Name", value: "last_opened" } }, { kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_spam" } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, SU = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              account_status\n              default_language\n              dafault_currency\n              accepts_sms_marketing\n              accepts_email_marketing\n              channels {\n                sms {\n                  marketing {\n                    consent\n                    timestamp\n                  }\n                }\n                email {\n                  marketing {\n                    consent\n                    timestamp\n                    suppressions {\n                      timestamp\n                      timestamp\n                    }\n                  }\n                }\n              }\n              tags\n              address {\n                address1\n                address2\n                city\n                company\n                state\n                zip\n                province_code\n                country_code\n                phone_number\n              }\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n              }\n              yotpo_sms {\n                last_engaged\n                last_converted\n                last_sent\n                response_messages {\n                  id\n                  keyword\n                  flowId\n                  timestamp\n                }\n                campaigns {\n                  converted\n                  id\n                  clicked\n                }\n                flows {\n                  id\n                  opened\n                  clicked\n                  converted\n                }\n              }\n              yotpo_email {\n                last_sent\n                last_promotional_sent\n                last_delivered\n                last_opened\n                last_engaged\n                last_converted\n                last_spam\n                campaigns {\n                  opened\n                  id\n                  clicked\n                }\n                flows {\n                  converted\n                  id\n                }\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": xU
};
function NU(e) {
  return SU[e] ?? {};
}
const jU = NU(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              account_status
              default_language
              dafault_currency
              accepts_sms_marketing
              accepts_email_marketing
              channels {
                sms {
                  marketing {
                    consent
                    timestamp
                  }
                }
                email {
                  marketing {
                    consent
                    timestamp
                    suppressions {
                      timestamp
                      timestamp
                    }
                  }
                }
              }
              tags
              address {
                address1
                address2
                city
                company
                state
                zip
                province_code
                country_code
                phone_number
              }
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
              }
              yotpo_sms {
                last_engaged
                last_converted
                last_sent
                response_messages {
                  id
                  keyword
                  flowId
                  timestamp
                }
                campaigns {
                  converted
                  id
                  clicked
                }
                flows {
                  id
                  opened
                  clicked
                  converted
                }
              }
              yotpo_email {
                last_sent
                last_promotional_sent
                last_delivered
                last_opened
                last_engaged
                last_converted
                last_spam
                campaigns {
                  opened
                  id
                  clicked
                }
                flows {
                  converted
                  id
                }
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), wU = "_copyIcon_nr4rl_48", CU = "_list_nr4rl_53", FU = "_listItem_nr4rl_63", $r = {
  copyIcon: wU,
  list: CU,
  listItem: FU
}, En = ({
  description: e,
  content: n,
  tooltip: r
}) => {
  if (n == null)
    return null;
  const i = CS(n);
  return /* @__PURE__ */ de.jsx(He.Text, { variant: "dense", className: $r.listItem, children: /* @__PURE__ */ de.jsx(Ke, { content: r, children: /* @__PURE__ */ de.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", children: e }),
    i ? n : ib(n)
  ] }) }) });
}, Vv = ({
  channel: e
}) => {
  const n = (a) => ws(a.replace("_", " "));
  if (!e?.marketing)
    return null;
  const { marketing: r } = e, i = "suppressions" in r && !!r.suppressions;
  return /* @__PURE__ */ de.jsxs(de.Fragment, { children: [
    /* @__PURE__ */ de.jsx(He.Text, { variant: "dense", className: $r.listItem, children: /* @__PURE__ */ de.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", children: "Consent" }),
      /* @__PURE__ */ de.jsxs(b, { gap: "100", alignItems: "center", children: [
        r?.timestamp && /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Pn(r?.timestamp).format(ct) }),
        r?.consent && /* @__PURE__ */ de.jsx(Un, { variant: "primary", size: "small", children: n(r?.consent) })
      ] })
    ] }) }),
    i && /* @__PURE__ */ de.jsx(He.Text, { variant: "dense", className: $r.listItem, children: /* @__PURE__ */ de.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", children: "Suppressions" }),
      /* @__PURE__ */ de.jsxs(b, { gap: "100", alignItems: "center", children: [
        r.suppressions?.timestamp && /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Pn(r.suppressions?.timestamp).format(
          ct
        ) }),
        r.suppressions?.suppression_reason && /* @__PURE__ */ de.jsx(Un, { variant: "warning", size: "small", children: r.suppressions?.suppression_reason })
      ] })
    ] }) })
  ] });
}, IU = "_channelHeadline_yeqqp_1", zv = {
  channelHeadline: IU
}, EU = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { channels: n } = e, { yotpo_email: r, yotpo_sms: i } = e;
  return /* @__PURE__ */ de.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ de.jsx(A.Heading, { variant: "heading-3", children: "Channels" }),
    /* @__PURE__ */ de.jsxs(b, { flexDirection: "column", children: [
      /* @__PURE__ */ de.jsxs(b, { gap: "100", className: zv.channelHeadline, children: [
        /* @__PURE__ */ de.jsx(me, { name: "mail" }),
        /* @__PURE__ */ de.jsx(A.Heading, { variant: "heading-4", children: "EMAIL" })
      ] }),
      /* @__PURE__ */ de.jsxs(He, { className: $r.list, children: [
        /* @__PURE__ */ de.jsx(Vv, { channel: n?.email }),
        /* @__PURE__ */ de.jsx(
          En,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the customer's last email was sent.",
            content: r?.last_sent
          }
        ),
        /* @__PURE__ */ de.jsx(
          En,
          {
            description: "Last promotional sent",
            tooltip: "The timestamp for when the customer's last promotional email was sent.",
            content: r?.last_promotional_sent
          }
        ),
        /* @__PURE__ */ de.jsx(
          En,
          {
            description: "Last delivered",
            tooltip: "The timestamp for when the customer's last email was delivered.",
            content: r?.last_delivered
          }
        ),
        /* @__PURE__ */ de.jsx(
          En,
          {
            description: "Last opened",
            tooltip: "The timestamp for when the customer's last email was opened.",
            content: r?.last_opened
          }
        ),
        /* @__PURE__ */ de.jsx(
          En,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via email.",
            content: r?.last_engaged
          }
        ),
        /* @__PURE__ */ de.jsx(
          En,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via email.",
            content: r?.last_converted
          }
        ),
        /* @__PURE__ */ de.jsx(
          En,
          {
            description: "Last spam",
            tooltip: "The timestamp for when the customer's last email was marked as spam.",
            content: r?.last_spam
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ de.jsxs(b, { flexDirection: "column", children: [
      /* @__PURE__ */ de.jsxs(b, { gap: "100", className: zv.channelHeadline, children: [
        /* @__PURE__ */ de.jsx(me, { name: "sms" }),
        /* @__PURE__ */ de.jsx(A.Heading, { variant: "heading-4", children: "SMS" })
      ] }),
      /* @__PURE__ */ de.jsxs(He, { className: $r.list, children: [
        /* @__PURE__ */ de.jsx(Vv, { channel: n?.sms }),
        /* @__PURE__ */ de.jsx(
          En,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via SMS.",
            content: i?.last_engaged
          }
        ),
        /* @__PURE__ */ de.jsx(
          En,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the last SMS was sent to the customer.",
            content: i?.last_sent
          }
        ),
        /* @__PURE__ */ de.jsx(
          En,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via SMS.",
            content: i?.last_converted
          }
        )
      ] })
    ] })
  ] });
}, TU = "_wrapper_1xucg_1", $U = "_externalLink_1xucg_7", Ru = {
  wrapper: TU,
  externalLink: $U
}, DU = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Xt(), { isCopied: i, copy: a } = Xt(), { isCopied: o, copy: s } = Xt();
  if (!e)
    return null;
  const {
    first_name: l,
    last_name: d,
    address: m,
    email: u,
    phone_number: f,
    account_created_at: h,
    account_status: v,
    accepts_sms_marketing: S,
    accepts_email_marketing: N
  } = e, F = 14, I = `${l || ""} ${d || ""}`.trim() || "A customer has no name", {
    address1: g,
    address2: q,
    city: E,
    company: j,
    state: $,
    zip: U,
    province_code: Z,
    country_code: Q
  } = m || {}, ee = [
    g,
    q,
    [U, E].filter(Boolean).join(", "),
    [Q, $, Z].filter(Boolean).join(", "),
    j
  ].filter(Boolean);
  return /* @__PURE__ */ de.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ de.jsxs(b, { className: Ru.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ de.jsx(
      b,
      {
        justifyContent: "space-between",
        className: Ru.block,
        alignItems: "center",
        children: /* @__PURE__ */ de.jsx(A.Heading, { variant: "heading-2", children: I })
      }
    ),
    h && /* @__PURE__ */ de.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", children: Pn(h).format(ct) })
    ] }),
    u && /* @__PURE__ */ de.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ de.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ de.jsx(me, { size: F, name: "mail" }),
        /* @__PURE__ */ de.jsx("span", { className: Ru.externalLink, children: u })
      ] }),
      /* @__PURE__ */ de.jsx(Ke, { content: "Copy email", children: /* @__PURE__ */ de.jsx(b, { alignItems: "center", children: /* @__PURE__ */ de.jsx(
        me,
        {
          size: F,
          name: n ? "done" : "copy",
          onClick: () => r(u),
          className: $r.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ de.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ de.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ de.jsx(me, { size: F, name: "phone" }),
        /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", children: f })
      ] }),
      /* @__PURE__ */ de.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ de.jsx(b, { alignItems: "center", children: /* @__PURE__ */ de.jsx(
        me,
        {
          size: F,
          name: i ? "done" : "copy",
          onClick: () => a(f),
          className: $r.copyIcon
        }
      ) }) })
    ] }),
    (g || E || j || $ || U || Q) && /* @__PURE__ */ de.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ de.jsxs(b, { gap: "200", children: [
        /* @__PURE__ */ de.jsx(me, { size: F, name: "home" }),
        /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", color: "secondary", children: ee.map((J) => /* @__PURE__ */ de.jsx(Jn, { children: J }, J)) })
      ] }),
      /* @__PURE__ */ de.jsx(Ke, { content: "Copy address", children: /* @__PURE__ */ de.jsx(b, { alignItems: "center", children: /* @__PURE__ */ de.jsx(
        me,
        {
          size: F,
          name: o ? "done" : "copy",
          onClick: () => s(ee.join(", ")),
          className: $r.copyIcon
        }
      ) }) })
    ] }),
    /* @__PURE__ */ de.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ de.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ de.jsx(me, { size: F, name: "sms" }),
        /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", children: "Accepts sms marketing" })
      ] }),
      /* @__PURE__ */ de.jsx(
        me,
        {
          name: S ? "check-circle-filled" : "close-circle-filled",
          color: S ? "green.500" : "red.500"
        }
      )
    ] }),
    /* @__PURE__ */ de.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ de.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ de.jsx(me, { size: F, name: "paper-plane" }),
        /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", children: "Accepts email marketing" })
      ] }),
      /* @__PURE__ */ de.jsx(
        me,
        {
          name: N ? "check-circle-filled" : "close-circle-filled",
          color: N ? "green.500" : "red.500"
        }
      )
    ] }),
    v && /* @__PURE__ */ de.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ de.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ de.jsx(me, { size: F, name: "yotpo", color: "rgb(0, 66, 228)" }),
        /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", children: "Account status" })
      ] }),
      /* @__PURE__ */ de.jsx(On, { children: ws(v) })
    ] })
  ] }) });
}, RU = ({
  loyalty: e
}) => /* @__PURE__ */ de.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ de.jsx(A.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ de.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ de.jsxs(He, { className: $r.list, children: [
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Points expire date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.points_expire_date
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), OU = ({ tags: e }) => {
  const n = e?.split(","), r = n && n.length > 0;
  return /* @__PURE__ */ de.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ de.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
    !r && /* @__PURE__ */ de.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No tags available" }) }),
    r && /* @__PURE__ */ de.jsx(b, { gap: "200", flexWrap: "wrap", children: n.map((i, a) => /* @__PURE__ */ de.jsx(On, { children: i }, a)) })
  ] });
}, PU = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ de.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ de.jsx(A.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ de.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ de.jsxs(He, { className: $r.list, children: [
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: e.sentiment_avg_site
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Pn(e.last_review_date).format(
          ct
        )
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: e.last_sentiment
      }
    ),
    /* @__PURE__ */ de.jsx(
      En,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ de.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ de.jsx(Un, { variant: "info", size: "small", children: /* @__PURE__ */ de.jsx(de.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), AU = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), { track: i } = kn(), [a, o] = se(), [s, l] = se(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, v = n?.showTags ?? !1, S = n?.showChannels ?? !1, N = n?.showUserGeneratedContent ?? !1, F = n?.displayLoyalty ?? !1, I = n?.displayEmailData ?? !1, g = n?.displaySmsData ?? !1, q = n?.displaySubscriptions ?? !1, E = !h && !v && !S && !N && !F && !I && !g && !q, {
    loading: j,
    error: $,
    data: U
  } = r(jU, {
    skip: !d || !f,
    variables: {
      ...d && { email: d },
      // eslint-disable-next-line camelcase
      ...!d && m && { phone_number: m },
      storeId: f,
      expand: "all"
    }
  });
  if (qe(() => {
    const Z = U?.Yotpo?.getCustomers;
    Z?.customers && (Z?.customers?.length > 0 ? (o(Z?.customers[0]), l(!1), i("yotpo:customer:received")) : l(!0));
  }, [U?.Yotpo, j]), u)
    return /* @__PURE__ */ de.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (s)
    return /* @__PURE__ */ de.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (E)
    return /* @__PURE__ */ de.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ de.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if ($) {
    const Z = $.graphQLErrors;
    return km({ errors: Z }) ? /* @__PURE__ */ de.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : vm({ errors: Z }) ? /* @__PURE__ */ de.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ de.jsx(wn, { error: $ });
  }
  return j ? /* @__PURE__ */ de.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ de.jsx(un, {}) }) : /* @__PURE__ */ de.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ de.jsx(DU, { customerDetails: a }),
        v && /* @__PURE__ */ de.jsx(OU, { tags: a?.tags }),
        S && /* @__PURE__ */ de.jsx(EU, { customerDetails: a }),
        N && /* @__PURE__ */ de.jsx(
          PU,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        F && /* @__PURE__ */ de.jsx(RU, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var lo = (e) => e.type === "checkbox", ci = (e) => e instanceof Date, Ot = (e) => e == null;
const Yx = (e) => typeof e == "object";
var lt = (e) => !Ot(e) && !Array.isArray(e) && Yx(e) && !ci(e), Jx = (e) => lt(e) && e.target ? lo(e.target) ? e.target.checked : e.target.value : e, LU = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Qx = (e, n) => e.has(LU(n)), VU = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return lt(n) && n.hasOwnProperty("isPrototypeOf");
}, Tp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Nt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Tp && (e instanceof Blob || i)) && (r || lt(e)))
    if (n = r ? [] : {}, !r && !VU(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Nt(e[a]));
  else
    return e;
  return n;
}
var Ks = (e) => Array.isArray(e) ? e.filter(Boolean) : [], it = (e) => e === void 0, Qe = (e, n, r) => {
  if (!n || !lt(e))
    return r;
  const i = Ks(n.split(/[,[\].]+?/)).reduce((a, o) => Ot(a) ? a : a[o], e);
  return it(i) || i === e ? it(e[n]) ? r : e[n] : i;
}, Qt = (e) => typeof e == "boolean", $p = (e) => /^\w*$/.test(e), Xx = (e) => Ks(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Yn = (e, n, r) => {
  let i = -1;
  const a = $p(n) ? [n] : Xx(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = lt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const xs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, yr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Ur = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, zU = Se.createContext(null), Dp = () => Se.useContext(zU);
var Zx = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== yr.all && (n._proxyFormState[s] = !i || yr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function UU(e) {
  const n = Dp(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => Zx(s, r, d.current, !1), [s, r]);
}
var Tr = (e) => typeof e == "string", eS = (e, n, r, i, a) => Tr(e) ? (i && n.watch.add(e), Qe(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Qe(r, o))) : (i && (n.watchAll = !0), r);
function nS(e) {
  const n = Dp(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(eS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function MU(e) {
  const n = Dp(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Qx(a._names.array, r), l = nS({
    control: a,
    name: r,
    defaultValue: Qe(a._formValues, r, Qe(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = UU({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Qt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Qe(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Qe(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Qe(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Qe(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Qe(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((F) => u.current.onChange({
    target: {
      value: Jx(F),
      name: r
    },
    type: xs.CHANGE
  }), [r]), v = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Qe(a._formValues, r),
      name: r
    },
    type: xs.BLUR
  }), [r, a._formValues]), S = Se.useCallback((F) => {
    const I = Qe(a._fields, r);
    I && F && (I._f.ref = {
      focus: () => F.focus(),
      select: () => F.select(),
      setCustomValidity: (g) => F.setCustomValidity(g),
      reportValidity: () => F.reportValidity()
    });
  }, [a._fields, r]), N = Se.useMemo(() => ({
    name: r,
    value: l,
    ...Qt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: S
  }), [r, i, d.disabled, h, v, S, l]);
  return Se.useEffect(() => {
    const F = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Qt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const I = (g, q) => {
      const E = Qe(a._fields, g);
      E && E._f && (E._f.mount = q);
    };
    if (I(r, !0), F) {
      const g = Nt(Qe(a._options.defaultValues, r));
      Yn(a._defaultValues, r, g), it(Qe(a._formValues, r)) && Yn(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? F && !a._state.action : F) ? a.unregister(r) : I(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: N,
    formState: d,
    fieldState: f
  }), [N, d, f]);
}
const Uv = (e) => e.render(MU(e));
var BU = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ua = (e) => Array.isArray(e) ? e : [e], Mv = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, gm = (e) => Ot(e) || !Yx(e);
function Jr(e, n) {
  if (gm(e) || gm(n))
    return e === n;
  if (ci(e) && ci(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (ci(o) && ci(s) || lt(o) && lt(s) || Array.isArray(o) && Array.isArray(s) ? !Jr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var $t = (e) => lt(e) && !Object.keys(e).length, Rp = (e) => e.type === "file", gr = (e) => typeof e == "function", Ss = (e) => {
  if (!Tp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, tS = (e) => e.type === "select-multiple", Op = (e) => e.type === "radio", qU = (e) => Op(e) || lo(e), Ou = (e) => Ss(e) && e.isConnected;
function HU(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = it(e) ? i++ : e[n[i++]];
  return e;
}
function WU(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !it(e[n]))
      return !1;
  return !0;
}
function yt(e, n) {
  const r = Array.isArray(n) ? n : $p(n) ? [n] : Xx(n), i = r.length === 1 ? e : HU(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (lt(i) && $t(i) || Array.isArray(i) && WU(i)) && yt(e, r.slice(0, -1)), e;
}
var rS = (e) => {
  for (const n in e)
    if (gr(e[n]))
      return !0;
  return !1;
};
function Ns(e, n = {}) {
  const r = Array.isArray(e);
  if (lt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || lt(e[i]) && !rS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Ns(e[i], n[i])) : Ot(e[i]) || (n[i] = !0);
  return n;
}
function iS(e, n, r) {
  const i = Array.isArray(e);
  if (lt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || lt(e[a]) && !rS(e[a]) ? it(n) || gm(r[a]) ? r[a] = Array.isArray(e[a]) ? Ns(e[a], []) : { ...Ns(e[a]) } : iS(e[a], Ot(n) ? {} : n[a], r[a]) : r[a] = !Jr(e[a], n[a]);
  return r;
}
var Fa = (e, n) => iS(e, n, Ns(n));
const Bv = {
  value: !1,
  isValid: !1
}, qv = { value: !0, isValid: !0 };
var aS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !it(e[0].attributes.value) ? it(e[0].value) || e[0].value === "" ? qv : { value: e[0].value, isValid: !0 } : qv
    ) : Bv;
  }
  return Bv;
}, oS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => it(e) ? e : n ? e === "" ? NaN : e && +e : r && Tr(e) ? new Date(e) : i ? i(e) : e;
const Hv = {
  isValid: !1,
  value: null
};
var sS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Hv) : Hv;
function Wv(e) {
  const n = e.ref;
  return Rp(n) ? n.files : Op(n) ? sS(e.refs).value : tS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : lo(n) ? aS(e.refs).value : oS(it(n.value) ? e.ref.value : n.value, e);
}
var KU = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Qe(n, o);
    s && Yn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, js = (e) => e instanceof RegExp, Ia = (e) => it(e) ? e : js(e) ? e.source : lt(e) ? js(e.value) ? e.value.source : e.value : e, Kv = (e) => ({
  isOnSubmit: !e || e === yr.onSubmit,
  isOnBlur: e === yr.onBlur,
  isOnChange: e === yr.onChange,
  isOnAll: e === yr.all,
  isOnTouch: e === yr.onTouched
});
const Gv = "AsyncFunction";
var GU = (e) => !!e && !!e.validate && !!(gr(e.validate) && e.validate.constructor.name === Gv || lt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Gv)), YU = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Yv = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ma = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Qe(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ma(l, n))
          break;
      } else if (lt(l) && Ma(l, n))
        break;
    }
  }
};
function Jv(e, n, r) {
  const i = Qe(e, r);
  if (i || $p(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Qe(n, o), l = Qe(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var JU = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return $t(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || yr.all));
}, QU = (e, n, r) => !e || !n || e === n || Ua(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), XU = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, ZU = (e, n) => !Ks(Qe(e, n)).length && yt(e, n), e4 = (e, n, r) => {
  const i = Ua(Qe(e, r));
  return Yn(i, "root", n[r]), Yn(e, r, i), e;
}, rs = (e) => Tr(e);
function Qv(e, n, r = "validate") {
  if (rs(e) || Array.isArray(e) && e.every(rs) || Qt(e) && !e)
    return {
      type: r,
      message: rs(e) ? e : "",
      ref: n
    };
}
var wi = (e) => lt(e) && !js(e) ? e : {
  value: e,
  message: ""
}, Xv = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: S, name: N, valueAsNumber: F, mount: I } = e._f, g = Qe(r, N);
  if (!I || n.has(N))
    return {};
  const q = l ? l[0] : s, E = (W) => {
    a && q.reportValidity && (q.setCustomValidity(Qt(W) ? "" : W || ""), q.reportValidity());
  }, j = {}, $ = Op(s), U = lo(s), Z = $ || U, Q = (F || Rp(s)) && it(s.value) && it(g) || Ss(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, ee = BU.bind(null, N, i, j), J = (W, P, K, ne = Ur.maxLength, ke = Ur.minLength) => {
    const ue = W ? P : K;
    j[N] = {
      type: W ? ne : ke,
      message: ue,
      ref: s,
      ...ee(W ? ne : ke, ue)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!Z && (Q || Ot(g)) || Qt(g) && !g || U && !aS(l).isValid || $ && !sS(l).isValid)) {
    const { value: W, message: P } = rs(d) ? { value: !!d, message: d } : wi(d);
    if (W && (j[N] = {
      type: Ur.required,
      message: P,
      ref: q,
      ...ee(Ur.required, P)
    }, !i))
      return E(P), j;
  }
  if (!Q && (!Ot(f) || !Ot(h))) {
    let W, P;
    const K = wi(h), ne = wi(f);
    if (!Ot(g) && !isNaN(g)) {
      const ke = s.valueAsNumber || g && +g;
      Ot(K.value) || (W = ke > K.value), Ot(ne.value) || (P = ke < ne.value);
    } else {
      const ke = s.valueAsDate || new Date(g), ue = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), ce = s.type == "time", he = s.type == "week";
      Tr(K.value) && g && (W = ce ? ue(g) > ue(K.value) : he ? g > K.value : ke > new Date(K.value)), Tr(ne.value) && g && (P = ce ? ue(g) < ue(ne.value) : he ? g < ne.value : ke < new Date(ne.value));
    }
    if ((W || P) && (J(!!W, K.message, ne.message, Ur.max, Ur.min), !i))
      return E(j[N].message), j;
  }
  if ((m || u) && !Q && (Tr(g) || o && Array.isArray(g))) {
    const W = wi(m), P = wi(u), K = !Ot(W.value) && g.length > +W.value, ne = !Ot(P.value) && g.length < +P.value;
    if ((K || ne) && (J(K, W.message, P.message), !i))
      return E(j[N].message), j;
  }
  if (v && !Q && Tr(g)) {
    const { value: W, message: P } = wi(v);
    if (js(W) && !g.match(W) && (j[N] = {
      type: Ur.pattern,
      message: P,
      ref: s,
      ...ee(Ur.pattern, P)
    }, !i))
      return E(P), j;
  }
  if (S) {
    if (gr(S)) {
      const W = await S(g, r), P = Qv(W, q);
      if (P && (j[N] = {
        ...P,
        ...ee(Ur.validate, P.message)
      }, !i))
        return E(P.message), j;
    } else if (lt(S)) {
      let W = {};
      for (const P in S) {
        if (!$t(W) && !i)
          break;
        const K = Qv(await S[P](g, r), q, P);
        K && (W = {
          ...K,
          ...ee(P, K.message)
        }, E(K.message), i && (j[N] = W));
      }
      if (!$t(W) && (j[N] = {
        ref: q,
        ...W
      }, !i))
        return j;
    }
  }
  return E(!0), j;
};
const n4 = {
  mode: yr.onSubmit,
  reValidateMode: yr.onChange,
  shouldFocusError: !0
};
function t4(e = {}) {
  let n = {
    ...n4,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: gr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = lt(n.defaultValues) || lt(n.values) ? Nt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Nt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Mv(),
    state: Mv()
  }, v = Kv(n.mode), S = Kv(n.reValidateMode), N = n.criteriaMode === yr.all, F = (w) => (_) => {
    clearTimeout(m), m = setTimeout(w, _);
  }, I = async (w) => {
    if (!n.disabled && (u.isValid || f.isValid || w)) {
      const _ = n.resolver ? $t((await Q()).errors) : await J(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, g = (w, _) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((w || Array.from(l.mount)).forEach((D) => {
      D && (_ ? Yn(r.validatingFields, D, _) : yt(r.validatingFields, D));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !$t(r.validatingFields)
    }));
  }, q = (w, _ = [], D, Y, X = !0, O = !0) => {
    if (Y && D && !n.disabled) {
      if (s.action = !0, O && Array.isArray(Qe(i, w))) {
        const B = D(Qe(i, w), Y.argA, Y.argB);
        X && Yn(i, w, B);
      }
      if (O && Array.isArray(Qe(r.errors, w))) {
        const B = D(Qe(r.errors, w), Y.argA, Y.argB);
        X && Yn(r.errors, w, B), ZU(r.errors, w);
      }
      if ((u.touchedFields || f.touchedFields) && O && Array.isArray(Qe(r.touchedFields, w))) {
        const B = D(Qe(r.touchedFields, w), Y.argA, Y.argB);
        X && Yn(r.touchedFields, w, B);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Fa(a, o)), h.state.next({
        name: w,
        isDirty: P(w, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Yn(o, w, _);
  }, E = (w, _) => {
    Yn(r.errors, w, _), h.state.next({
      errors: r.errors
    });
  }, j = (w) => {
    r.errors = w, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, $ = (w, _, D, Y) => {
    const X = Qe(i, w);
    if (X) {
      const O = Qe(o, w, it(D) ? Qe(a, w) : D);
      it(O) || Y && Y.defaultChecked || _ ? Yn(o, w, _ ? O : Wv(X._f)) : ke(w, O), s.mount && I();
    }
  }, U = (w, _, D, Y, X) => {
    let O = !1, B = !1;
    const ie = {
      name: w
    };
    if (!n.disabled) {
      if (!D || Y) {
        (u.isDirty || f.isDirty) && (B = r.isDirty, r.isDirty = ie.isDirty = P(), O = B !== ie.isDirty);
        const fe = Jr(Qe(a, w), _);
        B = !!Qe(r.dirtyFields, w), fe ? yt(r.dirtyFields, w) : Yn(r.dirtyFields, w, !0), ie.dirtyFields = r.dirtyFields, O = O || (u.dirtyFields || f.dirtyFields) && B !== !fe;
      }
      if (D) {
        const fe = Qe(r.touchedFields, w);
        fe || (Yn(r.touchedFields, w, D), ie.touchedFields = r.touchedFields, O = O || (u.touchedFields || f.touchedFields) && fe !== D);
      }
      O && X && h.state.next(ie);
    }
    return O ? ie : {};
  }, Z = (w, _, D, Y) => {
    const X = Qe(r.errors, w), O = (u.isValid || f.isValid) && Qt(_) && r.isValid !== _;
    if (n.delayError && D ? (d = F(() => E(w, D)), d(n.delayError)) : (clearTimeout(m), d = null, D ? Yn(r.errors, w, D) : yt(r.errors, w)), (D ? !Jr(X, D) : X) || !$t(Y) || O) {
      const B = {
        ...Y,
        ...O && Qt(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: w
      };
      r = {
        ...r,
        ...B
      }, h.state.next(B);
    }
  }, Q = async (w) => {
    g(w, !0);
    const _ = await n.resolver(o, n.context, KU(w || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(w), _;
  }, ee = async (w) => {
    const { errors: _ } = await Q(w);
    if (w)
      for (const D of w) {
        const Y = Qe(_, D);
        Y ? Yn(r.errors, D, Y) : yt(r.errors, D);
      }
    else
      r.errors = _;
    return _;
  }, J = async (w, _, D = {
    valid: !0
  }) => {
    for (const Y in w) {
      const X = w[Y];
      if (X) {
        const { _f: O, ...B } = X;
        if (O) {
          const ie = l.array.has(O.name), fe = X._f && GU(X._f);
          fe && u.validatingFields && g([Y], !0);
          const _e = await Xv(X, l.disabled, o, N, n.shouldUseNativeValidation && !_, ie);
          if (fe && u.validatingFields && g([Y]), _e[O.name] && (D.valid = !1, _))
            break;
          !_ && (Qe(_e, O.name) ? ie ? e4(r.errors, _e, O.name) : Yn(r.errors, O.name, _e[O.name]) : yt(r.errors, O.name));
        }
        !$t(B) && await J(B, _, D);
      }
    }
    return D.valid;
  }, W = () => {
    for (const w of l.unMount) {
      const _ = Qe(i, w);
      _ && (_._f.refs ? _._f.refs.every((D) => !Ou(D)) : !Ou(_._f.ref)) && Le(w);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (w, _) => !n.disabled && (w && _ && Yn(o, w, _), !Jr(Ce(), a)), K = (w, _, D) => eS(w, l, {
    ...s.mount ? o : it(_) ? a : Tr(w) ? { [w]: _ } : _
  }, D, _), ne = (w) => Ks(Qe(s.mount ? o : a, w, n.shouldUnregister ? Qe(a, w, []) : [])), ke = (w, _, D = {}) => {
    const Y = Qe(i, w);
    let X = _;
    if (Y) {
      const O = Y._f;
      O && (!O.disabled && Yn(o, w, oS(_, O)), X = Ss(O.ref) && Ot(_) ? "" : _, tS(O.ref) ? [...O.ref.options].forEach((B) => B.selected = X.includes(B.value)) : O.refs ? lo(O.ref) ? O.refs.length > 1 ? O.refs.forEach((B) => (!B.defaultChecked || !B.disabled) && (B.checked = Array.isArray(X) ? !!X.find((ie) => ie === B.value) : X === B.value)) : O.refs[0] && (O.refs[0].checked = !!X) : O.refs.forEach((B) => B.checked = B.value === X) : Rp(O.ref) ? O.ref.value = "" : (O.ref.value = X, O.ref.type || h.state.next({
        name: w,
        values: Nt(o)
      })));
    }
    (D.shouldDirty || D.shouldTouch) && U(w, X, D.shouldTouch, D.shouldDirty, !0), D.shouldValidate && be(w);
  }, ue = (w, _, D) => {
    for (const Y in _) {
      const X = _[Y], O = `${w}.${Y}`, B = Qe(i, O);
      (l.array.has(w) || lt(X) || B && !B._f) && !ci(X) ? ue(O, X, D) : ke(O, X, D);
    }
  }, ce = (w, _, D = {}) => {
    const Y = Qe(i, w), X = l.array.has(w), O = Nt(_);
    Yn(o, w, O), X ? (h.array.next({
      name: w,
      values: Nt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && D.shouldDirty && h.state.next({
      name: w,
      dirtyFields: Fa(a, o),
      isDirty: P(w, O)
    })) : Y && !Y._f && !Ot(O) ? ue(w, O, D) : ke(w, O, D), Yv(w, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? w : void 0,
      values: Nt(o)
    });
  }, he = async (w) => {
    s.mount = !0;
    const _ = w.target;
    let D = _.name, Y = !0;
    const X = Qe(i, D), O = (B) => {
      Y = Number.isNaN(B) || ci(B) && isNaN(B.getTime()) || Jr(B, Qe(o, D, B));
    };
    if (X) {
      let B, ie;
      const fe = _.type ? Wv(X._f) : Jx(w), _e = w.type === xs.BLUR || w.type === xs.FOCUS_OUT, en = !YU(X._f) && !n.resolver && !Qe(r.errors, D) && !X._f.deps || XU(_e, Qe(r.touchedFields, D), r.isSubmitted, S, v), dn = Yv(D, l, _e);
      Yn(o, D, fe), _e ? (X._f.onBlur && X._f.onBlur(w), d && d(0)) : X._f.onChange && X._f.onChange(w);
      const tn = U(D, fe, _e), sn = !$t(tn) || dn;
      if (!_e && h.state.next({
        name: D,
        type: w.type,
        values: Nt(o)
      }), en)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? _e && I() : _e || I()), sn && h.state.next({ name: D, ...dn ? {} : tn });
      if (!_e && dn && h.state.next({ ...r }), n.resolver) {
        const { errors: fn } = await Q([D]);
        if (O(fe), Y) {
          const pn = Jv(r.errors, i, D), yn = Jv(fn, i, pn.name || D);
          B = yn.error, D = yn.name, ie = $t(fn);
        }
      } else
        g([D], !0), B = (await Xv(X, l.disabled, o, N, n.shouldUseNativeValidation))[D], g([D]), O(fe), Y && (B ? ie = !1 : (u.isValid || f.isValid) && (ie = await J(i, !0)));
      Y && (X._f.deps && be(X._f.deps), Z(D, ie, B, tn));
    }
  }, H = (w, _) => {
    if (Qe(r.errors, _) && w.focus)
      return w.focus(), 1;
  }, be = async (w, _ = {}) => {
    let D, Y;
    const X = Ua(w);
    if (n.resolver) {
      const O = await ee(it(w) ? w : X);
      D = $t(O), Y = w ? !X.some((B) => Qe(O, B)) : D;
    } else w ? (Y = (await Promise.all(X.map(async (O) => {
      const B = Qe(i, O);
      return await J(B && B._f ? { [O]: B } : B);
    }))).every(Boolean), !(!Y && !r.isValid) && I()) : Y = D = await J(i);
    return h.state.next({
      ...!Tr(w) || (u.isValid || f.isValid) && D !== r.isValid ? {} : { name: w },
      ...n.resolver || !w ? { isValid: D } : {},
      errors: r.errors
    }), _.shouldFocus && !Y && Ma(i, H, w ? X : l.mount), Y;
  }, Ce = (w) => {
    const _ = {
      ...s.mount ? o : a
    };
    return it(w) ? _ : Tr(w) ? Qe(_, w) : w.map((D) => Qe(_, D));
  }, G = (w, _) => ({
    invalid: !!Qe((_ || r).errors, w),
    isDirty: !!Qe((_ || r).dirtyFields, w),
    error: Qe((_ || r).errors, w),
    isValidating: !!Qe(r.validatingFields, w),
    isTouched: !!Qe((_ || r).touchedFields, w)
  }), ze = (w) => {
    w && Ua(w).forEach((_) => yt(r.errors, _)), h.state.next({
      errors: w ? r.errors : {}
    });
  }, Be = (w, _, D) => {
    const Y = (Qe(i, w, { _f: {} })._f || {}).ref, X = Qe(r.errors, w) || {}, { ref: O, message: B, type: ie, ...fe } = X;
    Yn(r.errors, w, {
      ...fe,
      ..._,
      ref: Y
    }), h.state.next({
      name: w,
      errors: r.errors,
      isValid: !1
    }), D && D.shouldFocus && Y && Y.focus && Y.focus();
  }, Pe = (w, _) => gr(w) ? h.state.subscribe({
    next: (D) => w(K(void 0, _), D)
  }) : K(w, _, !0), Me = (w) => h.state.subscribe({
    next: (_) => {
      QU(w.name, _.name, w.exact) && JU(_, w.formState || u, Ee, w.reRenderRoot) && w.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, Ie = (w) => (s.mount = !0, f = {
    ...f,
    ...w.formState
  }, Me({
    ...w,
    formState: f
  })), Le = (w, _ = {}) => {
    for (const D of w ? Ua(w) : l.mount)
      l.mount.delete(D), l.array.delete(D), _.keepValue || (yt(i, D), yt(o, D)), !_.keepError && yt(r.errors, D), !_.keepDirty && yt(r.dirtyFields, D), !_.keepTouched && yt(r.touchedFields, D), !_.keepIsValidating && yt(r.validatingFields, D), !n.shouldUnregister && !_.keepDefaultValue && yt(a, D);
    h.state.next({
      values: Nt(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: P() } : {}
    }), !_.keepIsValid && I();
  }, De = ({ disabled: w, name: _ }) => {
    (Qt(w) && s.mount || w || l.disabled.has(_)) && (w ? l.disabled.add(_) : l.disabled.delete(_));
  }, rn = (w, _ = {}) => {
    let D = Qe(i, w);
    const Y = Qt(_.disabled) || Qt(n.disabled);
    return Yn(i, w, {
      ...D || {},
      _f: {
        ...D && D._f ? D._f : { ref: { name: w } },
        name: w,
        mount: !0,
        ..._
      }
    }), l.mount.add(w), D ? De({
      disabled: Qt(_.disabled) ? _.disabled : n.disabled,
      name: w
    }) : $(w, !0, _.value), {
      ...Y ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: Ia(_.min),
        max: Ia(_.max),
        minLength: Ia(_.minLength),
        maxLength: Ia(_.maxLength),
        pattern: Ia(_.pattern)
      } : {},
      name: w,
      onChange: he,
      onBlur: he,
      ref: (X) => {
        if (X) {
          rn(w, _), D = Qe(i, w);
          const O = it(X.value) && X.querySelectorAll && X.querySelectorAll("input,select,textarea")[0] || X, B = qU(O), ie = D._f.refs || [];
          if (B ? ie.find((fe) => fe === O) : O === D._f.ref)
            return;
          Yn(i, w, {
            _f: {
              ...D._f,
              ...B ? {
                refs: [
                  ...ie.filter(Ou),
                  O,
                  ...Array.isArray(Qe(a, w)) ? [{}] : []
                ],
                ref: { type: O.type, name: w }
              } : { ref: O }
            }
          }), $(w, !1, void 0, O);
        } else
          D = Qe(i, w, {}), D._f && (D._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(Qx(l.array, w) && s.action) && l.unMount.add(w);
      }
    };
  }, je = () => n.shouldFocusError && Ma(i, H, l.mount), We = (w) => {
    Qt(w) && (h.state.next({ disabled: w }), Ma(i, (_, D) => {
      const Y = Qe(i, D);
      Y && (_.disabled = Y._f.disabled || w, Array.isArray(Y._f.refs) && Y._f.refs.forEach((X) => {
        X.disabled = Y._f.disabled || w;
      }));
    }, 0, !1));
  }, Ge = (w, _) => async (D) => {
    let Y;
    D && (D.preventDefault && D.preventDefault(), D.persist && D.persist());
    let X = Nt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: O, values: B } = await Q();
      r.errors = O, X = B;
    } else
      await J(i);
    if (l.disabled.size)
      for (const O of l.disabled)
        Yn(X, O, void 0);
    if (yt(r.errors, "root"), $t(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await w(X, D);
      } catch (O) {
        Y = O;
      }
    } else
      _ && await _({ ...r.errors }, D), je(), setTimeout(je);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: $t(r.errors) && !Y,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), Y)
      throw Y;
  }, pe = (w, _ = {}) => {
    Qe(i, w) && (it(_.defaultValue) ? ce(w, Nt(Qe(a, w))) : (ce(w, _.defaultValue), Yn(a, w, Nt(_.defaultValue))), _.keepTouched || yt(r.touchedFields, w), _.keepDirty || (yt(r.dirtyFields, w), r.isDirty = _.defaultValue ? P(w, Nt(Qe(a, w))) : P()), _.keepError || (yt(r.errors, w), u.isValid && I()), h.state.next({ ...r }));
  }, le = (w, _ = {}) => {
    const D = w ? Nt(w) : a, Y = Nt(D), X = $t(w), O = X ? a : Y;
    if (_.keepDefaultValues || (a = D), !_.keepValues) {
      if (_.keepDirtyValues) {
        const B = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Fa(a, o))
        ]);
        for (const ie of Array.from(B))
          Qe(r.dirtyFields, ie) ? Yn(O, ie, Qe(o, ie)) : ce(ie, Qe(O, ie));
      } else {
        if (Tp && it(w))
          for (const B of l.mount) {
            const ie = Qe(i, B);
            if (ie && ie._f) {
              const fe = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (Ss(fe)) {
                const _e = fe.closest("form");
                if (_e) {
                  _e.reset();
                  break;
                }
              }
            }
          }
        for (const B of l.mount)
          ce(B, Qe(O, B));
      }
      o = Nt(O), h.array.next({
        values: { ...O }
      }), h.state.next({
        values: { ...O }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: X ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !Jr(w, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: X ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? Fa(a, o) : r.dirtyFields : _.keepDefaultValues && w ? Fa(a, w) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ne = (w, _) => le(gr(w) ? w(o) : w, _), Ae = (w, _ = {}) => {
    const D = Qe(i, w), Y = D && D._f;
    if (Y) {
      const X = Y.refs ? Y.refs[0] : Y.ref;
      X.focus && (X.focus(), _.shouldSelect && gr(X.select) && X.select());
    }
  }, Ee = (w) => {
    r = {
      ...r,
      ...w
    };
  }, cn = {
    control: {
      register: rn,
      unregister: Le,
      getFieldState: G,
      handleSubmit: Ge,
      setError: Be,
      _subscribe: Me,
      _runSchema: Q,
      _getWatch: K,
      _getDirty: P,
      _setValid: I,
      _setFieldArray: q,
      _setDisabledField: De,
      _setErrors: j,
      _getFieldArray: ne,
      _reset: le,
      _resetDefaultValues: () => gr(n.defaultValues) && n.defaultValues().then((w) => {
        Ne(w, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: W,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(w) {
        s = w;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(w) {
        l = w;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(w) {
        n = {
          ...n,
          ...w
        };
      }
    },
    subscribe: Ie,
    trigger: be,
    register: rn,
    handleSubmit: Ge,
    watch: Pe,
    setValue: ce,
    getValues: Ce,
    reset: Ne,
    resetField: pe,
    clearErrors: ze,
    unregister: Le,
    setError: Be,
    setFocus: Ae,
    getFieldState: G
  };
  return {
    ...cn,
    formControl: cn
  };
}
function r4(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: gr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: gr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : t4(e),
    formState: i
  }, e.formControl && e.defaultValues && !gr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Jr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !$t(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = Zx(i, o), n.current;
}
const i4 = "_settingsWrapper_1ycvy_1", a4 = "_settingsWrapperHeader_1ycvy_6", o4 = "_settingsWrapperContent_1ycvy_10", s4 = "_settingsWrapperContentCode_1ycvy_18", l4 = "_settingsWrapperContentCURL_1ycvy_26", Ea = {
  settingsWrapper: i4,
  settingsWrapperHeader: a4,
  settingsWrapperContent: o4,
  settingsWrapperContentCode: s4,
  settingsWrapperContentCURL: l4
}, c4 = ({
  handleChangeText: e
}) => {
  const [n, r] = se(!1), { isCopied: i, copy: a } = Xt(), { control: o } = r4({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = nS({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = at(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ de.jsx(de.Fragment, { children: /* @__PURE__ */ de.jsx(nn, { span: 6, children: /* @__PURE__ */ de.jsxs(b, { flexDirection: "column", className: Ea.settingsWrapper, children: [
    /* @__PURE__ */ de.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: Ea.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ de.jsx(A.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ de.jsx(me, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ de.jsxs(
      b,
      {
        flexDirection: "column",
        className: Ea.settingsWrapperContent,
        children: [
          /* @__PURE__ */ de.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ de.jsx(
            Ja,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ de.jsxs("ol", { children: [
                /* @__PURE__ */ de.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ de.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ de.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ de.jsx("span", { className: Ea.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ de.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ de.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ de.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ de.jsx(
            Uv,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ de.jsx(
                ir,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ de.jsx(
            Uv,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ de.jsx(
                ir,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ de.jsxs(de.Fragment, { children: [
            /* @__PURE__ */ de.jsx(An, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ de.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: Ea.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ de.jsx(b, { alignContent: "start", children: /* @__PURE__ */ de.jsx(
              Ke,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ de.jsx(
                  Wn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, d4 = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showChannels",
    label: "Show email and sms channels",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], u4 = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ga
  }
], m4 = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: c4
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], p4 = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, f4 = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, h4 = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: kL,
  featureSettings: []
} : n ? {
  authSettings: vL,
  featureSettings: [...Ix]
} : e ? {
  authSettings: [
    ...ev,
    ...yL
  ],
  featureSettings: [...nv]
} : {
  authSettings: [
    ...ev,
    ...gL
  ],
  featureSettings: [...nv]
}, y4 = ({
  hasYotpoOAuth: e = !1,
  isCreationMode: n = !1
}) => e || n ? u4 : m4, lS = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = f4(a?.value, r), s = i !== void 0 ? i : p4(
    r
  );
  return o !== void 0 ? o : s;
}, cS = (e = {
  SHOPIFY: {},
  YOTPO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r } = e, {
    authSettings: i,
    featureSettings: a
  } = h4(n), o = y4(r);
  return {
    SHOPIFY: {
      widget: bz,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...i,
        ...a
      ]
    },
    JIRA: {
      widget: EF,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      settingsConfiguration: [
        ...Qf ? [...Qf] : []
      ]
    },
    GITHUB: {
      widget: OC,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      settingsConfiguration: [...PC]
    },
    MIUROS: {
      widget: AP,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      settingsConfiguration: [...LP]
    },
    KLAVIYO: {
      widget: qI,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...HI]
    },
    LINEAR: {
      widget: yO,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      settingsConfiguration: [...gO]
    },
    VOYADO: {
      widget: gU,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...kU]
    },
    LOYALTYLION: {
      widget: GO,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      settingsConfiguration: [...YO]
    },
    RECHARGE: {
      widget: cA,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      settingsConfiguration: [...dA]
    },
    BRAZE: {
      widget: Wj,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      settingsConfiguration: [...Kj]
    },
    YOTPO: {
      widget: AU,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...o, ...d4]
    },
    INGRID: {
      widget: l1,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...c1]
    }
  };
}, g4 = (e) => {
  const n = cS();
  return e.map(
    ({ id: r, type: i, name: a, settings: o, misconfigured: s }) => {
      const d = n[i], { settingsConfiguration: m } = d, u = m?.filter(({ secret: f }) => !f)?.map(
        ({
          key: f,
          type: h,
          defaultValue: v
        }) => ({
          key: f,
          value: lS({
            key: f,
            configuration: o,
            settingType: h,
            settingDefault: v
          })
        })
      );
      return {
        id: r,
        type: i,
        name: a,
        settings: u,
        misconfigured: s,
        icon: d.icon,
        iconColors: d.iconColors,
        widget: d.widget
      };
    }
  );
}, Pu = (e) => `partner-integration-${e}`, fM = ({
  configuration: e,
  conversationContext: n,
  showNotification: r,
  onToggleFn: i,
  isOpenFn: a,
  isMinimized: o,
  getVisibilityProperties: s,
  sortFn: l
}) => {
  const { track: d } = kn(), { isLoading: m, widgets: u } = kj(
    e.baseUrl
  ), [f, h] = se([]);
  qe(() => {
    if (u?.length && !m) {
      const E = u.filter((j) => e.featureFlags[j.type]).filter((j) => j.enabled);
      h(
        // Mapping the widget from the backend (`widgets`) to our
        // `widgetDefinitions` configuration
        g4(E)
      );
    }
  }, [m]);
  const v = {
    headline: "",
    text: "",
    onConfirm: () => q(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [S, N] = se(v), [F, I] = se(!1), g = (E) => {
    I(!0), N(E);
  }, q = () => {
    I(!1), N(v);
  };
  return /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
    [...f].sort(
      (E, j) => l ? l(E, j, Pu(E.id), Pu(j.id)) : E.name.localeCompare(j.name)
    ).map(
      ({
        id: E,
        name: j,
        type: $,
        widget: U,
        settings: Z,
        misconfigured: Q,
        icon: ee,
        iconColors: J
      }) => {
        const W = Pu(E), P = s?.(W);
        if (P?.isHidden)
          return null;
        const K = `partner-integration-${$}`, ne = /* @__PURE__ */ Ue.jsx(xm, { icon: ee, color: J }), ke = Z?.reduce(
          (ue, ce) => (ue[ce.key] = ce.value, ue),
          {}
        );
        return o ? /* @__PURE__ */ Ue.jsx("div", { className: "icon-holder", children: ne }, `partner-icon-${E}`) : /* @__PURE__ */ Ue.jsxs(
          rr,
          {
            onToggle: () => {
              d(
                a(W) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: E,
                  widgetType: $.toLowerCase()
                }
              ), i(W);
            },
            isOpen: a(W),
            className: K,
            children: [
              /* @__PURE__ */ Ue.jsx(
                rr.Header,
                {
                  wrap: "normal",
                  avatar: ne,
                  slotAfterTitle: P?.toggler,
                  children: j
                }
              ),
              /* @__PURE__ */ Ue.jsx(rr.Content, { children: Q ? /* @__PURE__ */ Ue.jsx(wn, { isMisconfigured: !0 }) : /* @__PURE__ */ Ue.jsx(
                sb.Provider,
                {
                  value: {
                    onError: (ue, ce) => console.warn(
                      `Something went wrong with a partner widget of type '${$}' and id '${E}'`,
                      ue,
                      ce
                    )
                  },
                  children: /* @__PURE__ */ Ue.jsx(
                    Mb,
                    {
                      integrationId: E,
                      type: $,
                      configuration: e,
                      showNotification: r,
                      showModal: g,
                      children: FS(U, {
                        conversationContext: n,
                        settings: ke
                      })
                    }
                  )
                }
              ) })
            ]
          },
          W
        );
      }
    ),
    /* @__PURE__ */ Ue.jsx(
      Bb,
      {
        isOpen: F,
        setIsOpen: I,
        headline: S.headline,
        text: S.text,
        confirmLabel: S.confirmLabel,
        confirmVariant: S.confirmVariant,
        cancelLabel: S.cancelLabel,
        cancelVariant: S.cancelVariant,
        onConfirm: S.onConfirm ? () => {
          try {
            S.onConfirm && S.onConfirm();
          } finally {
            I(!1), N(v);
          }
        } : void 0,
        onCancel: S.onCancel ? () => {
          try {
            S.onCancel && S.onCancel();
          } finally {
            I(!1), N(v);
          }
        } : void 0,
        children: S.children
      }
    )
  ] });
}, k4 = ({
  widgetConfiguration: e
}) => {
  const n = et(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = et(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, v4 = "FULL_ACCESS", b4 = "2", _4 = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((d) => d.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [v4],
        version: b4
      })
    }).then((l) => l.json())
  };
}, x4 = "dixaApiToken", Pp = "dixaApiTokenId", dS = "dixaApiTokenName", Zv = (e) => [Pp, dS].every(
  (r) => e.find((i) => i?.key === r)
);
function S4({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = N4(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const N4 = (e) => [
  {
    key: x4,
    value: e.value,
    secret: !0
  },
  {
    key: Pp,
    value: e.id,
    secret: !1
  },
  {
    key: dS,
    value: e.name,
    secret: !1
  }
], j4 = Qr`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, w4 = Qr`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, C4 = Qr`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, F4 = Qr`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, I4 = "_wrapper_1lmim_1", E4 = "_wrapperBox_1lmim_4", T4 = "_wrapperBoxErrorBorder_1lmim_9", Au = {
  wrapper: I4,
  wrapperBox: E4,
  wrapperBoxErrorBorder: T4
}, $4 = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: d,
  handleChangeText: m
}) => {
  const f = o?.find(
    (q) => q.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: v } = f, S = `Insert your ${h.label.toLowerCase()}`, N = `Insert your ${v.label.toLowerCase()}`, [F, I] = se({
    username: "",
    password: ""
  }), g = at(
    (q) => {
      m({
        target: {
          name: s,
          value: q
        }
      });
    },
    [s, m]
  );
  return qe(() => {
    g(
      F.username !== "" && F.password !== "" ? window.btoa(`${F.username}:${F.password}`) : ""
    );
  }, [F]), /* @__PURE__ */ Ue.jsx(
    An,
    {
      required: e,
      label: a,
      meta: l,
      className: Au.wrapper,
      children: /* @__PURE__ */ Ue.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: dt(Au.wrapperBox, {
            [Au.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ Ue.jsx(
              ir,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: S,
                input: {
                  name: s,
                  value: F.username,
                  onChange: (q) => I({
                    username: q?.target.value ?? "",
                    password: F.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ Ue.jsx(
              ir,
              {
                noAlert: !0,
                required: e,
                label: v.label,
                readOnly: n,
                placeholder: N,
                input: {
                  name: s,
                  value: F.password,
                  onChange: (q) => I({
                    username: F.username,
                    password: q?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function D4({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: d,
  handleEditSecret: m,
  getValueByKey: u,
  isEditingField: f,
  errors: h,
  type: v,
  isCreationMode: S,
  prefix: N,
  integrationId: F,
  integrationType: I,
  configuration: g,
  settings: q,
  otherProps: E
}) {
  const j = v === "custom" && E?.component, $ = u(n)?.value;
  return j ? /* @__PURE__ */ Ue.jsx(
    j,
    {
      configuration: g,
      integrationId: F,
      integrationType: I,
      label: r,
      settings: q,
      getValueByKey: u,
      widgetSettingsKey: n,
      handleChangeSelect: d,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
    /* @__PURE__ */ Ue.jsx(nn, { span: 3, children: /* @__PURE__ */ Ue.jsx(
      R4,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: S,
        children: v === "input" ? /* @__PURE__ */ Ue.jsx(
          ir,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: $,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: N,
            ...e && !S && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : v === "basicAuthInput" ? /* @__PURE__ */ Ue.jsx(
          $4,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: S,
            label: r,
            widgetSettingsKey: n,
            settings: q,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : v === "switch" ? /* @__PURE__ */ Ue.jsx(An, { label: r, children: /* @__PURE__ */ Ue.jsx(
          lb,
          {
            input: {
              name: n,
              value: "",
              checked: $,
              onChange: l
            }
          }
        ) }) : v === "select" ? /* @__PURE__ */ Ue.jsx(An, { label: r, children: /* @__PURE__ */ Ue.jsx(
          Kr,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (U) => d(n, U),
            getItemTitleByValue: (U) => U ? /* @__PURE__ */ Ue.jsx(A.Paragraph, { children: U.label }) : /* @__PURE__ */ Ue.jsx(Ue.Fragment, {}),
            value: $ ? [
              {
                label: (E?.selectItems || []).find(
                  (U) => U.value === $
                )?.label,
                value: $
              }
            ] : [],
            equalityFn: (U, Z) => U.value === Z.value,
            children: (E?.selectItems || []).map((U) => /* @__PURE__ */ Ue.jsx(pt.Item, { value: U, children: U.label }, U.value))
          }
        ) }) : /* @__PURE__ */ Ue.jsx(Ue.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ Ue.jsx(nn, { span: 3 })
  ] });
}
function R4({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ Ue.jsx(An, { label: n, children: /* @__PURE__ */ Ue.jsxs(
    Wn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Ba = "partner-integrations-widget-name-form-field", eb = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: d
  }) => ({
    key: i,
    value: lS({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...d && { customValidation: d }
  })
), O4 = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = se(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = se({}), s = (E) => i(E), l = (E) => !E || E === "", d = (E) => {
    const { [E]: j, ...$ } = a;
    o($);
  }, m = (E) => ({
    ...E,
    settings: E.settings.filter(({ isEditing: j }) => j).map(({ key: j, value: $, secret: U }) => ({
      key: j,
      value: $,
      secret: U
    }))
  }), u = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = (E) => {
    if (!E)
      return;
    const {
      target: { name: j, value: $ }
    } = E;
    a[j] && !l($) && d(j), i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === j ? { ...U, value: $ } : U
      )
    });
  }, h = (E) => {
    if (!E)
      return;
    const {
      target: { name: j, checked: $ }
    } = E;
    i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === j ? { ...U, value: $ } : U
      )
    });
  }, v = (E, j) => {
    if (!j)
      return;
    const { selectedValues: $ } = j, U = $?.[0];
    if (U) {
      const Z = r.settings.map(
        (Q) => Q.key === E ? { ...Q, value: U?.value } : Q
      );
      i({
        ...r,
        settings: Z
      });
    } else {
      const Z = r.settings.filter(
        (Q) => Q.key !== E
      );
      i({
        ...r,
        settings: Z
      });
    }
  }, S = (E) => {
    i({
      ...r,
      enabled: E
    });
  }, N = (E) => {
    if (!E)
      return;
    const {
      target: { value: j }
    } = E;
    a[Ba] && !l(j) && d(Ba), i({
      ...r,
      name: j
    });
  }, F = (E, j) => {
    const { settings: $ } = r, U = $.map((Z) => Z.key === j ? {
      ...Z,
      isEditing: E,
      ...!E && { value: "" }
    } : Z);
    a[j] && !E && d(j), i({
      ...r,
      settings: U
    });
  }, I = (E) => r.settings.find(
    (j) => j.key === E
  ), g = async (E) => {
    E.preventDefault(), q() && n(m(r));
  }, q = () => {
    const E = {}, { name: j, settings: $ } = r;
    return l(j) && (E[Ba] = u.input), $.forEach(
      ({ key: U, value: Z, required: Q, isEditing: ee, type: J, customValidation: W }) => {
        if (Q && ee)
          if (W) {
            const P = W(Z);
            typeof P == "string" && (E[U] = P);
          } else
            typeof Z == "string" && l(Z) && (E[U] = u[J]);
      }
    ), o(E), !Object.keys(E)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: S,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: v,
    handleEditSecret: F,
    handleChangeName: N,
    handleSubmit: g,
    getSettingValueByKey: I,
    initializeFormData: s,
    validate: q
  };
}, P4 = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], nb = "The configuration of the integration is not correct. Please check the settings.", A4 = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o
}) => {
  const { track: s } = kn(), { deleteDixaApiToken: l, createDixaApiToken: d } = _4({
    type: n,
    baseUrl: a.baseUrl
  }), u = GS().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), f = !e && !!n && !!u, h = P4.includes(n), [v, S] = se(), [N, F] = se(!1), [I, g] = se(!1), [q, E] = se(!1), [j, $] = se(null), [U, Z] = se(), {
    hasShopifyWidgetOAuth: Q,
    isShopifyMarketplaceApp: ee,
    initialValuesForShopify: J
  } = k4({
    featureFlags: a.featureFlags,
    widgetConfiguration: U
  }), W = n === "YOTPO" && !!U?.additionalProperties?.isUsingOAuth, P = f && n === "SHOPIFY", ke = cS({
    SHOPIFY: {
      hasShopifyOAuth: Q,
      isShopifyMarketplaceApp: ee,
      isCreationMode: f
    },
    YOTPO: {
      hasYotpoOAuth: W,
      isCreationMode: f
    }
  })[n].settingsConfiguration, ue = ke.filter(({ type: le }) => le !== "hidden").filter(({ hideOnCreate: le }) => f ? !le : !0), {
    error: ce,
    loading: he,
    refetch: H
  } = qS(j4, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (le) => {
      if (Object.keys(le).length === 0)
        E(!0);
      else {
        E(!1);
        const Ne = le?.Management?.widgetConfigurations[0];
        Ne && Z(Ne);
      }
    }
  }), [be, { error: Ce }] = Vp(
    f ? C4 : w4,
    {
      onError: (le) => {
        S(le), F(!1), i({
          title: "Something went wrong",
          text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (le) => {
        if (F(!1), Object.keys(le).length !== 0) {
          if (f && r(le?.Management?.createWidgetConfiguration?.id), !f) {
            const Ne = le?.Management?.updateWidgetConfiguration;
            Ne.misconfigured ? $(
              Ne?.misconfigurationCause ?? nb
            ) : $(null);
          }
          i({
            title: `${f ? "Creating" : "Updating"} was successful`,
            text: `${f ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [G] = Vp(F4, {
    onError: (le) => {
      S(le), F(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      F(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: ze,
    handleIsEnabled: Be,
    errors: Pe,
    handleChangeText: Me,
    handleChangeBoolean: Ie,
    handleChangeSelect: Le,
    handleEditSecret: De,
    handleChangeName: rn,
    handleSubmit: je,
    getSettingValueByKey: We,
    initializeFormData: Ge
  } = O4({
    onSubmit: async (le) => {
      f ? s("settings:create:submitted", { widgetType: n }) : e && s("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), F(!0);
      const Ne = le.settings.map(
        (w) => typeof w.value == "boolean" ? { ...w, value: w.value.toString() } : w
      ), Ae = Zv(Ne) && f;
      let Ee = [];
      if (Ae) {
        const w = await d().catch(
          (_) => {
            F(!1), console.warn("API-Token (creation) error resonse", _), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        w?.data && (Ee = S4({
          token: w.data,
          settings: Ne
        }));
      }
      const cn = {
        ...le,
        settings: [
          ...Ee.length > 0 ? Ee : Ne
        ]
      };
      (Ae && Ee.length > 1 || !Ae && Ee.length === 0) && (be({
        variables: {
          ...!f && { id: e },
          ...f && { type: n },
          ...cn
        }
      }), Ne.forEach(
        (w) => w.secret && De(!1, w.key)
      ));
    },
    ...f && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: eb({
          settingsFromBackend: J,
          settingsConfiguration: ke,
          creating: !0
        })
      }
    }
  });
  qe(() => {
    if (U) {
      const le = eb({
        settingsFromBackend: U.settings,
        settingsConfiguration: ke
      });
      Ge({
        enabled: !!U.enabled,
        name: U.name,
        settings: le
      }), U.misconfigured ? $(
        U?.misconfigurationCause ?? nb
      ) : $(null);
    }
  }, [U]);
  const pe = et(() => o ? !o.isCoupled : !0, [o]);
  return ce || Ce || v ? /* @__PURE__ */ Ue.jsx(
    wn,
    {
      error: ce || v,
      retry: ce ? H : void 0
    }
  ) : N || he ? /* @__PURE__ */ Ue.jsx(un, { "data-testid": "widget-settings-loading" }) : q ? /* @__PURE__ */ Ue.jsxs(A.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ Ue.jsx(On, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ Ue.jsxs("form", { children: [
    j && /* @__PURE__ */ Ue.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ue.jsx(
      Ja,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ Ue.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ Ue.jsx(A.Paragraph, { children: j }),
          /* @__PURE__ */ Ue.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ Ue.jsx(A.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ Ue.jsx(A.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ Ue.jsxs(
      zt,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          !P && /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
            /* @__PURE__ */ Ue.jsx(nn, { children: /* @__PURE__ */ Ue.jsx(An, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ue.jsx(
              lb,
              {
                input: {
                  name: "enabled",
                  checked: ze.enabled,
                  value: "dummy",
                  onChange: (le) => Be(le.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ Ue.jsx(nn, { span: 3, children: /* @__PURE__ */ Ue.jsx(
              ir,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: Ba,
                  value: ze.name,
                  onChange: rn
                },
                meta: {
                  error: Pe[Ba]
                }
              }
            ) }),
            /* @__PURE__ */ Ue.jsx(nn, { span: 3 })
          ] }),
          ue?.map(
            ({
              key: le,
              secret: Ne,
              label: Ae,
              placeholder: Ee = "",
              required: cn = !1,
              type: w,
              prefix: _,
              readOnly: D,
              ...Y
            }) => {
              const { settings: X } = ze, O = X.find(
                (B) => B.key === le
              );
              return /* @__PURE__ */ Ue.jsx(IS, { children: /* @__PURE__ */ Ue.jsx(
                D4,
                {
                  widgetSettingsKey: le,
                  isEditingField: !!O?.isEditing,
                  handleEditSecret: De,
                  handleChangeText: Me,
                  handleChangeBoolean: Ie,
                  handleChangeSelect: Le,
                  getValueByKey: We,
                  isSecret: Ne,
                  label: Ae,
                  placeholder: Ee,
                  required: cn,
                  errors: Pe,
                  type: w,
                  isCreationMode: f,
                  prefix: _,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: D,
                  settings: ke,
                  otherProps: Y
                }
              ) }, le);
            }
          )
        ]
      }
    ),
    !P && /* @__PURE__ */ Ue.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ Ue.jsx(Wn, { onClick: je, children: "Submit" }),
      !f && /* @__PURE__ */ Ue.jsx(
        Ke,
        {
          content: "The widget is used in automations",
          disabled: pe,
          children: /* @__PURE__ */ Ue.jsx(
            Wn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && s("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), g(!0);
              },
              disabled: !pe,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ Ue.jsx(
      Bb,
      {
        isOpen: I,
        setIsOpen: g,
        confirmVariant: h ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && s("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && s("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), Zv(ze.settings)) {
            const le = ze.settings.find(
              ({ key: Ne }) => Ne === Pp
            )?.value;
            le && l(le).catch((Ne) => {
              console.warn("API-Token (deletion) error response", Ne), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          G({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ Ue.jsx(b, { children: h ? /* @__PURE__ */ Ue.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ Ue.jsx(
            me,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ Ue.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ Ue.jsxs(A.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ Ue.jsxs(A.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ Ue.jsxs(A.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              ze.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          ze.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, hM = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o
}) => /* @__PURE__ */ Ue.jsx(
  sb.Provider,
  {
    value: {
      onError: (s, l) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        s,
        l
      )
    },
    children: /* @__PURE__ */ Ue.jsx(
      Mb,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ Ue.jsx(
          A4,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o
          }
        )
      }
    )
  }
);
var Uo = { exports: {} }, tb;
function L4() {
  if (tb) return Uo.exports;
  tb = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(j, $, U) {
    return Function.prototype.apply.call(j, $, U);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(j) {
    return Object.getOwnPropertyNames(j).concat(Object.getOwnPropertySymbols(j));
  } : r = function(j) {
    return Object.getOwnPropertyNames(j);
  };
  function i(E) {
    console && console.warn && console.warn(E);
  }
  var a = Number.isNaN || function(j) {
    return j !== j;
  };
  function o() {
    o.init.call(this);
  }
  Uo.exports = o, Uo.exports.once = I, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(E) {
    if (typeof E != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof E);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(E) {
      if (typeof E != "number" || E < 0 || a(E))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + E + ".");
      s = E;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(j) {
    if (typeof j != "number" || j < 0 || a(j))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + j + ".");
    return this._maxListeners = j, this;
  };
  function d(E) {
    return E._maxListeners === void 0 ? o.defaultMaxListeners : E._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(j) {
    for (var $ = [], U = 1; U < arguments.length; U++) $.push(arguments[U]);
    var Z = j === "error", Q = this._events;
    if (Q !== void 0)
      Z = Z && Q.error === void 0;
    else if (!Z)
      return !1;
    if (Z) {
      var ee;
      if ($.length > 0 && (ee = $[0]), ee instanceof Error)
        throw ee;
      var J = new Error("Unhandled error." + (ee ? " (" + ee.message + ")" : ""));
      throw J.context = ee, J;
    }
    var W = Q[j];
    if (W === void 0)
      return !1;
    if (typeof W == "function")
      n(W, this, $);
    else
      for (var P = W.length, K = S(W, P), U = 0; U < P; ++U)
        n(K[U], this, $);
    return !0;
  };
  function m(E, j, $, U) {
    var Z, Q, ee;
    if (l($), Q = E._events, Q === void 0 ? (Q = E._events = /* @__PURE__ */ Object.create(null), E._eventsCount = 0) : (Q.newListener !== void 0 && (E.emit(
      "newListener",
      j,
      $.listener ? $.listener : $
    ), Q = E._events), ee = Q[j]), ee === void 0)
      ee = Q[j] = $, ++E._eventsCount;
    else if (typeof ee == "function" ? ee = Q[j] = U ? [$, ee] : [ee, $] : U ? ee.unshift($) : ee.push($), Z = d(E), Z > 0 && ee.length > Z && !ee.warned) {
      ee.warned = !0;
      var J = new Error("Possible EventEmitter memory leak detected. " + ee.length + " " + String(j) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      J.name = "MaxListenersExceededWarning", J.emitter = E, J.type = j, J.count = ee.length, i(J);
    }
    return E;
  }
  o.prototype.addListener = function(j, $) {
    return m(this, j, $, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(j, $) {
    return m(this, j, $, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(E, j, $) {
    var U = { fired: !1, wrapFn: void 0, target: E, type: j, listener: $ }, Z = u.bind(U);
    return Z.listener = $, U.wrapFn = Z, Z;
  }
  o.prototype.once = function(j, $) {
    return l($), this.on(j, f(this, j, $)), this;
  }, o.prototype.prependOnceListener = function(j, $) {
    return l($), this.prependListener(j, f(this, j, $)), this;
  }, o.prototype.removeListener = function(j, $) {
    var U, Z, Q, ee, J;
    if (l($), Z = this._events, Z === void 0)
      return this;
    if (U = Z[j], U === void 0)
      return this;
    if (U === $ || U.listener === $)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Z[j], Z.removeListener && this.emit("removeListener", j, U.listener || $));
    else if (typeof U != "function") {
      for (Q = -1, ee = U.length - 1; ee >= 0; ee--)
        if (U[ee] === $ || U[ee].listener === $) {
          J = U[ee].listener, Q = ee;
          break;
        }
      if (Q < 0)
        return this;
      Q === 0 ? U.shift() : N(U, Q), U.length === 1 && (Z[j] = U[0]), Z.removeListener !== void 0 && this.emit("removeListener", j, J || $);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(j) {
    var $, U, Z;
    if (U = this._events, U === void 0)
      return this;
    if (U.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : U[j] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete U[j]), this;
    if (arguments.length === 0) {
      var Q = Object.keys(U), ee;
      for (Z = 0; Z < Q.length; ++Z)
        ee = Q[Z], ee !== "removeListener" && this.removeAllListeners(ee);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if ($ = U[j], typeof $ == "function")
      this.removeListener(j, $);
    else if ($ !== void 0)
      for (Z = $.length - 1; Z >= 0; Z--)
        this.removeListener(j, $[Z]);
    return this;
  };
  function h(E, j, $) {
    var U = E._events;
    if (U === void 0)
      return [];
    var Z = U[j];
    return Z === void 0 ? [] : typeof Z == "function" ? $ ? [Z.listener || Z] : [Z] : $ ? F(Z) : S(Z, Z.length);
  }
  o.prototype.listeners = function(j) {
    return h(this, j, !0);
  }, o.prototype.rawListeners = function(j) {
    return h(this, j, !1);
  }, o.listenerCount = function(E, j) {
    return typeof E.listenerCount == "function" ? E.listenerCount(j) : v.call(E, j);
  }, o.prototype.listenerCount = v;
  function v(E) {
    var j = this._events;
    if (j !== void 0) {
      var $ = j[E];
      if (typeof $ == "function")
        return 1;
      if ($ !== void 0)
        return $.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function S(E, j) {
    for (var $ = new Array(j), U = 0; U < j; ++U)
      $[U] = E[U];
    return $;
  }
  function N(E, j) {
    for (; j + 1 < E.length; j++)
      E[j] = E[j + 1];
    E.pop();
  }
  function F(E) {
    for (var j = new Array(E.length), $ = 0; $ < j.length; ++$)
      j[$] = E[$].listener || E[$];
    return j;
  }
  function I(E, j) {
    return new Promise(function($, U) {
      function Z(ee) {
        E.removeListener(j, Q), U(ee);
      }
      function Q() {
        typeof E.removeListener == "function" && E.removeListener("error", Z), $([].slice.call(arguments));
      }
      q(E, j, Q, { once: !0 }), j !== "error" && g(E, Z, { once: !0 });
    });
  }
  function g(E, j, $) {
    typeof E.on == "function" && q(E, "error", j, $);
  }
  function q(E, j, $, U) {
    if (typeof E.on == "function")
      U.once ? E.once(j, $) : E.on(j, $);
    else if (typeof E.addEventListener == "function")
      E.addEventListener(j, function Z(Q) {
        U.once && E.removeEventListener(j, Z), $(Q);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof E);
  }
  return Uo.exports;
}
var V4 = L4();
function yM() {
  const e = new V4.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  pj as GraphQLClientProvider,
  Bb as IntegrationModal,
  fM as PartnerIntegrations,
  hM as PartnerIntegrationsSettings,
  C4 as createWidgetConfigurationMutation,
  F4 as deleteWidgetConfigurationMutation,
  j4 as getWidgetConfigurationByIdQuery,
  cS as getWidgetDefinitions,
  yM as initializePartnerEventEmitter,
  w4 as updateWidgetConfigurationMutation,
  kj as usePartnerIntegrationWidgetConfigurations,
  k4 as useShopifyConfiguration
};
